//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ApiBaseUrl = new InjectionToken<string>('ApiBaseUrl');

@Injectable()
export class ActivityAuditClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    searchAssistanceApplicationActivityAudits(id?: string | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<PagedListOfActivityAuditViewModel> {
        let url_ = this.baseUrl + "/api/v1/activityaudit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAssistanceApplicationActivityAudits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAssistanceApplicationActivityAudits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfActivityAuditViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfActivityAuditViewModel>;
        }));
    }

    protected processSearchAssistanceApplicationActivityAudits(response: HttpResponseBase): Observable<PagedListOfActivityAuditViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfActivityAuditViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    recomputeSsnSearchHash(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/admin/ssn-search-hash/recompute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecomputeSsnSearchHash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecomputeSsnSearchHash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRecomputeSsnSearchHash(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgencyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    searchAgencies(searchValue?: string | null | undefined, pledgeTypeId?: string | null | undefined, includeDisabled?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfAgency> {
        let url_ = this.baseUrl + "/api/v1/agency/searchagencies?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAgencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAgencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAgency>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAgency>;
        }));
    }

    protected processSearchAgencies(response: HttpResponseBase): Observable<PagedListOfAgency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAgency.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveAgency(id?: string | undefined): Observable<Agency> {
        let url_ = this.baseUrl + "/api/v1/agency/retrieveagency?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency>;
        }));
    }

    protected processRetrieveAgency(response: HttpResponseBase): Observable<Agency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agency.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAgency(agency: Agency): Observable<Agency> {
        let url_ = this.baseUrl + "/api/v1/agency/addagency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agency);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency>;
        }));
    }

    protected processAddAgency(response: HttpResponseBase): Observable<Agency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agency.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAgency(agency: Agency): Observable<Agency> {
        let url_ = this.baseUrl + "/api/v1/agency/updateagency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agency);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency>;
        }));
    }

    protected processUpdateAgency(response: HttpResponseBase): Observable<Agency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agency.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAgency(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/agency/deleteagency?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAgency(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegionAdminAgencies(): Observable<Agency[]> {
        let url_ = this.baseUrl + "/api/v1/agency/getregionadminagencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionAdminAgencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionAdminAgencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency[]>;
        }));
    }

    protected processGetRegionAdminAgencies(response: HttpResponseBase): Observable<Agency[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Agency.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgenciesUnderRegionAdmin(agencyId?: string | undefined, assistanceApplicationType?: AssistanceApplicationType | null | undefined): Observable<Agency[]> {
        let url_ = this.baseUrl + "/api/v1/agency/getagenciesunderregionadmin?";
        if (agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (assistanceApplicationType !== undefined && assistanceApplicationType !== null)
            url_ += "assistanceApplicationType=" + encodeURIComponent("" + assistanceApplicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgenciesUnderRegionAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgenciesUnderRegionAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency[]>;
        }));
    }

    protected processGetAgenciesUnderRegionAdmin(response: HttpResponseBase): Observable<Agency[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Agency.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AllocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addAllocation(allocation: Allocation): Observable<Allocation> {
        let url_ = this.baseUrl + "/api/v1/allocation/addallocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allocation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Allocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Allocation>;
        }));
    }

    protected processAddAllocation(response: HttpResponseBase): Observable<Allocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Allocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAllocation(allocation: Allocation): Observable<Allocation> {
        let url_ = this.baseUrl + "/api/v1/allocation/updateallocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allocation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Allocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Allocation>;
        }));
    }

    protected processUpdateAllocation(response: HttpResponseBase): Observable<Allocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Allocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveAllocationsPaged(searchValue?: string | null | undefined, pledgeTypeId?: string | null | undefined, showZeroBalances?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfAllocationListItem> {
        let url_ = this.baseUrl + "/api/v1/allocation/retrieveallocationspaged?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (showZeroBalances === null)
            throw new globalThis.Error("The parameter 'showZeroBalances' cannot be null.");
        else if (showZeroBalances !== undefined)
            url_ += "showZeroBalances=" + encodeURIComponent("" + showZeroBalances) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllocationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllocationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAllocationListItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAllocationListItem>;
        }));
    }

    protected processRetrieveAllocationsPaged(response: HttpResponseBase): Observable<PagedListOfAllocationListItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAllocationListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveAllocation(id?: string | undefined): Observable<Allocation> {
        let url_ = this.baseUrl + "/api/v1/allocation/retrieveallocation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Allocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Allocation>;
        }));
    }

    protected processRetrieveAllocation(response: HttpResponseBase): Observable<Allocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Allocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAllocation(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/allocation/deleteallocation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAllocation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AllocationImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    uploadAllocations(uploadFile?: FileParameter | null | undefined): Observable<AllocationValidationResult[]> {
        let url_ = this.baseUrl + "/api/v1/allocationimport/uploadallocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile !== null && uploadFile !== undefined)
            content_.append("uploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "uploadFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllocationValidationResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllocationValidationResult[]>;
        }));
    }

    protected processUploadAllocations(response: HttpResponseBase): Observable<AllocationValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllocationValidationResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AllocationReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    detailReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, agencyId?: string | null | undefined, hideZeroBalances?: boolean | undefined): Observable<AllocationReport[]> {
        let url_ = this.baseUrl + "/api/v1/allocationreport/detailreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (hideZeroBalances === null)
            throw new globalThis.Error("The parameter 'hideZeroBalances' cannot be null.");
        else if (hideZeroBalances !== undefined)
            url_ += "hideZeroBalances=" + encodeURIComponent("" + hideZeroBalances) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllocationReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllocationReport[]>;
        }));
    }

    protected processDetailReport(response: HttpResponseBase): Observable<AllocationReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllocationReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDetailReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, agencyId?: string | null | undefined, hideZeroBalances?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/allocationreport/downloaddetailreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (hideZeroBalances === null)
            throw new globalThis.Error("The parameter 'hideZeroBalances' cannot be null.");
        else if (hideZeroBalances !== undefined)
            url_ += "hideZeroBalances=" + encodeURIComponent("" + hideZeroBalances) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDetailReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AmerenFtpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    initiateDownloads(token?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/amerenftp/initiatedownloads?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateDownloads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateDownloads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitiateDownloads(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cleanupOldFiles(token?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/amerenftp/cleanupoldfiles?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanupOldFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanupOldFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCleanupOldFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationCountyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    searchApplicationCounties(searchValue?: string | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<PagedListOfApplicationCounty> {
        let url_ = this.baseUrl + "/api/v1/applicationcounty?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchApplicationCounties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchApplicationCounties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfApplicationCounty>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfApplicationCounty>;
        }));
    }

    protected processSearchApplicationCounties(response: HttpResponseBase): Observable<PagedListOfApplicationCounty> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfApplicationCounty.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateApplicationCounty(applicationCounty: ApplicationCounty): Observable<ApplicationCounty> {
        let url_ = this.baseUrl + "/api/v1/applicationcounty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationCounty);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplicationCounty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicationCounty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCounty>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCounty>;
        }));
    }

    protected processUpdateApplicationCounty(response: HttpResponseBase): Observable<ApplicationCounty> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationCounty.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveApplicationCountyById(id?: string | undefined): Observable<ApplicationCounty> {
        let url_ = this.baseUrl + "/api/v1/applicationcounty/retrieveapplicationcountybyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveApplicationCountyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveApplicationCountyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCounty>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCounty>;
        }));
    }

    protected processRetrieveApplicationCountyById(response: HttpResponseBase): Observable<ApplicationCounty> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationCounty.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssistanceApplicationCommentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    add(comment: AssistanceApplicationComment): Observable<AssistanceApplicationComment> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationcomment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationComment>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AssistanceApplicationComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(assistanceApplicationId?: string | undefined): Observable<AssistanceApplicationComment[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationcomment?";
        if (assistanceApplicationId === null)
            throw new globalThis.Error("The parameter 'assistanceApplicationId' cannot be null.");
        else if (assistanceApplicationId !== undefined)
            url_ += "assistanceApplicationId=" + encodeURIComponent("" + assistanceApplicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationComment[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssistanceApplicationComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplicationComment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssistanceApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getById(id?: string | undefined): Observable<AssistanceApplication> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplication>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssistanceApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    add(assistanceApplication: CreateAssistanceApplication): Observable<AssistanceApplication> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assistanceApplication);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplication>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AssistanceApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(assistanceApplication: UpdateAssistanceApplication): Observable<AssistanceApplication> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assistanceApplication);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplication>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssistanceApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    readyForReview(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/readyforreview/{id}/readyforreview";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadyForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadyForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReadyForReview(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resubmit(id: string, body?: ResubmitAssistanceApplicationRequest | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/resubmit/{id}/resubmit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResubmit(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isAssistanceApplicationCountyActive(county?: string | null | undefined, applicationType?: AssistanceApplicationType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/isassistanceapplicationcountyactive?";
        if (county !== undefined && county !== null)
            url_ += "county=" + encodeURIComponent("" + county) + "&";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAssistanceApplicationCountyActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAssistanceApplicationCountyActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsAssistanceApplicationCountyActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exposeMinorAdultSsn(revealParams: AssistanceApplicationRevealSsnParams): Observable<SimpleStringResult> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/exposeminoradultssn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(revealParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExposeMinorAdultSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExposeMinorAdultSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleStringResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleStringResult>;
        }));
    }

    protected processExposeMinorAdultSsn(response: HttpResponseBase): Observable<SimpleStringResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleStringResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientAssistanceApplications(clientId?: string | undefined, applicationType?: AssistanceApplicationType | undefined): Observable<AssistanceApplication[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getclientassistanceapplications?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAssistanceApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAssistanceApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplication[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplication[]>;
        }));
    }

    protected processGetClientAssistanceApplications(response: HttpResponseBase): Observable<AssistanceApplication[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplication.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssistanceApplicationsPaged(applicationType?: AssistanceApplicationType | undefined, searchValue?: string | null | undefined, agencyId?: string | null | undefined, managingAgencyId?: string | null | undefined, status?: AssistanceApplicationStatus | null | undefined, publicInternalFilter?: PublicInternalFilter | null | undefined, fundTypeIds?: string[] | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfAssistanceApplicationListPreview> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getassistanceapplicationspaged?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (managingAgencyId !== undefined && managingAgencyId !== null)
            url_ += "managingAgencyId=" + encodeURIComponent("" + managingAgencyId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (publicInternalFilter !== undefined && publicInternalFilter !== null)
            url_ += "publicInternalFilter=" + encodeURIComponent("" + publicInternalFilter) + "&";
        if (fundTypeIds !== undefined && fundTypeIds !== null)
            fundTypeIds && fundTypeIds.forEach(item => { url_ += "fundTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistanceApplicationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistanceApplicationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAssistanceApplicationListPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAssistanceApplicationListPreview>;
        }));
    }

    protected processGetAssistanceApplicationsPaged(response: HttpResponseBase): Observable<PagedListOfAssistanceApplicationListPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAssistanceApplicationListPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isCaseCountyActive(county?: string | null | undefined, applicationType?: AssistanceApplicationType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/iscasecountyactive?";
        if (county !== undefined && county !== null)
            url_ += "county=" + encodeURIComponent("" + county) + "&";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCaseCountyActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCaseCountyActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCaseCountyActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByPledgeId(pledgeId?: string | undefined): Observable<GetApplicationByPledgeIdResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getbypledgeid?";
        if (pledgeId === null)
            throw new globalThis.Error("The parameter 'pledgeId' cannot be null.");
        else if (pledgeId !== undefined)
            url_ += "pledgeId=" + encodeURIComponent("" + pledgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPledgeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPledgeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationByPledgeIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationByPledgeIdResponse>;
        }));
    }

    protected processGetByPledgeId(response: HttpResponseBase): Observable<GetApplicationByPledgeIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicationByPledgeIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssistanceApplicationFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getassistanceapplicationfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistanceApplicationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistanceApplicationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAssistanceApplicationFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFundPledgeTypesForAgency(agencyId?: string | undefined, applicationType?: AssistanceApplicationType | null | undefined, activeOnly?: boolean | undefined, includePledgeTypeId?: string | null | undefined): Observable<PledgeType[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getfundpledgetypesforagency?";
        if (agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (applicationType !== undefined && applicationType !== null)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        if (includePledgeTypeId !== undefined && includePledgeTypeId !== null)
            url_ += "includePledgeTypeId=" + encodeURIComponent("" + includePledgeTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundPledgeTypesForAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundPledgeTypesForAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeType[]>;
        }));
    }

    protected processGetFundPledgeTypesForAgency(response: HttpResponseBase): Observable<PledgeType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuditReportTableRows(isPublic?: boolean | null | undefined, agencyIds?: string[] | null | undefined, userIds?: string[] | null | undefined, fundPledgeTypeId?: string | null | undefined, enteredDateStart?: Date | null | undefined, enteredDateEnd?: Date | null | undefined, totalRequestedMin?: number | null | undefined, totalRequestedMax?: number | null | undefined, auditStatus?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortName?: string | null | undefined, secondarySort?: string | null | undefined, descending?: boolean | undefined): Observable<PagedListOfAuditReportTableRowViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getauditreporttablerows/audit-report-rows?";
        if (isPublic !== undefined && isPublic !== null)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (agencyIds !== undefined && agencyIds !== null)
            agencyIds && agencyIds.forEach(item => { url_ += "AgencyIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (fundPledgeTypeId !== undefined && fundPledgeTypeId !== null)
            url_ += "FundPledgeTypeId=" + encodeURIComponent("" + fundPledgeTypeId) + "&";
        if (enteredDateStart !== undefined && enteredDateStart !== null)
            url_ += "EnteredDateStart=" + encodeURIComponent(enteredDateStart ? "" + enteredDateStart.toISOString() : "") + "&";
        if (enteredDateEnd !== undefined && enteredDateEnd !== null)
            url_ += "EnteredDateEnd=" + encodeURIComponent(enteredDateEnd ? "" + enteredDateEnd.toISOString() : "") + "&";
        if (totalRequestedMin !== undefined && totalRequestedMin !== null)
            url_ += "TotalRequestedMin=" + encodeURIComponent("" + totalRequestedMin) + "&";
        if (totalRequestedMax !== undefined && totalRequestedMax !== null)
            url_ += "TotalRequestedMax=" + encodeURIComponent("" + totalRequestedMax) + "&";
        if (auditStatus !== undefined && auditStatus !== null)
            url_ += "AuditStatus=" + encodeURIComponent("" + auditStatus) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortName !== undefined && sortName !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortName) + "&";
        if (secondarySort !== undefined && secondarySort !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySort) + "&";
        if (descending === null)
            throw new globalThis.Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditReportTableRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditReportTableRows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAuditReportTableRowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAuditReportTableRowViewModel>;
        }));
    }

    protected processGetAuditReportTableRows(response: HttpResponseBase): Observable<PagedListOfAuditReportTableRowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAuditReportTableRowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAuditReportCsv(isPublic?: boolean | null | undefined, agencyIds?: string[] | null | undefined, userIds?: string[] | null | undefined, fundPledgeTypeId?: string | null | undefined, enteredDateStart?: Date | null | undefined, enteredDateEnd?: Date | null | undefined, totalRequestedMin?: number | null | undefined, totalRequestedMax?: number | null | undefined, auditStatus?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/downloadauditreportcsv?";
        if (isPublic !== undefined && isPublic !== null)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (agencyIds !== undefined && agencyIds !== null)
            agencyIds && agencyIds.forEach(item => { url_ += "AgencyIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (fundPledgeTypeId !== undefined && fundPledgeTypeId !== null)
            url_ += "FundPledgeTypeId=" + encodeURIComponent("" + fundPledgeTypeId) + "&";
        if (enteredDateStart !== undefined && enteredDateStart !== null)
            url_ += "EnteredDateStart=" + encodeURIComponent(enteredDateStart ? "" + enteredDateStart.toISOString() : "") + "&";
        if (enteredDateEnd !== undefined && enteredDateEnd !== null)
            url_ += "EnteredDateEnd=" + encodeURIComponent(enteredDateEnd ? "" + enteredDateEnd.toISOString() : "") + "&";
        if (totalRequestedMin !== undefined && totalRequestedMin !== null)
            url_ += "TotalRequestedMin=" + encodeURIComponent("" + totalRequestedMin) + "&";
        if (totalRequestedMax !== undefined && totalRequestedMax !== null)
            url_ += "TotalRequestedMax=" + encodeURIComponent("" + totalRequestedMax) + "&";
        if (auditStatus !== undefined && auditStatus !== null)
            url_ += "AuditStatus=" + encodeURIComponent("" + auditStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAuditReportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAuditReportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAuditReportCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuditProgressReportTableRows(limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined, activeOnly?: boolean | undefined): Observable<PagedListOfAuditProgressReportTableRowViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getauditprogressreporttablerows/audit-progress-report-rows?";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditProgressReportTableRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditProgressReportTableRows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAuditProgressReportTableRowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAuditProgressReportTableRowViewModel>;
        }));
    }

    protected processGetAuditProgressReportTableRows(response: HttpResponseBase): Observable<PagedListOfAuditProgressReportTableRowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAuditProgressReportTableRowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAuditProgressReportCsv(activeOnly?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/downloadauditprogressreportcsv?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAuditProgressReportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAuditProgressReportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAuditProgressReportCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProgramDefaultPayee(applicationType?: AssistanceApplicationType | undefined): Observable<Company> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getprogramdefaultpayee?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramDefaultPayee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramDefaultPayee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company>;
        }));
    }

    protected processGetProgramDefaultPayee(response: HttpResponseBase): Observable<Company> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssistanceApplicationsExport(applicationType?: AssistanceApplicationType | undefined, searchValue?: string | null | undefined, agencyId?: string | null | undefined, managingAgencyId?: string | null | undefined, status?: AssistanceApplicationStatus | null | undefined, publicInternalFilter?: PublicInternalFilter | null | undefined, fundTypeIds?: string[] | null | undefined, sortName?: string | null | undefined, secondarySort?: string | null | undefined, descending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getassistanceapplicationsexport?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (managingAgencyId !== undefined && managingAgencyId !== null)
            url_ += "managingAgencyId=" + encodeURIComponent("" + managingAgencyId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (publicInternalFilter !== undefined && publicInternalFilter !== null)
            url_ += "publicInternalFilter=" + encodeURIComponent("" + publicInternalFilter) + "&";
        if (fundTypeIds !== undefined && fundTypeIds !== null)
            fundTypeIds && fundTypeIds.forEach(item => { url_ += "fundTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortName !== undefined && sortName !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortName) + "&";
        if (secondarySort !== undefined && secondarySort !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySort) + "&";
        if (descending === null)
            throw new globalThis.Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistanceApplicationsExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistanceApplicationsExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAssistanceApplicationsExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStormTotalNeedRequested(clientId?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/getstormtotalneedrequested?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStormTotalNeedRequested(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStormTotalNeedRequested(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetStormTotalNeedRequested(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplication/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssistanceApplicationFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addFiles(fileTypes?: string[] | null | undefined, id?: string | null | undefined, files?: FileParameter[] | null | undefined): Observable<AssistanceApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/addfiles?";
        if (fileTypes !== undefined && fileTypes !== null)
            fileTypes && fileTypes.forEach(item => { url_ += "fileTypes=" + encodeURIComponent("" + item) + "&"; });
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationFile[]>;
        }));
    }

    protected processAddFiles(response: HttpResponseBase): Observable<AssistanceApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFiles(fileTypes?: string[] | null | undefined, deletedFileIds?: string[] | null | undefined, id?: string | null | undefined, files?: FileParameter[] | null | undefined): Observable<AssistanceApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/updatefiles?";
        if (fileTypes !== undefined && fileTypes !== null)
            fileTypes && fileTypes.forEach(item => { url_ += "fileTypes=" + encodeURIComponent("" + item) + "&"; });
        if (deletedFileIds !== undefined && deletedFileIds !== null)
            deletedFileIds && deletedFileIds.forEach(item => { url_ += "deletedFileIds=" + encodeURIComponent("" + item) + "&"; });
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationFile[]>;
        }));
    }

    protected processUpdateFiles(response: HttpResponseBase): Observable<AssistanceApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(id?: string | undefined, fileType?: string | null | undefined, uploadFile?: FileParameter | null | undefined): Observable<AssistanceApplicationFile> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/uploadfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile !== null && uploadFile !== undefined)
            content_.append("uploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "uploadFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationFile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationFile>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<AssistanceApplicationFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFileByAssistanceApplicationId(id?: string | undefined): Observable<AssistanceApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/getfilebyassistanceapplicationid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileByAssistanceApplicationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileByAssistanceApplicationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationFile[]>;
        }));
    }

    protected processGetFileByAssistanceApplicationId(response: HttpResponseBase): Observable<AssistanceApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/getfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/deletefile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFiles(assistanceApplicationId?: string | undefined, files?: AssistanceApplicationFileSkeleton[] | null | undefined): Observable<AssistanceApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationfile/uploadfiles?";
        if (assistanceApplicationId === null)
            throw new globalThis.Error("The parameter 'assistanceApplicationId' cannot be null.");
        else if (assistanceApplicationId !== undefined)
            url_ += "assistanceApplicationId=" + encodeURIComponent("" + assistanceApplicationId) + "&";
        if (files !== undefined && files !== null)
            files && files.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "files[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationFile[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<AssistanceApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssistanceApplicationReviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getCurrentInformationRequest(applicationId?: string | undefined): Observable<AssistanceApplicationInformationRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview/getcurrentinformationrequest?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentInformationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentInformationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
        }));
    }

    protected processGetCurrentInformationRequest(response: HttpResponseBase): Observable<AssistanceApplicationInformationRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationInformationRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addInformationRequest(informationRequest: AddAssistanceApplicationInformationRequestViewModel): Observable<AssistanceApplicationInformationRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(informationRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInformationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInformationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
        }));
    }

    protected processAddInformationRequest(response: HttpResponseBase): Observable<AssistanceApplicationInformationRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationInformationRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeRequest(id: string): Observable<AssistanceApplicationInformationRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview/{id}/completerequest";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
        }));
    }

    protected processCompleteRequest(response: HttpResponseBase): Observable<AssistanceApplicationInformationRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationInformationRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    passReviewAssistanceApplication(id: string, additionalInformation?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview/{id}/passreviewassistanceapplication?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (additionalInformation !== undefined && additionalInformation !== null)
            url_ += "additionalInformation=" + encodeURIComponent("" + additionalInformation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPassReviewAssistanceApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPassReviewAssistanceApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPassReviewAssistanceApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAgencyInformationRequest(informationRequest: AddAssistanceApplicationInformationRequestViewModel): Observable<AssistanceApplicationInformationRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview/addagencyinformationrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(informationRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgencyInformationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgencyInformationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationInformationRequestViewModel>;
        }));
    }

    protected processAddAgencyInformationRequest(response: HttpResponseBase): Observable<AssistanceApplicationInformationRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationInformationRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    passAgencyReviewAssistanceApplication(id: string, additionalInformation?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview/{id}/passagencyreviewassistanceapplication?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (additionalInformation !== undefined && additionalInformation !== null)
            url_ += "additionalInformation=" + encodeURIComponent("" + additionalInformation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPassAgencyReviewAssistanceApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPassAgencyReviewAssistanceApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPassAgencyReviewAssistanceApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    denyReviewAssistanceApplication(vm: DenyReviewAssistanceApplicationViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationreview/denyreviewassistanceapplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenyReviewAssistanceApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenyReviewAssistanceApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDenyReviewAssistanceApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssistanceApplicationStateAuditClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    retrieveCaseCurrentState(caseId?: string | undefined): Observable<AssistanceApplicationStateAuditViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationstateaudit/retrievecasecurrentstate?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCaseCurrentState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCaseCurrentState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationStateAuditViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationStateAuditViewModel>;
        }));
    }

    protected processRetrieveCaseCurrentState(response: HttpResponseBase): Observable<AssistanceApplicationStateAuditViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationStateAuditViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrievePagedAssistanceApplicationAudits(caseId?: string | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<PagedListOfAssistanceApplicationStateAuditListViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationstateaudit/retrievepagedassistanceapplicationaudits?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePagedAssistanceApplicationAudits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePagedAssistanceApplicationAudits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAssistanceApplicationStateAuditListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAssistanceApplicationStateAuditListViewModel>;
        }));
    }

    protected processRetrievePagedAssistanceApplicationAudits(response: HttpResponseBase): Observable<PagedListOfAssistanceApplicationStateAuditListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAssistanceApplicationStateAuditListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAssistanceApplicationStateAudit(assistanceApplicationStateAudit: AddAssistanceApplicationStateAuditViewModel): Observable<AssistanceApplicationStateAuditViewModel> {
        let url_ = this.baseUrl + "/api/v1/assistanceapplicationstateaudit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assistanceApplicationStateAudit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAssistanceApplicationStateAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAssistanceApplicationStateAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationStateAuditViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationStateAuditViewModel>;
        }));
    }

    protected processAddAssistanceApplicationStateAudit(response: HttpResponseBase): Observable<AssistanceApplicationStateAuditViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistanceApplicationStateAuditViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BannerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    banner(): Observable<Banner> {
        let url_ = this.baseUrl + "/api/v1/banner/banner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Banner>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Banner>;
        }));
    }

    protected processBanner(response: HttpResponseBase): Observable<Banner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Banner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    searchClients(searchType?: ClientSearchTypes | undefined, searchValue?: string | null | undefined, agencyId?: string | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<PagedListOfClient> {
        let url_ = this.baseUrl + "/api/v1/client/searchclients?";
        if (searchType === null)
            throw new globalThis.Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfClient>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfClient>;
        }));
    }

    protected processSearchClients(response: HttpResponseBase): Observable<PagedListOfClient> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfClient.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveClient(id?: string | undefined): Observable<Client> {
        let url_ = this.baseUrl + "/api/v1/client/retrieveclient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Client>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Client>;
        }));
    }

    protected processRetrieveClient(response: HttpResponseBase): Observable<Client> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Client.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyClient(id?: string | undefined): Observable<Client> {
        let url_ = this.baseUrl + "/api/v1/client/verifyclient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Client>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Client>;
        }));
    }

    protected processVerifyClient(response: HttpResponseBase): Observable<Client> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Client.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteClient(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/client/deleteclient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addClient(client: Client): Observable<Client> {
        let url_ = this.baseUrl + "/api/v1/client/addclient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Client>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Client>;
        }));
    }

    protected processAddClient(response: HttpResponseBase): Observable<Client> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Client.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClient(client: Client): Observable<Client> {
        let url_ = this.baseUrl + "/api/v1/client/updateclient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Client>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Client>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<Client> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Client.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clientUniqueSsnCheck(ssn?: string | null | undefined, id?: string | null | undefined): Observable<SimpleBooleanResult> {
        let url_ = this.baseUrl + "/api/v1/client/clientuniquessncheck?";
        if (ssn !== undefined && ssn !== null)
            url_ += "ssn=" + encodeURIComponent("" + ssn) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientUniqueSsnCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientUniqueSsnCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleBooleanResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleBooleanResult>;
        }));
    }

    protected processClientUniqueSsnCheck(response: HttpResponseBase): Observable<SimpleBooleanResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleBooleanResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mergeClients(parameters: MergeClientParameters): Observable<Client> {
        let url_ = this.baseUrl + "/api/v1/client/mergeclients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Client>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Client>;
        }));
    }

    protected processMergeClients(response: HttpResponseBase): Observable<Client> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Client.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exposeSsn(revealParams: ClientRevealSsnParams): Observable<SimpleStringResult> {
        let url_ = this.baseUrl + "/api/v1/client/exposessn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(revealParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExposeSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExposeSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleStringResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleStringResult>;
        }));
    }

    protected processExposeSsn(response: HttpResponseBase): Observable<SimpleStringResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleStringResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyAddressChangeRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    createRequest(request: CompanyAddressChangeRequestViewModel): Observable<CompanyAddressChangeRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/companyaddresschangerequest/createrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyAddressChangeRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyAddressChangeRequestViewModel>;
        }));
    }

    protected processCreateRequest(response: HttpResponseBase): Observable<CompanyAddressChangeRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyAddressChangeRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingRequests(limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfCompanyAddressChangeRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/companyaddresschangerequest/getpendingrequests?";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfCompanyAddressChangeRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfCompanyAddressChangeRequestViewModel>;
        }));
    }

    protected processGetPendingRequests(response: HttpResponseBase): Observable<PagedListOfCompanyAddressChangeRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfCompanyAddressChangeRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveRequest(id?: string | undefined): Observable<CompanyAddressChangeRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/companyaddresschangerequest/approverequest?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyAddressChangeRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyAddressChangeRequestViewModel>;
        }));
    }

    protected processApproveRequest(response: HttpResponseBase): Observable<CompanyAddressChangeRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyAddressChangeRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    denyRequest(id?: string | undefined): Observable<CompanyAddressChangeRequestViewModel> {
        let url_ = this.baseUrl + "/api/v1/companyaddresschangerequest/denyrequest?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenyRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenyRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyAddressChangeRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyAddressChangeRequestViewModel>;
        }));
    }

    protected processDenyRequest(response: HttpResponseBase): Observable<CompanyAddressChangeRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyAddressChangeRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getCompanyCategoryThresholds(applicationType?: AssistanceApplicationType | null | undefined): Observable<CompanyCategoryThresholdViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/companycategory/getcompanycategorythresholds?";
        if (applicationType !== undefined && applicationType !== null)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyCategoryThresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyCategoryThresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyCategoryThresholdViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyCategoryThresholdViewModel[]>;
        }));
    }

    protected processGetCompanyCategoryThresholds(response: HttpResponseBase): Observable<CompanyCategoryThresholdViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyCategoryThresholdViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addCompany(company: Company): Observable<Company> {
        let url_ = this.baseUrl + "/api/v1/company/addcompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(company);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company>;
        }));
    }

    protected processAddCompany(response: HttpResponseBase): Observable<Company> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkDuplicateCompany(name?: string | null | undefined, address?: string | null | undefined): Observable<DuplicateCompanyCheckResponse> {
        let url_ = this.baseUrl + "/api/v1/company/checkduplicatecompany?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuplicateCompanyCheckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuplicateCompanyCheckResponse>;
        }));
    }

    protected processCheckDuplicateCompany(response: HttpResponseBase): Observable<DuplicateCompanyCheckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuplicateCompanyCheckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCompany(company: Company): Observable<Company> {
        let url_ = this.baseUrl + "/api/v1/company/updatecompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(company);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company>;
        }));
    }

    protected processUpdateCompany(response: HttpResponseBase): Observable<Company> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCompanies(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/company/downloadcompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCompanies(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveCompaniesPaged(searchValue?: string | null | undefined, region?: string | null | undefined, includeDisabled?: boolean | undefined, categories?: CompanyCategoryType[] | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfCompany> {
        let url_ = this.baseUrl + "/api/v1/company/retrievecompaniespaged?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompaniesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompaniesPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfCompany>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfCompany>;
        }));
    }

    protected processRetrieveCompaniesPaged(response: HttpResponseBase): Observable<PagedListOfCompany> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfCompany.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveCompany(id?: string | undefined): Observable<Company> {
        let url_ = this.baseUrl + "/api/v1/company/retrievecompany?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company>;
        }));
    }

    protected processRetrieveCompany(response: HttpResponseBase): Observable<Company> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCompany(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/company/deletecompany?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getCountiesWithDefault(zipCode?: string | null | undefined, state?: string | null | undefined): Observable<CountyResult> {
        let url_ = this.baseUrl + "/api/v1/county/getcountieswithdefault?";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "zipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountiesWithDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountiesWithDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountyResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountyResult>;
        }));
    }

    protected processGetCountiesWithDefault(response: HttpResponseBase): Observable<CountyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountySpendingReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getCounties(): Observable<CountySelection[]> {
        let url_ = this.baseUrl + "/api/v1/countyspendingreport/getcounties";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountySelection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountySelection[]>;
        }));
    }

    protected processGetCounties(response: HttpResponseBase): Observable<CountySelection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountySelection.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewCountySpendingReport(parameters: CountySpendingReportParameter, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<PagedListOfCountySpendingReportPreview> {
        let url_ = this.baseUrl + "/api/v1/countyspendingreport/previewcountyspendingreport?";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewCountySpendingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewCountySpendingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfCountySpendingReportPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfCountySpendingReportPreview>;
        }));
    }

    protected processPreviewCountySpendingReport(response: HttpResponseBase): Observable<PagedListOfCountySpendingReportPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfCountySpendingReportPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCountySpendingReport(fundTypeIds?: string | null | undefined, isAllFundAdministrativeAgency?: boolean | undefined, countyName?: string | null | undefined, isallCounties?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/countyspendingreport/downloadcountyspendingreport?";
        if (fundTypeIds !== undefined && fundTypeIds !== null)
            url_ += "fundTypeIds=" + encodeURIComponent("" + fundTypeIds) + "&";
        if (isAllFundAdministrativeAgency === null)
            throw new globalThis.Error("The parameter 'isAllFundAdministrativeAgency' cannot be null.");
        else if (isAllFundAdministrativeAgency !== undefined)
            url_ += "isAllFundAdministrativeAgency=" + encodeURIComponent("" + isAllFundAdministrativeAgency) + "&";
        if (countyName !== undefined && countyName !== null)
            url_ += "countyName=" + encodeURIComponent("" + countyName) + "&";
        if (isallCounties === null)
            throw new globalThis.Error("The parameter 'isallCounties' cannot be null.");
        else if (isallCounties !== undefined)
            url_ += "isallCounties=" + encodeURIComponent("" + isallCounties) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCountySpendingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCountySpendingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCountySpendingReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemographicReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    detailReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfPledgeDemographicDetailReport> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/detailreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfPledgeDemographicDetailReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfPledgeDemographicDetailReport>;
        }));
    }

    protected processDetailReport(response: HttpResponseBase): Observable<PagedListOfPledgeDemographicDetailReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfPledgeDemographicDetailReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDetailReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/downloaddetailreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDetailReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countyReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<PledgeCountyReport[]> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/countyreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeCountyReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeCountyReport[]>;
        }));
    }

    protected processCountyReport(response: HttpResponseBase): Observable<PledgeCountyReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeCountyReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCountyReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/downloadcountyreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCountyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCountyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCountyReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    zipcodeReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<PledgeZipcodeReport[]> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/zipcodereport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZipcodeReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZipcodeReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeZipcodeReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeZipcodeReport[]>;
        }));
    }

    protected processZipcodeReport(response: HttpResponseBase): Observable<PledgeZipcodeReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeZipcodeReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadZipcodeReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/downloadzipcodereport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadZipcodeReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadZipcodeReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadZipcodeReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    summaryReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<PledgeDemographicSummaryReport> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/summaryreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeDemographicSummaryReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeDemographicSummaryReport>;
        }));
    }

    protected processSummaryReport(response: HttpResponseBase): Observable<PledgeDemographicSummaryReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeDemographicSummaryReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadSummaryReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/demographicreport/downloadsummaryreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSummaryReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DraftApplicationFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    uploadFiles(fileTypes?: string[] | null | undefined, draftApplicationId?: string | null | undefined, files?: FileParameter[] | null | undefined): Observable<DraftApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/draftapplicationfile/uploadfiles?";
        if (fileTypes !== undefined && fileTypes !== null)
            fileTypes && fileTypes.forEach(item => { url_ += "fileTypes=" + encodeURIComponent("" + item) + "&"; });
        if (draftApplicationId !== undefined && draftApplicationId !== null)
            url_ += "draftApplicationId=" + encodeURIComponent("" + draftApplicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftApplicationFile[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<DraftApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DraftApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFilesByDraftId(draftApplicationId?: string | undefined): Observable<DraftApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/draftapplicationfile/getfilesbydraftid?";
        if (draftApplicationId === null)
            throw new globalThis.Error("The parameter 'draftApplicationId' cannot be null.");
        else if (draftApplicationId !== undefined)
            url_ += "draftApplicationId=" + encodeURIComponent("" + draftApplicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesByDraftId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesByDraftId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftApplicationFile[]>;
        }));
    }

    protected processGetFilesByDraftId(response: HttpResponseBase): Observable<DraftApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DraftApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/draftapplicationfile/getfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/draftapplicationfile/deletefile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    migrateToCase(draftApplicationId?: string | undefined, assistanceApplicationId?: string | undefined): Observable<AssistanceApplicationFile[]> {
        let url_ = this.baseUrl + "/api/v1/draftapplicationfile/migratetocase?";
        if (draftApplicationId === null)
            throw new globalThis.Error("The parameter 'draftApplicationId' cannot be null.");
        else if (draftApplicationId !== undefined)
            url_ += "draftApplicationId=" + encodeURIComponent("" + draftApplicationId) + "&";
        if (assistanceApplicationId === null)
            throw new globalThis.Error("The parameter 'assistanceApplicationId' cannot be null.");
        else if (assistanceApplicationId !== undefined)
            url_ += "assistanceApplicationId=" + encodeURIComponent("" + assistanceApplicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateToCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateToCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationFile[]>;
        }));
    }

    protected processMigrateToCase(response: HttpResponseBase): Observable<AssistanceApplicationFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistanceApplicationFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EfnCommentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addEfnCaseComment(newCaseComment: EfnCaseComment): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/efncomments/addefncasecomment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCaseComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEfnCaseComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEfnCaseComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddEfnCaseComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEfnCommentsByEfnCaseId(caseId?: string | undefined): Observable<EfnCaseComment[]> {
        let url_ = this.baseUrl + "/api/v1/efncomments/getefncommentsbyefncaseid?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfnCommentsByEfnCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfnCommentsByEfnCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCaseComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCaseComment[]>;
        }));
    }

    protected processGetEfnCommentsByEfnCaseId(response: HttpResponseBase): Observable<EfnCaseComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfnCaseComment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EfnClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addEfnCase(newCase: EfnCase): Observable<EfnCase> {
        let url_ = this.baseUrl + "/api/v1/efn/addefncase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCase);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEfnCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEfnCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCase>;
        }));
    }

    protected processAddEfnCase(response: HttpResponseBase): Observable<EfnCase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EfnCase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEfnCase(updatedCase: EfnCase): Observable<EfnCase> {
        let url_ = this.baseUrl + "/api/v1/efn/updateefncase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedCase);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEfnCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEfnCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCase>;
        }));
    }

    protected processUpdateEfnCase(response: HttpResponseBase): Observable<EfnCase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EfnCase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commitEfnCase(parameters: CommitEfnCaseParameters): Observable<AgencyEfnCase> {
        let url_ = this.baseUrl + "/api/v1/efn/commitefncase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommitEfnCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommitEfnCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyEfnCase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyEfnCase>;
        }));
    }

    protected processCommitEfnCase(response: HttpResponseBase): Observable<AgencyEfnCase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyEfnCase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    declineEfnCase(parameters: DeclineEfnCaseParameters): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/efn/declineefncase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineEfnCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineEfnCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeclineEfnCase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEfnCasesByClient(id?: string | undefined): Observable<EfnCase[]> {
        let url_ = this.baseUrl + "/api/v1/efn/getefncasesbyclient/getefncasesbyclient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfnCasesByClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfnCasesByClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCase[]>;
        }));
    }

    protected processGetEfnCasesByClient(response: HttpResponseBase): Observable<EfnCase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfnCase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOpenEfnCasesByAgencyId(id?: string | undefined): Observable<EfnCase[]> {
        let url_ = this.baseUrl + "/api/v1/efn/getopenefncasesbyagencyid/getopenefncasesbyagencyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenEfnCasesByAgencyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenEfnCasesByAgencyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCase[]>;
        }));
    }

    protected processGetOpenEfnCasesByAgencyId(response: HttpResponseBase): Observable<EfnCase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfnCase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFundedEfnCasesByAgencyId(id?: string | undefined): Observable<EfnCase[]> {
        let url_ = this.baseUrl + "/api/v1/efn/getfundedefncasesbyagencyid/getfundedefncasesbyagencyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundedEfnCasesByAgencyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundedEfnCasesByAgencyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCase[]>;
        }));
    }

    protected processGetFundedEfnCasesByAgencyId(response: HttpResponseBase): Observable<EfnCase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfnCase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEfnCasesPaged(searchValue?: string | null | undefined, agencyId?: string | null | undefined, status?: EfnCaseStatusType | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfEfnCase> {
        let url_ = this.baseUrl + "/api/v1/efn/getefncasespaged?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfnCasesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfnCasesPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfEfnCase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfEfnCase>;
        }));
    }

    protected processGetEfnCasesPaged(response: HttpResponseBase): Observable<PagedListOfEfnCase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfEfnCase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEfnCase(id?: string | undefined): Observable<EfnCase> {
        let url_ = this.baseUrl + "/api/v1/efn/getefncase?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfnCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfnCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCase>;
        }));
    }

    protected processGetEfnCase(response: HttpResponseBase): Observable<EfnCase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EfnCase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgencyEfnCasesByEfnCaseId(efnCaseId?: string | undefined): Observable<AgencyEfnCase[]> {
        let url_ = this.baseUrl + "/api/v1/efn/getagencyefncasesbyefncaseid?";
        if (efnCaseId === null)
            throw new globalThis.Error("The parameter 'efnCaseId' cannot be null.");
        else if (efnCaseId !== undefined)
            url_ += "efnCaseId=" + encodeURIComponent("" + efnCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyEfnCasesByEfnCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyEfnCasesByEfnCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyEfnCase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyEfnCase[]>;
        }));
    }

    protected processGetAgencyEfnCasesByEfnCaseId(response: HttpResponseBase): Observable<AgencyEfnCase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgencyEfnCase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inviteAgency(args: InviteAgencyParams): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/efn/inviteagency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInviteAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAgencyEfn(agencyEfnCaseId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/efn/removeagencyefn?";
        if (agencyEfnCaseId === null)
            throw new globalThis.Error("The parameter 'agencyEfnCaseId' cannot be null.");
        else if (agencyEfnCaseId !== undefined)
            url_ += "agencyEfnCaseId=" + encodeURIComponent("" + agencyEfnCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAgencyEfn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAgencyEfn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAgencyEfn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isCaseCountyActive(county?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/efn/iscasecountyactive/iscasecountyactive?";
        if (county !== undefined && county !== null)
            url_ += "county=" + encodeURIComponent("" + county) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCaseCountyActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCaseCountyActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCaseCountyActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EfnFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    uploadEfnFile(efnCaseId?: string | undefined, uploadFile?: FileParameter | null | undefined): Observable<EfnCaseFile> {
        let url_ = this.baseUrl + "/api/v1/efnfile/uploadefnfile?";
        if (efnCaseId === null)
            throw new globalThis.Error("The parameter 'efnCaseId' cannot be null.");
        else if (efnCaseId !== undefined)
            url_ += "efnCaseId=" + encodeURIComponent("" + efnCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile !== null && uploadFile !== undefined)
            content_.append("uploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "uploadFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadEfnFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadEfnFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCaseFile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCaseFile>;
        }));
    }

    protected processUploadEfnFile(response: HttpResponseBase): Observable<EfnCaseFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EfnCaseFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEfnFileByEfnCaseId(efnCaseId?: string | undefined): Observable<EfnCaseFile[]> {
        let url_ = this.baseUrl + "/api/v1/efnfile/getefnfilebyefncaseid?";
        if (efnCaseId === null)
            throw new globalThis.Error("The parameter 'efnCaseId' cannot be null.");
        else if (efnCaseId !== undefined)
            url_ += "efnCaseId=" + encodeURIComponent("" + efnCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfnFileByEfnCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfnFileByEfnCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfnCaseFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfnCaseFile[]>;
        }));
    }

    protected processGetEfnFileByEfnCaseId(response: HttpResponseBase): Observable<EfnCaseFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfnCaseFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEfnFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/efnfile/getefnfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfnFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfnFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetEfnFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEfnFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/efnfile/deleteefnfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEfnFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEfnFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteEfnFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EfsAssistanceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addEfsAssistance(assistance: Efs): Observable<Efs> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/addefsassistance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assistance);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEfsAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEfsAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Efs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Efs>;
        }));
    }

    protected processAddEfsAssistance(response: HttpResponseBase): Observable<Efs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Efs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEfsAssistance(assistance: Efs): Observable<Efs> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/updateefsassistance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assistance);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEfsAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEfsAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Efs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Efs>;
        }));
    }

    protected processUpdateEfsAssistance(response: HttpResponseBase): Observable<Efs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Efs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEfs(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/deleteefs?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEfs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEfs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteEfs(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveEfsAssistances(): Observable<Efs[]> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/retrieveefsassistances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEfsAssistances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEfsAssistances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Efs[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Efs[]>;
        }));
    }

    protected processRetrieveEfsAssistances(response: HttpResponseBase): Observable<Efs[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Efs.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveEfsAssistance(id?: string | undefined): Observable<Efs> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/retrieveefsassistance?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEfsAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEfsAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Efs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Efs>;
        }));
    }

    protected processRetrieveEfsAssistance(response: HttpResponseBase): Observable<Efs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Efs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveEfsAssistancesPaged(searchValue?: string | null | undefined, assistanceType?: string | null | undefined, agencyId?: string | null | undefined, clientId?: string | null | undefined): Observable<PagedListOfEfs> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/retrieveefsassistancespaged?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (assistanceType !== undefined && assistanceType !== null)
            url_ += "assistanceType=" + encodeURIComponent("" + assistanceType) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEfsAssistancesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEfsAssistancesPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfEfs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfEfs>;
        }));
    }

    protected processRetrieveEfsAssistancesPaged(response: HttpResponseBase): Observable<PagedListOfEfs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfEfs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveClientsEfsAssistances(id?: string | undefined, pledgeTypeId?: string | null | undefined): Observable<Efs[]> {
        let url_ = this.baseUrl + "/api/v1/efsassistance/retrieveclientsefsassistances?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveClientsEfsAssistances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveClientsEfsAssistances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Efs[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Efs[]>;
        }));
    }

    protected processRetrieveClientsEfsAssistances(response: HttpResponseBase): Observable<Efs[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Efs.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EfsReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    buildEfsReport(pledgeTypeId?: string | null | undefined, agencyId?: string | null | undefined): Observable<EfsReport[]> {
        let url_ = this.baseUrl + "/api/v1/efsreport/buildefsreport?";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildEfsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildEfsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfsReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfsReport[]>;
        }));
    }

    protected processBuildEfsReport(response: HttpResponseBase): Observable<EfsReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfsReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadEfsReport(pledgeTypeId?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/efsreport/downloadefsreport?";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEfsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEfsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadEfsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FederalPovertyLevelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addFederalPovertyLevel(federalPovertyLevel: FederalPovertyLevel): Observable<FederalPovertyLevel> {
        let url_ = this.baseUrl + "/api/v1/federalpovertylevel/addfederalpovertylevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(federalPovertyLevel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFederalPovertyLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFederalPovertyLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FederalPovertyLevel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FederalPovertyLevel>;
        }));
    }

    protected processAddFederalPovertyLevel(response: HttpResponseBase): Observable<FederalPovertyLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederalPovertyLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFederalPovertyLevel(federalPovertyLevel: FederalPovertyLevel): Observable<FederalPovertyLevel> {
        let url_ = this.baseUrl + "/api/v1/federalpovertylevel/updatefederalpovertylevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(federalPovertyLevel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFederalPovertyLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFederalPovertyLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FederalPovertyLevel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FederalPovertyLevel>;
        }));
    }

    protected processUpdateFederalPovertyLevel(response: HttpResponseBase): Observable<FederalPovertyLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederalPovertyLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveFederalPovertyLevels(): Observable<FederalPovertyLevel[]> {
        let url_ = this.baseUrl + "/api/v1/federalpovertylevel/retrievefederalpovertylevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFederalPovertyLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFederalPovertyLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FederalPovertyLevel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FederalPovertyLevel[]>;
        }));
    }

    protected processRetrieveFederalPovertyLevels(response: HttpResponseBase): Observable<FederalPovertyLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FederalPovertyLevel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveFederalPovertyLevel(id?: string | undefined): Observable<FederalPovertyLevel> {
        let url_ = this.baseUrl + "/api/v1/federalpovertylevel/retrievefederalpovertylevel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFederalPovertyLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFederalPovertyLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FederalPovertyLevel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FederalPovertyLevel>;
        }));
    }

    protected processRetrieveFederalPovertyLevel(response: HttpResponseBase): Observable<FederalPovertyLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederalPovertyLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateFederalPovertyLevel(familySize?: number | null | undefined, monthlyIncome?: number | null | undefined): Observable<SimpleDecimalResult> {
        let url_ = this.baseUrl + "/api/v1/federalpovertylevel/calculatefederalpovertylevel?";
        if (familySize !== undefined && familySize !== null)
            url_ += "familySize=" + encodeURIComponent("" + familySize) + "&";
        if (monthlyIncome !== undefined && monthlyIncome !== null)
            url_ += "monthlyIncome=" + encodeURIComponent("" + monthlyIncome) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateFederalPovertyLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFederalPovertyLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleDecimalResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleDecimalResult>;
        }));
    }

    protected processCalculateFederalPovertyLevel(response: HttpResponseBase): Observable<SimpleDecimalResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleDecimalResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FundTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getFundTypeId(fundName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/fundtype/getfundtypeid?";
        if (fundName !== undefined && fundName !== null)
            url_ += "fundName=" + encodeURIComponent("" + fundName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFundTypeId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFundAdministrativeAgencyFundTypes(): Observable<FundTypeSelection[]> {
        let url_ = this.baseUrl + "/api/v1/fundtype/getfundadministrativeagencyfundtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundAdministrativeAgencyFundTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundAdministrativeAgencyFundTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundTypeSelection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundTypeSelection[]>;
        }));
    }

    protected processGetFundAdministrativeAgencyFundTypes(response: HttpResponseBase): Observable<FundTypeSelection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FundTypeSelection.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleFundTypes(): Observable<FundTypeSelection[]> {
        let url_ = this.baseUrl + "/api/v1/fundtype/getrolefundtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleFundTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleFundTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundTypeSelection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundTypeSelection[]>;
        }));
    }

    protected processGetRoleFundTypes(response: HttpResponseBase): Observable<FundTypeSelection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FundTypeSelection.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatusesByAssistanceApplicationType(assistanceApplicationType?: AssistanceApplicationType | undefined): Observable<AssistanceApplicationStatus[]> {
        let url_ = this.baseUrl + "/api/v1/fundtype/getstatusesbyassistanceapplicationtype?";
        if (assistanceApplicationType === null)
            throw new globalThis.Error("The parameter 'assistanceApplicationType' cannot be null.");
        else if (assistanceApplicationType !== undefined)
            url_ += "assistanceApplicationType=" + encodeURIComponent("" + assistanceApplicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusesByAssistanceApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusesByAssistanceApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistanceApplicationStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistanceApplicationStatus[]>;
        }));
    }

    protected processGetStatusesByAssistanceApplicationType(response: HttpResponseBase): Observable<AssistanceApplicationStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPledgeTypesByAssistanceApplicationType(assistanceApplicationType?: AssistanceApplicationType | undefined, agencyId?: string | null | undefined): Observable<FundTypeSelection[]> {
        let url_ = this.baseUrl + "/api/v1/fundtype/getpledgetypesbyassistanceapplicationtype?";
        if (assistanceApplicationType === null)
            throw new globalThis.Error("The parameter 'assistanceApplicationType' cannot be null.");
        else if (assistanceApplicationType !== undefined)
            url_ += "assistanceApplicationType=" + encodeURIComponent("" + assistanceApplicationType) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPledgeTypesByAssistanceApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPledgeTypesByAssistanceApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundTypeSelection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundTypeSelection[]>;
        }));
    }

    protected processGetPledgeTypesByAssistanceApplicationType(response: HttpResponseBase): Observable<FundTypeSelection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FundTypeSelection.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InternalDraftApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    save(request: SaveInternalDraftRequest, existingDraftId?: string | null | undefined): Observable<InternalDraftApplicationViewModel> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/save?";
        if (existingDraftId !== undefined && existingDraftId !== null)
            url_ += "existingDraftId=" + encodeURIComponent("" + existingDraftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalDraftApplicationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalDraftApplicationViewModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<InternalDraftApplicationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalDraftApplicationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id?: string | undefined): Observable<InternalDraftApplicationViewModel> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/getbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalDraftApplicationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalDraftApplicationViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<InternalDraftApplicationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalDraftApplicationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByClientAndType(clientId?: string | undefined, applicationType?: AssistanceApplicationType | undefined): Observable<InternalDraftApplicationViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/getbyclientandtype?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByClientAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByClientAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalDraftApplicationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalDraftApplicationViewModel[]>;
        }));
    }

    protected processGetByClientAndType(response: HttpResponseBase): Observable<InternalDraftApplicationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InternalDraftApplicationViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(applicationType?: AssistanceApplicationType | undefined, searchValue?: string | null | undefined, agencyId?: string | null | undefined, managingAgencyId?: string | null | undefined, fundTypeIds?: string[] | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfInternalDraftListPreview> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/search?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (managingAgencyId !== undefined && managingAgencyId !== null)
            url_ += "managingAgencyId=" + encodeURIComponent("" + managingAgencyId) + "&";
        if (fundTypeIds !== undefined && fundTypeIds !== null)
            fundTypeIds && fundTypeIds.forEach(item => { url_ += "fundTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfInternalDraftListPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfInternalDraftListPreview>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedListOfInternalDraftListPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfInternalDraftListPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCount(applicationType?: AssistanceApplicationType | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/getcount?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exposeSsn(revealParams: DraftRevealSsnParams): Observable<SimpleStringResult> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/exposessn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(revealParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExposeSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExposeSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleStringResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleStringResult>;
        }));
    }

    protected processExposeSsn(response: HttpResponseBase): Observable<SimpleStringResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleStringResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/internaldraftapplication/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class KcApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addKcApplication(application: KcApplication): Observable<KcApplication> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/addkcapplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddKcApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKcApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcApplication>;
        }));
    }

    protected processAddKcApplication(response: HttpResponseBase): Observable<KcApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateKcApplication(application: KcApplication): Observable<KcApplication> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/updatekcapplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateKcApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKcApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcApplication>;
        }));
    }

    protected processUpdateKcApplication(response: HttpResponseBase): Observable<KcApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createApplicationEnrollment(application: KcApplication): Observable<KcApplication> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/createapplicationenrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateApplicationEnrollment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateApplicationEnrollment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcApplication>;
        }));
    }

    protected processCreateApplicationEnrollment(response: HttpResponseBase): Observable<KcApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveKcApplicationsByClientId(id?: string | undefined): Observable<KcApplication[]> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/retrievekcapplicationsbyclientid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveKcApplicationsByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveKcApplicationsByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcApplication[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcApplication[]>;
        }));
    }

    protected processRetrieveKcApplicationsByClientId(response: HttpResponseBase): Observable<KcApplication[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KcApplication.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncompleteOrApprovedApplication(id?: string | undefined): Observable<KcApplication> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/getincompleteorapprovedapplication?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncompleteOrApprovedApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncompleteOrApprovedApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcApplication>;
        }));
    }

    protected processGetIncompleteOrApprovedApplication(response: HttpResponseBase): Observable<KcApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveKcApplication(id?: string | undefined): Observable<KcApplicationResult> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/retrievekcapplication?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveKcApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveKcApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcApplicationResult>;
        }));
    }

    protected processRetrieveKcApplication(response: HttpResponseBase): Observable<KcApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcApplicationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveKcPrograms(povertyLevel?: number | undefined): Observable<KcProgram[]> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/retrievekcprograms?";
        if (povertyLevel === null)
            throw new globalThis.Error("The parameter 'povertyLevel' cannot be null.");
        else if (povertyLevel !== undefined)
            url_ += "povertyLevel=" + encodeURIComponent("" + povertyLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveKcPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveKcPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcProgram[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcProgram[]>;
        }));
    }

    protected processRetrieveKcPrograms(response: HttpResponseBase): Observable<KcProgram[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KcProgram.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveKcApplicationsPaged(searchValueAccount?: string | null | undefined, searchValueSSN?: string | null | undefined, agencyId?: string | null | undefined, statusId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfKcApplication> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/retrievekcapplicationspaged?";
        if (searchValueAccount !== undefined && searchValueAccount !== null)
            url_ += "searchValueAccount=" + encodeURIComponent("" + searchValueAccount) + "&";
        if (searchValueSSN !== undefined && searchValueSSN !== null)
            url_ += "searchValueSSN=" + encodeURIComponent("" + searchValueSSN) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveKcApplicationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveKcApplicationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfKcApplication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfKcApplication>;
        }));
    }

    protected processRetrieveKcApplicationsPaged(response: HttpResponseBase): Observable<PagedListOfKcApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfKcApplication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getKeepingCurrentNotes(applicationId?: string | undefined): Observable<KcNoteResult[]> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/getkeepingcurrentnotes?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKeepingCurrentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeepingCurrentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcNoteResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcNoteResult[]>;
        }));
    }

    protected processGetKeepingCurrentNotes(response: HttpResponseBase): Observable<KcNoteResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KcNoteResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addKcNote(note: KcNote): Observable<KcNote> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/addkcnote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddKcNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKcNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcNote>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcNote>;
        }));
    }

    protected processAddKcNote(response: HttpResponseBase): Observable<KcNote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcNote.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteNoteById(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/deletenotebyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNoteById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProgramDetails(programId?: string | undefined, federalPovertyLevel?: number | undefined): Observable<KcProgramLevel> {
        let url_ = this.baseUrl + "/api/v1/kcapplication/getprogramdetails?";
        if (programId === null)
            throw new globalThis.Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (federalPovertyLevel === null)
            throw new globalThis.Error("The parameter 'federalPovertyLevel' cannot be null.");
        else if (federalPovertyLevel !== undefined)
            url_ += "federalPovertyLevel=" + encodeURIComponent("" + federalPovertyLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KcProgramLevel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KcProgramLevel>;
        }));
    }

    protected processGetProgramDetails(response: HttpResponseBase): Observable<KcProgramLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KcProgramLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class KeepingCurrentReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    buildConfirmOrphanReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, agencyId?: string | null | undefined): Observable<ConfirmOrphanReport[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildconfirmorphanreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildConfirmOrphanReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildConfirmOrphanReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmOrphanReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmOrphanReport[]>;
        }));
    }

    protected processBuildConfirmOrphanReport(response: HttpResponseBase): Observable<ConfirmOrphanReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfirmOrphanReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadConfirmOrphanReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/downloadconfirmorphanreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadConfirmOrphanReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadConfirmOrphanReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadConfirmOrphanReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildMissedPaymentReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, agencyId?: string | null | undefined): Observable<MissedPaymentReport[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildmissedpaymentreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildMissedPaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildMissedPaymentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissedPaymentReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissedPaymentReport[]>;
        }));
    }

    protected processBuildMissedPaymentReport(response: HttpResponseBase): Observable<MissedPaymentReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissedPaymentReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadMissedPaymentReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/downloadmissedpaymentreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMissedPaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMissedPaymentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMissedPaymentReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildEnrollmentReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, agencyId?: string | null | undefined, statusId?: string | null | undefined): Observable<EnrollmentReport[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildenrollmentreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildEnrollmentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildEnrollmentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnrollmentReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnrollmentReport[]>;
        }));
    }

    protected processBuildEnrollmentReport(response: HttpResponseBase): Observable<EnrollmentReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnrollmentReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadEnrollmentReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, agencyId?: string | null | undefined, statusId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/downloadenrollmentreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEnrollmentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEnrollmentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadEnrollmentReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param exportDate (optional) 
     * @deprecated
     */
    buildEnrollmentsDownloadReport(exportDate?: Date | null | undefined): Observable<EnrollmentDownload[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildenrollmentsdownloadreport?";
        if (exportDate !== undefined && exportDate !== null)
            url_ += "exportDate=" + encodeURIComponent(exportDate ? "" + exportDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildEnrollmentsDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildEnrollmentsDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnrollmentDownload[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnrollmentDownload[]>;
        }));
    }

    protected processBuildEnrollmentsDownloadReport(response: HttpResponseBase): Observable<EnrollmentDownload[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnrollmentDownload.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildApprovedEnrollmentsReport(exportDate?: Date | undefined): Observable<ApprovedEnrollment[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildapprovedenrollmentsreport?";
        if (exportDate === null)
            throw new globalThis.Error("The parameter 'exportDate' cannot be null.");
        else if (exportDate !== undefined)
            url_ += "exportDate=" + encodeURIComponent(exportDate ? "" + exportDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildApprovedEnrollmentsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildApprovedEnrollmentsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedEnrollment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedEnrollment[]>;
        }));
    }

    protected processBuildApprovedEnrollmentsReport(response: HttpResponseBase): Observable<ApprovedEnrollment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovedEnrollment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildBudgetBillingReport(monthYear?: string | null | undefined, agencyId?: string | null | undefined): Observable<BudgetBillingReport[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildbudgetbillingreport?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildBudgetBillingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildBudgetBillingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BudgetBillingReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BudgetBillingReport[]>;
        }));
    }

    protected processBuildBudgetBillingReport(response: HttpResponseBase): Observable<BudgetBillingReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetBillingReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadBudgetBillingReport(monthYear?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/downloadbudgetbillingreport?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBudgetBillingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBudgetBillingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBudgetBillingReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildCompletionReport(startMonthYear?: string | null | undefined, endMonthYear?: string | null | undefined, agencyId?: string | null | undefined): Observable<CompletionReport[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/buildcompletionreport?";
        if (startMonthYear !== undefined && startMonthYear !== null)
            url_ += "startMonthYear=" + encodeURIComponent("" + startMonthYear) + "&";
        if (endMonthYear !== undefined && endMonthYear !== null)
            url_ += "endMonthYear=" + encodeURIComponent("" + endMonthYear) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildCompletionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildCompletionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletionReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletionReport[]>;
        }));
    }

    protected processBuildCompletionReport(response: HttpResponseBase): Observable<CompletionReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompletionReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCompletionReport(startMonthYear?: string | null | undefined, endMonthYear?: string | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/downloadcompletionreport?";
        if (startMonthYear !== undefined && startMonthYear !== null)
            url_ += "startMonthYear=" + encodeURIComponent("" + startMonthYear) + "&";
        if (endMonthYear !== undefined && endMonthYear !== null)
            url_ += "endMonthYear=" + encodeURIComponent("" + endMonthYear) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCompletionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCompletionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCompletionReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadApprovedEnrollmentsReport(exportDate?: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/downloadapprovedenrollmentsreport?";
        if (exportDate === null)
            throw new globalThis.Error("The parameter 'exportDate' cannot be null.");
        else if (exportDate !== undefined)
            url_ += "exportDate=" + encodeURIComponent(exportDate ? "" + exportDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApprovedEnrollmentsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApprovedEnrollmentsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadApprovedEnrollmentsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedEnrollmentHistory(): Observable<ApprovedEnrollmentHistory[]> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/getapprovedenrollmenthistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedEnrollmentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedEnrollmentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedEnrollmentHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedEnrollmentHistory[]>;
        }));
    }

    protected processGetApprovedEnrollmentHistory(response: HttpResponseBase): Observable<ApprovedEnrollmentHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovedEnrollmentHistory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDownloadTimeStampForApprovalRecordedApplications(): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/keepingcurrentreport/setdownloadtimestampforapprovalrecordedapplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDownloadTimeStampForApprovalRecordedApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDownloadTimeStampForApprovalRecordedApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDownloadTimeStampForApprovalRecordedApplications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LookUpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addLookUp(lookup: LookUp): Observable<LookUp> {
        let url_ = this.baseUrl + "/api/v1/lookup/addlookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLookUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLookUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUp>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUp>;
        }));
    }

    protected processAddLookUp(response: HttpResponseBase): Observable<LookUp> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookUp.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLookUp(lookup: LookUp): Observable<LookUp> {
        let url_ = this.baseUrl + "/api/v1/lookup/updatelookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLookUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLookUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUp>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUp>;
        }));
    }

    protected processUpdateLookUp(response: HttpResponseBase): Observable<LookUp> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookUp.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLookUp(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/lookup/deletelookup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLookUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLookUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteLookUp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveLookUps(categoryType?: LookUpCategoryType | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfLookUp> {
        let url_ = this.baseUrl + "/api/v1/lookup/retrievelookups?";
        if (categoryType === null)
            throw new globalThis.Error("The parameter 'categoryType' cannot be null.");
        else if (categoryType !== undefined)
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLookUps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLookUps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfLookUp>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfLookUp>;
        }));
    }

    protected processRetrieveLookUps(response: HttpResponseBase): Observable<PagedListOfLookUp> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfLookUp.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MailUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    mailUsers(parameters: MailUsersParameters): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/mailusers/mailusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMailUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentProcessingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    buildCompanyMailingLabels(displayPledgeStatus?: PledgeStatusType | null | undefined, shiftPledgeStatus?: PledgeStatusType | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeId?: string | null | undefined, pledgeTypeIds?: string[] | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined, entryDate?: Date | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfCompanyMailingReport> {
        let url_ = this.baseUrl + "/api/v1/paymentprocessing/buildcompanymailinglabels?";
        if (displayPledgeStatus !== undefined && displayPledgeStatus !== null)
            url_ += "DisplayPledgeStatus=" + encodeURIComponent("" + displayPledgeStatus) + "&";
        if (shiftPledgeStatus !== undefined && shiftPledgeStatus !== null)
            url_ += "ShiftPledgeStatus=" + encodeURIComponent("" + shiftPledgeStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "PledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "PledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (entryDate !== undefined && entryDate !== null)
            url_ += "EntryDate=" + encodeURIComponent(entryDate ? "" + entryDate.toISOString() : "") + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildCompanyMailingLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildCompanyMailingLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfCompanyMailingReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfCompanyMailingReport>;
        }));
    }

    protected processBuildCompanyMailingLabels(response: HttpResponseBase): Observable<PagedListOfCompanyMailingReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfCompanyMailingReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCompanyMailingLabels(displayPledgeStatus?: PledgeStatusType | null | undefined, shiftPledgeStatus?: PledgeStatusType | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeId?: string | null | undefined, pledgeTypeIds?: string[] | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined, entryDate?: Date | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/paymentprocessing/downloadcompanymailinglabels?";
        if (displayPledgeStatus !== undefined && displayPledgeStatus !== null)
            url_ += "DisplayPledgeStatus=" + encodeURIComponent("" + displayPledgeStatus) + "&";
        if (shiftPledgeStatus !== undefined && shiftPledgeStatus !== null)
            url_ += "ShiftPledgeStatus=" + encodeURIComponent("" + shiftPledgeStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "PledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "PledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (entryDate !== undefined && entryDate !== null)
            url_ += "EntryDate=" + encodeURIComponent(entryDate ? "" + entryDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCompanyMailingLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCompanyMailingLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCompanyMailingLabels(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildShiftPledgeReport(displayPledgeStatus?: PledgeStatusType | null | undefined, shiftPledgeStatus?: PledgeStatusType | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeId?: string | null | undefined, pledgeTypeIds?: string[] | null | undefined, companyId?: string | null | undefined, agencyId?: string | null | undefined, entryDate?: Date | null | undefined): Observable<ShiftPledgeReportSummary[]> {
        let url_ = this.baseUrl + "/api/v1/paymentprocessing/buildshiftpledgereport?";
        if (displayPledgeStatus !== undefined && displayPledgeStatus !== null)
            url_ += "DisplayPledgeStatus=" + encodeURIComponent("" + displayPledgeStatus) + "&";
        if (shiftPledgeStatus !== undefined && shiftPledgeStatus !== null)
            url_ += "ShiftPledgeStatus=" + encodeURIComponent("" + shiftPledgeStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "PledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "PledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (entryDate !== undefined && entryDate !== null)
            url_ += "EntryDate=" + encodeURIComponent(entryDate ? "" + entryDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildShiftPledgeReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildShiftPledgeReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftPledgeReportSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftPledgeReportSummary[]>;
        }));
    }

    protected processBuildShiftPledgeReport(response: HttpResponseBase): Observable<ShiftPledgeReportSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftPledgeReportSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePledgeStatus(reportParams: PledgeReportParams): Observable<SimpleBooleanResult> {
        let url_ = this.baseUrl + "/api/v1/paymentprocessing/changepledgestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePledgeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePledgeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleBooleanResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleBooleanResult>;
        }));
    }

    protected processChangePledgeStatus(response: HttpResponseBase): Observable<SimpleBooleanResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleBooleanResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    buildProcessingSummaryReport(reportParams: PledgeReportParams): Observable<PagedListOfProcessingReport> {
        let url_ = this.baseUrl + "/api/v1/paymentprocessing/buildprocessingsummaryreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildProcessingSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildProcessingSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfProcessingReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfProcessingReport>;
        }));
    }

    protected processBuildProcessingSummaryReport(response: HttpResponseBase): Observable<PagedListOfProcessingReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfProcessingReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadProcessingSummaryReport(reportParams: PledgeReportParams): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/paymentprocessing/downloadprocessingsummaryreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProcessingSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProcessingSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProcessingSummaryReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PledgeBulkPaymentReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getPledgeCountForStatus(): Observable<PledgeBulkPaymentReport[]> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/getpledgecountforstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPledgeCountForStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPledgeCountForStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeBulkPaymentReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeBulkPaymentReport[]>;
        }));
    }

    protected processGetPledgeCountForStatus(response: HttpResponseBase): Observable<PledgeBulkPaymentReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeBulkPaymentReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBulkPaymentBatch(filters: PledgeBulkPaymentBatchParameters): Observable<PledgeBulkPaymentCreateBatchResponse> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/createbulkpaymentbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBulkPaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBulkPaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeBulkPaymentCreateBatchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeBulkPaymentCreateBatchResponse>;
        }));
    }

    protected processCreateBulkPaymentBatch(response: HttpResponseBase): Observable<PledgeBulkPaymentCreateBatchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeBulkPaymentCreateBatchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkPayPledges(parameters: BulkPaymentPayPledgeParameters): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/bulkpaypledges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkPayPledges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkPayPledges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkPayPledges(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkPaymentPdfData(parameters: BulkPaymentPdfParameters): Observable<PledgeBulkPaymentVendorSummaryViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/getbulkpaymentpdfdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkPaymentPdfData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkPaymentPdfData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeBulkPaymentVendorSummaryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeBulkPaymentVendorSummaryViewModel[]>;
        }));
    }

    protected processGetBulkPaymentPdfData(response: HttpResponseBase): Observable<PledgeBulkPaymentVendorSummaryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeBulkPaymentVendorSummaryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkPaymentReports(): Observable<PledgeBulkPaymentReport[]> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/getbulkpaymentreports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkPaymentReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkPaymentReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeBulkPaymentReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeBulkPaymentReport[]>;
        }));
    }

    protected processGetBulkPaymentReports(response: HttpResponseBase): Observable<PledgeBulkPaymentReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeBulkPaymentReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPledgeCount(filters: PledgeBulkPaymentBatchParameters): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/getpledgecount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPledgeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPledgeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPledgeCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBatch(batchId: string, overridePaidStatus?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/{batchId}?";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (overridePaidStatus === null)
            throw new globalThis.Error("The parameter 'overridePaidStatus' cannot be null.");
        else if (overridePaidStatus !== undefined)
            url_ += "overridePaidStatus=" + encodeURIComponent("" + overridePaidStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteBatch(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkPaymentBatchPreviews(shouldShowPaidPledges?: boolean | undefined): Observable<PledgeBulkPaymentBatchPreview[]> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/getbulkpaymentbatchpreviews?";
        if (shouldShowPaidPledges === null)
            throw new globalThis.Error("The parameter 'shouldShowPaidPledges' cannot be null.");
        else if (shouldShowPaidPledges !== undefined)
            url_ += "shouldShowPaidPledges=" + encodeURIComponent("" + shouldShowPaidPledges) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkPaymentBatchPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkPaymentBatchPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeBulkPaymentBatchPreview[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeBulkPaymentBatchPreview[]>;
        }));
    }

    protected processGetBulkPaymentBatchPreviews(response: HttpResponseBase): Observable<PledgeBulkPaymentBatchPreview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeBulkPaymentBatchPreview.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadBulkPaymentBatchCsv(batchId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/pledgebulkpaymentreport/downloadbulkpaymentbatchcsv?";
        if (batchId === null)
            throw new globalThis.Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkPaymentBatchCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkPaymentBatchCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkPaymentBatchCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PledgeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    addPledge(pledge: Pledge): Observable<Pledge> {
        let url_ = this.baseUrl + "/api/v1/pledge/addpledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pledge);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge>;
        }));
    }

    protected processAddPledge(response: HttpResponseBase): Observable<Pledge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pledge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePledge(pledge: Pledge): Observable<Pledge> {
        let url_ = this.baseUrl + "/api/v1/pledge/updatepledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pledge);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge>;
        }));
    }

    protected processUpdatePledge(response: HttpResponseBase): Observable<Pledge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pledge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePledge(id?: string | undefined): Observable<Pledge> {
        let url_ = this.baseUrl + "/api/v1/pledge/deletepledge?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge>;
        }));
    }

    protected processDeletePledge(response: HttpResponseBase): Observable<Pledge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pledge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrievePledges(): Observable<Pledge[]> {
        let url_ = this.baseUrl + "/api/v1/pledge/retrievepledges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePledges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePledges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge[]>;
        }));
    }

    protected processRetrievePledges(response: HttpResponseBase): Observable<Pledge[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pledge.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrievePledge(id?: string | undefined): Observable<Pledge> {
        let url_ = this.baseUrl + "/api/v1/pledge/retrievepledge?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge>;
        }));
    }

    protected processRetrievePledge(response: HttpResponseBase): Observable<Pledge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pledge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrievePledgesPaged(searchValue?: string | null | undefined, agencyId?: string | null | undefined, pledgeTypeId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfPledge> {
        let url_ = this.baseUrl + "/api/v1/pledge/retrievepledgespaged?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePledgesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePledgesPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfPledge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfPledge>;
        }));
    }

    protected processRetrievePledgesPaged(response: HttpResponseBase): Observable<PagedListOfPledge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfPledge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveClientsPledges(id?: string | undefined): Observable<Pledge[]> {
        let url_ = this.baseUrl + "/api/v1/pledge/retrieveclientspledges?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveClientsPledges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveClientsPledges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge[]>;
        }));
    }

    protected processRetrieveClientsPledges(response: HttpResponseBase): Observable<Pledge[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pledge.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConfirmedUwdaPledges(pledgeTypeId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfPledge> {
        let url_ = this.baseUrl + "/api/v1/pledge/getconfirmeduwdapledges?";
        if (pledgeTypeId !== undefined && pledgeTypeId !== null)
            url_ += "PledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfirmedUwdaPledges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfirmedUwdaPledges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfPledge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfPledge>;
        }));
    }

    protected processGetConfirmedUwdaPledges(response: HttpResponseBase): Observable<PagedListOfPledge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfPledge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveConfirmedUwdaPledgesAuto(ids: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/pledge/approveconfirmeduwdapledgesauto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveConfirmedUwdaPledgesAuto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveConfirmedUwdaPledgesAuto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveConfirmedUwdaPledgesAuto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveConfirmedUwdaPledgesManual(ids: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/pledge/approveconfirmeduwdapledgesmanual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveConfirmedUwdaPledgesManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveConfirmedUwdaPledgesManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveConfirmedUwdaPledgesManual(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getManualPendingPledges(): Observable<Pledge[]> {
        let url_ = this.baseUrl + "/api/v1/pledge/getmanualpendingpledges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualPendingPledges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualPendingPledges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pledge[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pledge[]>;
        }));
    }

    protected processGetManualPendingPledges(response: HttpResponseBase): Observable<Pledge[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pledge.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeManualPandingToPaid(parms: ManualPendingPledgeParameters): Observable<SimpleBooleanResult> {
        let url_ = this.baseUrl + "/api/v1/pledge/changemanualpandingtopaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parms);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeManualPandingToPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeManualPandingToPaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleBooleanResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleBooleanResult>;
        }));
    }

    protected processChangeManualPandingToPaid(response: HttpResponseBase): Observable<SimpleBooleanResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleBooleanResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadPledgesByBatch(request: GetPledgesByBatchRequest): Observable<PledgeDisplayData[]> {
        let url_ = this.baseUrl + "/api/v1/pledge/loadpledgesbybatch/by-batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadPledgesByBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadPledgesByBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeDisplayData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeDisplayData[]>;
        }));
    }

    protected processLoadPledgesByBatch(response: HttpResponseBase): Observable<PledgeDisplayData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeDisplayData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canCurrentUserManagePledge(pledgeId?: string | undefined): Observable<UserPledgeAccess> {
        let url_ = this.baseUrl + "/api/v1/pledge/cancurrentusermanagepledge?";
        if (pledgeId === null)
            throw new globalThis.Error("The parameter 'pledgeId' cannot be null.");
        else if (pledgeId !== undefined)
            url_ += "pledgeId=" + encodeURIComponent("" + pledgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanCurrentUserManagePledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanCurrentUserManagePledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPledgeAccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPledgeAccess>;
        }));
    }

    protected processCanCurrentUserManagePledge(response: HttpResponseBase): Observable<UserPledgeAccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPledgeAccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PledgeReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    detailReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, agencyId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfPledgeDetailReport> {
        let url_ = this.baseUrl + "/api/v1/pledgereport/detailreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfPledgeDetailReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfPledgeDetailReport>;
        }));
    }

    protected processDetailReport(response: HttpResponseBase): Observable<PagedListOfPledgeDetailReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfPledgeDetailReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDetailReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/pledgereport/downloaddetailreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDetailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDetailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDetailReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    summaryReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, agencyId?: string | null | undefined): Observable<PledgeSummaryReport[]> {
        let url_ = this.baseUrl + "/api/v1/pledgereport/summaryreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeSummaryReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeSummaryReport[]>;
        }));
    }

    protected processSummaryReport(response: HttpResponseBase): Observable<PledgeSummaryReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeSummaryReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadSummaryReport(startDate?: Date | null | undefined, endDate?: Date | null | undefined, pledgeTypeIds?: string[] | null | undefined, pledgeStatus?: PledgeStatusType | null | undefined, agencyId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/pledgereport/downloadsummaryreport?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pledgeTypeIds !== undefined && pledgeTypeIds !== null)
            pledgeTypeIds && pledgeTypeIds.forEach(item => { url_ += "pledgeTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pledgeStatus !== undefined && pledgeStatus !== null)
            url_ += "pledgeStatus=" + encodeURIComponent("" + pledgeStatus) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSummaryReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PledgeTypeBalanceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    retrieveBalance(agencyId?: string | undefined, pledgeTypeId?: string | undefined): Observable<PledgeTypeBalance> {
        let url_ = this.baseUrl + "/api/v1/pledgetypebalance/retrievebalance?";
        if (agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (pledgeTypeId === null)
            throw new globalThis.Error("The parameter 'pledgeTypeId' cannot be null.");
        else if (pledgeTypeId !== undefined)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeTypeBalance>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeTypeBalance>;
        }));
    }

    protected processRetrieveBalance(response: HttpResponseBase): Observable<PledgeTypeBalance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeTypeBalance.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveBalances(parameters: PledgeTypeBalanceParameters): Observable<PledgeTypeBalance[]> {
        let url_ = this.baseUrl + "/api/v1/pledgetypebalance/retrievebalances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeTypeBalance[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeTypeBalance[]>;
        }));
    }

    protected processRetrieveBalances(response: HttpResponseBase): Observable<PledgeTypeBalance[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeTypeBalance.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkYearlyMaxPledge(clientId?: string | undefined, pledgeTypeId?: string | undefined): Observable<PledgeTypeBalance> {
        let url_ = this.baseUrl + "/api/v1/pledgetypebalance/checkyearlymaxpledge?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (pledgeTypeId === null)
            throw new globalThis.Error("The parameter 'pledgeTypeId' cannot be null.");
        else if (pledgeTypeId !== undefined)
            url_ += "pledgeTypeId=" + encodeURIComponent("" + pledgeTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckYearlyMaxPledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckYearlyMaxPledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeTypeBalance>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeTypeBalance>;
        }));
    }

    protected processCheckYearlyMaxPledge(response: HttpResponseBase): Observable<PledgeTypeBalance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeTypeBalance.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PledgeTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    searchPledgeTypes(searchValue?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfPledgeType> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/searchpledgetypes?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPledgeTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPledgeTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfPledgeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfPledgeType>;
        }));
    }

    protected processSearchPledgeTypes(response: HttpResponseBase): Observable<PagedListOfPledgeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfPledgeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrievePledgeType(id?: string | undefined): Observable<PledgeType> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/retrievepledgetype?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePledgeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePledgeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeType>;
        }));
    }

    protected processRetrievePledgeType(response: HttpResponseBase): Observable<PledgeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPledgeType(pledgeType: PledgeType): Observable<PledgeType> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/addpledgetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pledgeType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPledgeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPledgeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeType>;
        }));
    }

    protected processAddPledgeType(response: HttpResponseBase): Observable<PledgeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePledgeType(pledgeType: PledgeType): Observable<PledgeType> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/updatepledgetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pledgeType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePledgeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePledgeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeType>;
        }));
    }

    protected processUpdatePledgeType(response: HttpResponseBase): Observable<PledgeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePledgeType(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/deletepledgetype?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePledgeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePledgeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeletePledgeType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrievePledgeTypes(): Observable<PledgeType[]> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/retrievepledgetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePledgeTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePledgeTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeType[]>;
        }));
    }

    protected processRetrievePledgeTypes(response: HttpResponseBase): Observable<PledgeType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    massAssignPledgeType(parameters: MassAssignPledgeTypeParams): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/massassignpledgetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMassAssignPledgeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMassAssignPledgeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMassAssignPledgeType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveFundAdministrativeAgencyPledgeTypes(): Observable<PledgeType[]> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/retrievefundadministrativeagencypledgetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFundAdministrativeAgencyPledgeTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFundAdministrativeAgencyPledgeTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeType[]>;
        }));
    }

    protected processRetrieveFundAdministrativeAgencyPledgeTypes(response: HttpResponseBase): Observable<PledgeType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuthorizedPledgeTypes(): Observable<PledgeTypeSelectionViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/pledgetype/getauthorizedpledgetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizedPledgeTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizedPledgeTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeTypeSelectionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeTypeSelectionViewModel[]>;
        }));
    }

    protected processGetAuthorizedPledgeTypes(response: HttpResponseBase): Observable<PledgeTypeSelectionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PledgeTypeSelectionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicAssistanceApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    submit(publicAssistanceApplicationJson?: string | null | undefined, files?: FileParameter[] | null | undefined, draftId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/publicassistanceapplication/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (publicAssistanceApplicationJson !== null && publicAssistanceApplicationJson !== undefined)
            content_.append("publicAssistanceApplicationJson", publicAssistanceApplicationJson.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (draftId !== null && draftId !== undefined)
            content_.append("draftId", draftId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    isValidUrl(pledgeType?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/public/isvalidurl/isvalidurl?";
        if (pledgeType !== undefined && pledgeType !== null)
            url_ += "pledgeType=" + encodeURIComponent("" + pledgeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsValidUrl(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isApplicationCountyActive(county?: string | null | undefined, applicationType?: AssistanceApplicationType | undefined): Observable<ApplicationCountyEligibilityResult> {
        let url_ = this.baseUrl + "/api/v1/public/isapplicationcountyactive/isapplicationcountyactive?";
        if (county !== undefined && county !== null)
            url_ += "county=" + encodeURIComponent("" + county) + "&";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsApplicationCountyActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsApplicationCountyActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCountyEligibilityResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCountyEligibilityResult>;
        }));
    }

    protected processIsApplicationCountyActive(response: HttpResponseBase): Observable<ApplicationCountyEligibilityResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationCountyEligibilityResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveLookUps(categoryType?: LookUpCategoryType | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfLookUp> {
        let url_ = this.baseUrl + "/api/v1/public/retrievelookups?";
        if (categoryType === null)
            throw new globalThis.Error("The parameter 'categoryType' cannot be null.");
        else if (categoryType !== undefined)
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLookUps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLookUps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfLookUp>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfLookUp>;
        }));
    }

    protected processRetrieveLookUps(response: HttpResponseBase): Observable<PagedListOfLookUp> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfLookUp.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveDraft(draftApplication: DraftApplicationModel, id?: string | null | undefined, fundName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/public/savedraft?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fundName !== undefined && fundName !== null)
            url_ += "fundName=" + encodeURIComponent("" + fundName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(draftApplication);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveDraft(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDraftById(id?: string | undefined, accessCode?: string | null | undefined): Observable<GerDraftApplicationResponse> {
        let url_ = this.baseUrl + "/api/v1/public/getdraftbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (accessCode !== undefined && accessCode !== null)
            url_ += "accessCode=" + encodeURIComponent("" + accessCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GerDraftApplicationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GerDraftApplicationResponse>;
        }));
    }

    protected processGetDraftById(response: HttpResponseBase): Observable<GerDraftApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GerDraftApplicationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaxAnnualUhonsIncomes(): Observable<MaxAnnualIncomeLevelViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/public/getmaxannualuhonsincomes/getmaxannualuhonsincomes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaxAnnualUhonsIncomes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaxAnnualUhonsIncomes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaxAnnualIncomeLevelViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaxAnnualIncomeLevelViewModel[]>;
        }));
    }

    protected processGetMaxAnnualUhonsIncomes(response: HttpResponseBase): Observable<MaxAnnualIncomeLevelViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaxAnnualIncomeLevelViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaxAnnualStlWaterIncomes(): Observable<MaxAnnualIncomeLevelViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/public/getmaxannualstlwaterincomes/getmaxannualstlwaterincomes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaxAnnualStlWaterIncomes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaxAnnualStlWaterIncomes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaxAnnualIncomeLevelViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaxAnnualIncomeLevelViewModel[]>;
        }));
    }

    protected processGetMaxAnnualStlWaterIncomes(response: HttpResponseBase): Observable<MaxAnnualIncomeLevelViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaxAnnualIncomeLevelViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaxAnnualUfFIncomes(): Observable<MaxAnnualIncomeLevelViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/public/getmaxannualuffincomes/getmaxannualuffincomes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaxAnnualUfFIncomes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaxAnnualUfFIncomes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaxAnnualIncomeLevelViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaxAnnualIncomeLevelViewModel[]>;
        }));
    }

    protected processGetMaxAnnualUfFIncomes(response: HttpResponseBase): Observable<MaxAnnualIncomeLevelViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaxAnnualIncomeLevelViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFundTypeConfiguration(applicationType?: AssistanceApplicationType | undefined): Observable<FundType> {
        let url_ = this.baseUrl + "/api/v1/public/getfundtypeconfiguration/getfundtypeconfiguration?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundTypeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundTypeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundType>;
        }));
    }

    protected processGetFundTypeConfiguration(response: HttpResponseBase): Observable<FundType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FundType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SecurityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    login(parameters: LoginParameters): Observable<LoginResult> {
        let url_ = this.baseUrl + "/api/v1/security/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResult>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    me(): Observable<LoginResult> {
        let url_ = this.baseUrl + "/api/v1/security/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResult>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<LoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<GenericApiResponse> {
        let url_ = this.baseUrl + "/api/v1/security/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericApiResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<GenericApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendResetPasswordRequest(parameter: EmailParameter): Observable<GenericApiResponse> {
        let url_ = this.baseUrl + "/api/v1/security/sendresetpasswordrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResetPasswordRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResetPasswordRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericApiResponse>;
        }));
    }

    protected processSendResetPasswordRequest(response: HttpResponseBase): Observable<GenericApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(parameters: ResetPasswordParameters): Observable<GenericApiResponse> {
        let url_ = this.baseUrl + "/api/v1/security/resetpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericApiResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<GenericApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SystemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    getSystemData(): Observable<SystemData> {
        let url_ = this.baseUrl + "/api/v1/system/getsystemdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemData>;
        }));
    }

    protected processGetSystemData(response: HttpResponseBase): Observable<SystemData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:17797";
    }

    searchUsers(searchValue?: string | null | undefined, agencyId?: string | null | undefined, userTypeId?: UserType | null | undefined, includeDisabled?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<PagedListOfUser> {
        let url_ = this.baseUrl + "/api/v1/user/searchusers?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (userTypeId !== undefined && userTypeId !== null)
            url_ += "userTypeId=" + encodeURIComponent("" + userTypeId) + "&";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfUser>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<PagedListOfUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadUsers(searchValue?: string | null | undefined, agencyId?: string | null | undefined, userTypeId?: UserType | null | undefined, includeDisabled?: boolean | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortNameQuery?: string | null | undefined, secondarySortQuery?: string | null | undefined, descendingQuery?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/downloadusers?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (userTypeId !== undefined && userTypeId !== null)
            url_ += "userTypeId=" + encodeURIComponent("" + userTypeId) + "&";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sortNameQuery !== undefined && sortNameQuery !== null)
            url_ += "SortName=" + encodeURIComponent("" + sortNameQuery) + "&";
        if (secondarySortQuery !== undefined && secondarySortQuery !== null)
            url_ += "SecondarySort=" + encodeURIComponent("" + secondarySortQuery) + "&";
        if (descendingQuery === null)
            throw new globalThis.Error("The parameter 'descendingQuery' cannot be null.");
        else if (descendingQuery !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descendingQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUsers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserById(id?: string | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/v1/user/getuserbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersByAgencyIds(agencyIds?: string[] | null | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/api/v1/user/getusersbyagencyids?";
        if (agencyIds !== undefined && agencyIds !== null)
            agencyIds && agencyIds.forEach(item => { url_ += "agencyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByAgencyIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByAgencyIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processGetUsersByAgencyIds(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(user: User): Observable<User> {
        let url_ = this.baseUrl + "/api/v1/user/adduser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(user: User): Observable<User> {
        let url_ = this.baseUrl + "/api/v1/user/updateuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(parameters: ChangePasswordParameters): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/user/changepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isEmailTaken(email?: string | null | undefined, id?: string | null | undefined): Observable<SimpleBooleanResult> {
        let url_ = this.baseUrl + "/api/v1/user/isemailtaken?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailTaken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailTaken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleBooleanResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleBooleanResult>;
        }));
    }

    protected processIsEmailTaken(response: HttpResponseBase): Observable<SimpleBooleanResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleBooleanResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserAgreementDate(dateTimeOffset: DateTimeOffsetParameter): Observable<SimpleBooleanResult> {
        let url_ = this.baseUrl + "/api/v1/user/setuseragreementdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dateTimeOffset);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserAgreementDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserAgreementDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleBooleanResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleBooleanResult>;
        }));
    }

    protected processSetUserAgreementDate(response: HttpResponseBase): Observable<SimpleBooleanResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleBooleanResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class PagedListOfActivityAuditViewModel implements IPagedListOfActivityAuditViewModel {
    items?: ActivityAuditViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfActivityAuditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityAuditViewModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfActivityAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfActivityAuditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfActivityAuditViewModel {
        const json = this.toJSON();
        let result = new PagedListOfActivityAuditViewModel();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfActivityAuditViewModel {
    items?: ActivityAuditViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class BaseViewModel implements IBaseViewModel {
    id?: string | null;
    enteredBy?: string | null;
    enteredDate?: Date | null;
    modifiedBy?: string | null;
    modifiedDate?: Date | null;

    constructor(data?: IBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.enteredBy = _data["enteredBy"] !== undefined ? _data["enteredBy"] : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.modifiedBy = _data["modifiedBy"] !== undefined ? _data["modifiedBy"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): BaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["enteredBy"] = this.enteredBy !== undefined ? this.enteredBy : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["modifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        return data;
    }

    clone(): BaseViewModel {
        const json = this.toJSON();
        let result = new BaseViewModel();
        result.init(json);
        return result;
    }
}

export interface IBaseViewModel {
    id?: string | null;
    enteredBy?: string | null;
    enteredDate?: Date | null;
    modifiedBy?: string | null;
    modifiedDate?: Date | null;
}

export class ActivityAuditViewModel extends BaseViewModel implements IActivityAuditViewModel {
    createdBy?: string | null;
    date?: Date;
    organization?: string | null;
    propertyName?: string | null;
    newValue?: string | null;
    oldValue?: string | null;
    action?: ActivityAuditState;
    processType?: string | null;

    constructor(data?: IActivityAuditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.organization = _data["organization"] !== undefined ? _data["organization"] : null as any;
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.processType = _data["processType"] !== undefined ? _data["processType"] : null as any;
        }
    }

    static override fromJS(data: any): ActivityAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["organization"] = this.organization !== undefined ? this.organization : null as any;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["processType"] = this.processType !== undefined ? this.processType : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActivityAuditViewModel {
        const json = this.toJSON();
        let result = new ActivityAuditViewModel();
        result.init(json);
        return result;
    }
}

export interface IActivityAuditViewModel extends IBaseViewModel {
    createdBy?: string | null;
    date?: Date;
    organization?: string | null;
    propertyName?: string | null;
    newValue?: string | null;
    oldValue?: string | null;
    action?: ActivityAuditState;
    processType?: string | null;
}

export enum ActivityAuditState {
    Created = "Created",
    Modified = "Modified",
    Deleted = "Deleted",
}

export class PagedListOfAgency implements IPagedListOfAgency {
    items?: Agency[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Agency.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfAgency {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAgency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfAgency {
        const json = this.toJSON();
        let result = new PagedListOfAgency();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfAgency {
    items?: Agency[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class Agency extends BaseViewModel implements IAgency {
    agencyName?: string | null;
    status?: AgencyStatusType;
    amerenCssCode?: string | null;
    pledgeTypeIds?: string[] | null;
    efnZones?: string[] | null;
    isEfnAgency?: boolean;
    isDefaultManagementAgency?: boolean;

    constructor(data?: IAgency) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.amerenCssCode = _data["amerenCssCode"] !== undefined ? _data["amerenCssCode"] : null as any;
            if (Array.isArray(_data["pledgeTypeIds"])) {
                this.pledgeTypeIds = [] as any;
                for (let item of _data["pledgeTypeIds"])
                    this.pledgeTypeIds!.push(item);
            }
            else {
                this.pledgeTypeIds = null as any;
            }
            if (Array.isArray(_data["efnZones"])) {
                this.efnZones = [] as any;
                for (let item of _data["efnZones"])
                    this.efnZones!.push(item);
            }
            else {
                this.efnZones = null as any;
            }
            this.isEfnAgency = _data["isEfnAgency"] !== undefined ? _data["isEfnAgency"] : null as any;
            this.isDefaultManagementAgency = _data["isDefaultManagementAgency"] !== undefined ? _data["isDefaultManagementAgency"] : null as any;
        }
    }

    static override fromJS(data: any): Agency {
        data = typeof data === 'object' ? data : {};
        let result = new Agency();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["amerenCssCode"] = this.amerenCssCode !== undefined ? this.amerenCssCode : null as any;
        if (Array.isArray(this.pledgeTypeIds)) {
            data["pledgeTypeIds"] = [];
            for (let item of this.pledgeTypeIds)
                data["pledgeTypeIds"].push(item);
        }
        if (Array.isArray(this.efnZones)) {
            data["efnZones"] = [];
            for (let item of this.efnZones)
                data["efnZones"].push(item);
        }
        data["isEfnAgency"] = this.isEfnAgency !== undefined ? this.isEfnAgency : null as any;
        data["isDefaultManagementAgency"] = this.isDefaultManagementAgency !== undefined ? this.isDefaultManagementAgency : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Agency {
        const json = this.toJSON();
        let result = new Agency();
        result.init(json);
        return result;
    }
}

export interface IAgency extends IBaseViewModel {
    agencyName?: string | null;
    status?: AgencyStatusType;
    amerenCssCode?: string | null;
    pledgeTypeIds?: string[] | null;
    efnZones?: string[] | null;
    isEfnAgency?: boolean;
    isDefaultManagementAgency?: boolean;
}

export enum AgencyStatusType {
    Unknown = "Unknown",
    Active = "Active",
    Disabled = "Disabled",
}

export enum AssistanceApplicationType {
    UHONS = "UHONS",
    UFF = "UFF",
    STLWater = "STLWater",
    EFN = "EFN",
    STLStorm = "STLStorm",
}

export class Allocation extends BaseViewModel implements IAllocation {
    agencyId?: string;
    companyId?: string | null;
    pledgeTypeId?: string | null;
    agencyName?: string | null;
    companyName?: string | null;
    pledgeTypeName?: string | null;
    reason?: string | null;
    amount?: number;
    adminPercent?: number | null;
    status?: StatusType;
    remainingBalance?: number;
    allocatedAmount?: number | null;

    constructor(data?: IAllocation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.pledgeTypeName = _data["pledgeTypeName"] !== undefined ? _data["pledgeTypeName"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.adminPercent = _data["adminPercent"] !== undefined ? _data["adminPercent"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.remainingBalance = _data["remainingBalance"] !== undefined ? _data["remainingBalance"] : null as any;
            this.allocatedAmount = _data["allocatedAmount"] !== undefined ? _data["allocatedAmount"] : null as any;
        }
    }

    static override fromJS(data: any): Allocation {
        data = typeof data === 'object' ? data : {};
        let result = new Allocation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["pledgeTypeName"] = this.pledgeTypeName !== undefined ? this.pledgeTypeName : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["adminPercent"] = this.adminPercent !== undefined ? this.adminPercent : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["remainingBalance"] = this.remainingBalance !== undefined ? this.remainingBalance : null as any;
        data["allocatedAmount"] = this.allocatedAmount !== undefined ? this.allocatedAmount : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Allocation {
        const json = this.toJSON();
        let result = new Allocation();
        result.init(json);
        return result;
    }
}

export interface IAllocation extends IBaseViewModel {
    agencyId?: string;
    companyId?: string | null;
    pledgeTypeId?: string | null;
    agencyName?: string | null;
    companyName?: string | null;
    pledgeTypeName?: string | null;
    reason?: string | null;
    amount?: number;
    adminPercent?: number | null;
    status?: StatusType;
    remainingBalance?: number;
    allocatedAmount?: number | null;
}

export enum StatusType {
    Disabled = "Disabled",
    Enabled = "Enabled",
}

export class PagedListOfAllocationListItem implements IPagedListOfAllocationListItem {
    items?: AllocationListItem[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfAllocationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AllocationListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfAllocationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAllocationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfAllocationListItem {
        const json = this.toJSON();
        let result = new PagedListOfAllocationListItem();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfAllocationListItem {
    items?: AllocationListItem[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class AllocationListItem extends BaseViewModel implements IAllocationListItem {
    adminPercent?: number;
    agencyName?: string | null;
    amount?: number;
    companyName?: string | null;
    remainingBalance?: number;
    pledgeTypeName?: string | null;
    reason?: string | null;
    status?: StatusType;

    constructor(data?: IAllocationListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adminPercent = _data["adminPercent"] !== undefined ? _data["adminPercent"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.remainingBalance = _data["remainingBalance"] !== undefined ? _data["remainingBalance"] : null as any;
            this.pledgeTypeName = _data["pledgeTypeName"] !== undefined ? _data["pledgeTypeName"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static override fromJS(data: any): AllocationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPercent"] = this.adminPercent !== undefined ? this.adminPercent : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["remainingBalance"] = this.remainingBalance !== undefined ? this.remainingBalance : null as any;
        data["pledgeTypeName"] = this.pledgeTypeName !== undefined ? this.pledgeTypeName : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AllocationListItem {
        const json = this.toJSON();
        let result = new AllocationListItem();
        result.init(json);
        return result;
    }
}

export interface IAllocationListItem extends IBaseViewModel {
    adminPercent?: number;
    agencyName?: string | null;
    amount?: number;
    companyName?: string | null;
    remainingBalance?: number;
    pledgeTypeName?: string | null;
    reason?: string | null;
    status?: StatusType;
}

export class AllocationUpload implements IAllocationUpload {
    agency?: string | null;
    company?: string | null;
    pledgeType?: string | null;
    reason?: string | null;
    amount?: number;
    adminPercent?: number | null;

    constructor(data?: IAllocationUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.pledgeType = _data["pledgeType"] !== undefined ? _data["pledgeType"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.adminPercent = _data["adminPercent"] !== undefined ? _data["adminPercent"] : null as any;
        }
    }

    static fromJS(data: any): AllocationUpload {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["pledgeType"] = this.pledgeType !== undefined ? this.pledgeType : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["adminPercent"] = this.adminPercent !== undefined ? this.adminPercent : null as any;
        return data;
    }

    clone(): AllocationUpload {
        const json = this.toJSON();
        let result = new AllocationUpload();
        result.init(json);
        return result;
    }
}

export interface IAllocationUpload {
    agency?: string | null;
    company?: string | null;
    pledgeType?: string | null;
    reason?: string | null;
    amount?: number;
    adminPercent?: number | null;
}

export class AllocationUploadResult extends AllocationUpload implements IAllocationUploadResult {
    lineNumber?: number;
    errorMessages?: string[] | null;

    constructor(data?: IAllocationUploadResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lineNumber = _data["lineNumber"] !== undefined ? _data["lineNumber"] : null as any;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            else {
                this.errorMessages = null as any;
            }
        }
    }

    static override fromJS(data: any): AllocationUploadResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationUploadResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AllocationUploadResult {
        const json = this.toJSON();
        let result = new AllocationUploadResult();
        result.init(json);
        return result;
    }
}

export interface IAllocationUploadResult extends IAllocationUpload {
    lineNumber?: number;
    errorMessages?: string[] | null;
}

export class AllocationValidationResult extends AllocationUploadResult implements IAllocationValidationResult {
    agencyId?: string;
    companyId?: string | null;
    pledgeTypeId?: string;

    constructor(data?: IAllocationValidationResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
        }
    }

    static override fromJS(data: any): AllocationValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationValidationResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AllocationValidationResult {
        const json = this.toJSON();
        let result = new AllocationValidationResult();
        result.init(json);
        return result;
    }
}

export interface IAllocationValidationResult extends IAllocationUploadResult {
    agencyId?: string;
    companyId?: string | null;
    pledgeTypeId?: string;
}

export class AllocationReport extends BaseViewModel implements IAllocationReport {
    agencyName?: string | null;
    note?: string | null;
    fundType?: string | null;
    adminPercent?: number | null;
    allocated?: number | null;
    spent?: number | null;
    remainingBalance?: number | null;
    ledgerNumber?: string | null;
    isPrivate?: boolean | null;

    constructor(data?: IAllocationReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.fundType = _data["fundType"] !== undefined ? _data["fundType"] : null as any;
            this.adminPercent = _data["adminPercent"] !== undefined ? _data["adminPercent"] : null as any;
            this.allocated = _data["allocated"] !== undefined ? _data["allocated"] : null as any;
            this.spent = _data["spent"] !== undefined ? _data["spent"] : null as any;
            this.remainingBalance = _data["remainingBalance"] !== undefined ? _data["remainingBalance"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
        }
    }

    static override fromJS(data: any): AllocationReport {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["fundType"] = this.fundType !== undefined ? this.fundType : null as any;
        data["adminPercent"] = this.adminPercent !== undefined ? this.adminPercent : null as any;
        data["allocated"] = this.allocated !== undefined ? this.allocated : null as any;
        data["spent"] = this.spent !== undefined ? this.spent : null as any;
        data["remainingBalance"] = this.remainingBalance !== undefined ? this.remainingBalance : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AllocationReport {
        const json = this.toJSON();
        let result = new AllocationReport();
        result.init(json);
        return result;
    }
}

export interface IAllocationReport extends IBaseViewModel {
    agencyName?: string | null;
    note?: string | null;
    fundType?: string | null;
    adminPercent?: number | null;
    allocated?: number | null;
    spent?: number | null;
    remainingBalance?: number | null;
    ledgerNumber?: string | null;
    isPrivate?: boolean | null;
}

export enum PledgeStatusType {
    Unknown = "Unknown",
    New = "New",
    Confirmed = "Confirmed",
    Pending = "Pending",
    Paid = "Paid",
    Deleted = "Deleted",
    PendingManual = "PendingManual",
}

export class PagedListOfApplicationCounty implements IPagedListOfApplicationCounty {
    items?: ApplicationCounty[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfApplicationCounty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationCounty.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfApplicationCounty {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfApplicationCounty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfApplicationCounty {
        const json = this.toJSON();
        let result = new PagedListOfApplicationCounty();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfApplicationCounty {
    items?: ApplicationCounty[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class ApplicationCounty extends BaseViewModel implements IApplicationCounty {
    name?: string | null;
    isUhonsActiveInternal?: boolean;
    isUhonsActiveExternal?: boolean;
    isStlWaterActiveInternal?: boolean;
    isStlWaterActiveExternal?: boolean;
    uhonsFundAdministrativePledgeTypeId?: string | null;
    uhonsFundAdministrativePledgeTypeName?: string | null;
    stlWaterFundAdministrativePledgeTypeId?: string | null;
    stlWaterFundAdministrativePledgeTypeName?: string | null;

    constructor(data?: IApplicationCounty) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isUhonsActiveInternal = _data["isUhonsActiveInternal"] !== undefined ? _data["isUhonsActiveInternal"] : null as any;
            this.isUhonsActiveExternal = _data["isUhonsActiveExternal"] !== undefined ? _data["isUhonsActiveExternal"] : null as any;
            this.isStlWaterActiveInternal = _data["isStlWaterActiveInternal"] !== undefined ? _data["isStlWaterActiveInternal"] : null as any;
            this.isStlWaterActiveExternal = _data["isStlWaterActiveExternal"] !== undefined ? _data["isStlWaterActiveExternal"] : null as any;
            this.uhonsFundAdministrativePledgeTypeId = _data["uhonsFundAdministrativePledgeTypeId"] !== undefined ? _data["uhonsFundAdministrativePledgeTypeId"] : null as any;
            this.uhonsFundAdministrativePledgeTypeName = _data["uhonsFundAdministrativePledgeTypeName"] !== undefined ? _data["uhonsFundAdministrativePledgeTypeName"] : null as any;
            this.stlWaterFundAdministrativePledgeTypeId = _data["stlWaterFundAdministrativePledgeTypeId"] !== undefined ? _data["stlWaterFundAdministrativePledgeTypeId"] : null as any;
            this.stlWaterFundAdministrativePledgeTypeName = _data["stlWaterFundAdministrativePledgeTypeName"] !== undefined ? _data["stlWaterFundAdministrativePledgeTypeName"] : null as any;
        }
    }

    static override fromJS(data: any): ApplicationCounty {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCounty();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isUhonsActiveInternal"] = this.isUhonsActiveInternal !== undefined ? this.isUhonsActiveInternal : null as any;
        data["isUhonsActiveExternal"] = this.isUhonsActiveExternal !== undefined ? this.isUhonsActiveExternal : null as any;
        data["isStlWaterActiveInternal"] = this.isStlWaterActiveInternal !== undefined ? this.isStlWaterActiveInternal : null as any;
        data["isStlWaterActiveExternal"] = this.isStlWaterActiveExternal !== undefined ? this.isStlWaterActiveExternal : null as any;
        data["uhonsFundAdministrativePledgeTypeId"] = this.uhonsFundAdministrativePledgeTypeId !== undefined ? this.uhonsFundAdministrativePledgeTypeId : null as any;
        data["uhonsFundAdministrativePledgeTypeName"] = this.uhonsFundAdministrativePledgeTypeName !== undefined ? this.uhonsFundAdministrativePledgeTypeName : null as any;
        data["stlWaterFundAdministrativePledgeTypeId"] = this.stlWaterFundAdministrativePledgeTypeId !== undefined ? this.stlWaterFundAdministrativePledgeTypeId : null as any;
        data["stlWaterFundAdministrativePledgeTypeName"] = this.stlWaterFundAdministrativePledgeTypeName !== undefined ? this.stlWaterFundAdministrativePledgeTypeName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationCounty {
        const json = this.toJSON();
        let result = new ApplicationCounty();
        result.init(json);
        return result;
    }
}

export interface IApplicationCounty extends IBaseViewModel {
    name?: string | null;
    isUhonsActiveInternal?: boolean;
    isUhonsActiveExternal?: boolean;
    isStlWaterActiveInternal?: boolean;
    isStlWaterActiveExternal?: boolean;
    uhonsFundAdministrativePledgeTypeId?: string | null;
    uhonsFundAdministrativePledgeTypeName?: string | null;
    stlWaterFundAdministrativePledgeTypeId?: string | null;
    stlWaterFundAdministrativePledgeTypeName?: string | null;
}

export class AssistanceApplicationComment extends BaseViewModel implements IAssistanceApplicationComment {
    assistanceApplicationId?: string;
    userId?: string;
    comment?: string | null;
    agencyName?: string | null;
    userFullName?: string | null;

    constructor(data?: IAssistanceApplicationComment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.userFullName = _data["userFullName"] !== undefined ? _data["userFullName"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationComment {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationComment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["userFullName"] = this.userFullName !== undefined ? this.userFullName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationComment {
        const json = this.toJSON();
        let result = new AssistanceApplicationComment();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationComment extends IBaseViewModel {
    assistanceApplicationId?: string;
    userId?: string;
    comment?: string | null;
    agencyName?: string | null;
    userFullName?: string | null;
}

export class AssistanceApplication extends BaseViewModel implements IAssistanceApplication {
    clientId?: string;
    fundTypeId?: string | null;
    assignedAgencyId?: string | null;
    createdByUserId?: string | null;
    companyId?: string | null;
    applicationType?: AssistanceApplicationType;
    summary?: string | null;
    description?: string | null;
    hasTranslation?: boolean;
    translatedDescription?: string | null;
    note?: string | null;
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    applicantAddress?: string | null;
    applicantZipCode?: string | null;
    applicantCity?: string | null;
    applicantState?: string | null;
    applicantCounty?: string | null;
    applicantPhone?: string | null;
    applicantEmail?: string | null;
    applicantIndividualMonthlyIncome?: number | null;
    applicantHouseHoldIncome?: number | null;
    applicantEmploymentStatus?: string | null;
    accountNumber?: string | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: string | null;
    denialReason?: string | null;
    otherDenialReason?: string | null;
    auditState?: AssistanceApplicationStateAuditType;
    censusTract?: string | null;
    currentInformationRequest?: AssistanceApplicationInformationRequestViewModel | null;
    currentPledgeStatus?: PledgeStatusType | null;
    fundPledgeTypeId?: string | null;
    fundPledgeTypeName?: string | null;
    totalNeed?: number | null;
    familyEducatedAboutResources?: boolean | null;
    client?: Client | null;
    fundType?: FundType | null;
    assignedAgency?: Agency | null;
    createdByUser?: User | null;
    company?: Company | null;
    assistanceApplicationAreasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    stormApplication?: StormApplicationViewModel | null;
    adults?: AssistanceApplicationAdult[] | null;
    minors?: AssistanceApplicationMinor[] | null;
    comments?: AssistanceApplicationComment[] | null;
    files?: AssistanceApplicationFile[] | null;
    companies?: AssistanceApplicationCompany[] | null;
    warnings?: string[] | null;

    constructor(data?: IAssistanceApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.fundTypeId = _data["fundTypeId"] !== undefined ? _data["fundTypeId"] : null as any;
            this.assignedAgencyId = _data["assignedAgencyId"] !== undefined ? _data["assignedAgencyId"] : null as any;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.hasTranslation = _data["hasTranslation"] !== undefined ? _data["hasTranslation"] : null as any;
            this.translatedDescription = _data["translatedDescription"] !== undefined ? _data["translatedDescription"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.applicantFirstName = _data["applicantFirstName"] !== undefined ? _data["applicantFirstName"] : null as any;
            this.applicantLastName = _data["applicantLastName"] !== undefined ? _data["applicantLastName"] : null as any;
            this.applicantAddress = _data["applicantAddress"] !== undefined ? _data["applicantAddress"] : null as any;
            this.applicantZipCode = _data["applicantZipCode"] !== undefined ? _data["applicantZipCode"] : null as any;
            this.applicantCity = _data["applicantCity"] !== undefined ? _data["applicantCity"] : null as any;
            this.applicantState = _data["applicantState"] !== undefined ? _data["applicantState"] : null as any;
            this.applicantCounty = _data["applicantCounty"] !== undefined ? _data["applicantCounty"] : null as any;
            this.applicantPhone = _data["applicantPhone"] !== undefined ? _data["applicantPhone"] : null as any;
            this.applicantEmail = _data["applicantEmail"] !== undefined ? _data["applicantEmail"] : null as any;
            this.applicantIndividualMonthlyIncome = _data["applicantIndividualMonthlyIncome"] !== undefined ? _data["applicantIndividualMonthlyIncome"] : null as any;
            this.applicantHouseHoldIncome = _data["applicantHouseHoldIncome"] !== undefined ? _data["applicantHouseHoldIncome"] : null as any;
            this.applicantEmploymentStatus = _data["applicantEmploymentStatus"] !== undefined ? _data["applicantEmploymentStatus"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.fundedDate = _data["fundedDate"] ? new Date(_data["fundedDate"].toString()) : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.otherDenialReason = _data["otherDenialReason"] !== undefined ? _data["otherDenialReason"] : null as any;
            this.auditState = _data["auditState"] !== undefined ? _data["auditState"] : null as any;
            this.censusTract = _data["censusTract"] !== undefined ? _data["censusTract"] : null as any;
            this.currentInformationRequest = _data["currentInformationRequest"] ? AssistanceApplicationInformationRequestViewModel.fromJS(_data["currentInformationRequest"]) : null as any;
            this.currentPledgeStatus = _data["currentPledgeStatus"] !== undefined ? _data["currentPledgeStatus"] : null as any;
            this.fundPledgeTypeId = _data["fundPledgeTypeId"] !== undefined ? _data["fundPledgeTypeId"] : null as any;
            this.fundPledgeTypeName = _data["fundPledgeTypeName"] !== undefined ? _data["fundPledgeTypeName"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.familyEducatedAboutResources = _data["familyEducatedAboutResources"] !== undefined ? _data["familyEducatedAboutResources"] : null as any;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : null as any;
            this.fundType = _data["fundType"] ? FundType.fromJS(_data["fundType"]) : null as any;
            this.assignedAgency = _data["assignedAgency"] ? Agency.fromJS(_data["assignedAgency"]) : null as any;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : null as any;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : null as any;
            this.assistanceApplicationAreasOfNeed = _data["assistanceApplicationAreasOfNeed"] ? AssistanceApplicationAreasOfNeed.fromJS(_data["assistanceApplicationAreasOfNeed"]) : null as any;
            this.stormApplication = _data["stormApplication"] ? StormApplicationViewModel.fromJS(_data["stormApplication"]) : null as any;
            if (Array.isArray(_data["adults"])) {
                this.adults = [] as any;
                for (let item of _data["adults"])
                    this.adults!.push(AssistanceApplicationAdult.fromJS(item));
            }
            else {
                this.adults = null as any;
            }
            if (Array.isArray(_data["minors"])) {
                this.minors = [] as any;
                for (let item of _data["minors"])
                    this.minors!.push(AssistanceApplicationMinor.fromJS(item));
            }
            else {
                this.minors = null as any;
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(AssistanceApplicationComment.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AssistanceApplicationFile.fromJS(item));
            }
            else {
                this.files = null as any;
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(AssistanceApplicationCompany.fromJS(item));
            }
            else {
                this.companies = null as any;
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            else {
                this.warnings = null as any;
            }
        }
    }

    static override fromJS(data: any): AssistanceApplication {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["fundTypeId"] = this.fundTypeId !== undefined ? this.fundTypeId : null as any;
        data["assignedAgencyId"] = this.assignedAgencyId !== undefined ? this.assignedAgencyId : null as any;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["hasTranslation"] = this.hasTranslation !== undefined ? this.hasTranslation : null as any;
        data["translatedDescription"] = this.translatedDescription !== undefined ? this.translatedDescription : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["applicantFirstName"] = this.applicantFirstName !== undefined ? this.applicantFirstName : null as any;
        data["applicantLastName"] = this.applicantLastName !== undefined ? this.applicantLastName : null as any;
        data["applicantAddress"] = this.applicantAddress !== undefined ? this.applicantAddress : null as any;
        data["applicantZipCode"] = this.applicantZipCode !== undefined ? this.applicantZipCode : null as any;
        data["applicantCity"] = this.applicantCity !== undefined ? this.applicantCity : null as any;
        data["applicantState"] = this.applicantState !== undefined ? this.applicantState : null as any;
        data["applicantCounty"] = this.applicantCounty !== undefined ? this.applicantCounty : null as any;
        data["applicantPhone"] = this.applicantPhone !== undefined ? this.applicantPhone : null as any;
        data["applicantEmail"] = this.applicantEmail !== undefined ? this.applicantEmail : null as any;
        data["applicantIndividualMonthlyIncome"] = this.applicantIndividualMonthlyIncome !== undefined ? this.applicantIndividualMonthlyIncome : null as any;
        data["applicantHouseHoldIncome"] = this.applicantHouseHoldIncome !== undefined ? this.applicantHouseHoldIncome : null as any;
        data["applicantEmploymentStatus"] = this.applicantEmploymentStatus !== undefined ? this.applicantEmploymentStatus : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["fundedDate"] = this.fundedDate ? this.fundedDate.toISOString() : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["otherDenialReason"] = this.otherDenialReason !== undefined ? this.otherDenialReason : null as any;
        data["auditState"] = this.auditState !== undefined ? this.auditState : null as any;
        data["censusTract"] = this.censusTract !== undefined ? this.censusTract : null as any;
        data["currentInformationRequest"] = this.currentInformationRequest ? this.currentInformationRequest.toJSON() : null as any;
        data["currentPledgeStatus"] = this.currentPledgeStatus !== undefined ? this.currentPledgeStatus : null as any;
        data["fundPledgeTypeId"] = this.fundPledgeTypeId !== undefined ? this.fundPledgeTypeId : null as any;
        data["fundPledgeTypeName"] = this.fundPledgeTypeName !== undefined ? this.fundPledgeTypeName : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["familyEducatedAboutResources"] = this.familyEducatedAboutResources !== undefined ? this.familyEducatedAboutResources : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["fundType"] = this.fundType ? this.fundType.toJSON() : null as any;
        data["assignedAgency"] = this.assignedAgency ? this.assignedAgency.toJSON() : null as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["assistanceApplicationAreasOfNeed"] = this.assistanceApplicationAreasOfNeed ? this.assistanceApplicationAreasOfNeed.toJSON() : null as any;
        data["stormApplication"] = this.stormApplication ? this.stormApplication.toJSON() : null as any;
        if (Array.isArray(this.adults)) {
            data["adults"] = [];
            for (let item of this.adults)
                data["adults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.minors)) {
            data["minors"] = [];
            for (let item of this.minors)
                data["minors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplication {
        const json = this.toJSON();
        let result = new AssistanceApplication();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplication extends IBaseViewModel {
    clientId?: string;
    fundTypeId?: string | null;
    assignedAgencyId?: string | null;
    createdByUserId?: string | null;
    companyId?: string | null;
    applicationType?: AssistanceApplicationType;
    summary?: string | null;
    description?: string | null;
    hasTranslation?: boolean;
    translatedDescription?: string | null;
    note?: string | null;
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    applicantAddress?: string | null;
    applicantZipCode?: string | null;
    applicantCity?: string | null;
    applicantState?: string | null;
    applicantCounty?: string | null;
    applicantPhone?: string | null;
    applicantEmail?: string | null;
    applicantIndividualMonthlyIncome?: number | null;
    applicantHouseHoldIncome?: number | null;
    applicantEmploymentStatus?: string | null;
    accountNumber?: string | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: string | null;
    denialReason?: string | null;
    otherDenialReason?: string | null;
    auditState?: AssistanceApplicationStateAuditType;
    censusTract?: string | null;
    currentInformationRequest?: AssistanceApplicationInformationRequestViewModel | null;
    currentPledgeStatus?: PledgeStatusType | null;
    fundPledgeTypeId?: string | null;
    fundPledgeTypeName?: string | null;
    totalNeed?: number | null;
    familyEducatedAboutResources?: boolean | null;
    client?: Client | null;
    fundType?: FundType | null;
    assignedAgency?: Agency | null;
    createdByUser?: User | null;
    company?: Company | null;
    assistanceApplicationAreasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    stormApplication?: StormApplicationViewModel | null;
    adults?: AssistanceApplicationAdult[] | null;
    minors?: AssistanceApplicationMinor[] | null;
    comments?: AssistanceApplicationComment[] | null;
    files?: AssistanceApplicationFile[] | null;
    companies?: AssistanceApplicationCompany[] | null;
    warnings?: string[] | null;
}

export enum AssistanceApplicationStateAuditType {
    NotYetAudited = "NotYetAudited",
    Pass = "Pass",
    Fail = "Fail",
    PassWithCorrection = "PassWithCorrection",
    PendingReAudit = "PendingReAudit",
}

export class AssistanceApplicationInformationRequestViewModel extends BaseViewModel implements IAssistanceApplicationInformationRequestViewModel {
    assistanceApplicationId?: string;
    requestDate?: Date;
    note?: string | null;
    requester?: string | null;
    requesterId?: string | null;
    informationProviderId?: string | null;
    informationProvider?: string | null;
    completedDate?: Date;

    constructor(data?: IAssistanceApplicationInformationRequestViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.requester = _data["requester"] !== undefined ? _data["requester"] : null as any;
            this.requesterId = _data["requesterId"] !== undefined ? _data["requesterId"] : null as any;
            this.informationProviderId = _data["informationProviderId"] !== undefined ? _data["informationProviderId"] : null as any;
            this.informationProvider = _data["informationProvider"] !== undefined ? _data["informationProvider"] : null as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationInformationRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationInformationRequestViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["requester"] = this.requester !== undefined ? this.requester : null as any;
        data["requesterId"] = this.requesterId !== undefined ? this.requesterId : null as any;
        data["informationProviderId"] = this.informationProviderId !== undefined ? this.informationProviderId : null as any;
        data["informationProvider"] = this.informationProvider !== undefined ? this.informationProvider : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationInformationRequestViewModel {
        const json = this.toJSON();
        let result = new AssistanceApplicationInformationRequestViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationInformationRequestViewModel extends IBaseViewModel {
    assistanceApplicationId?: string;
    requestDate?: Date;
    note?: string | null;
    requester?: string | null;
    requesterId?: string | null;
    informationProviderId?: string | null;
    informationProvider?: string | null;
    completedDate?: Date;
}

export class Client extends BaseViewModel implements IClient {
    ssn?: string | null;
    last4Ssn?: string | null;
    missingSsn?: boolean | null;
    prefix?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleInitial?: string | null;
    suffix?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    birthYear?: number | null;
    gender?: string | null;
    race?: string | null;
    otherRace?: string | null;
    houseHoldIncome?: number | null;
    houseHoldSize?: number | null;
    individualMonthlyIncome?: number | null;
    employmentStatus?: string | null;
    unionInfo?: string | null;
    isElderly?: boolean;
    isDisabled?: boolean;
    hasChildrenUnderFive?: boolean;
    isVeteran?: boolean;
    isHomeless?: boolean;
    isVerifiedPublicHousing?: boolean;
    membersAreElderly?: boolean;
    membersAreDisabled?: boolean;
    membersHaveChildrenUnderFive?: boolean;
    phoneAlt?: string | null;
    createdByAgencyId?: string | null;
    federalPovertyLevelDisplay?: number | null;
    phoneExt?: string | null;
    email?: string | null;
    lastVerifiedDate?: Date | null;
    lastVerifiedBy?: string | null;
    isVerificationStale?: boolean | null;

    constructor(data?: IClient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
            this.missingSsn = _data["missingSsn"] !== undefined ? _data["missingSsn"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.suffix = _data["suffix"] !== undefined ? _data["suffix"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.race = _data["race"] !== undefined ? _data["race"] : null as any;
            this.otherRace = _data["otherRace"] !== undefined ? _data["otherRace"] : null as any;
            this.houseHoldIncome = _data["houseHoldIncome"] !== undefined ? _data["houseHoldIncome"] : null as any;
            this.houseHoldSize = _data["houseHoldSize"] !== undefined ? _data["houseHoldSize"] : null as any;
            this.individualMonthlyIncome = _data["individualMonthlyIncome"] !== undefined ? _data["individualMonthlyIncome"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.unionInfo = _data["unionInfo"] !== undefined ? _data["unionInfo"] : null as any;
            this.isElderly = _data["isElderly"] !== undefined ? _data["isElderly"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.hasChildrenUnderFive = _data["hasChildrenUnderFive"] !== undefined ? _data["hasChildrenUnderFive"] : null as any;
            this.isVeteran = _data["isVeteran"] !== undefined ? _data["isVeteran"] : null as any;
            this.isHomeless = _data["isHomeless"] !== undefined ? _data["isHomeless"] : null as any;
            this.isVerifiedPublicHousing = _data["isVerifiedPublicHousing"] !== undefined ? _data["isVerifiedPublicHousing"] : null as any;
            this.membersAreElderly = _data["membersAreElderly"] !== undefined ? _data["membersAreElderly"] : null as any;
            this.membersAreDisabled = _data["membersAreDisabled"] !== undefined ? _data["membersAreDisabled"] : null as any;
            this.membersHaveChildrenUnderFive = _data["membersHaveChildrenUnderFive"] !== undefined ? _data["membersHaveChildrenUnderFive"] : null as any;
            this.phoneAlt = _data["phoneAlt"] !== undefined ? _data["phoneAlt"] : null as any;
            this.createdByAgencyId = _data["createdByAgencyId"] !== undefined ? _data["createdByAgencyId"] : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.phoneExt = _data["phoneExt"] !== undefined ? _data["phoneExt"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.lastVerifiedDate = _data["lastVerifiedDate"] ? new Date(_data["lastVerifiedDate"].toString()) : null as any;
            this.lastVerifiedBy = _data["lastVerifiedBy"] !== undefined ? _data["lastVerifiedBy"] : null as any;
            this.isVerificationStale = _data["isVerificationStale"] !== undefined ? _data["isVerificationStale"] : null as any;
        }
    }

    static override fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        data["missingSsn"] = this.missingSsn !== undefined ? this.missingSsn : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["suffix"] = this.suffix !== undefined ? this.suffix : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["race"] = this.race !== undefined ? this.race : null as any;
        data["otherRace"] = this.otherRace !== undefined ? this.otherRace : null as any;
        data["houseHoldIncome"] = this.houseHoldIncome !== undefined ? this.houseHoldIncome : null as any;
        data["houseHoldSize"] = this.houseHoldSize !== undefined ? this.houseHoldSize : null as any;
        data["individualMonthlyIncome"] = this.individualMonthlyIncome !== undefined ? this.individualMonthlyIncome : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["unionInfo"] = this.unionInfo !== undefined ? this.unionInfo : null as any;
        data["isElderly"] = this.isElderly !== undefined ? this.isElderly : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["hasChildrenUnderFive"] = this.hasChildrenUnderFive !== undefined ? this.hasChildrenUnderFive : null as any;
        data["isVeteran"] = this.isVeteran !== undefined ? this.isVeteran : null as any;
        data["isHomeless"] = this.isHomeless !== undefined ? this.isHomeless : null as any;
        data["isVerifiedPublicHousing"] = this.isVerifiedPublicHousing !== undefined ? this.isVerifiedPublicHousing : null as any;
        data["membersAreElderly"] = this.membersAreElderly !== undefined ? this.membersAreElderly : null as any;
        data["membersAreDisabled"] = this.membersAreDisabled !== undefined ? this.membersAreDisabled : null as any;
        data["membersHaveChildrenUnderFive"] = this.membersHaveChildrenUnderFive !== undefined ? this.membersHaveChildrenUnderFive : null as any;
        data["phoneAlt"] = this.phoneAlt !== undefined ? this.phoneAlt : null as any;
        data["createdByAgencyId"] = this.createdByAgencyId !== undefined ? this.createdByAgencyId : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["phoneExt"] = this.phoneExt !== undefined ? this.phoneExt : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["lastVerifiedDate"] = this.lastVerifiedDate ? this.lastVerifiedDate.toISOString() : null as any;
        data["lastVerifiedBy"] = this.lastVerifiedBy !== undefined ? this.lastVerifiedBy : null as any;
        data["isVerificationStale"] = this.isVerificationStale !== undefined ? this.isVerificationStale : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Client {
        const json = this.toJSON();
        let result = new Client();
        result.init(json);
        return result;
    }
}

export interface IClient extends IBaseViewModel {
    ssn?: string | null;
    last4Ssn?: string | null;
    missingSsn?: boolean | null;
    prefix?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleInitial?: string | null;
    suffix?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    birthYear?: number | null;
    gender?: string | null;
    race?: string | null;
    otherRace?: string | null;
    houseHoldIncome?: number | null;
    houseHoldSize?: number | null;
    individualMonthlyIncome?: number | null;
    employmentStatus?: string | null;
    unionInfo?: string | null;
    isElderly?: boolean;
    isDisabled?: boolean;
    hasChildrenUnderFive?: boolean;
    isVeteran?: boolean;
    isHomeless?: boolean;
    isVerifiedPublicHousing?: boolean;
    membersAreElderly?: boolean;
    membersAreDisabled?: boolean;
    membersHaveChildrenUnderFive?: boolean;
    phoneAlt?: string | null;
    createdByAgencyId?: string | null;
    federalPovertyLevelDisplay?: number | null;
    phoneExt?: string | null;
    email?: string | null;
    lastVerifiedDate?: Date | null;
    lastVerifiedBy?: string | null;
    isVerificationStale?: boolean | null;
}

export class FundType extends BaseViewModel implements IFundType {
    name?: string | null;
    slug?: string | null;
    auditType?: AuditType;
    isBirthYearAndSsnOptional?: boolean;

    constructor(data?: IFundType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : null as any;
            this.auditType = _data["auditType"] !== undefined ? _data["auditType"] : null as any;
            this.isBirthYearAndSsnOptional = _data["isBirthYearAndSsnOptional"] !== undefined ? _data["isBirthYearAndSsnOptional"] : null as any;
        }
    }

    static override fromJS(data: any): FundType {
        data = typeof data === 'object' ? data : {};
        let result = new FundType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["slug"] = this.slug !== undefined ? this.slug : null as any;
        data["auditType"] = this.auditType !== undefined ? this.auditType : null as any;
        data["isBirthYearAndSsnOptional"] = this.isBirthYearAndSsnOptional !== undefined ? this.isBirthYearAndSsnOptional : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FundType {
        const json = this.toJSON();
        let result = new FundType();
        result.init(json);
        return result;
    }
}

export interface IFundType extends IBaseViewModel {
    name?: string | null;
    slug?: string | null;
    auditType?: AuditType;
    isBirthYearAndSsnOptional?: boolean;
}

export enum AuditType {
    None = "None",
    ReviewAndAudit = "ReviewAndAudit",
    AgencyReview = "AgencyReview",
}

export class User extends BaseViewModel implements IUser {
    companyId?: string | null;
    agencyId?: string | null;
    username?: string | null;
    userType?: UserType;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    password?: string | null;
    status?: UserStatusType;
    emailOptOut?: boolean;
    passwordExpire?: Date | null;
    accessFailedCount?: number;
    lockoutEnd?: Date | null;
    phone?: string | null;
    phoneExt?: string | null;
    company?: Company | null;
    agency?: Agency | null;
    hasKeepingCurrent?: boolean;
    receiveEfnEmails?: boolean;
    hasEfs?: boolean;
    hasEfn?: boolean;
    hasPrivate?: boolean;
    programAccess?: AssistanceApplicationType[] | null;
    isManagementAgencyUser?: boolean;
    uwAgreementDate?: Date | null;
    canAuditApplications?: boolean | null;
    canReviewApplications?: boolean | null;

    constructor(data?: IUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.emailOptOut = _data["emailOptOut"] !== undefined ? _data["emailOptOut"] : null as any;
            this.passwordExpire = _data["passwordExpire"] ? new Date(_data["passwordExpire"].toString()) : null as any;
            this.accessFailedCount = _data["accessFailedCount"] !== undefined ? _data["accessFailedCount"] : null as any;
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.phoneExt = _data["phoneExt"] !== undefined ? _data["phoneExt"] : null as any;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : null as any;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : null as any;
            this.hasKeepingCurrent = _data["hasKeepingCurrent"] !== undefined ? _data["hasKeepingCurrent"] : null as any;
            this.receiveEfnEmails = _data["receiveEfnEmails"] !== undefined ? _data["receiveEfnEmails"] : null as any;
            this.hasEfs = _data["hasEfs"] !== undefined ? _data["hasEfs"] : null as any;
            this.hasEfn = _data["hasEfn"] !== undefined ? _data["hasEfn"] : null as any;
            this.hasPrivate = _data["hasPrivate"] !== undefined ? _data["hasPrivate"] : null as any;
            if (Array.isArray(_data["programAccess"])) {
                this.programAccess = [] as any;
                for (let item of _data["programAccess"])
                    this.programAccess!.push(item);
            }
            else {
                this.programAccess = null as any;
            }
            this.isManagementAgencyUser = _data["isManagementAgencyUser"] !== undefined ? _data["isManagementAgencyUser"] : null as any;
            this.uwAgreementDate = _data["uwAgreementDate"] ? new Date(_data["uwAgreementDate"].toString()) : null as any;
            this.canAuditApplications = _data["canAuditApplications"] !== undefined ? _data["canAuditApplications"] : null as any;
            this.canReviewApplications = _data["canReviewApplications"] !== undefined ? _data["canReviewApplications"] : null as any;
        }
    }

    static override fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["emailOptOut"] = this.emailOptOut !== undefined ? this.emailOptOut : null as any;
        data["passwordExpire"] = this.passwordExpire ? this.passwordExpire.toISOString() : null as any;
        data["accessFailedCount"] = this.accessFailedCount !== undefined ? this.accessFailedCount : null as any;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["phoneExt"] = this.phoneExt !== undefined ? this.phoneExt : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["hasKeepingCurrent"] = this.hasKeepingCurrent !== undefined ? this.hasKeepingCurrent : null as any;
        data["receiveEfnEmails"] = this.receiveEfnEmails !== undefined ? this.receiveEfnEmails : null as any;
        data["hasEfs"] = this.hasEfs !== undefined ? this.hasEfs : null as any;
        data["hasEfn"] = this.hasEfn !== undefined ? this.hasEfn : null as any;
        data["hasPrivate"] = this.hasPrivate !== undefined ? this.hasPrivate : null as any;
        if (Array.isArray(this.programAccess)) {
            data["programAccess"] = [];
            for (let item of this.programAccess)
                data["programAccess"].push(item);
        }
        data["isManagementAgencyUser"] = this.isManagementAgencyUser !== undefined ? this.isManagementAgencyUser : null as any;
        data["uwAgreementDate"] = this.uwAgreementDate ? this.uwAgreementDate.toISOString() : null as any;
        data["canAuditApplications"] = this.canAuditApplications !== undefined ? this.canAuditApplications : null as any;
        data["canReviewApplications"] = this.canReviewApplications !== undefined ? this.canReviewApplications : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser extends IBaseViewModel {
    companyId?: string | null;
    agencyId?: string | null;
    username?: string | null;
    userType?: UserType;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    password?: string | null;
    status?: UserStatusType;
    emailOptOut?: boolean;
    passwordExpire?: Date | null;
    accessFailedCount?: number;
    lockoutEnd?: Date | null;
    phone?: string | null;
    phoneExt?: string | null;
    company?: Company | null;
    agency?: Agency | null;
    hasKeepingCurrent?: boolean;
    receiveEfnEmails?: boolean;
    hasEfs?: boolean;
    hasEfn?: boolean;
    hasPrivate?: boolean;
    programAccess?: AssistanceApplicationType[] | null;
    isManagementAgencyUser?: boolean;
    uwAgreementDate?: Date | null;
    canAuditApplications?: boolean | null;
    canReviewApplications?: boolean | null;
}

export enum UserType {
    User = "User",
    Viewer = "Viewer",
    AgencyAdmin = "AgencyAdmin",
    FundAdmin = "FundAdmin",
    SystemAdmin = "SystemAdmin",
    RegionAdmin = "RegionAdmin",
}

export enum UserStatusType {
    Unknown = "Unknown",
    Active = "Active",
    Disabled = "Disabled",
}

export class Company extends BaseViewModel implements ICompany {
    isUwdaCompany?: boolean;
    name?: string | null;
    isIndividual?: boolean;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    allocateAllowed?: boolean | null;
    sortOrder?: number | null;
    status?: StatusType;
    contactName1?: string | null;
    contactPhone1?: string | null;
    contactName2?: string | null;
    contactPhone2?: string | null;
    contactName3?: string | null;
    contactPhone3?: string | null;
    isAccountValidationEnforced?: boolean | null;
    isAccountValidAlphabetical?: boolean | null;
    isAccountValidNumerical?: boolean | null;
    isAccountValidSpecialChars?: boolean | null;
    accountValidationMinLen?: number | null;
    accountValidationMaxLen?: number | null;
    accountValidationErrorMsg?: string | null;
    urlLink?: string | null;
    urlDisplay?: string | null;
    lastUsedDate?: Date | null;
    regionValue?: string[] | null;
    pledgeTypeIds?: string[] | null;
    payeeType?: CompanyPayeeType;
    category?: CompanyCategoryType;
    categoryLabel?: string | null;

    constructor(data?: ICompany) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isUwdaCompany = _data["isUwdaCompany"] !== undefined ? _data["isUwdaCompany"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isIndividual = _data["isIndividual"] !== undefined ? _data["isIndividual"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.allocateAllowed = _data["allocateAllowed"] !== undefined ? _data["allocateAllowed"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.contactName1 = _data["contactName1"] !== undefined ? _data["contactName1"] : null as any;
            this.contactPhone1 = _data["contactPhone1"] !== undefined ? _data["contactPhone1"] : null as any;
            this.contactName2 = _data["contactName2"] !== undefined ? _data["contactName2"] : null as any;
            this.contactPhone2 = _data["contactPhone2"] !== undefined ? _data["contactPhone2"] : null as any;
            this.contactName3 = _data["contactName3"] !== undefined ? _data["contactName3"] : null as any;
            this.contactPhone3 = _data["contactPhone3"] !== undefined ? _data["contactPhone3"] : null as any;
            this.isAccountValidationEnforced = _data["isAccountValidationEnforced"] !== undefined ? _data["isAccountValidationEnforced"] : null as any;
            this.isAccountValidAlphabetical = _data["isAccountValidAlphabetical"] !== undefined ? _data["isAccountValidAlphabetical"] : null as any;
            this.isAccountValidNumerical = _data["isAccountValidNumerical"] !== undefined ? _data["isAccountValidNumerical"] : null as any;
            this.isAccountValidSpecialChars = _data["isAccountValidSpecialChars"] !== undefined ? _data["isAccountValidSpecialChars"] : null as any;
            this.accountValidationMinLen = _data["accountValidationMinLen"] !== undefined ? _data["accountValidationMinLen"] : null as any;
            this.accountValidationMaxLen = _data["accountValidationMaxLen"] !== undefined ? _data["accountValidationMaxLen"] : null as any;
            this.accountValidationErrorMsg = _data["accountValidationErrorMsg"] !== undefined ? _data["accountValidationErrorMsg"] : null as any;
            this.urlLink = _data["urlLink"] !== undefined ? _data["urlLink"] : null as any;
            this.urlDisplay = _data["urlDisplay"] !== undefined ? _data["urlDisplay"] : null as any;
            this.lastUsedDate = _data["lastUsedDate"] ? new Date(_data["lastUsedDate"].toString()) : null as any;
            if (Array.isArray(_data["regionValue"])) {
                this.regionValue = [] as any;
                for (let item of _data["regionValue"])
                    this.regionValue!.push(item);
            }
            else {
                this.regionValue = null as any;
            }
            if (Array.isArray(_data["pledgeTypeIds"])) {
                this.pledgeTypeIds = [] as any;
                for (let item of _data["pledgeTypeIds"])
                    this.pledgeTypeIds!.push(item);
            }
            else {
                this.pledgeTypeIds = null as any;
            }
            this.payeeType = _data["payeeType"] !== undefined ? _data["payeeType"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.categoryLabel = _data["categoryLabel"] !== undefined ? _data["categoryLabel"] : null as any;
        }
    }

    static override fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUwdaCompany"] = this.isUwdaCompany !== undefined ? this.isUwdaCompany : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isIndividual"] = this.isIndividual !== undefined ? this.isIndividual : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["allocateAllowed"] = this.allocateAllowed !== undefined ? this.allocateAllowed : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["contactName1"] = this.contactName1 !== undefined ? this.contactName1 : null as any;
        data["contactPhone1"] = this.contactPhone1 !== undefined ? this.contactPhone1 : null as any;
        data["contactName2"] = this.contactName2 !== undefined ? this.contactName2 : null as any;
        data["contactPhone2"] = this.contactPhone2 !== undefined ? this.contactPhone2 : null as any;
        data["contactName3"] = this.contactName3 !== undefined ? this.contactName3 : null as any;
        data["contactPhone3"] = this.contactPhone3 !== undefined ? this.contactPhone3 : null as any;
        data["isAccountValidationEnforced"] = this.isAccountValidationEnforced !== undefined ? this.isAccountValidationEnforced : null as any;
        data["isAccountValidAlphabetical"] = this.isAccountValidAlphabetical !== undefined ? this.isAccountValidAlphabetical : null as any;
        data["isAccountValidNumerical"] = this.isAccountValidNumerical !== undefined ? this.isAccountValidNumerical : null as any;
        data["isAccountValidSpecialChars"] = this.isAccountValidSpecialChars !== undefined ? this.isAccountValidSpecialChars : null as any;
        data["accountValidationMinLen"] = this.accountValidationMinLen !== undefined ? this.accountValidationMinLen : null as any;
        data["accountValidationMaxLen"] = this.accountValidationMaxLen !== undefined ? this.accountValidationMaxLen : null as any;
        data["accountValidationErrorMsg"] = this.accountValidationErrorMsg !== undefined ? this.accountValidationErrorMsg : null as any;
        data["urlLink"] = this.urlLink !== undefined ? this.urlLink : null as any;
        data["urlDisplay"] = this.urlDisplay !== undefined ? this.urlDisplay : null as any;
        data["lastUsedDate"] = this.lastUsedDate ? this.lastUsedDate.toISOString() : null as any;
        if (Array.isArray(this.regionValue)) {
            data["regionValue"] = [];
            for (let item of this.regionValue)
                data["regionValue"].push(item);
        }
        if (Array.isArray(this.pledgeTypeIds)) {
            data["pledgeTypeIds"] = [];
            for (let item of this.pledgeTypeIds)
                data["pledgeTypeIds"].push(item);
        }
        data["payeeType"] = this.payeeType !== undefined ? this.payeeType : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["categoryLabel"] = this.categoryLabel !== undefined ? this.categoryLabel : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany extends IBaseViewModel {
    isUwdaCompany?: boolean;
    name?: string | null;
    isIndividual?: boolean;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    allocateAllowed?: boolean | null;
    sortOrder?: number | null;
    status?: StatusType;
    contactName1?: string | null;
    contactPhone1?: string | null;
    contactName2?: string | null;
    contactPhone2?: string | null;
    contactName3?: string | null;
    contactPhone3?: string | null;
    isAccountValidationEnforced?: boolean | null;
    isAccountValidAlphabetical?: boolean | null;
    isAccountValidNumerical?: boolean | null;
    isAccountValidSpecialChars?: boolean | null;
    accountValidationMinLen?: number | null;
    accountValidationMaxLen?: number | null;
    accountValidationErrorMsg?: string | null;
    urlLink?: string | null;
    urlDisplay?: string | null;
    lastUsedDate?: Date | null;
    regionValue?: string[] | null;
    pledgeTypeIds?: string[] | null;
    payeeType?: CompanyPayeeType;
    category?: CompanyCategoryType;
    categoryLabel?: string | null;
}

export enum CompanyPayeeType {
    Company = "Company",
    Individual = "Individual",
}

export enum CompanyCategoryType {
    EmergencyRentalAssistance = "EmergencyRentalAssistance",
    TransportationForWorkforceNeeds = "TransportationForWorkforceNeeds",
    Utility = "Utility",
    ChildcareSupport = "ChildcareSupport",
    CarRepair = "CarRepair",
    Appliances = "Appliances",
    MoldRemediationAssistance = "MoldRemediationAssistance",
    TemporaryStorage = "TemporaryStorage",
    HvacPlumbing = "HvacPlumbing",
    Construction = "Construction",
    OtherDisasterCausedNeeds = "OtherDisasterCausedNeeds",
}

export class AssistanceApplicationAreasOfNeed extends BaseViewModel implements IAssistanceApplicationAreasOfNeed {
    assistanceApplicationId?: string | null;
    uhonsRent?: boolean | null;
    uhonsElectric?: boolean | null;
    uhonsGasHeat?: boolean | null;
    uhonsWater?: boolean | null;
    uhonsSewer?: boolean | null;
    uhonsChildcareExpenses?: boolean | null;
    uhonsTransportationRideShare?: boolean | null;
    uhonsCarRepair?: boolean | null;
    evictionNotification?: boolean | null;
    uffMortgagePayment?: boolean | null;
    uffCarInsurance?: boolean | null;
    uffChildEdSupportUniforms?: boolean | null;
    uffSecurityDeposit?: boolean | null;
    uffTuition?: boolean | null;
    uffCarRepair?: boolean | null;
    uffRentPayment?: boolean | null;
    uffStateLicensedChildcareProvider?: boolean | null;
    uffMovingExpenses?: boolean | null;
    uffChildSupportTutoring?: boolean | null;
    uffCarPayment?: boolean | null;
    uffUtilityBills?: boolean | null;
    stlWaterWater?: boolean | null;
    stormAppliances?: boolean | null;
    stormMoldRemediationAssistance?: boolean | null;
    stormTemporaryStorageAssistance?: boolean | null;
    stormHvacPlumbing?: boolean | null;
    stormConstruction?: boolean | null;
    stormOtherDisasterCausedUnmetNeeds?: boolean | null;

    constructor(data?: IAssistanceApplicationAreasOfNeed) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.uhonsRent = _data["uhonsRent"] !== undefined ? _data["uhonsRent"] : null as any;
            this.uhonsElectric = _data["uhonsElectric"] !== undefined ? _data["uhonsElectric"] : null as any;
            this.uhonsGasHeat = _data["uhonsGasHeat"] !== undefined ? _data["uhonsGasHeat"] : null as any;
            this.uhonsWater = _data["uhonsWater"] !== undefined ? _data["uhonsWater"] : null as any;
            this.uhonsSewer = _data["uhonsSewer"] !== undefined ? _data["uhonsSewer"] : null as any;
            this.uhonsChildcareExpenses = _data["uhonsChildcareExpenses"] !== undefined ? _data["uhonsChildcareExpenses"] : null as any;
            this.uhonsTransportationRideShare = _data["uhonsTransportationRideShare"] !== undefined ? _data["uhonsTransportationRideShare"] : null as any;
            this.uhonsCarRepair = _data["uhonsCarRepair"] !== undefined ? _data["uhonsCarRepair"] : null as any;
            this.evictionNotification = _data["evictionNotification"] !== undefined ? _data["evictionNotification"] : null as any;
            this.uffMortgagePayment = _data["uffMortgagePayment"] !== undefined ? _data["uffMortgagePayment"] : null as any;
            this.uffCarInsurance = _data["uffCarInsurance"] !== undefined ? _data["uffCarInsurance"] : null as any;
            this.uffChildEdSupportUniforms = _data["uffChildEdSupportUniforms"] !== undefined ? _data["uffChildEdSupportUniforms"] : null as any;
            this.uffSecurityDeposit = _data["uffSecurityDeposit"] !== undefined ? _data["uffSecurityDeposit"] : null as any;
            this.uffTuition = _data["uffTuition"] !== undefined ? _data["uffTuition"] : null as any;
            this.uffCarRepair = _data["uffCarRepair"] !== undefined ? _data["uffCarRepair"] : null as any;
            this.uffRentPayment = _data["uffRentPayment"] !== undefined ? _data["uffRentPayment"] : null as any;
            this.uffStateLicensedChildcareProvider = _data["uffStateLicensedChildcareProvider"] !== undefined ? _data["uffStateLicensedChildcareProvider"] : null as any;
            this.uffMovingExpenses = _data["uffMovingExpenses"] !== undefined ? _data["uffMovingExpenses"] : null as any;
            this.uffChildSupportTutoring = _data["uffChildSupportTutoring"] !== undefined ? _data["uffChildSupportTutoring"] : null as any;
            this.uffCarPayment = _data["uffCarPayment"] !== undefined ? _data["uffCarPayment"] : null as any;
            this.uffUtilityBills = _data["uffUtilityBills"] !== undefined ? _data["uffUtilityBills"] : null as any;
            this.stlWaterWater = _data["stlWaterWater"] !== undefined ? _data["stlWaterWater"] : null as any;
            this.stormAppliances = _data["stormAppliances"] !== undefined ? _data["stormAppliances"] : null as any;
            this.stormMoldRemediationAssistance = _data["stormMoldRemediationAssistance"] !== undefined ? _data["stormMoldRemediationAssistance"] : null as any;
            this.stormTemporaryStorageAssistance = _data["stormTemporaryStorageAssistance"] !== undefined ? _data["stormTemporaryStorageAssistance"] : null as any;
            this.stormHvacPlumbing = _data["stormHvacPlumbing"] !== undefined ? _data["stormHvacPlumbing"] : null as any;
            this.stormConstruction = _data["stormConstruction"] !== undefined ? _data["stormConstruction"] : null as any;
            this.stormOtherDisasterCausedUnmetNeeds = _data["stormOtherDisasterCausedUnmetNeeds"] !== undefined ? _data["stormOtherDisasterCausedUnmetNeeds"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationAreasOfNeed {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationAreasOfNeed();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["uhonsRent"] = this.uhonsRent !== undefined ? this.uhonsRent : null as any;
        data["uhonsElectric"] = this.uhonsElectric !== undefined ? this.uhonsElectric : null as any;
        data["uhonsGasHeat"] = this.uhonsGasHeat !== undefined ? this.uhonsGasHeat : null as any;
        data["uhonsWater"] = this.uhonsWater !== undefined ? this.uhonsWater : null as any;
        data["uhonsSewer"] = this.uhonsSewer !== undefined ? this.uhonsSewer : null as any;
        data["uhonsChildcareExpenses"] = this.uhonsChildcareExpenses !== undefined ? this.uhonsChildcareExpenses : null as any;
        data["uhonsTransportationRideShare"] = this.uhonsTransportationRideShare !== undefined ? this.uhonsTransportationRideShare : null as any;
        data["uhonsCarRepair"] = this.uhonsCarRepair !== undefined ? this.uhonsCarRepair : null as any;
        data["evictionNotification"] = this.evictionNotification !== undefined ? this.evictionNotification : null as any;
        data["uffMortgagePayment"] = this.uffMortgagePayment !== undefined ? this.uffMortgagePayment : null as any;
        data["uffCarInsurance"] = this.uffCarInsurance !== undefined ? this.uffCarInsurance : null as any;
        data["uffChildEdSupportUniforms"] = this.uffChildEdSupportUniforms !== undefined ? this.uffChildEdSupportUniforms : null as any;
        data["uffSecurityDeposit"] = this.uffSecurityDeposit !== undefined ? this.uffSecurityDeposit : null as any;
        data["uffTuition"] = this.uffTuition !== undefined ? this.uffTuition : null as any;
        data["uffCarRepair"] = this.uffCarRepair !== undefined ? this.uffCarRepair : null as any;
        data["uffRentPayment"] = this.uffRentPayment !== undefined ? this.uffRentPayment : null as any;
        data["uffStateLicensedChildcareProvider"] = this.uffStateLicensedChildcareProvider !== undefined ? this.uffStateLicensedChildcareProvider : null as any;
        data["uffMovingExpenses"] = this.uffMovingExpenses !== undefined ? this.uffMovingExpenses : null as any;
        data["uffChildSupportTutoring"] = this.uffChildSupportTutoring !== undefined ? this.uffChildSupportTutoring : null as any;
        data["uffCarPayment"] = this.uffCarPayment !== undefined ? this.uffCarPayment : null as any;
        data["uffUtilityBills"] = this.uffUtilityBills !== undefined ? this.uffUtilityBills : null as any;
        data["stlWaterWater"] = this.stlWaterWater !== undefined ? this.stlWaterWater : null as any;
        data["stormAppliances"] = this.stormAppliances !== undefined ? this.stormAppliances : null as any;
        data["stormMoldRemediationAssistance"] = this.stormMoldRemediationAssistance !== undefined ? this.stormMoldRemediationAssistance : null as any;
        data["stormTemporaryStorageAssistance"] = this.stormTemporaryStorageAssistance !== undefined ? this.stormTemporaryStorageAssistance : null as any;
        data["stormHvacPlumbing"] = this.stormHvacPlumbing !== undefined ? this.stormHvacPlumbing : null as any;
        data["stormConstruction"] = this.stormConstruction !== undefined ? this.stormConstruction : null as any;
        data["stormOtherDisasterCausedUnmetNeeds"] = this.stormOtherDisasterCausedUnmetNeeds !== undefined ? this.stormOtherDisasterCausedUnmetNeeds : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationAreasOfNeed {
        const json = this.toJSON();
        let result = new AssistanceApplicationAreasOfNeed();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationAreasOfNeed extends IBaseViewModel {
    assistanceApplicationId?: string | null;
    uhonsRent?: boolean | null;
    uhonsElectric?: boolean | null;
    uhonsGasHeat?: boolean | null;
    uhonsWater?: boolean | null;
    uhonsSewer?: boolean | null;
    uhonsChildcareExpenses?: boolean | null;
    uhonsTransportationRideShare?: boolean | null;
    uhonsCarRepair?: boolean | null;
    evictionNotification?: boolean | null;
    uffMortgagePayment?: boolean | null;
    uffCarInsurance?: boolean | null;
    uffChildEdSupportUniforms?: boolean | null;
    uffSecurityDeposit?: boolean | null;
    uffTuition?: boolean | null;
    uffCarRepair?: boolean | null;
    uffRentPayment?: boolean | null;
    uffStateLicensedChildcareProvider?: boolean | null;
    uffMovingExpenses?: boolean | null;
    uffChildSupportTutoring?: boolean | null;
    uffCarPayment?: boolean | null;
    uffUtilityBills?: boolean | null;
    stlWaterWater?: boolean | null;
    stormAppliances?: boolean | null;
    stormMoldRemediationAssistance?: boolean | null;
    stormTemporaryStorageAssistance?: boolean | null;
    stormHvacPlumbing?: boolean | null;
    stormConstruction?: boolean | null;
    stormOtherDisasterCausedUnmetNeeds?: boolean | null;
}

export class StormApplicationViewModel implements IStormApplicationViewModel {
    id?: string | null;
    assistanceApplicationId?: string | null;
    tierLevel?: TierLevel | null;
    femaRegistrationNumber?: string | null;
    visionLinkNumber?: string | null;
    longTermRecoveryApproved?: boolean | null;
    damagedDwellingAddress1?: string | null;
    damagedDwellingAddress2?: string | null;
    damagedDwellingCity?: string | null;
    damagedDwellingState?: string | null;
    damagedDwellingZipCode?: string | null;
    totalAmountRequestedToDate?: number | null;

    constructor(data?: IStormApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.tierLevel = _data["tierLevel"] !== undefined ? _data["tierLevel"] : null as any;
            this.femaRegistrationNumber = _data["femaRegistrationNumber"] !== undefined ? _data["femaRegistrationNumber"] : null as any;
            this.visionLinkNumber = _data["visionLinkNumber"] !== undefined ? _data["visionLinkNumber"] : null as any;
            this.longTermRecoveryApproved = _data["longTermRecoveryApproved"] !== undefined ? _data["longTermRecoveryApproved"] : null as any;
            this.damagedDwellingAddress1 = _data["damagedDwellingAddress1"] !== undefined ? _data["damagedDwellingAddress1"] : null as any;
            this.damagedDwellingAddress2 = _data["damagedDwellingAddress2"] !== undefined ? _data["damagedDwellingAddress2"] : null as any;
            this.damagedDwellingCity = _data["damagedDwellingCity"] !== undefined ? _data["damagedDwellingCity"] : null as any;
            this.damagedDwellingState = _data["damagedDwellingState"] !== undefined ? _data["damagedDwellingState"] : null as any;
            this.damagedDwellingZipCode = _data["damagedDwellingZipCode"] !== undefined ? _data["damagedDwellingZipCode"] : null as any;
            this.totalAmountRequestedToDate = _data["totalAmountRequestedToDate"] !== undefined ? _data["totalAmountRequestedToDate"] : null as any;
        }
    }

    static fromJS(data: any): StormApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StormApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["tierLevel"] = this.tierLevel !== undefined ? this.tierLevel : null as any;
        data["femaRegistrationNumber"] = this.femaRegistrationNumber !== undefined ? this.femaRegistrationNumber : null as any;
        data["visionLinkNumber"] = this.visionLinkNumber !== undefined ? this.visionLinkNumber : null as any;
        data["longTermRecoveryApproved"] = this.longTermRecoveryApproved !== undefined ? this.longTermRecoveryApproved : null as any;
        data["damagedDwellingAddress1"] = this.damagedDwellingAddress1 !== undefined ? this.damagedDwellingAddress1 : null as any;
        data["damagedDwellingAddress2"] = this.damagedDwellingAddress2 !== undefined ? this.damagedDwellingAddress2 : null as any;
        data["damagedDwellingCity"] = this.damagedDwellingCity !== undefined ? this.damagedDwellingCity : null as any;
        data["damagedDwellingState"] = this.damagedDwellingState !== undefined ? this.damagedDwellingState : null as any;
        data["damagedDwellingZipCode"] = this.damagedDwellingZipCode !== undefined ? this.damagedDwellingZipCode : null as any;
        data["totalAmountRequestedToDate"] = this.totalAmountRequestedToDate !== undefined ? this.totalAmountRequestedToDate : null as any;
        return data;
    }

    clone(): StormApplicationViewModel {
        const json = this.toJSON();
        let result = new StormApplicationViewModel();
        result.init(json);
        return result;
    }
}

export interface IStormApplicationViewModel {
    id?: string | null;
    assistanceApplicationId?: string | null;
    tierLevel?: TierLevel | null;
    femaRegistrationNumber?: string | null;
    visionLinkNumber?: string | null;
    longTermRecoveryApproved?: boolean | null;
    damagedDwellingAddress1?: string | null;
    damagedDwellingAddress2?: string | null;
    damagedDwellingCity?: string | null;
    damagedDwellingState?: string | null;
    damagedDwellingZipCode?: string | null;
    totalAmountRequestedToDate?: number | null;
}

export enum TierLevel {
    Tier1 = "Tier1",
    Tier2 = "Tier2",
    Tier3 = "Tier3",
    Tier4 = "Tier4",
}

export class AssistanceApplicationAdult extends BaseViewModel implements IAssistanceApplicationAdult {
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    last4Ssn?: string | null;
    employmentStatus?: string | null;
    monthlyIncomeAmount?: number;
    birthYear?: number | null;

    constructor(data?: IAssistanceApplicationAdult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.monthlyIncomeAmount = _data["monthlyIncomeAmount"] !== undefined ? _data["monthlyIncomeAmount"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationAdult {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationAdult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["monthlyIncomeAmount"] = this.monthlyIncomeAmount !== undefined ? this.monthlyIncomeAmount : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationAdult {
        const json = this.toJSON();
        let result = new AssistanceApplicationAdult();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationAdult extends IBaseViewModel {
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    last4Ssn?: string | null;
    employmentStatus?: string | null;
    monthlyIncomeAmount?: number;
    birthYear?: number | null;
}

export class AssistanceApplicationMinor extends BaseViewModel implements IAssistanceApplicationMinor {
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: number | null;
    ssn?: string | null;
    last4Ssn?: string | null;

    constructor(data?: IAssistanceApplicationMinor) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationMinor {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationMinor();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationMinor {
        const json = this.toJSON();
        let result = new AssistanceApplicationMinor();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationMinor extends IBaseViewModel {
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: number | null;
    ssn?: string | null;
    last4Ssn?: string | null;
}

export class AssistanceApplicationFile extends BaseViewModel implements IAssistanceApplicationFile {
    assistanceApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileType?: string | null;
    fileUrl?: string | null;
    caseFileType?: string | null;

    constructor(data?: IAssistanceApplicationFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.caseFileType = _data["caseFileType"] !== undefined ? _data["caseFileType"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationFile {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["caseFileType"] = this.caseFileType !== undefined ? this.caseFileType : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationFile {
        const json = this.toJSON();
        let result = new AssistanceApplicationFile();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationFile extends IBaseViewModel {
    assistanceApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileType?: string | null;
    fileUrl?: string | null;
    caseFileType?: string | null;
}

export class AssistanceApplicationCompany extends BaseViewModel implements IAssistanceApplicationCompany {
    paymentTo?: string | null;
    payeeAddress?: string | null;
    accountNumber?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    payeeAddress2?: string | null;
    companyName?: string | null;
    isLegacyPayee?: boolean;
    payeeType?: CompanyPayeeType | null;
    isUwdaCompany?: boolean | null;
    regionValue?: string[] | null;
    companyId?: string | null;
    amount?: number;
    category?: CompanyCategoryType;
    pledgeId?: string | null;

    constructor(data?: IAssistanceApplicationCompany) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentTo = _data["paymentTo"] !== undefined ? _data["paymentTo"] : null as any;
            this.payeeAddress = _data["payeeAddress"] !== undefined ? _data["payeeAddress"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.payeeCity = _data["payeeCity"] !== undefined ? _data["payeeCity"] : null as any;
            this.payeeState = _data["payeeState"] !== undefined ? _data["payeeState"] : null as any;
            this.payeeZip = _data["payeeZip"] !== undefined ? _data["payeeZip"] : null as any;
            this.payeeAddress2 = _data["payeeAddress2"] !== undefined ? _data["payeeAddress2"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.isLegacyPayee = _data["isLegacyPayee"] !== undefined ? _data["isLegacyPayee"] : null as any;
            this.payeeType = _data["payeeType"] !== undefined ? _data["payeeType"] : null as any;
            this.isUwdaCompany = _data["isUwdaCompany"] !== undefined ? _data["isUwdaCompany"] : null as any;
            if (Array.isArray(_data["regionValue"])) {
                this.regionValue = [] as any;
                for (let item of _data["regionValue"])
                    this.regionValue!.push(item);
            }
            else {
                this.regionValue = null as any;
            }
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationCompany {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationCompany();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTo"] = this.paymentTo !== undefined ? this.paymentTo : null as any;
        data["payeeAddress"] = this.payeeAddress !== undefined ? this.payeeAddress : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["payeeCity"] = this.payeeCity !== undefined ? this.payeeCity : null as any;
        data["payeeState"] = this.payeeState !== undefined ? this.payeeState : null as any;
        data["payeeZip"] = this.payeeZip !== undefined ? this.payeeZip : null as any;
        data["payeeAddress2"] = this.payeeAddress2 !== undefined ? this.payeeAddress2 : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["isLegacyPayee"] = this.isLegacyPayee !== undefined ? this.isLegacyPayee : null as any;
        data["payeeType"] = this.payeeType !== undefined ? this.payeeType : null as any;
        data["isUwdaCompany"] = this.isUwdaCompany !== undefined ? this.isUwdaCompany : null as any;
        if (Array.isArray(this.regionValue)) {
            data["regionValue"] = [];
            for (let item of this.regionValue)
                data["regionValue"].push(item);
        }
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationCompany {
        const json = this.toJSON();
        let result = new AssistanceApplicationCompany();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationCompany extends IBaseViewModel {
    paymentTo?: string | null;
    payeeAddress?: string | null;
    accountNumber?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    payeeAddress2?: string | null;
    companyName?: string | null;
    isLegacyPayee?: boolean;
    payeeType?: CompanyPayeeType | null;
    isUwdaCompany?: boolean | null;
    regionValue?: string[] | null;
    companyId?: string | null;
    amount?: number;
    category?: CompanyCategoryType;
    pledgeId?: string | null;
}

export class CreateAssistanceApplication implements ICreateAssistanceApplication {
    clientId?: string;
    fundTypeId?: string | null;
    applicationType?: AssistanceApplicationType;
    assignedAgencyId?: string | null;
    createdByUserId?: string | null;
    companyId?: string | null;
    summary?: string | null;
    description?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: string | null;
    totalNeed?: number | null;
    fundPledgeTypeId?: string | null;
    familyEducatedAboutResources?: boolean | null;
    client?: Client | null;
    assignedAgency?: Agency | null;
    stormApplication?: StormApplicationViewModel | null;
    assistanceApplicationAreasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    adults?: AssistanceApplicationAdult[] | null;
    minors?: AssistanceApplicationMinor[] | null;
    companies?: AssistanceApplicationCompany[] | null;
    draftId?: string | null;
    pendingAddressChangeRequests?: CompanyAddressChangeRequestViewModel[] | null;

    constructor(data?: ICreateAssistanceApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.fundTypeId = _data["fundTypeId"] !== undefined ? _data["fundTypeId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.assignedAgencyId = _data["assignedAgencyId"] !== undefined ? _data["assignedAgencyId"] : null as any;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.fundedDate = _data["fundedDate"] ? new Date(_data["fundedDate"].toString()) : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.fundPledgeTypeId = _data["fundPledgeTypeId"] !== undefined ? _data["fundPledgeTypeId"] : null as any;
            this.familyEducatedAboutResources = _data["familyEducatedAboutResources"] !== undefined ? _data["familyEducatedAboutResources"] : null as any;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : null as any;
            this.assignedAgency = _data["assignedAgency"] ? Agency.fromJS(_data["assignedAgency"]) : null as any;
            this.stormApplication = _data["stormApplication"] ? StormApplicationViewModel.fromJS(_data["stormApplication"]) : null as any;
            this.assistanceApplicationAreasOfNeed = _data["assistanceApplicationAreasOfNeed"] ? AssistanceApplicationAreasOfNeed.fromJS(_data["assistanceApplicationAreasOfNeed"]) : null as any;
            if (Array.isArray(_data["adults"])) {
                this.adults = [] as any;
                for (let item of _data["adults"])
                    this.adults!.push(AssistanceApplicationAdult.fromJS(item));
            }
            else {
                this.adults = null as any;
            }
            if (Array.isArray(_data["minors"])) {
                this.minors = [] as any;
                for (let item of _data["minors"])
                    this.minors!.push(AssistanceApplicationMinor.fromJS(item));
            }
            else {
                this.minors = null as any;
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(AssistanceApplicationCompany.fromJS(item));
            }
            else {
                this.companies = null as any;
            }
            this.draftId = _data["draftId"] !== undefined ? _data["draftId"] : null as any;
            if (Array.isArray(_data["pendingAddressChangeRequests"])) {
                this.pendingAddressChangeRequests = [] as any;
                for (let item of _data["pendingAddressChangeRequests"])
                    this.pendingAddressChangeRequests!.push(CompanyAddressChangeRequestViewModel.fromJS(item));
            }
            else {
                this.pendingAddressChangeRequests = null as any;
            }
        }
    }

    static fromJS(data: any): CreateAssistanceApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssistanceApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["fundTypeId"] = this.fundTypeId !== undefined ? this.fundTypeId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["assignedAgencyId"] = this.assignedAgencyId !== undefined ? this.assignedAgencyId : null as any;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["fundedDate"] = this.fundedDate ? this.fundedDate.toISOString() : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["fundPledgeTypeId"] = this.fundPledgeTypeId !== undefined ? this.fundPledgeTypeId : null as any;
        data["familyEducatedAboutResources"] = this.familyEducatedAboutResources !== undefined ? this.familyEducatedAboutResources : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["assignedAgency"] = this.assignedAgency ? this.assignedAgency.toJSON() : null as any;
        data["stormApplication"] = this.stormApplication ? this.stormApplication.toJSON() : null as any;
        data["assistanceApplicationAreasOfNeed"] = this.assistanceApplicationAreasOfNeed ? this.assistanceApplicationAreasOfNeed.toJSON() : null as any;
        if (Array.isArray(this.adults)) {
            data["adults"] = [];
            for (let item of this.adults)
                data["adults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.minors)) {
            data["minors"] = [];
            for (let item of this.minors)
                data["minors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : null as any);
        }
        data["draftId"] = this.draftId !== undefined ? this.draftId : null as any;
        if (Array.isArray(this.pendingAddressChangeRequests)) {
            data["pendingAddressChangeRequests"] = [];
            for (let item of this.pendingAddressChangeRequests)
                data["pendingAddressChangeRequests"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): CreateAssistanceApplication {
        const json = this.toJSON();
        let result = new CreateAssistanceApplication();
        result.init(json);
        return result;
    }
}

export interface ICreateAssistanceApplication {
    clientId?: string;
    fundTypeId?: string | null;
    applicationType?: AssistanceApplicationType;
    assignedAgencyId?: string | null;
    createdByUserId?: string | null;
    companyId?: string | null;
    summary?: string | null;
    description?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: string | null;
    totalNeed?: number | null;
    fundPledgeTypeId?: string | null;
    familyEducatedAboutResources?: boolean | null;
    client?: Client | null;
    assignedAgency?: Agency | null;
    stormApplication?: StormApplicationViewModel | null;
    assistanceApplicationAreasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    adults?: AssistanceApplicationAdult[] | null;
    minors?: AssistanceApplicationMinor[] | null;
    companies?: AssistanceApplicationCompany[] | null;
    draftId?: string | null;
    pendingAddressChangeRequests?: CompanyAddressChangeRequestViewModel[] | null;
}

export class CompanyAddressChangeRequestViewModel extends BaseViewModel implements ICompanyAddressChangeRequestViewModel {
    companyId?: string;
    requestedByUserId?: string | null;
    assistanceApplicationId?: string | null;
    status?: CompanyAddressChangeRequestStatus | null;
    companyName?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    oldAddress1?: string | null;
    oldAddress2?: string | null;
    oldCity?: string | null;
    oldState?: string | null;
    oldZipCode?: string | null;
    requestedByName?: string | null;

    constructor(data?: ICompanyAddressChangeRequestViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.requestedByUserId = _data["requestedByUserId"] !== undefined ? _data["requestedByUserId"] : null as any;
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.oldAddress1 = _data["oldAddress1"] !== undefined ? _data["oldAddress1"] : null as any;
            this.oldAddress2 = _data["oldAddress2"] !== undefined ? _data["oldAddress2"] : null as any;
            this.oldCity = _data["oldCity"] !== undefined ? _data["oldCity"] : null as any;
            this.oldState = _data["oldState"] !== undefined ? _data["oldState"] : null as any;
            this.oldZipCode = _data["oldZipCode"] !== undefined ? _data["oldZipCode"] : null as any;
            this.requestedByName = _data["requestedByName"] !== undefined ? _data["requestedByName"] : null as any;
        }
    }

    static override fromJS(data: any): CompanyAddressChangeRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyAddressChangeRequestViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["requestedByUserId"] = this.requestedByUserId !== undefined ? this.requestedByUserId : null as any;
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["oldAddress1"] = this.oldAddress1 !== undefined ? this.oldAddress1 : null as any;
        data["oldAddress2"] = this.oldAddress2 !== undefined ? this.oldAddress2 : null as any;
        data["oldCity"] = this.oldCity !== undefined ? this.oldCity : null as any;
        data["oldState"] = this.oldState !== undefined ? this.oldState : null as any;
        data["oldZipCode"] = this.oldZipCode !== undefined ? this.oldZipCode : null as any;
        data["requestedByName"] = this.requestedByName !== undefined ? this.requestedByName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): CompanyAddressChangeRequestViewModel {
        const json = this.toJSON();
        let result = new CompanyAddressChangeRequestViewModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyAddressChangeRequestViewModel extends IBaseViewModel {
    companyId?: string;
    requestedByUserId?: string | null;
    assistanceApplicationId?: string | null;
    status?: CompanyAddressChangeRequestStatus | null;
    companyName?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    oldAddress1?: string | null;
    oldAddress2?: string | null;
    oldCity?: string | null;
    oldState?: string | null;
    oldZipCode?: string | null;
    requestedByName?: string | null;
}

export enum CompanyAddressChangeRequestStatus {
    Pending = "Pending",
    Approved = "Approved",
    Denied = "Denied",
}

export class UpdateAssistanceApplication implements IUpdateAssistanceApplication {
    id?: string;
    clientId?: string;
    applicationType?: AssistanceApplicationType;
    fundTypeId?: string | null;
    assignedAgencyId?: string | null;
    createdByUserId?: string | null;
    companyId?: string | null;
    summary?: string | null;
    description?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    totalNeed?: number | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: string | null;
    denialReason?: string | null;
    otherDenialReason?: string | null;
    fundPledgeTypeId?: string | null;
    familyEducatedAboutResources?: boolean | null;
    assignedAgency?: Agency | null;
    stormApplication?: StormApplicationViewModel | null;
    assistanceApplicationAreasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    adults?: AssistanceApplicationAdult[] | null;
    minors?: AssistanceApplicationMinor[] | null;
    companies?: AssistanceApplicationCompany[] | null;
    pendingAddressChangeRequests?: CompanyAddressChangeRequestViewModel[] | null;

    constructor(data?: IUpdateAssistanceApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.fundTypeId = _data["fundTypeId"] !== undefined ? _data["fundTypeId"] : null as any;
            this.assignedAgencyId = _data["assignedAgencyId"] !== undefined ? _data["assignedAgencyId"] : null as any;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.fundedDate = _data["fundedDate"] ? new Date(_data["fundedDate"].toString()) : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.otherDenialReason = _data["otherDenialReason"] !== undefined ? _data["otherDenialReason"] : null as any;
            this.fundPledgeTypeId = _data["fundPledgeTypeId"] !== undefined ? _data["fundPledgeTypeId"] : null as any;
            this.familyEducatedAboutResources = _data["familyEducatedAboutResources"] !== undefined ? _data["familyEducatedAboutResources"] : null as any;
            this.assignedAgency = _data["assignedAgency"] ? Agency.fromJS(_data["assignedAgency"]) : null as any;
            this.stormApplication = _data["stormApplication"] ? StormApplicationViewModel.fromJS(_data["stormApplication"]) : null as any;
            this.assistanceApplicationAreasOfNeed = _data["assistanceApplicationAreasOfNeed"] ? AssistanceApplicationAreasOfNeed.fromJS(_data["assistanceApplicationAreasOfNeed"]) : null as any;
            if (Array.isArray(_data["adults"])) {
                this.adults = [] as any;
                for (let item of _data["adults"])
                    this.adults!.push(AssistanceApplicationAdult.fromJS(item));
            }
            else {
                this.adults = null as any;
            }
            if (Array.isArray(_data["minors"])) {
                this.minors = [] as any;
                for (let item of _data["minors"])
                    this.minors!.push(AssistanceApplicationMinor.fromJS(item));
            }
            else {
                this.minors = null as any;
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(AssistanceApplicationCompany.fromJS(item));
            }
            else {
                this.companies = null as any;
            }
            if (Array.isArray(_data["pendingAddressChangeRequests"])) {
                this.pendingAddressChangeRequests = [] as any;
                for (let item of _data["pendingAddressChangeRequests"])
                    this.pendingAddressChangeRequests!.push(CompanyAddressChangeRequestViewModel.fromJS(item));
            }
            else {
                this.pendingAddressChangeRequests = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateAssistanceApplication {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssistanceApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["fundTypeId"] = this.fundTypeId !== undefined ? this.fundTypeId : null as any;
        data["assignedAgencyId"] = this.assignedAgencyId !== undefined ? this.assignedAgencyId : null as any;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["fundedDate"] = this.fundedDate ? this.fundedDate.toISOString() : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["otherDenialReason"] = this.otherDenialReason !== undefined ? this.otherDenialReason : null as any;
        data["fundPledgeTypeId"] = this.fundPledgeTypeId !== undefined ? this.fundPledgeTypeId : null as any;
        data["familyEducatedAboutResources"] = this.familyEducatedAboutResources !== undefined ? this.familyEducatedAboutResources : null as any;
        data["assignedAgency"] = this.assignedAgency ? this.assignedAgency.toJSON() : null as any;
        data["stormApplication"] = this.stormApplication ? this.stormApplication.toJSON() : null as any;
        data["assistanceApplicationAreasOfNeed"] = this.assistanceApplicationAreasOfNeed ? this.assistanceApplicationAreasOfNeed.toJSON() : null as any;
        if (Array.isArray(this.adults)) {
            data["adults"] = [];
            for (let item of this.adults)
                data["adults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.minors)) {
            data["minors"] = [];
            for (let item of this.minors)
                data["minors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pendingAddressChangeRequests)) {
            data["pendingAddressChangeRequests"] = [];
            for (let item of this.pendingAddressChangeRequests)
                data["pendingAddressChangeRequests"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateAssistanceApplication {
        const json = this.toJSON();
        let result = new UpdateAssistanceApplication();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssistanceApplication {
    id?: string;
    clientId?: string;
    applicationType?: AssistanceApplicationType;
    fundTypeId?: string | null;
    assignedAgencyId?: string | null;
    createdByUserId?: string | null;
    companyId?: string | null;
    summary?: string | null;
    description?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    totalNeed?: number | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: string | null;
    denialReason?: string | null;
    otherDenialReason?: string | null;
    fundPledgeTypeId?: string | null;
    familyEducatedAboutResources?: boolean | null;
    assignedAgency?: Agency | null;
    stormApplication?: StormApplicationViewModel | null;
    assistanceApplicationAreasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    adults?: AssistanceApplicationAdult[] | null;
    minors?: AssistanceApplicationMinor[] | null;
    companies?: AssistanceApplicationCompany[] | null;
    pendingAddressChangeRequests?: CompanyAddressChangeRequestViewModel[] | null;
}

export class ResubmitAssistanceApplicationRequest implements IResubmitAssistanceApplicationRequest {
    note?: string | null;

    constructor(data?: IResubmitAssistanceApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ResubmitAssistanceApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitAssistanceApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): ResubmitAssistanceApplicationRequest {
        const json = this.toJSON();
        let result = new ResubmitAssistanceApplicationRequest();
        result.init(json);
        return result;
    }
}

export interface IResubmitAssistanceApplicationRequest {
    note?: string | null;
}

export abstract class SimpleResultOfString implements ISimpleResultOfString {
    result?: string | null;

    constructor(data?: ISimpleResultOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): SimpleResultOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SimpleResultOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): SimpleResultOfString {
        throw new Error("The abstract class 'SimpleResultOfString' cannot be instantiated.");
    }
}

export interface ISimpleResultOfString {
    result?: string | null;
}

export class SimpleStringResult extends SimpleResultOfString implements ISimpleStringResult {
    result?: string | null;

    constructor(data?: ISimpleStringResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static override fromJS(data: any): SimpleStringResult {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleStringResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SimpleStringResult {
        const json = this.toJSON();
        let result = new SimpleStringResult();
        result.init(json);
        return result;
    }
}

export interface ISimpleStringResult extends ISimpleResultOfString {
    result?: string | null;
}

export class AssistanceApplicationRevealSsnParams implements IAssistanceApplicationRevealSsnParams {
    id?: string;
    enteredPassword?: string | null;
    isAdult?: boolean;

    constructor(data?: IAssistanceApplicationRevealSsnParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.enteredPassword = _data["enteredPassword"] !== undefined ? _data["enteredPassword"] : null as any;
            this.isAdult = _data["isAdult"] !== undefined ? _data["isAdult"] : null as any;
        }
    }

    static fromJS(data: any): AssistanceApplicationRevealSsnParams {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationRevealSsnParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["enteredPassword"] = this.enteredPassword !== undefined ? this.enteredPassword : null as any;
        data["isAdult"] = this.isAdult !== undefined ? this.isAdult : null as any;
        return data;
    }

    clone(): AssistanceApplicationRevealSsnParams {
        const json = this.toJSON();
        let result = new AssistanceApplicationRevealSsnParams();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationRevealSsnParams {
    id?: string;
    enteredPassword?: string | null;
    isAdult?: boolean;
}

export class PagedListOfAssistanceApplicationListPreview implements IPagedListOfAssistanceApplicationListPreview {
    items?: AssistanceApplicationListPreview[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfAssistanceApplicationListPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssistanceApplicationListPreview.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfAssistanceApplicationListPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAssistanceApplicationListPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfAssistanceApplicationListPreview {
        const json = this.toJSON();
        let result = new PagedListOfAssistanceApplicationListPreview();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfAssistanceApplicationListPreview {
    items?: AssistanceApplicationListPreview[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class AssistanceApplicationListPreview extends BaseViewModel implements IAssistanceApplicationListPreview {
    clientId?: string | null;
    fundTypeName?: string | null;
    clientLastName?: string | null;
    clientFirstName?: string | null;
    clientLast4Ssn?: string | null;
    status?: string | null;
    agencyName?: string | null;
    totalNeed?: number;

    constructor(data?: IAssistanceApplicationListPreview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.fundTypeName = _data["fundTypeName"] !== undefined ? _data["fundTypeName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationListPreview {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationListPreview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["fundTypeName"] = this.fundTypeName !== undefined ? this.fundTypeName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationListPreview {
        const json = this.toJSON();
        let result = new AssistanceApplicationListPreview();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationListPreview extends IBaseViewModel {
    clientId?: string | null;
    fundTypeName?: string | null;
    clientLastName?: string | null;
    clientFirstName?: string | null;
    clientLast4Ssn?: string | null;
    status?: string | null;
    agencyName?: string | null;
    totalNeed?: number;
}

export enum AssistanceApplicationStatus {
    Submitted = "Submitted",
    UnderReview = "UnderReview",
    ReviewPassed = "ReviewPassed",
    InfoNeeded = "InfoNeeded",
    Approved = "Approved",
    Denied = "Denied",
    UnderAgencyReview = "UnderAgencyReview",
    AgencyInfoNeeded = "AgencyInfoNeeded",
}

export enum PublicInternalFilter {
    Public = "Public",
    Internal = "Internal",
    All = "All",
}

export class GetApplicationByPledgeIdResponse implements IGetApplicationByPledgeIdResponse {
    application?: AssistanceApplication | null;
    pledgeHasApplication?: boolean;

    constructor(data?: IGetApplicationByPledgeIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? AssistanceApplication.fromJS(_data["application"]) : null as any;
            this.pledgeHasApplication = _data["pledgeHasApplication"] !== undefined ? _data["pledgeHasApplication"] : null as any;
        }
    }

    static fromJS(data: any): GetApplicationByPledgeIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationByPledgeIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["pledgeHasApplication"] = this.pledgeHasApplication !== undefined ? this.pledgeHasApplication : null as any;
        return data;
    }

    clone(): GetApplicationByPledgeIdResponse {
        const json = this.toJSON();
        let result = new GetApplicationByPledgeIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationByPledgeIdResponse {
    application?: AssistanceApplication | null;
    pledgeHasApplication?: boolean;
}

export class PledgeType extends BaseViewModel implements IPledgeType {
    name?: string | null;
    minSinglePledgeAmt?: number;
    maxSinglePledgeAmt?: number;
    maxYearlyPledgeAmt?: number;
    status?: string | null;
    isActive?: boolean;
    crisisPledgeThreshold?: number;
    fiscalStartMonth?: number;
    fiscalStartDay?: number;
    isKeepingCurrent?: boolean;
    isSsnRequired?: boolean;
    isEmergencyNatGasRepair?: boolean;
    isPovertyLevelRequired?: boolean;
    maxPovertyLevel?: number | null;
    regionValue?: string | null;
    efsStartDate?: Date;
    efsEndDate?: Date;
    isEfs?: boolean;
    assistanceApplicationType?: AssistanceApplicationType | null;
    isUwda?: boolean;
    isPrivate?: boolean;
    ledgerNumber?: string | null;
    managementAgencyId?: string;
    managementAgencyName?: string | null;
    isFundAdministrativeAgency?: boolean;

    constructor(data?: IPledgeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.minSinglePledgeAmt = _data["minSinglePledgeAmt"] !== undefined ? _data["minSinglePledgeAmt"] : null as any;
            this.maxSinglePledgeAmt = _data["maxSinglePledgeAmt"] !== undefined ? _data["maxSinglePledgeAmt"] : null as any;
            this.maxYearlyPledgeAmt = _data["maxYearlyPledgeAmt"] !== undefined ? _data["maxYearlyPledgeAmt"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.crisisPledgeThreshold = _data["crisisPledgeThreshold"] !== undefined ? _data["crisisPledgeThreshold"] : null as any;
            this.fiscalStartMonth = _data["fiscalStartMonth"] !== undefined ? _data["fiscalStartMonth"] : null as any;
            this.fiscalStartDay = _data["fiscalStartDay"] !== undefined ? _data["fiscalStartDay"] : null as any;
            this.isKeepingCurrent = _data["isKeepingCurrent"] !== undefined ? _data["isKeepingCurrent"] : null as any;
            this.isSsnRequired = _data["isSsnRequired"] !== undefined ? _data["isSsnRequired"] : null as any;
            this.isEmergencyNatGasRepair = _data["isEmergencyNatGasRepair"] !== undefined ? _data["isEmergencyNatGasRepair"] : null as any;
            this.isPovertyLevelRequired = _data["isPovertyLevelRequired"] !== undefined ? _data["isPovertyLevelRequired"] : null as any;
            this.maxPovertyLevel = _data["maxPovertyLevel"] !== undefined ? _data["maxPovertyLevel"] : null as any;
            this.regionValue = _data["regionValue"] !== undefined ? _data["regionValue"] : null as any;
            this.efsStartDate = _data["efsStartDate"] ? new Date(_data["efsStartDate"].toString()) : null as any;
            this.efsEndDate = _data["efsEndDate"] ? new Date(_data["efsEndDate"].toString()) : null as any;
            this.isEfs = _data["isEfs"] !== undefined ? _data["isEfs"] : null as any;
            this.assistanceApplicationType = _data["assistanceApplicationType"] !== undefined ? _data["assistanceApplicationType"] : null as any;
            this.isUwda = _data["isUwda"] !== undefined ? _data["isUwda"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.managementAgencyId = _data["managementAgencyId"] !== undefined ? _data["managementAgencyId"] : null as any;
            this.managementAgencyName = _data["managementAgencyName"] !== undefined ? _data["managementAgencyName"] : null as any;
            this.isFundAdministrativeAgency = _data["isFundAdministrativeAgency"] !== undefined ? _data["isFundAdministrativeAgency"] : null as any;
        }
    }

    static override fromJS(data: any): PledgeType {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["minSinglePledgeAmt"] = this.minSinglePledgeAmt !== undefined ? this.minSinglePledgeAmt : null as any;
        data["maxSinglePledgeAmt"] = this.maxSinglePledgeAmt !== undefined ? this.maxSinglePledgeAmt : null as any;
        data["maxYearlyPledgeAmt"] = this.maxYearlyPledgeAmt !== undefined ? this.maxYearlyPledgeAmt : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["crisisPledgeThreshold"] = this.crisisPledgeThreshold !== undefined ? this.crisisPledgeThreshold : null as any;
        data["fiscalStartMonth"] = this.fiscalStartMonth !== undefined ? this.fiscalStartMonth : null as any;
        data["fiscalStartDay"] = this.fiscalStartDay !== undefined ? this.fiscalStartDay : null as any;
        data["isKeepingCurrent"] = this.isKeepingCurrent !== undefined ? this.isKeepingCurrent : null as any;
        data["isSsnRequired"] = this.isSsnRequired !== undefined ? this.isSsnRequired : null as any;
        data["isEmergencyNatGasRepair"] = this.isEmergencyNatGasRepair !== undefined ? this.isEmergencyNatGasRepair : null as any;
        data["isPovertyLevelRequired"] = this.isPovertyLevelRequired !== undefined ? this.isPovertyLevelRequired : null as any;
        data["maxPovertyLevel"] = this.maxPovertyLevel !== undefined ? this.maxPovertyLevel : null as any;
        data["regionValue"] = this.regionValue !== undefined ? this.regionValue : null as any;
        data["efsStartDate"] = this.efsStartDate ? this.efsStartDate.toISOString() : null as any;
        data["efsEndDate"] = this.efsEndDate ? this.efsEndDate.toISOString() : null as any;
        data["isEfs"] = this.isEfs !== undefined ? this.isEfs : null as any;
        data["assistanceApplicationType"] = this.assistanceApplicationType !== undefined ? this.assistanceApplicationType : null as any;
        data["isUwda"] = this.isUwda !== undefined ? this.isUwda : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["managementAgencyId"] = this.managementAgencyId !== undefined ? this.managementAgencyId : null as any;
        data["managementAgencyName"] = this.managementAgencyName !== undefined ? this.managementAgencyName : null as any;
        data["isFundAdministrativeAgency"] = this.isFundAdministrativeAgency !== undefined ? this.isFundAdministrativeAgency : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeType {
        const json = this.toJSON();
        let result = new PledgeType();
        result.init(json);
        return result;
    }
}

export interface IPledgeType extends IBaseViewModel {
    name?: string | null;
    minSinglePledgeAmt?: number;
    maxSinglePledgeAmt?: number;
    maxYearlyPledgeAmt?: number;
    status?: string | null;
    isActive?: boolean;
    crisisPledgeThreshold?: number;
    fiscalStartMonth?: number;
    fiscalStartDay?: number;
    isKeepingCurrent?: boolean;
    isSsnRequired?: boolean;
    isEmergencyNatGasRepair?: boolean;
    isPovertyLevelRequired?: boolean;
    maxPovertyLevel?: number | null;
    regionValue?: string | null;
    efsStartDate?: Date;
    efsEndDate?: Date;
    isEfs?: boolean;
    assistanceApplicationType?: AssistanceApplicationType | null;
    isUwda?: boolean;
    isPrivate?: boolean;
    ledgerNumber?: string | null;
    managementAgencyId?: string;
    managementAgencyName?: string | null;
    isFundAdministrativeAgency?: boolean;
}

export class PagedListOfAuditReportTableRowViewModel implements IPagedListOfAuditReportTableRowViewModel {
    items?: AuditReportTableRowViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfAuditReportTableRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditReportTableRowViewModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfAuditReportTableRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAuditReportTableRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfAuditReportTableRowViewModel {
        const json = this.toJSON();
        let result = new PagedListOfAuditReportTableRowViewModel();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfAuditReportTableRowViewModel {
    items?: AuditReportTableRowViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class AuditReportTableRowViewModel implements IAuditReportTableRowViewModel {
    assistanceApplicationId?: string | null;
    clientId?: string | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    enteredDate?: Date;
    auditState?: string | null;
    auditComment?: string | null;

    constructor(data?: IAuditReportTableRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.auditState = _data["auditState"] !== undefined ? _data["auditState"] : null as any;
            this.auditComment = _data["auditComment"] !== undefined ? _data["auditComment"] : null as any;
        }
    }

    static fromJS(data: any): AuditReportTableRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditReportTableRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["auditState"] = this.auditState !== undefined ? this.auditState : null as any;
        data["auditComment"] = this.auditComment !== undefined ? this.auditComment : null as any;
        return data;
    }

    clone(): AuditReportTableRowViewModel {
        const json = this.toJSON();
        let result = new AuditReportTableRowViewModel();
        result.init(json);
        return result;
    }
}

export interface IAuditReportTableRowViewModel {
    assistanceApplicationId?: string | null;
    clientId?: string | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    enteredDate?: Date;
    auditState?: string | null;
    auditComment?: string | null;
}

export class PagedListOfAuditProgressReportTableRowViewModel implements IPagedListOfAuditProgressReportTableRowViewModel {
    items?: AuditProgressReportTableRowViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfAuditProgressReportTableRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditProgressReportTableRowViewModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfAuditProgressReportTableRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAuditProgressReportTableRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfAuditProgressReportTableRowViewModel {
        const json = this.toJSON();
        let result = new PagedListOfAuditProgressReportTableRowViewModel();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfAuditProgressReportTableRowViewModel {
    items?: AuditProgressReportTableRowViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class AuditProgressReportTableRowViewModel implements IAuditProgressReportTableRowViewModel {
    fundName?: string | null;
    counties?: string[] | null;
    passCount?: number;
    failCount?: number;
    notYetAuditedCount?: number;
    passWithCorrectionsCount?: number;
    percentAudited?: number;

    constructor(data?: IAuditProgressReportTableRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundName = _data["fundName"] !== undefined ? _data["fundName"] : null as any;
            if (Array.isArray(_data["counties"])) {
                this.counties = [] as any;
                for (let item of _data["counties"])
                    this.counties!.push(item);
            }
            else {
                this.counties = null as any;
            }
            this.passCount = _data["passCount"] !== undefined ? _data["passCount"] : null as any;
            this.failCount = _data["failCount"] !== undefined ? _data["failCount"] : null as any;
            this.notYetAuditedCount = _data["notYetAuditedCount"] !== undefined ? _data["notYetAuditedCount"] : null as any;
            this.passWithCorrectionsCount = _data["passWithCorrectionsCount"] !== undefined ? _data["passWithCorrectionsCount"] : null as any;
            this.percentAudited = _data["percentAudited"] !== undefined ? _data["percentAudited"] : null as any;
        }
    }

    static fromJS(data: any): AuditProgressReportTableRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditProgressReportTableRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundName"] = this.fundName !== undefined ? this.fundName : null as any;
        if (Array.isArray(this.counties)) {
            data["counties"] = [];
            for (let item of this.counties)
                data["counties"].push(item);
        }
        data["passCount"] = this.passCount !== undefined ? this.passCount : null as any;
        data["failCount"] = this.failCount !== undefined ? this.failCount : null as any;
        data["notYetAuditedCount"] = this.notYetAuditedCount !== undefined ? this.notYetAuditedCount : null as any;
        data["passWithCorrectionsCount"] = this.passWithCorrectionsCount !== undefined ? this.passWithCorrectionsCount : null as any;
        data["percentAudited"] = this.percentAudited !== undefined ? this.percentAudited : null as any;
        return data;
    }

    clone(): AuditProgressReportTableRowViewModel {
        const json = this.toJSON();
        let result = new AuditProgressReportTableRowViewModel();
        result.init(json);
        return result;
    }
}

export interface IAuditProgressReportTableRowViewModel {
    fundName?: string | null;
    counties?: string[] | null;
    passCount?: number;
    failCount?: number;
    notYetAuditedCount?: number;
    passWithCorrectionsCount?: number;
    percentAudited?: number;
}

export class AssistanceApplicationFileSkeleton implements IAssistanceApplicationFileSkeleton {
    id?: string | null;
    file?: string | null;
    fileType?: string | null;

    constructor(data?: IAssistanceApplicationFileSkeleton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.file = _data["file"] !== undefined ? _data["file"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
        }
    }

    static fromJS(data: any): AssistanceApplicationFileSkeleton {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationFileSkeleton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["file"] = this.file !== undefined ? this.file : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        return data;
    }

    clone(): AssistanceApplicationFileSkeleton {
        const json = this.toJSON();
        let result = new AssistanceApplicationFileSkeleton();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationFileSkeleton {
    id?: string | null;
    file?: string | null;
    fileType?: string | null;
}

export class AddAssistanceApplicationInformationRequestViewModel implements IAddAssistanceApplicationInformationRequestViewModel {
    assistanceApplicationId?: string;
    note?: string | null;

    constructor(data?: IAddAssistanceApplicationInformationRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): AddAssistanceApplicationInformationRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddAssistanceApplicationInformationRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): AddAssistanceApplicationInformationRequestViewModel {
        const json = this.toJSON();
        let result = new AddAssistanceApplicationInformationRequestViewModel();
        result.init(json);
        return result;
    }
}

export interface IAddAssistanceApplicationInformationRequestViewModel {
    assistanceApplicationId?: string;
    note?: string | null;
}

export class DenyReviewAssistanceApplicationViewModel implements IDenyReviewAssistanceApplicationViewModel {
    applicationId?: string;
    denialReason?: AssistanceApplicationDenialReason;
    otherReason?: string | null;

    constructor(data?: IDenyReviewAssistanceApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.otherReason = _data["otherReason"] !== undefined ? _data["otherReason"] : null as any;
        }
    }

    static fromJS(data: any): DenyReviewAssistanceApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DenyReviewAssistanceApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["otherReason"] = this.otherReason !== undefined ? this.otherReason : null as any;
        return data;
    }

    clone(): DenyReviewAssistanceApplicationViewModel {
        const json = this.toJSON();
        let result = new DenyReviewAssistanceApplicationViewModel();
        result.init(json);
        return result;
    }
}

export interface IDenyReviewAssistanceApplicationViewModel {
    applicationId?: string;
    denialReason?: AssistanceApplicationDenialReason;
    otherReason?: string | null;
}

export enum AssistanceApplicationDenialReason {
    OverIncome = "OverIncome",
    DuplicateHouseholdSubmission = "DuplicateHouseholdSubmission",
    Unresponsive = "Unresponsive",
    DuplicateIndividualSubmission = "DuplicateIndividualSubmission",
    ProgramClosed = "ProgramClosed",
    Cancelled = "Cancelled",
    Other = "Other",
}

export class AssistanceApplicationStateAuditViewModel extends BaseViewModel implements IAssistanceApplicationStateAuditViewModel {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplication | null;
    auditorId?: string;
    auditDate?: Date;
    oldState?: AssistanceApplicationStateAuditType;
    newState?: AssistanceApplicationStateAuditType;
    note?: string | null;

    constructor(data?: IAssistanceApplicationStateAuditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplication.fromJS(_data["assistanceApplication"]) : null as any;
            this.auditorId = _data["auditorId"] !== undefined ? _data["auditorId"] : null as any;
            this.auditDate = _data["auditDate"] ? new Date(_data["auditDate"].toString()) : null as any;
            this.oldState = _data["oldState"] !== undefined ? _data["oldState"] : null as any;
            this.newState = _data["newState"] !== undefined ? _data["newState"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationStateAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationStateAuditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["auditorId"] = this.auditorId !== undefined ? this.auditorId : null as any;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : null as any;
        data["oldState"] = this.oldState !== undefined ? this.oldState : null as any;
        data["newState"] = this.newState !== undefined ? this.newState : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationStateAuditViewModel {
        const json = this.toJSON();
        let result = new AssistanceApplicationStateAuditViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationStateAuditViewModel extends IBaseViewModel {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplication | null;
    auditorId?: string;
    auditDate?: Date;
    oldState?: AssistanceApplicationStateAuditType;
    newState?: AssistanceApplicationStateAuditType;
    note?: string | null;
}

export class PagedListOfAssistanceApplicationStateAuditListViewModel implements IPagedListOfAssistanceApplicationStateAuditListViewModel {
    items?: AssistanceApplicationStateAuditListViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfAssistanceApplicationStateAuditListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssistanceApplicationStateAuditListViewModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfAssistanceApplicationStateAuditListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAssistanceApplicationStateAuditListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfAssistanceApplicationStateAuditListViewModel {
        const json = this.toJSON();
        let result = new PagedListOfAssistanceApplicationStateAuditListViewModel();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfAssistanceApplicationStateAuditListViewModel {
    items?: AssistanceApplicationStateAuditListViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class AssistanceApplicationStateAuditListViewModel extends BaseViewModel implements IAssistanceApplicationStateAuditListViewModel {
    assistanceApplicationId?: string;
    auditorId?: string | null;
    auditorIdAgency?: string | null;
    auditDate?: Date;
    oldState?: string | null;
    newState?: string | null;
    note?: string | null;

    constructor(data?: IAssistanceApplicationStateAuditListViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.auditorId = _data["auditorId"] !== undefined ? _data["auditorId"] : null as any;
            this.auditorIdAgency = _data["auditorIdAgency"] !== undefined ? _data["auditorIdAgency"] : null as any;
            this.auditDate = _data["auditDate"] ? new Date(_data["auditDate"].toString()) : null as any;
            this.oldState = _data["oldState"] !== undefined ? _data["oldState"] : null as any;
            this.newState = _data["newState"] !== undefined ? _data["newState"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationStateAuditListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationStateAuditListViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["auditorId"] = this.auditorId !== undefined ? this.auditorId : null as any;
        data["auditorIdAgency"] = this.auditorIdAgency !== undefined ? this.auditorIdAgency : null as any;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : null as any;
        data["oldState"] = this.oldState !== undefined ? this.oldState : null as any;
        data["newState"] = this.newState !== undefined ? this.newState : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationStateAuditListViewModel {
        const json = this.toJSON();
        let result = new AssistanceApplicationStateAuditListViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationStateAuditListViewModel extends IBaseViewModel {
    assistanceApplicationId?: string;
    auditorId?: string | null;
    auditorIdAgency?: string | null;
    auditDate?: Date;
    oldState?: string | null;
    newState?: string | null;
    note?: string | null;
}

export class AddAssistanceApplicationStateAuditViewModel implements IAddAssistanceApplicationStateAuditViewModel {
    assistanceApplicationId?: string;
    newState?: AssistanceApplicationStateAuditType;
    note?: string | null;
    denialData?: ApplicationDenialData | null;

    constructor(data?: IAddAssistanceApplicationStateAuditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.newState = _data["newState"] !== undefined ? _data["newState"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.denialData = _data["denialData"] ? ApplicationDenialData.fromJS(_data["denialData"]) : null as any;
        }
    }

    static fromJS(data: any): AddAssistanceApplicationStateAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddAssistanceApplicationStateAuditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["newState"] = this.newState !== undefined ? this.newState : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["denialData"] = this.denialData ? this.denialData.toJSON() : null as any;
        return data;
    }

    clone(): AddAssistanceApplicationStateAuditViewModel {
        const json = this.toJSON();
        let result = new AddAssistanceApplicationStateAuditViewModel();
        result.init(json);
        return result;
    }
}

export interface IAddAssistanceApplicationStateAuditViewModel {
    assistanceApplicationId?: string;
    newState?: AssistanceApplicationStateAuditType;
    note?: string | null;
    denialData?: ApplicationDenialData | null;
}

export class ApplicationDenialData implements IApplicationDenialData {
    denialReason?: AssistanceApplicationDenialReason | null;
    otherReason?: string | null;

    constructor(data?: IApplicationDenialData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.otherReason = _data["otherReason"] !== undefined ? _data["otherReason"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationDenialData {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDenialData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["otherReason"] = this.otherReason !== undefined ? this.otherReason : null as any;
        return data;
    }

    clone(): ApplicationDenialData {
        const json = this.toJSON();
        let result = new ApplicationDenialData();
        result.init(json);
        return result;
    }
}

export interface IApplicationDenialData {
    denialReason?: AssistanceApplicationDenialReason | null;
    otherReason?: string | null;
}

export class Banner implements IBanner {
    message?: string | null;
    enabled?: boolean;

    constructor(data?: IBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
        }
    }

    static fromJS(data: any): Banner {
        data = typeof data === 'object' ? data : {};
        let result = new Banner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        return data;
    }

    clone(): Banner {
        const json = this.toJSON();
        let result = new Banner();
        result.init(json);
        return result;
    }
}

export interface IBanner {
    message?: string | null;
    enabled?: boolean;
}

export class PagedListOfClient implements IPagedListOfClient {
    items?: Client[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Client.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfClient {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfClient {
        const json = this.toJSON();
        let result = new PagedListOfClient();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfClient {
    items?: Client[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export enum ClientSearchTypes {
    Ssn = "Ssn",
    SearchAllAgencies = "SearchAllAgencies",
    SearchMyAgency = "SearchMyAgency",
}

export abstract class SimpleResultOfBoolean implements ISimpleResultOfBoolean {
    result?: boolean;

    constructor(data?: ISimpleResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): SimpleResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SimpleResultOfBoolean' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): SimpleResultOfBoolean {
        throw new Error("The abstract class 'SimpleResultOfBoolean' cannot be instantiated.");
    }
}

export interface ISimpleResultOfBoolean {
    result?: boolean;
}

export class SimpleBooleanResult extends SimpleResultOfBoolean implements ISimpleBooleanResult {
    result?: boolean;

    constructor(data?: ISimpleBooleanResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static override fromJS(data: any): SimpleBooleanResult {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleBooleanResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SimpleBooleanResult {
        const json = this.toJSON();
        let result = new SimpleBooleanResult();
        result.init(json);
        return result;
    }
}

export interface ISimpleBooleanResult extends ISimpleResultOfBoolean {
    result?: boolean;
}

export class MergeClientParameters implements IMergeClientParameters {
    srcClientId?: string;
    destClientId?: string;

    constructor(data?: IMergeClientParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.srcClientId = _data["srcClientId"] !== undefined ? _data["srcClientId"] : null as any;
            this.destClientId = _data["destClientId"] !== undefined ? _data["destClientId"] : null as any;
        }
    }

    static fromJS(data: any): MergeClientParameters {
        data = typeof data === 'object' ? data : {};
        let result = new MergeClientParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["srcClientId"] = this.srcClientId !== undefined ? this.srcClientId : null as any;
        data["destClientId"] = this.destClientId !== undefined ? this.destClientId : null as any;
        return data;
    }

    clone(): MergeClientParameters {
        const json = this.toJSON();
        let result = new MergeClientParameters();
        result.init(json);
        return result;
    }
}

export interface IMergeClientParameters {
    srcClientId?: string;
    destClientId?: string;
}

export class ClientRevealSsnParams implements IClientRevealSsnParams {
    clientId?: string;
    enteredPassword?: string | null;

    constructor(data?: IClientRevealSsnParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.enteredPassword = _data["enteredPassword"] !== undefined ? _data["enteredPassword"] : null as any;
        }
    }

    static fromJS(data: any): ClientRevealSsnParams {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRevealSsnParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["enteredPassword"] = this.enteredPassword !== undefined ? this.enteredPassword : null as any;
        return data;
    }

    clone(): ClientRevealSsnParams {
        const json = this.toJSON();
        let result = new ClientRevealSsnParams();
        result.init(json);
        return result;
    }
}

export interface IClientRevealSsnParams {
    clientId?: string;
    enteredPassword?: string | null;
}

export class PagedListOfCompanyAddressChangeRequestViewModel implements IPagedListOfCompanyAddressChangeRequestViewModel {
    items?: CompanyAddressChangeRequestViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfCompanyAddressChangeRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyAddressChangeRequestViewModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfCompanyAddressChangeRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfCompanyAddressChangeRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfCompanyAddressChangeRequestViewModel {
        const json = this.toJSON();
        let result = new PagedListOfCompanyAddressChangeRequestViewModel();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfCompanyAddressChangeRequestViewModel {
    items?: CompanyAddressChangeRequestViewModel[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class CompanyCategoryThresholdViewModel implements ICompanyCategoryThresholdViewModel {
    category?: CompanyCategoryType;
    categoryLabel?: string | null;
    thresholdAmount?: number | null;
    assistanceApplicationType?: AssistanceApplicationType | null;

    constructor(data?: ICompanyCategoryThresholdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.categoryLabel = _data["categoryLabel"] !== undefined ? _data["categoryLabel"] : null as any;
            this.thresholdAmount = _data["thresholdAmount"] !== undefined ? _data["thresholdAmount"] : null as any;
            this.assistanceApplicationType = _data["assistanceApplicationType"] !== undefined ? _data["assistanceApplicationType"] : null as any;
        }
    }

    static fromJS(data: any): CompanyCategoryThresholdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCategoryThresholdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["categoryLabel"] = this.categoryLabel !== undefined ? this.categoryLabel : null as any;
        data["thresholdAmount"] = this.thresholdAmount !== undefined ? this.thresholdAmount : null as any;
        data["assistanceApplicationType"] = this.assistanceApplicationType !== undefined ? this.assistanceApplicationType : null as any;
        return data;
    }

    clone(): CompanyCategoryThresholdViewModel {
        const json = this.toJSON();
        let result = new CompanyCategoryThresholdViewModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyCategoryThresholdViewModel {
    category?: CompanyCategoryType;
    categoryLabel?: string | null;
    thresholdAmount?: number | null;
    assistanceApplicationType?: AssistanceApplicationType | null;
}

export class DuplicateCompanyCheckResponse implements IDuplicateCompanyCheckResponse {
    company?: Company | null;
    name?: string | null;
    address?: string | null;

    constructor(data?: IDuplicateCompanyCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
        }
    }

    static fromJS(data: any): DuplicateCompanyCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateCompanyCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        return data;
    }

    clone(): DuplicateCompanyCheckResponse {
        const json = this.toJSON();
        let result = new DuplicateCompanyCheckResponse();
        result.init(json);
        return result;
    }
}

export interface IDuplicateCompanyCheckResponse {
    company?: Company | null;
    name?: string | null;
    address?: string | null;
}

export class PagedListOfCompany implements IPagedListOfCompany {
    items?: Company[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Company.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfCompany {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfCompany {
        const json = this.toJSON();
        let result = new PagedListOfCompany();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfCompany {
    items?: Company[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class CountyResult extends BaseViewModel implements ICountyResult {
    defaultCounty?: ZipCode | null;
    countyList?: string[] | null;

    constructor(data?: ICountyResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultCounty = _data["defaultCounty"] ? ZipCode.fromJS(_data["defaultCounty"]) : null as any;
            if (Array.isArray(_data["countyList"])) {
                this.countyList = [] as any;
                for (let item of _data["countyList"])
                    this.countyList!.push(item);
            }
            else {
                this.countyList = null as any;
            }
        }
    }

    static override fromJS(data: any): CountyResult {
        data = typeof data === 'object' ? data : {};
        let result = new CountyResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultCounty"] = this.defaultCounty ? this.defaultCounty.toJSON() : null as any;
        if (Array.isArray(this.countyList)) {
            data["countyList"] = [];
            for (let item of this.countyList)
                data["countyList"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CountyResult {
        const json = this.toJSON();
        let result = new CountyResult();
        result.init(json);
        return result;
    }
}

export interface ICountyResult extends IBaseViewModel {
    defaultCounty?: ZipCode | null;
    countyList?: string[] | null;
}

export class ZipCode extends BaseViewModel implements IZipCode {
    code?: string | null;
    county?: string | null;
    city?: string | null;
    state?: string | null;
    location?: string | null;

    constructor(data?: IZipCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
        }
    }

    static override fromJS(data: any): ZipCode {
        data = typeof data === 'object' ? data : {};
        let result = new ZipCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ZipCode {
        const json = this.toJSON();
        let result = new ZipCode();
        result.init(json);
        return result;
    }
}

export interface IZipCode extends IBaseViewModel {
    code?: string | null;
    county?: string | null;
    city?: string | null;
    state?: string | null;
    location?: string | null;
}

export class CountySelection implements ICountySelection {
    name?: string | null;
    displayName?: string | null;

    constructor(data?: ICountySelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
        }
    }

    static fromJS(data: any): CountySelection {
        data = typeof data === 'object' ? data : {};
        let result = new CountySelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        return data;
    }

    clone(): CountySelection {
        const json = this.toJSON();
        let result = new CountySelection();
        result.init(json);
        return result;
    }
}

export interface ICountySelection {
    name?: string | null;
    displayName?: string | null;
}

export class PagedListOfCountySpendingReportPreview implements IPagedListOfCountySpendingReportPreview {
    items?: CountySpendingReportPreview[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfCountySpendingReportPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CountySpendingReportPreview.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfCountySpendingReportPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfCountySpendingReportPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfCountySpendingReportPreview {
        const json = this.toJSON();
        let result = new PagedListOfCountySpendingReportPreview();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfCountySpendingReportPreview {
    items?: CountySpendingReportPreview[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class CountySpendingReportPreview implements ICountySpendingReportPreview {
    countyName?: string | null;
    pledgesInProgressTotal?: number;
    pledgesPaidTotal?: number;
    pledgeDollarsTotal?: number;
    pledgesUnprocessedTotal?: number;
    pledgesApplicationsTotal?: number;

    constructor(data?: ICountySpendingReportPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countyName = _data["countyName"] !== undefined ? _data["countyName"] : null as any;
            this.pledgesInProgressTotal = _data["pledgesInProgressTotal"] !== undefined ? _data["pledgesInProgressTotal"] : null as any;
            this.pledgesPaidTotal = _data["pledgesPaidTotal"] !== undefined ? _data["pledgesPaidTotal"] : null as any;
            this.pledgeDollarsTotal = _data["pledgeDollarsTotal"] !== undefined ? _data["pledgeDollarsTotal"] : null as any;
            this.pledgesUnprocessedTotal = _data["pledgesUnprocessedTotal"] !== undefined ? _data["pledgesUnprocessedTotal"] : null as any;
            this.pledgesApplicationsTotal = _data["pledgesApplicationsTotal"] !== undefined ? _data["pledgesApplicationsTotal"] : null as any;
        }
    }

    static fromJS(data: any): CountySpendingReportPreview {
        data = typeof data === 'object' ? data : {};
        let result = new CountySpendingReportPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countyName"] = this.countyName !== undefined ? this.countyName : null as any;
        data["pledgesInProgressTotal"] = this.pledgesInProgressTotal !== undefined ? this.pledgesInProgressTotal : null as any;
        data["pledgesPaidTotal"] = this.pledgesPaidTotal !== undefined ? this.pledgesPaidTotal : null as any;
        data["pledgeDollarsTotal"] = this.pledgeDollarsTotal !== undefined ? this.pledgeDollarsTotal : null as any;
        data["pledgesUnprocessedTotal"] = this.pledgesUnprocessedTotal !== undefined ? this.pledgesUnprocessedTotal : null as any;
        data["pledgesApplicationsTotal"] = this.pledgesApplicationsTotal !== undefined ? this.pledgesApplicationsTotal : null as any;
        return data;
    }

    clone(): CountySpendingReportPreview {
        const json = this.toJSON();
        let result = new CountySpendingReportPreview();
        result.init(json);
        return result;
    }
}

export interface ICountySpendingReportPreview {
    countyName?: string | null;
    pledgesInProgressTotal?: number;
    pledgesPaidTotal?: number;
    pledgeDollarsTotal?: number;
    pledgesUnprocessedTotal?: number;
    pledgesApplicationsTotal?: number;
}

export class CountySpendingReportParameter implements ICountySpendingReportParameter {
    fundTypeIds?: string[] | null;
    isAllFundAdministrativeAgency?: boolean;
    countyName?: string | null;
    isAllCounties?: boolean;

    constructor(data?: ICountySpendingReportParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fundTypeIds"])) {
                this.fundTypeIds = [] as any;
                for (let item of _data["fundTypeIds"])
                    this.fundTypeIds!.push(item);
            }
            else {
                this.fundTypeIds = null as any;
            }
            this.isAllFundAdministrativeAgency = _data["isAllFundAdministrativeAgency"] !== undefined ? _data["isAllFundAdministrativeAgency"] : null as any;
            this.countyName = _data["countyName"] !== undefined ? _data["countyName"] : null as any;
            this.isAllCounties = _data["isAllCounties"] !== undefined ? _data["isAllCounties"] : null as any;
        }
    }

    static fromJS(data: any): CountySpendingReportParameter {
        data = typeof data === 'object' ? data : {};
        let result = new CountySpendingReportParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fundTypeIds)) {
            data["fundTypeIds"] = [];
            for (let item of this.fundTypeIds)
                data["fundTypeIds"].push(item);
        }
        data["isAllFundAdministrativeAgency"] = this.isAllFundAdministrativeAgency !== undefined ? this.isAllFundAdministrativeAgency : null as any;
        data["countyName"] = this.countyName !== undefined ? this.countyName : null as any;
        data["isAllCounties"] = this.isAllCounties !== undefined ? this.isAllCounties : null as any;
        return data;
    }

    clone(): CountySpendingReportParameter {
        const json = this.toJSON();
        let result = new CountySpendingReportParameter();
        result.init(json);
        return result;
    }
}

export interface ICountySpendingReportParameter {
    fundTypeIds?: string[] | null;
    isAllFundAdministrativeAgency?: boolean;
    countyName?: string | null;
    isAllCounties?: boolean;
}

export class PagedListOfPledgeDemographicDetailReport implements IPagedListOfPledgeDemographicDetailReport {
    items?: PledgeDemographicDetailReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfPledgeDemographicDetailReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PledgeDemographicDetailReport.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfPledgeDemographicDetailReport {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfPledgeDemographicDetailReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfPledgeDemographicDetailReport {
        const json = this.toJSON();
        let result = new PagedListOfPledgeDemographicDetailReport();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfPledgeDemographicDetailReport {
    items?: PledgeDemographicDetailReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class PledgeDemographicDetailReport extends BaseViewModel implements IPledgeDemographicDetailReport {
    status?: PledgeStatusType;
    pledgeNumber?: number | null;
    pledgeType?: string | null;
    companyName?: string | null;
    onetimeCompanyRecipient?: string | null;
    pledgedAmount?: number;
    agencyName?: string | null;
    pledgedDate?: Date;
    paidDate?: Date | null;
    isCrisisPledge?: boolean | null;
    hadTraining?: boolean | null;
    householdBudgetTraining?: boolean | null;
    amerenBudgetTraining?: boolean | null;
    creditCounselling?: boolean | null;
    caseManagement?: boolean | null;
    otherTraining?: boolean | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientGender?: string | null;
    clientAge?: number | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientUnionInfo?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;

    constructor(data?: IPledgeDemographicDetailReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeNumber = _data["pledgeNumber"] !== undefined ? _data["pledgeNumber"] : null as any;
            this.pledgeType = _data["pledgeType"] !== undefined ? _data["pledgeType"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.onetimeCompanyRecipient = _data["onetimeCompanyRecipient"] !== undefined ? _data["onetimeCompanyRecipient"] : null as any;
            this.pledgedAmount = _data["pledgedAmount"] !== undefined ? _data["pledgedAmount"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.pledgedDate = _data["pledgedDate"] ? new Date(_data["pledgedDate"].toString()) : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.isCrisisPledge = _data["isCrisisPledge"] !== undefined ? _data["isCrisisPledge"] : null as any;
            this.hadTraining = _data["hadTraining"] !== undefined ? _data["hadTraining"] : null as any;
            this.householdBudgetTraining = _data["householdBudgetTraining"] !== undefined ? _data["householdBudgetTraining"] : null as any;
            this.amerenBudgetTraining = _data["amerenBudgetTraining"] !== undefined ? _data["amerenBudgetTraining"] : null as any;
            this.creditCounselling = _data["creditCounselling"] !== undefined ? _data["creditCounselling"] : null as any;
            this.caseManagement = _data["caseManagement"] !== undefined ? _data["caseManagement"] : null as any;
            this.otherTraining = _data["otherTraining"] !== undefined ? _data["otherTraining"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.clientPrefix = _data["clientPrefix"] !== undefined ? _data["clientPrefix"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientMiddleInitial = _data["clientMiddleInitial"] !== undefined ? _data["clientMiddleInitial"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientSuffix = _data["clientSuffix"] !== undefined ? _data["clientSuffix"] : null as any;
            this.clientAddress1 = _data["clientAddress1"] !== undefined ? _data["clientAddress1"] : null as any;
            this.clientAddress2 = _data["clientAddress2"] !== undefined ? _data["clientAddress2"] : null as any;
            this.clientCity = _data["clientCity"] !== undefined ? _data["clientCity"] : null as any;
            this.clientState = _data["clientState"] !== undefined ? _data["clientState"] : null as any;
            this.clientZipCode = _data["clientZipCode"] !== undefined ? _data["clientZipCode"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientGender = _data["clientGender"] !== undefined ? _data["clientGender"] : null as any;
            this.clientAge = _data["clientAge"] !== undefined ? _data["clientAge"] : null as any;
            this.clientHouseHoldIncome = _data["clientHouseHoldIncome"] !== undefined ? _data["clientHouseHoldIncome"] : null as any;
            this.clientHouseHoldSize = _data["clientHouseHoldSize"] !== undefined ? _data["clientHouseHoldSize"] : null as any;
            this.clientEmploymentStatus = _data["clientEmploymentStatus"] !== undefined ? _data["clientEmploymentStatus"] : null as any;
            this.clientUnionInfo = _data["clientUnionInfo"] !== undefined ? _data["clientUnionInfo"] : null as any;
            this.clientIsElderly = _data["clientIsElderly"] !== undefined ? _data["clientIsElderly"] : null as any;
            this.clientIsDisabled = _data["clientIsDisabled"] !== undefined ? _data["clientIsDisabled"] : null as any;
            this.clientHasChildrenUnderFive = _data["clientHasChildrenUnderFive"] !== undefined ? _data["clientHasChildrenUnderFive"] : null as any;
            this.clientIsVeteran = _data["clientIsVeteran"] !== undefined ? _data["clientIsVeteran"] : null as any;
            this.clientIsHomeless = _data["clientIsHomeless"] !== undefined ? _data["clientIsHomeless"] : null as any;
            this.clientMembersAreElderly = _data["clientMembersAreElderly"] !== undefined ? _data["clientMembersAreElderly"] : null as any;
            this.clientMembersAreDisabled = _data["clientMembersAreDisabled"] !== undefined ? _data["clientMembersAreDisabled"] : null as any;
            this.clientMembersHaveChildrenUnderFive = _data["clientMembersHaveChildrenUnderFive"] !== undefined ? _data["clientMembersHaveChildrenUnderFive"] : null as any;
            this.clientPhoneAlt = _data["clientPhoneAlt"] !== undefined ? _data["clientPhoneAlt"] : null as any;
            this.specialCoding = _data["specialCoding"] !== undefined ? _data["specialCoding"] : null as any;
            this.enteredByName = _data["enteredByName"] !== undefined ? _data["enteredByName"] : null as any;
            this.enteredByEmail = _data["enteredByEmail"] !== undefined ? _data["enteredByEmail"] : null as any;
        }
    }

    static override fromJS(data: any): PledgeDemographicDetailReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeDemographicDetailReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeNumber"] = this.pledgeNumber !== undefined ? this.pledgeNumber : null as any;
        data["pledgeType"] = this.pledgeType !== undefined ? this.pledgeType : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["onetimeCompanyRecipient"] = this.onetimeCompanyRecipient !== undefined ? this.onetimeCompanyRecipient : null as any;
        data["pledgedAmount"] = this.pledgedAmount !== undefined ? this.pledgedAmount : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["pledgedDate"] = this.pledgedDate ? this.pledgedDate.toISOString() : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["isCrisisPledge"] = this.isCrisisPledge !== undefined ? this.isCrisisPledge : null as any;
        data["hadTraining"] = this.hadTraining !== undefined ? this.hadTraining : null as any;
        data["householdBudgetTraining"] = this.householdBudgetTraining !== undefined ? this.householdBudgetTraining : null as any;
        data["amerenBudgetTraining"] = this.amerenBudgetTraining !== undefined ? this.amerenBudgetTraining : null as any;
        data["creditCounselling"] = this.creditCounselling !== undefined ? this.creditCounselling : null as any;
        data["caseManagement"] = this.caseManagement !== undefined ? this.caseManagement : null as any;
        data["otherTraining"] = this.otherTraining !== undefined ? this.otherTraining : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["clientPrefix"] = this.clientPrefix !== undefined ? this.clientPrefix : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientMiddleInitial"] = this.clientMiddleInitial !== undefined ? this.clientMiddleInitial : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientSuffix"] = this.clientSuffix !== undefined ? this.clientSuffix : null as any;
        data["clientAddress1"] = this.clientAddress1 !== undefined ? this.clientAddress1 : null as any;
        data["clientAddress2"] = this.clientAddress2 !== undefined ? this.clientAddress2 : null as any;
        data["clientCity"] = this.clientCity !== undefined ? this.clientCity : null as any;
        data["clientState"] = this.clientState !== undefined ? this.clientState : null as any;
        data["clientZipCode"] = this.clientZipCode !== undefined ? this.clientZipCode : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientGender"] = this.clientGender !== undefined ? this.clientGender : null as any;
        data["clientAge"] = this.clientAge !== undefined ? this.clientAge : null as any;
        data["clientHouseHoldIncome"] = this.clientHouseHoldIncome !== undefined ? this.clientHouseHoldIncome : null as any;
        data["clientHouseHoldSize"] = this.clientHouseHoldSize !== undefined ? this.clientHouseHoldSize : null as any;
        data["clientEmploymentStatus"] = this.clientEmploymentStatus !== undefined ? this.clientEmploymentStatus : null as any;
        data["clientUnionInfo"] = this.clientUnionInfo !== undefined ? this.clientUnionInfo : null as any;
        data["clientIsElderly"] = this.clientIsElderly !== undefined ? this.clientIsElderly : null as any;
        data["clientIsDisabled"] = this.clientIsDisabled !== undefined ? this.clientIsDisabled : null as any;
        data["clientHasChildrenUnderFive"] = this.clientHasChildrenUnderFive !== undefined ? this.clientHasChildrenUnderFive : null as any;
        data["clientIsVeteran"] = this.clientIsVeteran !== undefined ? this.clientIsVeteran : null as any;
        data["clientIsHomeless"] = this.clientIsHomeless !== undefined ? this.clientIsHomeless : null as any;
        data["clientMembersAreElderly"] = this.clientMembersAreElderly !== undefined ? this.clientMembersAreElderly : null as any;
        data["clientMembersAreDisabled"] = this.clientMembersAreDisabled !== undefined ? this.clientMembersAreDisabled : null as any;
        data["clientMembersHaveChildrenUnderFive"] = this.clientMembersHaveChildrenUnderFive !== undefined ? this.clientMembersHaveChildrenUnderFive : null as any;
        data["clientPhoneAlt"] = this.clientPhoneAlt !== undefined ? this.clientPhoneAlt : null as any;
        data["specialCoding"] = this.specialCoding !== undefined ? this.specialCoding : null as any;
        data["enteredByName"] = this.enteredByName !== undefined ? this.enteredByName : null as any;
        data["enteredByEmail"] = this.enteredByEmail !== undefined ? this.enteredByEmail : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeDemographicDetailReport {
        const json = this.toJSON();
        let result = new PledgeDemographicDetailReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeDemographicDetailReport extends IBaseViewModel {
    status?: PledgeStatusType;
    pledgeNumber?: number | null;
    pledgeType?: string | null;
    companyName?: string | null;
    onetimeCompanyRecipient?: string | null;
    pledgedAmount?: number;
    agencyName?: string | null;
    pledgedDate?: Date;
    paidDate?: Date | null;
    isCrisisPledge?: boolean | null;
    hadTraining?: boolean | null;
    householdBudgetTraining?: boolean | null;
    amerenBudgetTraining?: boolean | null;
    creditCounselling?: boolean | null;
    caseManagement?: boolean | null;
    otherTraining?: boolean | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientGender?: string | null;
    clientAge?: number | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientUnionInfo?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;
}

export class PledgeCountyReport extends BaseViewModel implements IPledgeCountyReport {
    state?: string | null;
    county?: string | null;
    pledgeCount?: number;
    pledgeTotal?: number;
    order?: number;

    constructor(data?: IPledgeCountyReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.pledgeCount = _data["pledgeCount"] !== undefined ? _data["pledgeCount"] : null as any;
            this.pledgeTotal = _data["pledgeTotal"] !== undefined ? _data["pledgeTotal"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
        }
    }

    static override fromJS(data: any): PledgeCountyReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeCountyReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["pledgeCount"] = this.pledgeCount !== undefined ? this.pledgeCount : null as any;
        data["pledgeTotal"] = this.pledgeTotal !== undefined ? this.pledgeTotal : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeCountyReport {
        const json = this.toJSON();
        let result = new PledgeCountyReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeCountyReport extends IBaseViewModel {
    state?: string | null;
    county?: string | null;
    pledgeCount?: number;
    pledgeTotal?: number;
    order?: number;
}

export class PledgeZipcodeReport extends BaseViewModel implements IPledgeZipcodeReport {
    zipcode?: string | null;
    pledgeCount?: number;
    pledgeTotal?: number;

    constructor(data?: IPledgeZipcodeReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zipcode = _data["zipcode"] !== undefined ? _data["zipcode"] : null as any;
            this.pledgeCount = _data["pledgeCount"] !== undefined ? _data["pledgeCount"] : null as any;
            this.pledgeTotal = _data["pledgeTotal"] !== undefined ? _data["pledgeTotal"] : null as any;
        }
    }

    static override fromJS(data: any): PledgeZipcodeReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeZipcodeReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zipcode"] = this.zipcode !== undefined ? this.zipcode : null as any;
        data["pledgeCount"] = this.pledgeCount !== undefined ? this.pledgeCount : null as any;
        data["pledgeTotal"] = this.pledgeTotal !== undefined ? this.pledgeTotal : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeZipcodeReport {
        const json = this.toJSON();
        let result = new PledgeZipcodeReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeZipcodeReport extends IBaseViewModel {
    zipcode?: string | null;
    pledgeCount?: number;
    pledgeTotal?: number;
}

export class PledgeDemographicSummaryReport implements IPledgeDemographicSummaryReport {
    companySummaryReport?: CompanySummaryReport[] | null;
    employmentStatus?: KeyValuePairOfStringAndInteger[] | null;
    clientDemographic?: KeyValuePairOfStringAndDecimal[] | null;
    clientAge?: KeyValuePairOfStringAndInteger[] | null;
    householdDemographic?: KeyValuePairOfStringAndInteger[] | null;
    householdIncome?: KeyValuePairOfStringAndInteger[] | null;
    householdSize?: KeyValuePairOfStringAndInteger[] | null;

    constructor(data?: IPledgeDemographicSummaryReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companySummaryReport"])) {
                this.companySummaryReport = [] as any;
                for (let item of _data["companySummaryReport"])
                    this.companySummaryReport!.push(CompanySummaryReport.fromJS(item));
            }
            else {
                this.companySummaryReport = null as any;
            }
            if (Array.isArray(_data["employmentStatus"])) {
                this.employmentStatus = [] as any;
                for (let item of _data["employmentStatus"])
                    this.employmentStatus!.push(KeyValuePairOfStringAndInteger.fromJS(item));
            }
            else {
                this.employmentStatus = null as any;
            }
            if (Array.isArray(_data["clientDemographic"])) {
                this.clientDemographic = [] as any;
                for (let item of _data["clientDemographic"])
                    this.clientDemographic!.push(KeyValuePairOfStringAndDecimal.fromJS(item));
            }
            else {
                this.clientDemographic = null as any;
            }
            if (Array.isArray(_data["clientAge"])) {
                this.clientAge = [] as any;
                for (let item of _data["clientAge"])
                    this.clientAge!.push(KeyValuePairOfStringAndInteger.fromJS(item));
            }
            else {
                this.clientAge = null as any;
            }
            if (Array.isArray(_data["householdDemographic"])) {
                this.householdDemographic = [] as any;
                for (let item of _data["householdDemographic"])
                    this.householdDemographic!.push(KeyValuePairOfStringAndInteger.fromJS(item));
            }
            else {
                this.householdDemographic = null as any;
            }
            if (Array.isArray(_data["householdIncome"])) {
                this.householdIncome = [] as any;
                for (let item of _data["householdIncome"])
                    this.householdIncome!.push(KeyValuePairOfStringAndInteger.fromJS(item));
            }
            else {
                this.householdIncome = null as any;
            }
            if (Array.isArray(_data["householdSize"])) {
                this.householdSize = [] as any;
                for (let item of _data["householdSize"])
                    this.householdSize!.push(KeyValuePairOfStringAndInteger.fromJS(item));
            }
            else {
                this.householdSize = null as any;
            }
        }
    }

    static fromJS(data: any): PledgeDemographicSummaryReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeDemographicSummaryReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companySummaryReport)) {
            data["companySummaryReport"] = [];
            for (let item of this.companySummaryReport)
                data["companySummaryReport"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.employmentStatus)) {
            data["employmentStatus"] = [];
            for (let item of this.employmentStatus)
                data["employmentStatus"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.clientDemographic)) {
            data["clientDemographic"] = [];
            for (let item of this.clientDemographic)
                data["clientDemographic"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.clientAge)) {
            data["clientAge"] = [];
            for (let item of this.clientAge)
                data["clientAge"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.householdDemographic)) {
            data["householdDemographic"] = [];
            for (let item of this.householdDemographic)
                data["householdDemographic"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.householdIncome)) {
            data["householdIncome"] = [];
            for (let item of this.householdIncome)
                data["householdIncome"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.householdSize)) {
            data["householdSize"] = [];
            for (let item of this.householdSize)
                data["householdSize"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): PledgeDemographicSummaryReport {
        const json = this.toJSON();
        let result = new PledgeDemographicSummaryReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeDemographicSummaryReport {
    companySummaryReport?: CompanySummaryReport[] | null;
    employmentStatus?: KeyValuePairOfStringAndInteger[] | null;
    clientDemographic?: KeyValuePairOfStringAndDecimal[] | null;
    clientAge?: KeyValuePairOfStringAndInteger[] | null;
    householdDemographic?: KeyValuePairOfStringAndInteger[] | null;
    householdIncome?: KeyValuePairOfStringAndInteger[] | null;
    householdSize?: KeyValuePairOfStringAndInteger[] | null;
}

export class CompanySummaryReport implements ICompanySummaryReport {
    companyName?: string | null;
    numberOfPledges?: number;
    totalPledged?: number;
    averagePledged?: number;
    avgDaysPledgedToEntry?: number;
    avgDaysEntryToPaid?: number;
    avgDaysTotal?: number;

    constructor(data?: ICompanySummaryReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.numberOfPledges = _data["numberOfPledges"] !== undefined ? _data["numberOfPledges"] : null as any;
            this.totalPledged = _data["totalPledged"] !== undefined ? _data["totalPledged"] : null as any;
            this.averagePledged = _data["averagePledged"] !== undefined ? _data["averagePledged"] : null as any;
            this.avgDaysPledgedToEntry = _data["avgDaysPledgedToEntry"] !== undefined ? _data["avgDaysPledgedToEntry"] : null as any;
            this.avgDaysEntryToPaid = _data["avgDaysEntryToPaid"] !== undefined ? _data["avgDaysEntryToPaid"] : null as any;
            this.avgDaysTotal = _data["avgDaysTotal"] !== undefined ? _data["avgDaysTotal"] : null as any;
        }
    }

    static fromJS(data: any): CompanySummaryReport {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySummaryReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["numberOfPledges"] = this.numberOfPledges !== undefined ? this.numberOfPledges : null as any;
        data["totalPledged"] = this.totalPledged !== undefined ? this.totalPledged : null as any;
        data["averagePledged"] = this.averagePledged !== undefined ? this.averagePledged : null as any;
        data["avgDaysPledgedToEntry"] = this.avgDaysPledgedToEntry !== undefined ? this.avgDaysPledgedToEntry : null as any;
        data["avgDaysEntryToPaid"] = this.avgDaysEntryToPaid !== undefined ? this.avgDaysEntryToPaid : null as any;
        data["avgDaysTotal"] = this.avgDaysTotal !== undefined ? this.avgDaysTotal : null as any;
        return data;
    }

    clone(): CompanySummaryReport {
        const json = this.toJSON();
        let result = new CompanySummaryReport();
        result.init(json);
        return result;
    }
}

export interface ICompanySummaryReport {
    companyName?: string | null;
    numberOfPledges?: number;
    totalPledged?: number;
    averagePledged?: number;
    avgDaysPledgedToEntry?: number;
    avgDaysEntryToPaid?: number;
    avgDaysTotal?: number;
}

export class KeyValuePairOfStringAndInteger implements IKeyValuePairOfStringAndInteger {
    key?: string | null;
    value?: number;

    constructor(data?: IKeyValuePairOfStringAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): KeyValuePairOfStringAndInteger {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringAndInteger();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringAndInteger {
    key?: string | null;
    value?: number;
}

export class KeyValuePairOfStringAndDecimal implements IKeyValuePairOfStringAndDecimal {
    key?: string | null;
    value?: number;

    constructor(data?: IKeyValuePairOfStringAndDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): KeyValuePairOfStringAndDecimal {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringAndDecimal();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringAndDecimal {
    key?: string | null;
    value?: number;
}

export class DraftApplicationFile extends BaseViewModel implements IDraftApplicationFile {
    draftApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileType?: string | null;
    fileUrl?: string | null;

    constructor(data?: IDraftApplicationFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.draftApplicationId = _data["draftApplicationId"] !== undefined ? _data["draftApplicationId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
        }
    }

    static override fromJS(data: any): DraftApplicationFile {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftApplicationId"] = this.draftApplicationId !== undefined ? this.draftApplicationId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): DraftApplicationFile {
        const json = this.toJSON();
        let result = new DraftApplicationFile();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationFile extends IBaseViewModel {
    draftApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileType?: string | null;
    fileUrl?: string | null;
}

export class EfnCaseComment extends BaseViewModel implements IEfnCaseComment {
    efnCaseId?: string;
    userId?: string;
    comment?: string | null;
    agencyName?: string | null;
    userFullName?: string | null;

    constructor(data?: IEfnCaseComment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.userFullName = _data["userFullName"] !== undefined ? _data["userFullName"] : null as any;
        }
    }

    static override fromJS(data: any): EfnCaseComment {
        data = typeof data === 'object' ? data : {};
        let result = new EfnCaseComment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["userFullName"] = this.userFullName !== undefined ? this.userFullName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfnCaseComment {
        const json = this.toJSON();
        let result = new EfnCaseComment();
        result.init(json);
        return result;
    }
}

export interface IEfnCaseComment extends IBaseViewModel {
    efnCaseId?: string;
    userId?: string;
    comment?: string | null;
    agencyName?: string | null;
    userFullName?: string | null;
}

export class EfnCase extends BaseViewModel implements IEfnCase {
    clientId?: string;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    createdByAgencyId?: string | null;
    createdByAgencyName?: string | null;
    totalNeed?: number | null;
    summary?: string | null;
    description?: string | null;
    caseNote?: string | null;
    status?: EfnCaseStatusType;
    deadline?: Date | null;
    fundedDate?: Date | null;
    currentTotal?: number;
    caseWorker?: string | null;
    clientSsn?: string | null;
    clientAddress?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientEmail?: string | null;
    paymentTo?: string | null;
    payeeAddress?: string | null;
    payeeAddress2?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    accountNumber?: string | null;
    companyId?: string | null;
    companyName?: string | null;
    createdByUserId?: string;
    user?: User | null;
    client?: Client | null;
    company?: Company | null;

    constructor(data?: IEfnCase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.createdByAgencyId = _data["createdByAgencyId"] !== undefined ? _data["createdByAgencyId"] : null as any;
            this.createdByAgencyName = _data["createdByAgencyName"] !== undefined ? _data["createdByAgencyName"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.caseNote = _data["caseNote"] !== undefined ? _data["caseNote"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : null as any;
            this.fundedDate = _data["fundedDate"] ? new Date(_data["fundedDate"].toString()) : null as any;
            this.currentTotal = _data["currentTotal"] !== undefined ? _data["currentTotal"] : null as any;
            this.caseWorker = _data["caseWorker"] !== undefined ? _data["caseWorker"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientAddress = _data["clientAddress"] !== undefined ? _data["clientAddress"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientEmail = _data["clientEmail"] !== undefined ? _data["clientEmail"] : null as any;
            this.paymentTo = _data["paymentTo"] !== undefined ? _data["paymentTo"] : null as any;
            this.payeeAddress = _data["payeeAddress"] !== undefined ? _data["payeeAddress"] : null as any;
            this.payeeAddress2 = _data["payeeAddress2"] !== undefined ? _data["payeeAddress2"] : null as any;
            this.payeeCity = _data["payeeCity"] !== undefined ? _data["payeeCity"] : null as any;
            this.payeeState = _data["payeeState"] !== undefined ? _data["payeeState"] : null as any;
            this.payeeZip = _data["payeeZip"] !== undefined ? _data["payeeZip"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : null as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : null as any;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : null as any;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : null as any;
        }
    }

    static override fromJS(data: any): EfnCase {
        data = typeof data === 'object' ? data : {};
        let result = new EfnCase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["createdByAgencyId"] = this.createdByAgencyId !== undefined ? this.createdByAgencyId : null as any;
        data["createdByAgencyName"] = this.createdByAgencyName !== undefined ? this.createdByAgencyName : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["caseNote"] = this.caseNote !== undefined ? this.caseNote : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : null as any;
        data["fundedDate"] = this.fundedDate ? this.fundedDate.toISOString() : null as any;
        data["currentTotal"] = this.currentTotal !== undefined ? this.currentTotal : null as any;
        data["caseWorker"] = this.caseWorker !== undefined ? this.caseWorker : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientAddress"] = this.clientAddress !== undefined ? this.clientAddress : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientEmail"] = this.clientEmail !== undefined ? this.clientEmail : null as any;
        data["paymentTo"] = this.paymentTo !== undefined ? this.paymentTo : null as any;
        data["payeeAddress"] = this.payeeAddress !== undefined ? this.payeeAddress : null as any;
        data["payeeAddress2"] = this.payeeAddress2 !== undefined ? this.payeeAddress2 : null as any;
        data["payeeCity"] = this.payeeCity !== undefined ? this.payeeCity : null as any;
        data["payeeState"] = this.payeeState !== undefined ? this.payeeState : null as any;
        data["payeeZip"] = this.payeeZip !== undefined ? this.payeeZip : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfnCase {
        const json = this.toJSON();
        let result = new EfnCase();
        result.init(json);
        return result;
    }
}

export interface IEfnCase extends IBaseViewModel {
    clientId?: string;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    createdByAgencyId?: string | null;
    createdByAgencyName?: string | null;
    totalNeed?: number | null;
    summary?: string | null;
    description?: string | null;
    caseNote?: string | null;
    status?: EfnCaseStatusType;
    deadline?: Date | null;
    fundedDate?: Date | null;
    currentTotal?: number;
    caseWorker?: string | null;
    clientSsn?: string | null;
    clientAddress?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientEmail?: string | null;
    paymentTo?: string | null;
    payeeAddress?: string | null;
    payeeAddress2?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    accountNumber?: string | null;
    companyId?: string | null;
    companyName?: string | null;
    createdByUserId?: string;
    user?: User | null;
    client?: Client | null;
    company?: Company | null;
}

export enum EfnCaseStatusType {
    Open = "Open",
    Funded = "Funded",
    Cancelled = "Cancelled",
}

export class AgencyEfnCase extends BaseViewModel implements IAgencyEfnCase {
    agencyId?: string;
    agencyName?: string | null;
    efnCaseId?: string;
    efnCaseClientName?: string | null;
    originalCommitAmount?: number | null;
    currentCommitAmount?: number | null;
    commitNote?: string | null;
    status?: AgencyEfnCaseStatusType;
    pledgeId?: string | null;

    constructor(data?: IAgencyEfnCase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.efnCaseClientName = _data["efnCaseClientName"] !== undefined ? _data["efnCaseClientName"] : null as any;
            this.originalCommitAmount = _data["originalCommitAmount"] !== undefined ? _data["originalCommitAmount"] : null as any;
            this.currentCommitAmount = _data["currentCommitAmount"] !== undefined ? _data["currentCommitAmount"] : null as any;
            this.commitNote = _data["commitNote"] !== undefined ? _data["commitNote"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
        }
    }

    static override fromJS(data: any): AgencyEfnCase {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyEfnCase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["efnCaseClientName"] = this.efnCaseClientName !== undefined ? this.efnCaseClientName : null as any;
        data["originalCommitAmount"] = this.originalCommitAmount !== undefined ? this.originalCommitAmount : null as any;
        data["currentCommitAmount"] = this.currentCommitAmount !== undefined ? this.currentCommitAmount : null as any;
        data["commitNote"] = this.commitNote !== undefined ? this.commitNote : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AgencyEfnCase {
        const json = this.toJSON();
        let result = new AgencyEfnCase();
        result.init(json);
        return result;
    }
}

export interface IAgencyEfnCase extends IBaseViewModel {
    agencyId?: string;
    agencyName?: string | null;
    efnCaseId?: string;
    efnCaseClientName?: string | null;
    originalCommitAmount?: number | null;
    currentCommitAmount?: number | null;
    commitNote?: string | null;
    status?: AgencyEfnCaseStatusType;
    pledgeId?: string | null;
}

export enum AgencyEfnCaseStatusType {
    Invited = "Invited",
    Declined = "Declined",
    Committed = "Committed",
}

export class CommitEfnCaseParameters implements ICommitEfnCaseParameters {
    efnCaseId?: string;
    agencyId?: string;
    commitAmount?: number;
    commitNote?: string | null;

    constructor(data?: ICommitEfnCaseParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.commitAmount = _data["commitAmount"] !== undefined ? _data["commitAmount"] : null as any;
            this.commitNote = _data["commitNote"] !== undefined ? _data["commitNote"] : null as any;
        }
    }

    static fromJS(data: any): CommitEfnCaseParameters {
        data = typeof data === 'object' ? data : {};
        let result = new CommitEfnCaseParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["commitAmount"] = this.commitAmount !== undefined ? this.commitAmount : null as any;
        data["commitNote"] = this.commitNote !== undefined ? this.commitNote : null as any;
        return data;
    }

    clone(): CommitEfnCaseParameters {
        const json = this.toJSON();
        let result = new CommitEfnCaseParameters();
        result.init(json);
        return result;
    }
}

export interface ICommitEfnCaseParameters {
    efnCaseId?: string;
    agencyId?: string;
    commitAmount?: number;
    commitNote?: string | null;
}

export class DeclineEfnCaseParameters implements IDeclineEfnCaseParameters {
    efnCaseId?: string;
    agencyId?: string;

    constructor(data?: IDeclineEfnCaseParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
        }
    }

    static fromJS(data: any): DeclineEfnCaseParameters {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineEfnCaseParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        return data;
    }

    clone(): DeclineEfnCaseParameters {
        const json = this.toJSON();
        let result = new DeclineEfnCaseParameters();
        result.init(json);
        return result;
    }
}

export interface IDeclineEfnCaseParameters {
    efnCaseId?: string;
    agencyId?: string;
}

export class PagedListOfEfnCase implements IPagedListOfEfnCase {
    items?: EfnCase[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfEfnCase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EfnCase.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfEfnCase {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfEfnCase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfEfnCase {
        const json = this.toJSON();
        let result = new PagedListOfEfnCase();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfEfnCase {
    items?: EfnCase[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class InviteAgencyParams implements IInviteAgencyParams {
    agencyId?: string;
    efnCaseId?: string;

    constructor(data?: IInviteAgencyParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
        }
    }

    static fromJS(data: any): InviteAgencyParams {
        data = typeof data === 'object' ? data : {};
        let result = new InviteAgencyParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        return data;
    }

    clone(): InviteAgencyParams {
        const json = this.toJSON();
        let result = new InviteAgencyParams();
        result.init(json);
        return result;
    }
}

export interface IInviteAgencyParams {
    agencyId?: string;
    efnCaseId?: string;
}

export class EfnCaseFile extends BaseViewModel implements IEfnCaseFile {
    efnCaseId?: string;
    userId?: string;
    fileName?: string | null;
    fileUrl?: string | null;

    constructor(data?: IEfnCaseFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
        }
    }

    static override fromJS(data: any): EfnCaseFile {
        data = typeof data === 'object' ? data : {};
        let result = new EfnCaseFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfnCaseFile {
        const json = this.toJSON();
        let result = new EfnCaseFile();
        result.init(json);
        return result;
    }
}

export interface IEfnCaseFile extends IBaseViewModel {
    efnCaseId?: string;
    userId?: string;
    fileName?: string | null;
    fileUrl?: string | null;
}

export class Efs extends BaseViewModel implements IEfs {
    clientId?: string;
    agencyId?: string | null;
    agencyName?: string | null;
    assistanceType?: string | null;
    zipCode?: string | null;
    description?: string | null;
    confirmed?: EfsStatusType;
    status?: StatusType;
    pledgeTypeId?: string;
    pledgeTypeName?: string | null;
    clientCompanyAccountNumber?: string | null;
    clientSsn?: string | null;
    clientSsnHash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    federalPovertyLevelDisplay?: number | null;
    assistanceDate?: Date;
    client?: Client | null;
    agency?: Agency | null;
    pledgeType?: PledgeType | null;

    constructor(data?: IEfs) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.assistanceType = _data["assistanceType"] !== undefined ? _data["assistanceType"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.pledgeTypeName = _data["pledgeTypeName"] !== undefined ? _data["pledgeTypeName"] : null as any;
            this.clientCompanyAccountNumber = _data["clientCompanyAccountNumber"] !== undefined ? _data["clientCompanyAccountNumber"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientSsnHash = _data["clientSsnHash"] !== undefined ? _data["clientSsnHash"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.clientPrefix = _data["clientPrefix"] !== undefined ? _data["clientPrefix"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientMiddleInitial = _data["clientMiddleInitial"] !== undefined ? _data["clientMiddleInitial"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientSuffix = _data["clientSuffix"] !== undefined ? _data["clientSuffix"] : null as any;
            this.clientAddress1 = _data["clientAddress1"] !== undefined ? _data["clientAddress1"] : null as any;
            this.clientAddress2 = _data["clientAddress2"] !== undefined ? _data["clientAddress2"] : null as any;
            this.clientCity = _data["clientCity"] !== undefined ? _data["clientCity"] : null as any;
            this.clientState = _data["clientState"] !== undefined ? _data["clientState"] : null as any;
            this.clientZipCode = _data["clientZipCode"] !== undefined ? _data["clientZipCode"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientPhoneExt = _data["clientPhoneExt"] !== undefined ? _data["clientPhoneExt"] : null as any;
            this.clientBirthYear = _data["clientBirthYear"] !== undefined ? _data["clientBirthYear"] : null as any;
            this.clientEmail = _data["clientEmail"] !== undefined ? _data["clientEmail"] : null as any;
            this.clientGender = _data["clientGender"] !== undefined ? _data["clientGender"] : null as any;
            this.clientHouseHoldIncome = _data["clientHouseHoldIncome"] !== undefined ? _data["clientHouseHoldIncome"] : null as any;
            this.clientHouseHoldSize = _data["clientHouseHoldSize"] !== undefined ? _data["clientHouseHoldSize"] : null as any;
            this.clientEmploymentStatus = _data["clientEmploymentStatus"] !== undefined ? _data["clientEmploymentStatus"] : null as any;
            this.clientIsElderly = _data["clientIsElderly"] !== undefined ? _data["clientIsElderly"] : null as any;
            this.clientIsDisabled = _data["clientIsDisabled"] !== undefined ? _data["clientIsDisabled"] : null as any;
            this.clientHasChildrenUnderFive = _data["clientHasChildrenUnderFive"] !== undefined ? _data["clientHasChildrenUnderFive"] : null as any;
            this.clientIsVeteran = _data["clientIsVeteran"] !== undefined ? _data["clientIsVeteran"] : null as any;
            this.clientIsHomeless = _data["clientIsHomeless"] !== undefined ? _data["clientIsHomeless"] : null as any;
            this.clientMembersAreElderly = _data["clientMembersAreElderly"] !== undefined ? _data["clientMembersAreElderly"] : null as any;
            this.clientMembersAreDisabled = _data["clientMembersAreDisabled"] !== undefined ? _data["clientMembersAreDisabled"] : null as any;
            this.clientMembersHaveChildrenUnderFive = _data["clientMembersHaveChildrenUnderFive"] !== undefined ? _data["clientMembersHaveChildrenUnderFive"] : null as any;
            this.clientPhoneAlt = _data["clientPhoneAlt"] !== undefined ? _data["clientPhoneAlt"] : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.assistanceDate = _data["assistanceDate"] ? new Date(_data["assistanceDate"].toString()) : null as any;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : null as any;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType.fromJS(_data["pledgeType"]) : null as any;
        }
    }

    static override fromJS(data: any): Efs {
        data = typeof data === 'object' ? data : {};
        let result = new Efs();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["assistanceType"] = this.assistanceType !== undefined ? this.assistanceType : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["pledgeTypeName"] = this.pledgeTypeName !== undefined ? this.pledgeTypeName : null as any;
        data["clientCompanyAccountNumber"] = this.clientCompanyAccountNumber !== undefined ? this.clientCompanyAccountNumber : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientSsnHash"] = this.clientSsnHash !== undefined ? this.clientSsnHash : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["clientPrefix"] = this.clientPrefix !== undefined ? this.clientPrefix : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientMiddleInitial"] = this.clientMiddleInitial !== undefined ? this.clientMiddleInitial : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientSuffix"] = this.clientSuffix !== undefined ? this.clientSuffix : null as any;
        data["clientAddress1"] = this.clientAddress1 !== undefined ? this.clientAddress1 : null as any;
        data["clientAddress2"] = this.clientAddress2 !== undefined ? this.clientAddress2 : null as any;
        data["clientCity"] = this.clientCity !== undefined ? this.clientCity : null as any;
        data["clientState"] = this.clientState !== undefined ? this.clientState : null as any;
        data["clientZipCode"] = this.clientZipCode !== undefined ? this.clientZipCode : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientPhoneExt"] = this.clientPhoneExt !== undefined ? this.clientPhoneExt : null as any;
        data["clientBirthYear"] = this.clientBirthYear !== undefined ? this.clientBirthYear : null as any;
        data["clientEmail"] = this.clientEmail !== undefined ? this.clientEmail : null as any;
        data["clientGender"] = this.clientGender !== undefined ? this.clientGender : null as any;
        data["clientHouseHoldIncome"] = this.clientHouseHoldIncome !== undefined ? this.clientHouseHoldIncome : null as any;
        data["clientHouseHoldSize"] = this.clientHouseHoldSize !== undefined ? this.clientHouseHoldSize : null as any;
        data["clientEmploymentStatus"] = this.clientEmploymentStatus !== undefined ? this.clientEmploymentStatus : null as any;
        data["clientIsElderly"] = this.clientIsElderly !== undefined ? this.clientIsElderly : null as any;
        data["clientIsDisabled"] = this.clientIsDisabled !== undefined ? this.clientIsDisabled : null as any;
        data["clientHasChildrenUnderFive"] = this.clientHasChildrenUnderFive !== undefined ? this.clientHasChildrenUnderFive : null as any;
        data["clientIsVeteran"] = this.clientIsVeteran !== undefined ? this.clientIsVeteran : null as any;
        data["clientIsHomeless"] = this.clientIsHomeless !== undefined ? this.clientIsHomeless : null as any;
        data["clientMembersAreElderly"] = this.clientMembersAreElderly !== undefined ? this.clientMembersAreElderly : null as any;
        data["clientMembersAreDisabled"] = this.clientMembersAreDisabled !== undefined ? this.clientMembersAreDisabled : null as any;
        data["clientMembersHaveChildrenUnderFive"] = this.clientMembersHaveChildrenUnderFive !== undefined ? this.clientMembersHaveChildrenUnderFive : null as any;
        data["clientPhoneAlt"] = this.clientPhoneAlt !== undefined ? this.clientPhoneAlt : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["assistanceDate"] = this.assistanceDate ? this.assistanceDate.toISOString() : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Efs {
        const json = this.toJSON();
        let result = new Efs();
        result.init(json);
        return result;
    }
}

export interface IEfs extends IBaseViewModel {
    clientId?: string;
    agencyId?: string | null;
    agencyName?: string | null;
    assistanceType?: string | null;
    zipCode?: string | null;
    description?: string | null;
    confirmed?: EfsStatusType;
    status?: StatusType;
    pledgeTypeId?: string;
    pledgeTypeName?: string | null;
    clientCompanyAccountNumber?: string | null;
    clientSsn?: string | null;
    clientSsnHash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    federalPovertyLevelDisplay?: number | null;
    assistanceDate?: Date;
    client?: Client | null;
    agency?: Agency | null;
    pledgeType?: PledgeType | null;
}

export enum EfsStatusType {
    NotConfirmed = "NotConfirmed",
    Confirmed = "Confirmed",
}

export class PagedListOfEfs implements IPagedListOfEfs {
    items?: Efs[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfEfs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Efs.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfEfs {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfEfs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfEfs {
        const json = this.toJSON();
        let result = new PagedListOfEfs();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfEfs {
    items?: Efs[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class EfsReport extends BaseViewModel implements IEfsReport {
    clientId?: string;
    agencyId?: string | null;
    agencyName?: string | null;
    assistanceType?: string | null;
    zipCode?: string | null;
    description?: string | null;
    confirmed?: EfsStatusType;
    status?: StatusType;
    pledgeTypeId?: string;
    pledgeTypeName?: string | null;
    clientCompanyAccountNumber?: string | null;
    clientSsn?: string | null;
    clientSsnHash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    federalPovertyLevelDisplay?: number | null;
    assistanceDate?: Date;

    constructor(data?: IEfsReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.assistanceType = _data["assistanceType"] !== undefined ? _data["assistanceType"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.pledgeTypeName = _data["pledgeTypeName"] !== undefined ? _data["pledgeTypeName"] : null as any;
            this.clientCompanyAccountNumber = _data["clientCompanyAccountNumber"] !== undefined ? _data["clientCompanyAccountNumber"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientSsnHash = _data["clientSsnHash"] !== undefined ? _data["clientSsnHash"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.clientPrefix = _data["clientPrefix"] !== undefined ? _data["clientPrefix"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientMiddleInitial = _data["clientMiddleInitial"] !== undefined ? _data["clientMiddleInitial"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientSuffix = _data["clientSuffix"] !== undefined ? _data["clientSuffix"] : null as any;
            this.clientAddress1 = _data["clientAddress1"] !== undefined ? _data["clientAddress1"] : null as any;
            this.clientAddress2 = _data["clientAddress2"] !== undefined ? _data["clientAddress2"] : null as any;
            this.clientCity = _data["clientCity"] !== undefined ? _data["clientCity"] : null as any;
            this.clientState = _data["clientState"] !== undefined ? _data["clientState"] : null as any;
            this.clientZipCode = _data["clientZipCode"] !== undefined ? _data["clientZipCode"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientPhoneExt = _data["clientPhoneExt"] !== undefined ? _data["clientPhoneExt"] : null as any;
            this.clientBirthYear = _data["clientBirthYear"] !== undefined ? _data["clientBirthYear"] : null as any;
            this.clientEmail = _data["clientEmail"] !== undefined ? _data["clientEmail"] : null as any;
            this.clientGender = _data["clientGender"] !== undefined ? _data["clientGender"] : null as any;
            this.clientHouseHoldIncome = _data["clientHouseHoldIncome"] !== undefined ? _data["clientHouseHoldIncome"] : null as any;
            this.clientHouseHoldSize = _data["clientHouseHoldSize"] !== undefined ? _data["clientHouseHoldSize"] : null as any;
            this.clientEmploymentStatus = _data["clientEmploymentStatus"] !== undefined ? _data["clientEmploymentStatus"] : null as any;
            this.clientIsElderly = _data["clientIsElderly"] !== undefined ? _data["clientIsElderly"] : null as any;
            this.clientIsDisabled = _data["clientIsDisabled"] !== undefined ? _data["clientIsDisabled"] : null as any;
            this.clientHasChildrenUnderFive = _data["clientHasChildrenUnderFive"] !== undefined ? _data["clientHasChildrenUnderFive"] : null as any;
            this.clientIsVeteran = _data["clientIsVeteran"] !== undefined ? _data["clientIsVeteran"] : null as any;
            this.clientIsHomeless = _data["clientIsHomeless"] !== undefined ? _data["clientIsHomeless"] : null as any;
            this.clientMembersAreElderly = _data["clientMembersAreElderly"] !== undefined ? _data["clientMembersAreElderly"] : null as any;
            this.clientMembersAreDisabled = _data["clientMembersAreDisabled"] !== undefined ? _data["clientMembersAreDisabled"] : null as any;
            this.clientMembersHaveChildrenUnderFive = _data["clientMembersHaveChildrenUnderFive"] !== undefined ? _data["clientMembersHaveChildrenUnderFive"] : null as any;
            this.clientPhoneAlt = _data["clientPhoneAlt"] !== undefined ? _data["clientPhoneAlt"] : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.assistanceDate = _data["assistanceDate"] ? new Date(_data["assistanceDate"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): EfsReport {
        data = typeof data === 'object' ? data : {};
        let result = new EfsReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["assistanceType"] = this.assistanceType !== undefined ? this.assistanceType : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["pledgeTypeName"] = this.pledgeTypeName !== undefined ? this.pledgeTypeName : null as any;
        data["clientCompanyAccountNumber"] = this.clientCompanyAccountNumber !== undefined ? this.clientCompanyAccountNumber : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientSsnHash"] = this.clientSsnHash !== undefined ? this.clientSsnHash : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["clientPrefix"] = this.clientPrefix !== undefined ? this.clientPrefix : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientMiddleInitial"] = this.clientMiddleInitial !== undefined ? this.clientMiddleInitial : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientSuffix"] = this.clientSuffix !== undefined ? this.clientSuffix : null as any;
        data["clientAddress1"] = this.clientAddress1 !== undefined ? this.clientAddress1 : null as any;
        data["clientAddress2"] = this.clientAddress2 !== undefined ? this.clientAddress2 : null as any;
        data["clientCity"] = this.clientCity !== undefined ? this.clientCity : null as any;
        data["clientState"] = this.clientState !== undefined ? this.clientState : null as any;
        data["clientZipCode"] = this.clientZipCode !== undefined ? this.clientZipCode : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientPhoneExt"] = this.clientPhoneExt !== undefined ? this.clientPhoneExt : null as any;
        data["clientBirthYear"] = this.clientBirthYear !== undefined ? this.clientBirthYear : null as any;
        data["clientEmail"] = this.clientEmail !== undefined ? this.clientEmail : null as any;
        data["clientGender"] = this.clientGender !== undefined ? this.clientGender : null as any;
        data["clientHouseHoldIncome"] = this.clientHouseHoldIncome !== undefined ? this.clientHouseHoldIncome : null as any;
        data["clientHouseHoldSize"] = this.clientHouseHoldSize !== undefined ? this.clientHouseHoldSize : null as any;
        data["clientEmploymentStatus"] = this.clientEmploymentStatus !== undefined ? this.clientEmploymentStatus : null as any;
        data["clientIsElderly"] = this.clientIsElderly !== undefined ? this.clientIsElderly : null as any;
        data["clientIsDisabled"] = this.clientIsDisabled !== undefined ? this.clientIsDisabled : null as any;
        data["clientHasChildrenUnderFive"] = this.clientHasChildrenUnderFive !== undefined ? this.clientHasChildrenUnderFive : null as any;
        data["clientIsVeteran"] = this.clientIsVeteran !== undefined ? this.clientIsVeteran : null as any;
        data["clientIsHomeless"] = this.clientIsHomeless !== undefined ? this.clientIsHomeless : null as any;
        data["clientMembersAreElderly"] = this.clientMembersAreElderly !== undefined ? this.clientMembersAreElderly : null as any;
        data["clientMembersAreDisabled"] = this.clientMembersAreDisabled !== undefined ? this.clientMembersAreDisabled : null as any;
        data["clientMembersHaveChildrenUnderFive"] = this.clientMembersHaveChildrenUnderFive !== undefined ? this.clientMembersHaveChildrenUnderFive : null as any;
        data["clientPhoneAlt"] = this.clientPhoneAlt !== undefined ? this.clientPhoneAlt : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["assistanceDate"] = this.assistanceDate ? this.assistanceDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfsReport {
        const json = this.toJSON();
        let result = new EfsReport();
        result.init(json);
        return result;
    }
}

export interface IEfsReport extends IBaseViewModel {
    clientId?: string;
    agencyId?: string | null;
    agencyName?: string | null;
    assistanceType?: string | null;
    zipCode?: string | null;
    description?: string | null;
    confirmed?: EfsStatusType;
    status?: StatusType;
    pledgeTypeId?: string;
    pledgeTypeName?: string | null;
    clientCompanyAccountNumber?: string | null;
    clientSsn?: string | null;
    clientSsnHash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    federalPovertyLevelDisplay?: number | null;
    assistanceDate?: Date;
}

export class FederalPovertyLevel extends BaseViewModel implements IFederalPovertyLevel {
    federalPovertyLevelDisplay?: string | null;
    minLevel?: number;
    maxLevel?: number;

    constructor(data?: IFederalPovertyLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.minLevel = _data["minLevel"] !== undefined ? _data["minLevel"] : null as any;
            this.maxLevel = _data["maxLevel"] !== undefined ? _data["maxLevel"] : null as any;
        }
    }

    static override fromJS(data: any): FederalPovertyLevel {
        data = typeof data === 'object' ? data : {};
        let result = new FederalPovertyLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["minLevel"] = this.minLevel !== undefined ? this.minLevel : null as any;
        data["maxLevel"] = this.maxLevel !== undefined ? this.maxLevel : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FederalPovertyLevel {
        const json = this.toJSON();
        let result = new FederalPovertyLevel();
        result.init(json);
        return result;
    }
}

export interface IFederalPovertyLevel extends IBaseViewModel {
    federalPovertyLevelDisplay?: string | null;
    minLevel?: number;
    maxLevel?: number;
}

export abstract class SimpleResultOfNullableDecimal implements ISimpleResultOfNullableDecimal {
    result?: number | null;

    constructor(data?: ISimpleResultOfNullableDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): SimpleResultOfNullableDecimal {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SimpleResultOfNullableDecimal' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): SimpleResultOfNullableDecimal {
        throw new Error("The abstract class 'SimpleResultOfNullableDecimal' cannot be instantiated.");
    }
}

export interface ISimpleResultOfNullableDecimal {
    result?: number | null;
}

export class SimpleDecimalResult extends SimpleResultOfNullableDecimal implements ISimpleDecimalResult {
    result?: number | null;

    constructor(data?: ISimpleDecimalResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static override fromJS(data: any): SimpleDecimalResult {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleDecimalResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SimpleDecimalResult {
        const json = this.toJSON();
        let result = new SimpleDecimalResult();
        result.init(json);
        return result;
    }
}

export interface ISimpleDecimalResult extends ISimpleResultOfNullableDecimal {
    result?: number | null;
}

export class FundTypeSelection implements IFundTypeSelection {
    id?: string;
    displayName?: string | null;
    isActive?: boolean;

    constructor(data?: IFundTypeSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): FundTypeSelection {
        data = typeof data === 'object' ? data : {};
        let result = new FundTypeSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }

    clone(): FundTypeSelection {
        const json = this.toJSON();
        let result = new FundTypeSelection();
        result.init(json);
        return result;
    }
}

export interface IFundTypeSelection {
    id?: string;
    displayName?: string | null;
    isActive?: boolean;
}

export class InternalDraftApplicationViewModel implements IInternalDraftApplicationViewModel {
    id?: string;
    clientId?: string;
    pledgeTypeId?: string | null;
    userId?: string;
    applicationType?: AssistanceApplicationType;
    formData?: InternalDraftFormData | null;
    enteredDate?: Date;
    modifiedDate?: Date | null;
    createdByName?: string | null;
    createdByEmail?: string | null;
    agencyName?: string | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    files?: DraftApplicationFile[] | null;
    warnings?: string[] | null;

    constructor(data?: IInternalDraftApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.formData = _data["formData"] ? InternalDraftFormData.fromJS(_data["formData"]) : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.createdByName = _data["createdByName"] !== undefined ? _data["createdByName"] : null as any;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DraftApplicationFile.fromJS(item));
            }
            else {
                this.files = null as any;
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            else {
                this.warnings = null as any;
            }
        }
    }

    static fromJS(data: any): InternalDraftApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternalDraftApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["formData"] = this.formData ? this.formData.toJSON() : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["createdByName"] = this.createdByName !== undefined ? this.createdByName : null as any;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }

    clone(): InternalDraftApplicationViewModel {
        const json = this.toJSON();
        let result = new InternalDraftApplicationViewModel();
        result.init(json);
        return result;
    }
}

export interface IInternalDraftApplicationViewModel {
    id?: string;
    clientId?: string;
    pledgeTypeId?: string | null;
    userId?: string;
    applicationType?: AssistanceApplicationType;
    formData?: InternalDraftFormData | null;
    enteredDate?: Date;
    modifiedDate?: Date | null;
    createdByName?: string | null;
    createdByEmail?: string | null;
    agencyName?: string | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    files?: DraftApplicationFile[] | null;
    warnings?: string[] | null;
}

export class InternalDraftFormData implements IInternalDraftFormData {
    summary?: string | null;
    description?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    totalNeed?: number | null;
    fundPledgeTypeId?: string | null;
    assignedAgencyId?: string | null;
    status?: string | null;
    familyEducatedAboutResources?: boolean | null;
    companies?: DraftCompany[] | null;
    adults?: DraftAdult[] | null;
    minors?: DraftMinor[] | null;
    areasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    stormApplication?: StormApplicationViewModel | null;

    constructor(data?: IInternalDraftFormData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.fundPledgeTypeId = _data["fundPledgeTypeId"] !== undefined ? _data["fundPledgeTypeId"] : null as any;
            this.assignedAgencyId = _data["assignedAgencyId"] !== undefined ? _data["assignedAgencyId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.familyEducatedAboutResources = _data["familyEducatedAboutResources"] !== undefined ? _data["familyEducatedAboutResources"] : null as any;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(DraftCompany.fromJS(item));
            }
            else {
                this.companies = null as any;
            }
            if (Array.isArray(_data["adults"])) {
                this.adults = [] as any;
                for (let item of _data["adults"])
                    this.adults!.push(DraftAdult.fromJS(item));
            }
            else {
                this.adults = null as any;
            }
            if (Array.isArray(_data["minors"])) {
                this.minors = [] as any;
                for (let item of _data["minors"])
                    this.minors!.push(DraftMinor.fromJS(item));
            }
            else {
                this.minors = null as any;
            }
            this.areasOfNeed = _data["areasOfNeed"] ? AssistanceApplicationAreasOfNeed.fromJS(_data["areasOfNeed"]) : null as any;
            this.stormApplication = _data["stormApplication"] ? StormApplicationViewModel.fromJS(_data["stormApplication"]) : null as any;
        }
    }

    static fromJS(data: any): InternalDraftFormData {
        data = typeof data === 'object' ? data : {};
        let result = new InternalDraftFormData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["fundPledgeTypeId"] = this.fundPledgeTypeId !== undefined ? this.fundPledgeTypeId : null as any;
        data["assignedAgencyId"] = this.assignedAgencyId !== undefined ? this.assignedAgencyId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["familyEducatedAboutResources"] = this.familyEducatedAboutResources !== undefined ? this.familyEducatedAboutResources : null as any;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.adults)) {
            data["adults"] = [];
            for (let item of this.adults)
                data["adults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.minors)) {
            data["minors"] = [];
            for (let item of this.minors)
                data["minors"].push(item ? item.toJSON() : null as any);
        }
        data["areasOfNeed"] = this.areasOfNeed ? this.areasOfNeed.toJSON() : null as any;
        data["stormApplication"] = this.stormApplication ? this.stormApplication.toJSON() : null as any;
        return data;
    }

    clone(): InternalDraftFormData {
        const json = this.toJSON();
        let result = new InternalDraftFormData();
        result.init(json);
        return result;
    }
}

export interface IInternalDraftFormData {
    summary?: string | null;
    description?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    totalNeed?: number | null;
    fundPledgeTypeId?: string | null;
    assignedAgencyId?: string | null;
    status?: string | null;
    familyEducatedAboutResources?: boolean | null;
    companies?: DraftCompany[] | null;
    adults?: DraftAdult[] | null;
    minors?: DraftMinor[] | null;
    areasOfNeed?: AssistanceApplicationAreasOfNeed | null;
    stormApplication?: StormApplicationViewModel | null;
}

export class DraftCompany implements IDraftCompany {
    id?: string | null;
    paymentTo?: string | null;
    payeeAddress?: string | null;
    accountNumber?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    payeeAddress2?: string | null;
    companyName?: string | null;
    isLegacyPayee?: boolean | null;
    payeeType?: CompanyPayeeType | null;
    isUwdaCompany?: boolean | null;
    regionValue?: string[] | null;
    companyId?: string | null;
    amount?: number | null;
    category?: CompanyCategoryType | null;
    pledgeId?: string | null;

    constructor(data?: IDraftCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paymentTo = _data["paymentTo"] !== undefined ? _data["paymentTo"] : null as any;
            this.payeeAddress = _data["payeeAddress"] !== undefined ? _data["payeeAddress"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.payeeCity = _data["payeeCity"] !== undefined ? _data["payeeCity"] : null as any;
            this.payeeState = _data["payeeState"] !== undefined ? _data["payeeState"] : null as any;
            this.payeeZip = _data["payeeZip"] !== undefined ? _data["payeeZip"] : null as any;
            this.payeeAddress2 = _data["payeeAddress2"] !== undefined ? _data["payeeAddress2"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.isLegacyPayee = _data["isLegacyPayee"] !== undefined ? _data["isLegacyPayee"] : null as any;
            this.payeeType = _data["payeeType"] !== undefined ? _data["payeeType"] : null as any;
            this.isUwdaCompany = _data["isUwdaCompany"] !== undefined ? _data["isUwdaCompany"] : null as any;
            if (Array.isArray(_data["regionValue"])) {
                this.regionValue = [] as any;
                for (let item of _data["regionValue"])
                    this.regionValue!.push(item);
            }
            else {
                this.regionValue = null as any;
            }
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
        }
    }

    static fromJS(data: any): DraftCompany {
        data = typeof data === 'object' ? data : {};
        let result = new DraftCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paymentTo"] = this.paymentTo !== undefined ? this.paymentTo : null as any;
        data["payeeAddress"] = this.payeeAddress !== undefined ? this.payeeAddress : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["payeeCity"] = this.payeeCity !== undefined ? this.payeeCity : null as any;
        data["payeeState"] = this.payeeState !== undefined ? this.payeeState : null as any;
        data["payeeZip"] = this.payeeZip !== undefined ? this.payeeZip : null as any;
        data["payeeAddress2"] = this.payeeAddress2 !== undefined ? this.payeeAddress2 : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["isLegacyPayee"] = this.isLegacyPayee !== undefined ? this.isLegacyPayee : null as any;
        data["payeeType"] = this.payeeType !== undefined ? this.payeeType : null as any;
        data["isUwdaCompany"] = this.isUwdaCompany !== undefined ? this.isUwdaCompany : null as any;
        if (Array.isArray(this.regionValue)) {
            data["regionValue"] = [];
            for (let item of this.regionValue)
                data["regionValue"].push(item);
        }
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        return data;
    }

    clone(): DraftCompany {
        const json = this.toJSON();
        let result = new DraftCompany();
        result.init(json);
        return result;
    }
}

export interface IDraftCompany {
    id?: string | null;
    paymentTo?: string | null;
    payeeAddress?: string | null;
    accountNumber?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    payeeAddress2?: string | null;
    companyName?: string | null;
    isLegacyPayee?: boolean | null;
    payeeType?: CompanyPayeeType | null;
    isUwdaCompany?: boolean | null;
    regionValue?: string[] | null;
    companyId?: string | null;
    amount?: number | null;
    category?: CompanyCategoryType | null;
    pledgeId?: string | null;
}

export class DraftAdult implements IDraftAdult {
    id?: string | null;
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    last4Ssn?: string | null;
    employmentStatus?: string | null;
    monthlyIncomeAmount?: number | null;
    birthYear?: number | null;

    constructor(data?: IDraftAdult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.monthlyIncomeAmount = _data["monthlyIncomeAmount"] !== undefined ? _data["monthlyIncomeAmount"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
        }
    }

    static fromJS(data: any): DraftAdult {
        data = typeof data === 'object' ? data : {};
        let result = new DraftAdult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["monthlyIncomeAmount"] = this.monthlyIncomeAmount !== undefined ? this.monthlyIncomeAmount : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        return data;
    }

    clone(): DraftAdult {
        const json = this.toJSON();
        let result = new DraftAdult();
        result.init(json);
        return result;
    }
}

export interface IDraftAdult {
    id?: string | null;
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    last4Ssn?: string | null;
    employmentStatus?: string | null;
    monthlyIncomeAmount?: number | null;
    birthYear?: number | null;
}

export class DraftMinor implements IDraftMinor {
    id?: string | null;
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: number | null;
    ssn?: string | null;
    last4Ssn?: string | null;

    constructor(data?: IDraftMinor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
        }
    }

    static fromJS(data: any): DraftMinor {
        data = typeof data === 'object' ? data : {};
        let result = new DraftMinor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        return data;
    }

    clone(): DraftMinor {
        const json = this.toJSON();
        let result = new DraftMinor();
        result.init(json);
        return result;
    }
}

export interface IDraftMinor {
    id?: string | null;
    assistanceApplicationId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: number | null;
    ssn?: string | null;
    last4Ssn?: string | null;
}

export class SaveInternalDraftRequest implements ISaveInternalDraftRequest {
    clientId?: string;
    pledgeTypeId?: string | null;
    applicationType?: AssistanceApplicationType;
    formData?: InternalDraftFormData | null;
    pendingAddressChangeRequests?: CompanyAddressChangeRequestViewModel[] | null;

    constructor(data?: ISaveInternalDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.formData = _data["formData"] ? InternalDraftFormData.fromJS(_data["formData"]) : null as any;
            if (Array.isArray(_data["pendingAddressChangeRequests"])) {
                this.pendingAddressChangeRequests = [] as any;
                for (let item of _data["pendingAddressChangeRequests"])
                    this.pendingAddressChangeRequests!.push(CompanyAddressChangeRequestViewModel.fromJS(item));
            }
            else {
                this.pendingAddressChangeRequests = null as any;
            }
        }
    }

    static fromJS(data: any): SaveInternalDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInternalDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["formData"] = this.formData ? this.formData.toJSON() : null as any;
        if (Array.isArray(this.pendingAddressChangeRequests)) {
            data["pendingAddressChangeRequests"] = [];
            for (let item of this.pendingAddressChangeRequests)
                data["pendingAddressChangeRequests"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): SaveInternalDraftRequest {
        const json = this.toJSON();
        let result = new SaveInternalDraftRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveInternalDraftRequest {
    clientId?: string;
    pledgeTypeId?: string | null;
    applicationType?: AssistanceApplicationType;
    formData?: InternalDraftFormData | null;
    pendingAddressChangeRequests?: CompanyAddressChangeRequestViewModel[] | null;
}

export class PagedListOfInternalDraftListPreview implements IPagedListOfInternalDraftListPreview {
    items?: InternalDraftListPreview[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfInternalDraftListPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InternalDraftListPreview.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfInternalDraftListPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfInternalDraftListPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfInternalDraftListPreview {
        const json = this.toJSON();
        let result = new PagedListOfInternalDraftListPreview();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfInternalDraftListPreview {
    items?: InternalDraftListPreview[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class InternalDraftListPreview implements IInternalDraftListPreview {
    id?: string;
    clientId?: string;
    createdByName?: string | null;
    createdByEmail?: string | null;
    createdDate?: Date;
    agencyName?: string | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    fundTypeName?: string | null;
    applicationType?: AssistanceApplicationType;

    constructor(data?: IInternalDraftListPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.createdByName = _data["createdByName"] !== undefined ? _data["createdByName"] : null as any;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.fundTypeName = _data["fundTypeName"] !== undefined ? _data["fundTypeName"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
        }
    }

    static fromJS(data: any): InternalDraftListPreview {
        data = typeof data === 'object' ? data : {};
        let result = new InternalDraftListPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["createdByName"] = this.createdByName !== undefined ? this.createdByName : null as any;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["fundTypeName"] = this.fundTypeName !== undefined ? this.fundTypeName : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        return data;
    }

    clone(): InternalDraftListPreview {
        const json = this.toJSON();
        let result = new InternalDraftListPreview();
        result.init(json);
        return result;
    }
}

export interface IInternalDraftListPreview {
    id?: string;
    clientId?: string;
    createdByName?: string | null;
    createdByEmail?: string | null;
    createdDate?: Date;
    agencyName?: string | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    fundTypeName?: string | null;
    applicationType?: AssistanceApplicationType;
}

export class DraftRevealSsnParams implements IDraftRevealSsnParams {
    draftId?: string;
    memberId?: string;
    isAdult?: boolean;
    enteredPassword?: string | null;

    constructor(data?: IDraftRevealSsnParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftId = _data["draftId"] !== undefined ? _data["draftId"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.isAdult = _data["isAdult"] !== undefined ? _data["isAdult"] : null as any;
            this.enteredPassword = _data["enteredPassword"] !== undefined ? _data["enteredPassword"] : null as any;
        }
    }

    static fromJS(data: any): DraftRevealSsnParams {
        data = typeof data === 'object' ? data : {};
        let result = new DraftRevealSsnParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftId"] = this.draftId !== undefined ? this.draftId : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["isAdult"] = this.isAdult !== undefined ? this.isAdult : null as any;
        data["enteredPassword"] = this.enteredPassword !== undefined ? this.enteredPassword : null as any;
        return data;
    }

    clone(): DraftRevealSsnParams {
        const json = this.toJSON();
        let result = new DraftRevealSsnParams();
        result.init(json);
        return result;
    }
}

export interface IDraftRevealSsnParams {
    draftId?: string;
    memberId?: string;
    isAdult?: boolean;
    enteredPassword?: string | null;
}

export class KcApplication extends BaseViewModel implements IKcApplication {
    keepingCurrentProgramId?: string;
    keepingCurrentStatusId?: string;
    clientId?: string;
    pledgeStatus?: PledgeStatusType;
    clientSsn?: string | null;
    clientLast4Ssn?: string | null;
    totalAmountOwed?: number;
    upfrontAmountDue?: number | null;
    upfrontAmountPaid?: number | null;
    upfrontPaySource?: KcPaySourceType | null;
    programMonthlyCredit?: number | null;
    programTotalNumMonthlyCredits?: number | null;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number | null;
    arrearsMonthlyPercent?: number | null;
    arrearsTotalNumMonthlyCredits?: number | null;
    arrearsMonthlyEstimatedCredit?: number | null;
    arrearsTotalEstimatedCredits?: number | null;
    totalMonthlyEstimatedCredit?: number | null;
    grandTotalEstimatedCredits?: number | null;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType;
    isThirdPartyAgreeable?: boolean;
    thirdPartyAgreement?: Date | null;
    downloadTimestamp?: Date | null;
    approvedTimestamp?: Date | null;
    rowIsNotActive?: boolean;
    accountNumber?: string | null;
    agencyId?: string;
    confirmation?: KcConfirmation | null;
    cancellation?: KcCancellation | null;
    clientFederalPovertyLevelDisplay?: number | null;
    agency?: Agency | null;
    client?: Client | null;
    keepingCurrentProgram?: KcProgram | null;
    keepingCurrentStatus?: KcStatus | null;

    constructor(data?: IKcApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentProgramId = _data["keepingCurrentProgramId"] !== undefined ? _data["keepingCurrentProgramId"] : null as any;
            this.keepingCurrentStatusId = _data["keepingCurrentStatusId"] !== undefined ? _data["keepingCurrentStatusId"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeStatus = _data["pledgeStatus"] !== undefined ? _data["pledgeStatus"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.totalAmountOwed = _data["totalAmountOwed"] !== undefined ? _data["totalAmountOwed"] : null as any;
            this.upfrontAmountDue = _data["upfrontAmountDue"] !== undefined ? _data["upfrontAmountDue"] : null as any;
            this.upfrontAmountPaid = _data["upfrontAmountPaid"] !== undefined ? _data["upfrontAmountPaid"] : null as any;
            this.upfrontPaySource = _data["upfrontPaySource"] !== undefined ? _data["upfrontPaySource"] : null as any;
            this.programMonthlyCredit = _data["programMonthlyCredit"] !== undefined ? _data["programMonthlyCredit"] : null as any;
            this.programTotalNumMonthlyCredits = _data["programTotalNumMonthlyCredits"] !== undefined ? _data["programTotalNumMonthlyCredits"] : null as any;
            this.programTotalEstimatedCredits = _data["programTotalEstimatedCredits"] !== undefined ? _data["programTotalEstimatedCredits"] : null as any;
            this.arrearsUpfrontPercent = _data["arrearsUpfrontPercent"] !== undefined ? _data["arrearsUpfrontPercent"] : null as any;
            this.arrearsMonthlyPercent = _data["arrearsMonthlyPercent"] !== undefined ? _data["arrearsMonthlyPercent"] : null as any;
            this.arrearsTotalNumMonthlyCredits = _data["arrearsTotalNumMonthlyCredits"] !== undefined ? _data["arrearsTotalNumMonthlyCredits"] : null as any;
            this.arrearsMonthlyEstimatedCredit = _data["arrearsMonthlyEstimatedCredit"] !== undefined ? _data["arrearsMonthlyEstimatedCredit"] : null as any;
            this.arrearsTotalEstimatedCredits = _data["arrearsTotalEstimatedCredits"] !== undefined ? _data["arrearsTotalEstimatedCredits"] : null as any;
            this.totalMonthlyEstimatedCredit = _data["totalMonthlyEstimatedCredit"] !== undefined ? _data["totalMonthlyEstimatedCredit"] : null as any;
            this.grandTotalEstimatedCredits = _data["grandTotalEstimatedCredits"] !== undefined ? _data["grandTotalEstimatedCredits"] : null as any;
            this.isLiheapReceived = _data["isLiheapReceived"] !== undefined ? _data["isLiheapReceived"] : null as any;
            this.isLiheapRequested = _data["isLiheapRequested"] !== undefined ? _data["isLiheapRequested"] : null as any;
            this.isWeatherizationReceived = _data["isWeatherizationReceived"] !== undefined ? _data["isWeatherizationReceived"] : null as any;
            this.isWeatherizationRequested = _data["isWeatherizationRequested"] !== undefined ? _data["isWeatherizationRequested"] : null as any;
            this.weatherizationStatus = _data["weatherizationStatus"] !== undefined ? _data["weatherizationStatus"] : null as any;
            this.isThirdPartyAgreeable = _data["isThirdPartyAgreeable"] !== undefined ? _data["isThirdPartyAgreeable"] : null as any;
            this.thirdPartyAgreement = _data["thirdPartyAgreement"] ? new Date(_data["thirdPartyAgreement"].toString()) : null as any;
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
            this.approvedTimestamp = _data["approvedTimestamp"] ? new Date(_data["approvedTimestamp"].toString()) : null as any;
            this.rowIsNotActive = _data["rowIsNotActive"] !== undefined ? _data["rowIsNotActive"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.confirmation = _data["confirmation"] ? KcConfirmation.fromJS(_data["confirmation"]) : null as any;
            this.cancellation = _data["cancellation"] ? KcCancellation.fromJS(_data["cancellation"]) : null as any;
            this.clientFederalPovertyLevelDisplay = _data["clientFederalPovertyLevelDisplay"] !== undefined ? _data["clientFederalPovertyLevelDisplay"] : null as any;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : null as any;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : null as any;
            this.keepingCurrentProgram = _data["keepingCurrentProgram"] ? KcProgram.fromJS(_data["keepingCurrentProgram"]) : null as any;
            this.keepingCurrentStatus = _data["keepingCurrentStatus"] ? KcStatus.fromJS(_data["keepingCurrentStatus"]) : null as any;
        }
    }

    static override fromJS(data: any): KcApplication {
        data = typeof data === 'object' ? data : {};
        let result = new KcApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentProgramId"] = this.keepingCurrentProgramId !== undefined ? this.keepingCurrentProgramId : null as any;
        data["keepingCurrentStatusId"] = this.keepingCurrentStatusId !== undefined ? this.keepingCurrentStatusId : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeStatus"] = this.pledgeStatus !== undefined ? this.pledgeStatus : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["totalAmountOwed"] = this.totalAmountOwed !== undefined ? this.totalAmountOwed : null as any;
        data["upfrontAmountDue"] = this.upfrontAmountDue !== undefined ? this.upfrontAmountDue : null as any;
        data["upfrontAmountPaid"] = this.upfrontAmountPaid !== undefined ? this.upfrontAmountPaid : null as any;
        data["upfrontPaySource"] = this.upfrontPaySource !== undefined ? this.upfrontPaySource : null as any;
        data["programMonthlyCredit"] = this.programMonthlyCredit !== undefined ? this.programMonthlyCredit : null as any;
        data["programTotalNumMonthlyCredits"] = this.programTotalNumMonthlyCredits !== undefined ? this.programTotalNumMonthlyCredits : null as any;
        data["programTotalEstimatedCredits"] = this.programTotalEstimatedCredits !== undefined ? this.programTotalEstimatedCredits : null as any;
        data["arrearsUpfrontPercent"] = this.arrearsUpfrontPercent !== undefined ? this.arrearsUpfrontPercent : null as any;
        data["arrearsMonthlyPercent"] = this.arrearsMonthlyPercent !== undefined ? this.arrearsMonthlyPercent : null as any;
        data["arrearsTotalNumMonthlyCredits"] = this.arrearsTotalNumMonthlyCredits !== undefined ? this.arrearsTotalNumMonthlyCredits : null as any;
        data["arrearsMonthlyEstimatedCredit"] = this.arrearsMonthlyEstimatedCredit !== undefined ? this.arrearsMonthlyEstimatedCredit : null as any;
        data["arrearsTotalEstimatedCredits"] = this.arrearsTotalEstimatedCredits !== undefined ? this.arrearsTotalEstimatedCredits : null as any;
        data["totalMonthlyEstimatedCredit"] = this.totalMonthlyEstimatedCredit !== undefined ? this.totalMonthlyEstimatedCredit : null as any;
        data["grandTotalEstimatedCredits"] = this.grandTotalEstimatedCredits !== undefined ? this.grandTotalEstimatedCredits : null as any;
        data["isLiheapReceived"] = this.isLiheapReceived !== undefined ? this.isLiheapReceived : null as any;
        data["isLiheapRequested"] = this.isLiheapRequested !== undefined ? this.isLiheapRequested : null as any;
        data["isWeatherizationReceived"] = this.isWeatherizationReceived !== undefined ? this.isWeatherizationReceived : null as any;
        data["isWeatherizationRequested"] = this.isWeatherizationRequested !== undefined ? this.isWeatherizationRequested : null as any;
        data["weatherizationStatus"] = this.weatherizationStatus !== undefined ? this.weatherizationStatus : null as any;
        data["isThirdPartyAgreeable"] = this.isThirdPartyAgreeable !== undefined ? this.isThirdPartyAgreeable : null as any;
        data["thirdPartyAgreement"] = this.thirdPartyAgreement ? this.thirdPartyAgreement.toISOString() : null as any;
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        data["approvedTimestamp"] = this.approvedTimestamp ? this.approvedTimestamp.toISOString() : null as any;
        data["rowIsNotActive"] = this.rowIsNotActive !== undefined ? this.rowIsNotActive : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["confirmation"] = this.confirmation ? this.confirmation.toJSON() : null as any;
        data["cancellation"] = this.cancellation ? this.cancellation.toJSON() : null as any;
        data["clientFederalPovertyLevelDisplay"] = this.clientFederalPovertyLevelDisplay !== undefined ? this.clientFederalPovertyLevelDisplay : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["keepingCurrentProgram"] = this.keepingCurrentProgram ? this.keepingCurrentProgram.toJSON() : null as any;
        data["keepingCurrentStatus"] = this.keepingCurrentStatus ? this.keepingCurrentStatus.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcApplication {
        const json = this.toJSON();
        let result = new KcApplication();
        result.init(json);
        return result;
    }
}

export interface IKcApplication extends IBaseViewModel {
    keepingCurrentProgramId?: string;
    keepingCurrentStatusId?: string;
    clientId?: string;
    pledgeStatus?: PledgeStatusType;
    clientSsn?: string | null;
    clientLast4Ssn?: string | null;
    totalAmountOwed?: number;
    upfrontAmountDue?: number | null;
    upfrontAmountPaid?: number | null;
    upfrontPaySource?: KcPaySourceType | null;
    programMonthlyCredit?: number | null;
    programTotalNumMonthlyCredits?: number | null;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number | null;
    arrearsMonthlyPercent?: number | null;
    arrearsTotalNumMonthlyCredits?: number | null;
    arrearsMonthlyEstimatedCredit?: number | null;
    arrearsTotalEstimatedCredits?: number | null;
    totalMonthlyEstimatedCredit?: number | null;
    grandTotalEstimatedCredits?: number | null;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType;
    isThirdPartyAgreeable?: boolean;
    thirdPartyAgreement?: Date | null;
    downloadTimestamp?: Date | null;
    approvedTimestamp?: Date | null;
    rowIsNotActive?: boolean;
    accountNumber?: string | null;
    agencyId?: string;
    confirmation?: KcConfirmation | null;
    cancellation?: KcCancellation | null;
    clientFederalPovertyLevelDisplay?: number | null;
    agency?: Agency | null;
    client?: Client | null;
    keepingCurrentProgram?: KcProgram | null;
    keepingCurrentStatus?: KcStatus | null;
}

export enum KcPaySourceType {
    EnergyAssistance = "EnergyAssistance",
    CustomerPayment = "CustomerPayment",
}

export enum WeatherizationStatusesType {
    NotSet = "NotSet",
    WeatherizationPending = "WeatherizationPending",
    WeatherizationComplete = "WeatherizationComplete",
    PremisesNotEligible = "PremisesNotEligible",
    ApplicationRejected = "ApplicationRejected",
}

export class KcConfirmation extends BaseViewModel implements IKcConfirmation {
    keepingCurrentApplicationId?: string;
    ssn?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    arrearsInstallments?: number | null;
    confirmedDate?: Date | null;
    initialBillDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    rejectionReason?: string | null;

    constructor(data?: IKcConfirmation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalAmountDue = _data["totalAmountDue"] !== undefined ? _data["totalAmountDue"] : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.arrearsInstallments = _data["arrearsInstallments"] !== undefined ? _data["arrearsInstallments"] : null as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : null as any;
            this.initialBillDate = _data["initialBillDate"] ? new Date(_data["initialBillDate"].toString()) : null as any;
            this.arrearsCreditExpiration = _data["arrearsCreditExpiration"] ? new Date(_data["arrearsCreditExpiration"].toString()) : null as any;
            this.programCreditExpiration = _data["programCreditExpiration"] ? new Date(_data["programCreditExpiration"].toString()) : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.enrollmentRejected = _data["enrollmentRejected"] !== undefined ? _data["enrollmentRejected"] : null as any;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : null as any;
        }
    }

    static override fromJS(data: any): KcConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new KcConfirmation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalAmountDue"] = this.totalAmountDue !== undefined ? this.totalAmountDue : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["arrearsInstallments"] = this.arrearsInstallments !== undefined ? this.arrearsInstallments : null as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : null as any;
        data["initialBillDate"] = this.initialBillDate ? this.initialBillDate.toISOString() : null as any;
        data["arrearsCreditExpiration"] = this.arrearsCreditExpiration ? this.arrearsCreditExpiration.toISOString() : null as any;
        data["programCreditExpiration"] = this.programCreditExpiration ? this.programCreditExpiration.toISOString() : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["enrollmentRejected"] = this.enrollmentRejected !== undefined ? this.enrollmentRejected : null as any;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcConfirmation {
        const json = this.toJSON();
        let result = new KcConfirmation();
        result.init(json);
        return result;
    }
}

export interface IKcConfirmation extends IBaseViewModel {
    keepingCurrentApplicationId?: string;
    ssn?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    arrearsInstallments?: number | null;
    confirmedDate?: Date | null;
    initialBillDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    rejectionReason?: string | null;
}

export class KcCancellation extends BaseViewModel implements IKcCancellation {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    accountNumber?: string | null;
    cancellationDate?: Date | null;
    cancellationReason?: string | null;

    constructor(data?: IKcCancellation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.cancellationDate = _data["cancellationDate"] ? new Date(_data["cancellationDate"].toString()) : null as any;
            this.cancellationReason = _data["cancellationReason"] !== undefined ? _data["cancellationReason"] : null as any;
        }
    }

    static override fromJS(data: any): KcCancellation {
        data = typeof data === 'object' ? data : {};
        let result = new KcCancellation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : null as any;
        data["cancellationReason"] = this.cancellationReason !== undefined ? this.cancellationReason : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcCancellation {
        const json = this.toJSON();
        let result = new KcCancellation();
        result.init(json);
        return result;
    }
}

export interface IKcCancellation extends IBaseViewModel {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    accountNumber?: string | null;
    cancellationDate?: Date | null;
    cancellationReason?: string | null;
}

export class KcProgram extends BaseViewModel implements IKcProgram {
    programName?: string | null;
    hasArrearsCredits?: boolean;
    displaySortOrder?: number;
    status?: boolean;
    minLevel?: number;
    maxLevel?: number;
    pledgeTypeId?: string;

    constructor(data?: IKcProgram) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programName = _data["programName"] !== undefined ? _data["programName"] : null as any;
            this.hasArrearsCredits = _data["hasArrearsCredits"] !== undefined ? _data["hasArrearsCredits"] : null as any;
            this.displaySortOrder = _data["displaySortOrder"] !== undefined ? _data["displaySortOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.minLevel = _data["minLevel"] !== undefined ? _data["minLevel"] : null as any;
            this.maxLevel = _data["maxLevel"] !== undefined ? _data["maxLevel"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
        }
    }

    static override fromJS(data: any): KcProgram {
        data = typeof data === 'object' ? data : {};
        let result = new KcProgram();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programName"] = this.programName !== undefined ? this.programName : null as any;
        data["hasArrearsCredits"] = this.hasArrearsCredits !== undefined ? this.hasArrearsCredits : null as any;
        data["displaySortOrder"] = this.displaySortOrder !== undefined ? this.displaySortOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["minLevel"] = this.minLevel !== undefined ? this.minLevel : null as any;
        data["maxLevel"] = this.maxLevel !== undefined ? this.maxLevel : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcProgram {
        const json = this.toJSON();
        let result = new KcProgram();
        result.init(json);
        return result;
    }
}

export interface IKcProgram extends IBaseViewModel {
    programName?: string | null;
    hasArrearsCredits?: boolean;
    displaySortOrder?: number;
    status?: boolean;
    minLevel?: number;
    maxLevel?: number;
    pledgeTypeId?: string;
}

export class KcStatus extends BaseViewModel implements IKcStatus {
    statusName?: string | null;
    isSystemSet?: boolean;
    displaySortOrder?: number;
    isNewStatus?: boolean;
    isPendingApprovalStatus?: boolean;
    isApprovedStatus?: boolean;
    isRejectedStatus?: boolean;
    isPayMissedStatus?: boolean;
    isDefaultedStatus?: boolean;
    isCancelledStatus?: boolean;
    isExpiredStatus?: boolean;
    isDeletedStatus?: boolean;

    constructor(data?: IKcStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.isSystemSet = _data["isSystemSet"] !== undefined ? _data["isSystemSet"] : null as any;
            this.displaySortOrder = _data["displaySortOrder"] !== undefined ? _data["displaySortOrder"] : null as any;
            this.isNewStatus = _data["isNewStatus"] !== undefined ? _data["isNewStatus"] : null as any;
            this.isPendingApprovalStatus = _data["isPendingApprovalStatus"] !== undefined ? _data["isPendingApprovalStatus"] : null as any;
            this.isApprovedStatus = _data["isApprovedStatus"] !== undefined ? _data["isApprovedStatus"] : null as any;
            this.isRejectedStatus = _data["isRejectedStatus"] !== undefined ? _data["isRejectedStatus"] : null as any;
            this.isPayMissedStatus = _data["isPayMissedStatus"] !== undefined ? _data["isPayMissedStatus"] : null as any;
            this.isDefaultedStatus = _data["isDefaultedStatus"] !== undefined ? _data["isDefaultedStatus"] : null as any;
            this.isCancelledStatus = _data["isCancelledStatus"] !== undefined ? _data["isCancelledStatus"] : null as any;
            this.isExpiredStatus = _data["isExpiredStatus"] !== undefined ? _data["isExpiredStatus"] : null as any;
            this.isDeletedStatus = _data["isDeletedStatus"] !== undefined ? _data["isDeletedStatus"] : null as any;
        }
    }

    static override fromJS(data: any): KcStatus {
        data = typeof data === 'object' ? data : {};
        let result = new KcStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["isSystemSet"] = this.isSystemSet !== undefined ? this.isSystemSet : null as any;
        data["displaySortOrder"] = this.displaySortOrder !== undefined ? this.displaySortOrder : null as any;
        data["isNewStatus"] = this.isNewStatus !== undefined ? this.isNewStatus : null as any;
        data["isPendingApprovalStatus"] = this.isPendingApprovalStatus !== undefined ? this.isPendingApprovalStatus : null as any;
        data["isApprovedStatus"] = this.isApprovedStatus !== undefined ? this.isApprovedStatus : null as any;
        data["isRejectedStatus"] = this.isRejectedStatus !== undefined ? this.isRejectedStatus : null as any;
        data["isPayMissedStatus"] = this.isPayMissedStatus !== undefined ? this.isPayMissedStatus : null as any;
        data["isDefaultedStatus"] = this.isDefaultedStatus !== undefined ? this.isDefaultedStatus : null as any;
        data["isCancelledStatus"] = this.isCancelledStatus !== undefined ? this.isCancelledStatus : null as any;
        data["isExpiredStatus"] = this.isExpiredStatus !== undefined ? this.isExpiredStatus : null as any;
        data["isDeletedStatus"] = this.isDeletedStatus !== undefined ? this.isDeletedStatus : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcStatus {
        const json = this.toJSON();
        let result = new KcStatus();
        result.init(json);
        return result;
    }
}

export interface IKcStatus extends IBaseViewModel {
    statusName?: string | null;
    isSystemSet?: boolean;
    displaySortOrder?: number;
    isNewStatus?: boolean;
    isPendingApprovalStatus?: boolean;
    isApprovedStatus?: boolean;
    isRejectedStatus?: boolean;
    isPayMissedStatus?: boolean;
    isDefaultedStatus?: boolean;
    isCancelledStatus?: boolean;
    isExpiredStatus?: boolean;
    isDeletedStatus?: boolean;
}

export class KcApplicationResult extends KcApplication implements IKcApplicationResult {
    keepingCurrentConfirmationId?: string | null;
    keepingCurrentCancellationId?: string | null;
    programName?: string | null;
    statusName?: string | null;
    pledgeId?: string;
    pledgeAmount?: number;
    agencyName?: string | null;
    amerenCssCode?: number;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    isDisabled?: boolean;
    hasChildrenUnderFive?: boolean;
    isSeniorDisabledOrChild?: boolean;
    isEstimatedMonthlyCredit?: boolean;
    arrearsMonthlyCredit?: number;
    totalMonthlyCredit?: number;
    programTotalMonthlyCredits?: number;
    programEstimatedCredits?: number;
    arrearsTotalNumMontlyCredits?: number;
    totalAmountDue?: number;
    confirmedDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number;
    customerMonthlyPayment?: number;
    arrearsAmountRemaining?: number;
    confirmationCreatedDate?: Date | null;
    totalProgramCreditsPaid?: number;
    totalArrearsCreditsPaid?: number;
    totalOverallCreditsPaid?: number;
    numProgramCreditsRemaining?: number;
    numArrearsCreditsRemaining?: number;

    constructor(data?: IKcApplicationResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentConfirmationId = _data["keepingCurrentConfirmationId"] !== undefined ? _data["keepingCurrentConfirmationId"] : null as any;
            this.keepingCurrentCancellationId = _data["keepingCurrentCancellationId"] !== undefined ? _data["keepingCurrentCancellationId"] : null as any;
            this.programName = _data["programName"] !== undefined ? _data["programName"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.pledgeAmount = _data["pledgeAmount"] !== undefined ? _data["pledgeAmount"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.amerenCssCode = _data["amerenCssCode"] !== undefined ? _data["amerenCssCode"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.hasChildrenUnderFive = _data["hasChildrenUnderFive"] !== undefined ? _data["hasChildrenUnderFive"] : null as any;
            this.isSeniorDisabledOrChild = _data["isSeniorDisabledOrChild"] !== undefined ? _data["isSeniorDisabledOrChild"] : null as any;
            this.isEstimatedMonthlyCredit = _data["isEstimatedMonthlyCredit"] !== undefined ? _data["isEstimatedMonthlyCredit"] : null as any;
            this.arrearsMonthlyCredit = _data["arrearsMonthlyCredit"] !== undefined ? _data["arrearsMonthlyCredit"] : null as any;
            this.totalMonthlyCredit = _data["totalMonthlyCredit"] !== undefined ? _data["totalMonthlyCredit"] : null as any;
            this.programTotalMonthlyCredits = _data["programTotalMonthlyCredits"] !== undefined ? _data["programTotalMonthlyCredits"] : null as any;
            this.programEstimatedCredits = _data["programEstimatedCredits"] !== undefined ? _data["programEstimatedCredits"] : null as any;
            this.arrearsTotalNumMontlyCredits = _data["arrearsTotalNumMontlyCredits"] !== undefined ? _data["arrearsTotalNumMontlyCredits"] : null as any;
            this.totalAmountDue = _data["totalAmountDue"] !== undefined ? _data["totalAmountDue"] : null as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : null as any;
            this.arrearsCreditExpiration = _data["arrearsCreditExpiration"] ? new Date(_data["arrearsCreditExpiration"].toString()) : null as any;
            this.programCreditExpiration = _data["programCreditExpiration"] ? new Date(_data["programCreditExpiration"].toString()) : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.arrearsAmountRemaining = _data["arrearsAmountRemaining"] !== undefined ? _data["arrearsAmountRemaining"] : null as any;
            this.confirmationCreatedDate = _data["confirmationCreatedDate"] ? new Date(_data["confirmationCreatedDate"].toString()) : null as any;
            this.totalProgramCreditsPaid = _data["totalProgramCreditsPaid"] !== undefined ? _data["totalProgramCreditsPaid"] : null as any;
            this.totalArrearsCreditsPaid = _data["totalArrearsCreditsPaid"] !== undefined ? _data["totalArrearsCreditsPaid"] : null as any;
            this.totalOverallCreditsPaid = _data["totalOverallCreditsPaid"] !== undefined ? _data["totalOverallCreditsPaid"] : null as any;
            this.numProgramCreditsRemaining = _data["numProgramCreditsRemaining"] !== undefined ? _data["numProgramCreditsRemaining"] : null as any;
            this.numArrearsCreditsRemaining = _data["numArrearsCreditsRemaining"] !== undefined ? _data["numArrearsCreditsRemaining"] : null as any;
        }
    }

    static override fromJS(data: any): KcApplicationResult {
        data = typeof data === 'object' ? data : {};
        let result = new KcApplicationResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentConfirmationId"] = this.keepingCurrentConfirmationId !== undefined ? this.keepingCurrentConfirmationId : null as any;
        data["keepingCurrentCancellationId"] = this.keepingCurrentCancellationId !== undefined ? this.keepingCurrentCancellationId : null as any;
        data["programName"] = this.programName !== undefined ? this.programName : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["pledgeAmount"] = this.pledgeAmount !== undefined ? this.pledgeAmount : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["amerenCssCode"] = this.amerenCssCode !== undefined ? this.amerenCssCode : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["hasChildrenUnderFive"] = this.hasChildrenUnderFive !== undefined ? this.hasChildrenUnderFive : null as any;
        data["isSeniorDisabledOrChild"] = this.isSeniorDisabledOrChild !== undefined ? this.isSeniorDisabledOrChild : null as any;
        data["isEstimatedMonthlyCredit"] = this.isEstimatedMonthlyCredit !== undefined ? this.isEstimatedMonthlyCredit : null as any;
        data["arrearsMonthlyCredit"] = this.arrearsMonthlyCredit !== undefined ? this.arrearsMonthlyCredit : null as any;
        data["totalMonthlyCredit"] = this.totalMonthlyCredit !== undefined ? this.totalMonthlyCredit : null as any;
        data["programTotalMonthlyCredits"] = this.programTotalMonthlyCredits !== undefined ? this.programTotalMonthlyCredits : null as any;
        data["programEstimatedCredits"] = this.programEstimatedCredits !== undefined ? this.programEstimatedCredits : null as any;
        data["arrearsTotalNumMontlyCredits"] = this.arrearsTotalNumMontlyCredits !== undefined ? this.arrearsTotalNumMontlyCredits : null as any;
        data["totalAmountDue"] = this.totalAmountDue !== undefined ? this.totalAmountDue : null as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : null as any;
        data["arrearsCreditExpiration"] = this.arrearsCreditExpiration ? this.arrearsCreditExpiration.toISOString() : null as any;
        data["programCreditExpiration"] = this.programCreditExpiration ? this.programCreditExpiration.toISOString() : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["arrearsAmountRemaining"] = this.arrearsAmountRemaining !== undefined ? this.arrearsAmountRemaining : null as any;
        data["confirmationCreatedDate"] = this.confirmationCreatedDate ? this.confirmationCreatedDate.toISOString() : null as any;
        data["totalProgramCreditsPaid"] = this.totalProgramCreditsPaid !== undefined ? this.totalProgramCreditsPaid : null as any;
        data["totalArrearsCreditsPaid"] = this.totalArrearsCreditsPaid !== undefined ? this.totalArrearsCreditsPaid : null as any;
        data["totalOverallCreditsPaid"] = this.totalOverallCreditsPaid !== undefined ? this.totalOverallCreditsPaid : null as any;
        data["numProgramCreditsRemaining"] = this.numProgramCreditsRemaining !== undefined ? this.numProgramCreditsRemaining : null as any;
        data["numArrearsCreditsRemaining"] = this.numArrearsCreditsRemaining !== undefined ? this.numArrearsCreditsRemaining : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcApplicationResult {
        const json = this.toJSON();
        let result = new KcApplicationResult();
        result.init(json);
        return result;
    }
}

export interface IKcApplicationResult extends IKcApplication {
    keepingCurrentConfirmationId?: string | null;
    keepingCurrentCancellationId?: string | null;
    programName?: string | null;
    statusName?: string | null;
    pledgeId?: string;
    pledgeAmount?: number;
    agencyName?: string | null;
    amerenCssCode?: number;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    isDisabled?: boolean;
    hasChildrenUnderFive?: boolean;
    isSeniorDisabledOrChild?: boolean;
    isEstimatedMonthlyCredit?: boolean;
    arrearsMonthlyCredit?: number;
    totalMonthlyCredit?: number;
    programTotalMonthlyCredits?: number;
    programEstimatedCredits?: number;
    arrearsTotalNumMontlyCredits?: number;
    totalAmountDue?: number;
    confirmedDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number;
    customerMonthlyPayment?: number;
    arrearsAmountRemaining?: number;
    confirmationCreatedDate?: Date | null;
    totalProgramCreditsPaid?: number;
    totalArrearsCreditsPaid?: number;
    totalOverallCreditsPaid?: number;
    numProgramCreditsRemaining?: number;
    numArrearsCreditsRemaining?: number;
}

export class PagedListOfKcApplication implements IPagedListOfKcApplication {
    items?: KcApplication[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfKcApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KcApplication.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfKcApplication {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfKcApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfKcApplication {
        const json = this.toJSON();
        let result = new PagedListOfKcApplication();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfKcApplication {
    items?: KcApplication[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class KcNoteResult implements IKcNoteResult {
    noteId?: string | null;
    kcAppId?: string;
    noteSource?: string | null;
    noteDate?: Date | null;
    noteType?: string | null;
    details?: string | null;
    user?: string | null;

    constructor(data?: IKcNoteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteId = _data["noteId"] !== undefined ? _data["noteId"] : null as any;
            this.kcAppId = _data["kcAppId"] !== undefined ? _data["kcAppId"] : null as any;
            this.noteSource = _data["noteSource"] !== undefined ? _data["noteSource"] : null as any;
            this.noteDate = _data["noteDate"] ? new Date(_data["noteDate"].toString()) : null as any;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : null as any;
            this.details = _data["details"] !== undefined ? _data["details"] : null as any;
            this.user = _data["user"] !== undefined ? _data["user"] : null as any;
        }
    }

    static fromJS(data: any): KcNoteResult {
        data = typeof data === 'object' ? data : {};
        let result = new KcNoteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteId"] = this.noteId !== undefined ? this.noteId : null as any;
        data["kcAppId"] = this.kcAppId !== undefined ? this.kcAppId : null as any;
        data["noteSource"] = this.noteSource !== undefined ? this.noteSource : null as any;
        data["noteDate"] = this.noteDate ? this.noteDate.toISOString() : null as any;
        data["noteType"] = this.noteType !== undefined ? this.noteType : null as any;
        data["details"] = this.details !== undefined ? this.details : null as any;
        data["user"] = this.user !== undefined ? this.user : null as any;
        return data;
    }

    clone(): KcNoteResult {
        const json = this.toJSON();
        let result = new KcNoteResult();
        result.init(json);
        return result;
    }
}

export interface IKcNoteResult {
    noteId?: string | null;
    kcAppId?: string;
    noteSource?: string | null;
    noteDate?: Date | null;
    noteType?: string | null;
    details?: string | null;
    user?: string | null;
}

export class KcNote extends BaseViewModel implements IKcNote {
    keepingCurrentApplicationId?: string;
    notes?: string | null;
    status?: StatusType;

    constructor(data?: IKcNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static override fromJS(data: any): KcNote {
        data = typeof data === 'object' ? data : {};
        let result = new KcNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcNote {
        const json = this.toJSON();
        let result = new KcNote();
        result.init(json);
        return result;
    }
}

export interface IKcNote extends IBaseViewModel {
    keepingCurrentApplicationId?: string;
    notes?: string | null;
    status?: StatusType;
}

export class KcProgramLevel extends BaseViewModel implements IKcProgramLevel {
    keepingCurrentProgramId?: string;
    federalPovertyLevelId?: string;
    isValidProgramLevel?: boolean;
    isRequiredSeniorDisabledOrChild?: boolean;
    programMonthlyCredit?: number;
    programTotalNumMonthlyCredits?: number;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number;
    arrearsMonthlyPercent?: number;
    arrearsTotalNumMonthlyCredits?: number;
    rowIsNotActive?: boolean;
    federalPovertyLevel?: FederalPovertyLevel | null;

    constructor(data?: IKcProgramLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentProgramId = _data["keepingCurrentProgramId"] !== undefined ? _data["keepingCurrentProgramId"] : null as any;
            this.federalPovertyLevelId = _data["federalPovertyLevelId"] !== undefined ? _data["federalPovertyLevelId"] : null as any;
            this.isValidProgramLevel = _data["isValidProgramLevel"] !== undefined ? _data["isValidProgramLevel"] : null as any;
            this.isRequiredSeniorDisabledOrChild = _data["isRequiredSeniorDisabledOrChild"] !== undefined ? _data["isRequiredSeniorDisabledOrChild"] : null as any;
            this.programMonthlyCredit = _data["programMonthlyCredit"] !== undefined ? _data["programMonthlyCredit"] : null as any;
            this.programTotalNumMonthlyCredits = _data["programTotalNumMonthlyCredits"] !== undefined ? _data["programTotalNumMonthlyCredits"] : null as any;
            this.programTotalEstimatedCredits = _data["programTotalEstimatedCredits"] !== undefined ? _data["programTotalEstimatedCredits"] : null as any;
            this.arrearsUpfrontPercent = _data["arrearsUpfrontPercent"] !== undefined ? _data["arrearsUpfrontPercent"] : null as any;
            this.arrearsMonthlyPercent = _data["arrearsMonthlyPercent"] !== undefined ? _data["arrearsMonthlyPercent"] : null as any;
            this.arrearsTotalNumMonthlyCredits = _data["arrearsTotalNumMonthlyCredits"] !== undefined ? _data["arrearsTotalNumMonthlyCredits"] : null as any;
            this.rowIsNotActive = _data["rowIsNotActive"] !== undefined ? _data["rowIsNotActive"] : null as any;
            this.federalPovertyLevel = _data["federalPovertyLevel"] ? FederalPovertyLevel.fromJS(_data["federalPovertyLevel"]) : null as any;
        }
    }

    static override fromJS(data: any): KcProgramLevel {
        data = typeof data === 'object' ? data : {};
        let result = new KcProgramLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentProgramId"] = this.keepingCurrentProgramId !== undefined ? this.keepingCurrentProgramId : null as any;
        data["federalPovertyLevelId"] = this.federalPovertyLevelId !== undefined ? this.federalPovertyLevelId : null as any;
        data["isValidProgramLevel"] = this.isValidProgramLevel !== undefined ? this.isValidProgramLevel : null as any;
        data["isRequiredSeniorDisabledOrChild"] = this.isRequiredSeniorDisabledOrChild !== undefined ? this.isRequiredSeniorDisabledOrChild : null as any;
        data["programMonthlyCredit"] = this.programMonthlyCredit !== undefined ? this.programMonthlyCredit : null as any;
        data["programTotalNumMonthlyCredits"] = this.programTotalNumMonthlyCredits !== undefined ? this.programTotalNumMonthlyCredits : null as any;
        data["programTotalEstimatedCredits"] = this.programTotalEstimatedCredits !== undefined ? this.programTotalEstimatedCredits : null as any;
        data["arrearsUpfrontPercent"] = this.arrearsUpfrontPercent !== undefined ? this.arrearsUpfrontPercent : null as any;
        data["arrearsMonthlyPercent"] = this.arrearsMonthlyPercent !== undefined ? this.arrearsMonthlyPercent : null as any;
        data["arrearsTotalNumMonthlyCredits"] = this.arrearsTotalNumMonthlyCredits !== undefined ? this.arrearsTotalNumMonthlyCredits : null as any;
        data["rowIsNotActive"] = this.rowIsNotActive !== undefined ? this.rowIsNotActive : null as any;
        data["federalPovertyLevel"] = this.federalPovertyLevel ? this.federalPovertyLevel.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KcProgramLevel {
        const json = this.toJSON();
        let result = new KcProgramLevel();
        result.init(json);
        return result;
    }
}

export interface IKcProgramLevel extends IBaseViewModel {
    keepingCurrentProgramId?: string;
    federalPovertyLevelId?: string;
    isValidProgramLevel?: boolean;
    isRequiredSeniorDisabledOrChild?: boolean;
    programMonthlyCredit?: number;
    programTotalNumMonthlyCredits?: number;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number;
    arrearsMonthlyPercent?: number;
    arrearsTotalNumMonthlyCredits?: number;
    rowIsNotActive?: boolean;
    federalPovertyLevel?: FederalPovertyLevel | null;
}

export class ConfirmOrphanReport implements IConfirmOrphanReport {
    agency?: string | null;
    ssn?: string | null;
    encryptedSsn?: string | null;
    customer?: string | null;
    accountNumber?: string | null;
    initialBillDate?: Date | null;
    programExpiration?: Date | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    budgetBillAmount?: number | null;
    customerPayAmount?: number | null;
    enrollmentStatus?: string | null;
    rejectionReason?: string | null;
    confirmDate?: Date | null;
    importDate?: Date | null;

    constructor(data?: IConfirmOrphanReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.encryptedSsn = _data["encryptedSsn"] !== undefined ? _data["encryptedSsn"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.initialBillDate = _data["initialBillDate"] ? new Date(_data["initialBillDate"].toString()) : null as any;
            this.programExpiration = _data["programExpiration"] ? new Date(_data["programExpiration"].toString()) : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerPayAmount = _data["customerPayAmount"] !== undefined ? _data["customerPayAmount"] : null as any;
            this.enrollmentStatus = _data["enrollmentStatus"] !== undefined ? _data["enrollmentStatus"] : null as any;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : null as any;
            this.confirmDate = _data["confirmDate"] ? new Date(_data["confirmDate"].toString()) : null as any;
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ConfirmOrphanReport {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmOrphanReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["encryptedSsn"] = this.encryptedSsn !== undefined ? this.encryptedSsn : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["initialBillDate"] = this.initialBillDate ? this.initialBillDate.toISOString() : null as any;
        data["programExpiration"] = this.programExpiration ? this.programExpiration.toISOString() : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerPayAmount"] = this.customerPayAmount !== undefined ? this.customerPayAmount : null as any;
        data["enrollmentStatus"] = this.enrollmentStatus !== undefined ? this.enrollmentStatus : null as any;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : null as any;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : null as any;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : null as any;
        return data;
    }

    clone(): ConfirmOrphanReport {
        const json = this.toJSON();
        let result = new ConfirmOrphanReport();
        result.init(json);
        return result;
    }
}

export interface IConfirmOrphanReport {
    agency?: string | null;
    ssn?: string | null;
    encryptedSsn?: string | null;
    customer?: string | null;
    accountNumber?: string | null;
    initialBillDate?: Date | null;
    programExpiration?: Date | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    budgetBillAmount?: number | null;
    customerPayAmount?: number | null;
    enrollmentStatus?: string | null;
    rejectionReason?: string | null;
    confirmDate?: Date | null;
    importDate?: Date | null;
}

export class MissedPaymentReport implements IMissedPaymentReport {
    agencyId?: string | null;
    agency?: string | null;
    customer?: string | null;
    accountNumber?: string | null;
    delinquentDate?: Date | null;
    billingDate?: Date | null;
    amountDue?: number | null;
    amountPaid?: number | null;
    importDate?: Date | null;
    enrollmentDate?: Date | null;

    constructor(data?: IMissedPaymentReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.delinquentDate = _data["delinquentDate"] ? new Date(_data["delinquentDate"].toString()) : null as any;
            this.billingDate = _data["billingDate"] ? new Date(_data["billingDate"].toString()) : null as any;
            this.amountDue = _data["amountDue"] !== undefined ? _data["amountDue"] : null as any;
            this.amountPaid = _data["amountPaid"] !== undefined ? _data["amountPaid"] : null as any;
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : null as any;
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MissedPaymentReport {
        data = typeof data === 'object' ? data : {};
        let result = new MissedPaymentReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["delinquentDate"] = this.delinquentDate ? this.delinquentDate.toISOString() : null as any;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : null as any;
        data["amountDue"] = this.amountDue !== undefined ? this.amountDue : null as any;
        data["amountPaid"] = this.amountPaid !== undefined ? this.amountPaid : null as any;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : null as any;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : null as any;
        return data;
    }

    clone(): MissedPaymentReport {
        const json = this.toJSON();
        let result = new MissedPaymentReport();
        result.init(json);
        return result;
    }
}

export interface IMissedPaymentReport {
    agencyId?: string | null;
    agency?: string | null;
    customer?: string | null;
    accountNumber?: string | null;
    delinquentDate?: Date | null;
    billingDate?: Date | null;
    amountDue?: number | null;
    amountPaid?: number | null;
    importDate?: Date | null;
    enrollmentDate?: Date | null;
}

export class EnrollmentReport implements IEnrollmentReport {
    agency?: string | null;
    ssn?: string | null;
    encryptedSsn?: string | null;
    customer?: string | null;
    accountNumber?: string | null;
    initialBillDate?: Date | null;
    programExpiration?: Date | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    budgetBillAmount?: number | null;
    customerPayAmount?: number | null;
    enrollmentStatus?: string | null;
    rejectionReason?: string | null;
    confirmDate?: Date | null;
    importDate?: Date | null;
    firstName?: string | null;
    lastName?: string | null;
    povertyLevelDisplay?: number | null;
    elderly?: boolean;
    disabled?: boolean;
    childUnder5?: boolean;
    amerenCssCode?: string | null;
    programName?: string | null;
    statusName?: string | null;
    upfrontPaySource?: KcPaySourceType | null;
    upfromAmountPaid?: number | null;
    originalArrearsOwed?: number;
    progamMonthlyCredit?: number | null;
    arrearsMonthlyCredit?: number | null;
    totalMonthlyCredit?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    pledgedAmount?: number;
    totalOverallCreditsPaid?: number | null;
    totalProgramCreditsPaid?: number | null;
    totalArrearsCreditsPaid?: number | null;
    arrearsAmountRemaining?: number | null;
    totalProgramInstallments?: number | null;
    totalArrearsInstallments?: number | null;
    totalMonthsEnrolled?: number | null;
    programCreditsRemaining?: number | null;
    arrearsCreditsRemaining?: number | null;
    thirdPartyAgreeable?: boolean;
    liheapReceived?: boolean | null;
    liheapRequested?: boolean | null;
    weatherizationReceived?: boolean | null;
    weatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    approvedTimestamp?: Date | null;
    confirmedDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    editorDate?: Date | null;
    editorUser?: string | null;
    createdUser?: string | null;

    constructor(data?: IEnrollmentReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.encryptedSsn = _data["encryptedSsn"] !== undefined ? _data["encryptedSsn"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.initialBillDate = _data["initialBillDate"] ? new Date(_data["initialBillDate"].toString()) : null as any;
            this.programExpiration = _data["programExpiration"] ? new Date(_data["programExpiration"].toString()) : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerPayAmount = _data["customerPayAmount"] !== undefined ? _data["customerPayAmount"] : null as any;
            this.enrollmentStatus = _data["enrollmentStatus"] !== undefined ? _data["enrollmentStatus"] : null as any;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : null as any;
            this.confirmDate = _data["confirmDate"] ? new Date(_data["confirmDate"].toString()) : null as any;
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.povertyLevelDisplay = _data["povertyLevelDisplay"] !== undefined ? _data["povertyLevelDisplay"] : null as any;
            this.elderly = _data["elderly"] !== undefined ? _data["elderly"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.childUnder5 = _data["childUnder5"] !== undefined ? _data["childUnder5"] : null as any;
            this.amerenCssCode = _data["amerenCssCode"] !== undefined ? _data["amerenCssCode"] : null as any;
            this.programName = _data["programName"] !== undefined ? _data["programName"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.upfrontPaySource = _data["upfrontPaySource"] !== undefined ? _data["upfrontPaySource"] : null as any;
            this.upfromAmountPaid = _data["upfromAmountPaid"] !== undefined ? _data["upfromAmountPaid"] : null as any;
            this.originalArrearsOwed = _data["originalArrearsOwed"] !== undefined ? _data["originalArrearsOwed"] : null as any;
            this.progamMonthlyCredit = _data["progamMonthlyCredit"] !== undefined ? _data["progamMonthlyCredit"] : null as any;
            this.arrearsMonthlyCredit = _data["arrearsMonthlyCredit"] !== undefined ? _data["arrearsMonthlyCredit"] : null as any;
            this.totalMonthlyCredit = _data["totalMonthlyCredit"] !== undefined ? _data["totalMonthlyCredit"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.enrollmentRejected = _data["enrollmentRejected"] !== undefined ? _data["enrollmentRejected"] : null as any;
            this.pledgedAmount = _data["pledgedAmount"] !== undefined ? _data["pledgedAmount"] : null as any;
            this.totalOverallCreditsPaid = _data["totalOverallCreditsPaid"] !== undefined ? _data["totalOverallCreditsPaid"] : null as any;
            this.totalProgramCreditsPaid = _data["totalProgramCreditsPaid"] !== undefined ? _data["totalProgramCreditsPaid"] : null as any;
            this.totalArrearsCreditsPaid = _data["totalArrearsCreditsPaid"] !== undefined ? _data["totalArrearsCreditsPaid"] : null as any;
            this.arrearsAmountRemaining = _data["arrearsAmountRemaining"] !== undefined ? _data["arrearsAmountRemaining"] : null as any;
            this.totalProgramInstallments = _data["totalProgramInstallments"] !== undefined ? _data["totalProgramInstallments"] : null as any;
            this.totalArrearsInstallments = _data["totalArrearsInstallments"] !== undefined ? _data["totalArrearsInstallments"] : null as any;
            this.totalMonthsEnrolled = _data["totalMonthsEnrolled"] !== undefined ? _data["totalMonthsEnrolled"] : null as any;
            this.programCreditsRemaining = _data["programCreditsRemaining"] !== undefined ? _data["programCreditsRemaining"] : null as any;
            this.arrearsCreditsRemaining = _data["arrearsCreditsRemaining"] !== undefined ? _data["arrearsCreditsRemaining"] : null as any;
            this.thirdPartyAgreeable = _data["thirdPartyAgreeable"] !== undefined ? _data["thirdPartyAgreeable"] : null as any;
            this.liheapReceived = _data["liheapReceived"] !== undefined ? _data["liheapReceived"] : null as any;
            this.liheapRequested = _data["liheapRequested"] !== undefined ? _data["liheapRequested"] : null as any;
            this.weatherizationReceived = _data["weatherizationReceived"] !== undefined ? _data["weatherizationReceived"] : null as any;
            this.weatherizationRequested = _data["weatherizationRequested"] !== undefined ? _data["weatherizationRequested"] : null as any;
            this.weatherizationStatus = _data["weatherizationStatus"] !== undefined ? _data["weatherizationStatus"] : null as any;
            this.approvedTimestamp = _data["approvedTimestamp"] ? new Date(_data["approvedTimestamp"].toString()) : null as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : null as any;
            this.arrearsCreditExpiration = _data["arrearsCreditExpiration"] ? new Date(_data["arrearsCreditExpiration"].toString()) : null as any;
            this.programCreditExpiration = _data["programCreditExpiration"] ? new Date(_data["programCreditExpiration"].toString()) : null as any;
            this.editorDate = _data["editorDate"] ? new Date(_data["editorDate"].toString()) : null as any;
            this.editorUser = _data["editorUser"] !== undefined ? _data["editorUser"] : null as any;
            this.createdUser = _data["createdUser"] !== undefined ? _data["createdUser"] : null as any;
        }
    }

    static fromJS(data: any): EnrollmentReport {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["encryptedSsn"] = this.encryptedSsn !== undefined ? this.encryptedSsn : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["initialBillDate"] = this.initialBillDate ? this.initialBillDate.toISOString() : null as any;
        data["programExpiration"] = this.programExpiration ? this.programExpiration.toISOString() : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerPayAmount"] = this.customerPayAmount !== undefined ? this.customerPayAmount : null as any;
        data["enrollmentStatus"] = this.enrollmentStatus !== undefined ? this.enrollmentStatus : null as any;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : null as any;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : null as any;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["povertyLevelDisplay"] = this.povertyLevelDisplay !== undefined ? this.povertyLevelDisplay : null as any;
        data["elderly"] = this.elderly !== undefined ? this.elderly : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["childUnder5"] = this.childUnder5 !== undefined ? this.childUnder5 : null as any;
        data["amerenCssCode"] = this.amerenCssCode !== undefined ? this.amerenCssCode : null as any;
        data["programName"] = this.programName !== undefined ? this.programName : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["upfrontPaySource"] = this.upfrontPaySource !== undefined ? this.upfrontPaySource : null as any;
        data["upfromAmountPaid"] = this.upfromAmountPaid !== undefined ? this.upfromAmountPaid : null as any;
        data["originalArrearsOwed"] = this.originalArrearsOwed !== undefined ? this.originalArrearsOwed : null as any;
        data["progamMonthlyCredit"] = this.progamMonthlyCredit !== undefined ? this.progamMonthlyCredit : null as any;
        data["arrearsMonthlyCredit"] = this.arrearsMonthlyCredit !== undefined ? this.arrearsMonthlyCredit : null as any;
        data["totalMonthlyCredit"] = this.totalMonthlyCredit !== undefined ? this.totalMonthlyCredit : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["enrollmentRejected"] = this.enrollmentRejected !== undefined ? this.enrollmentRejected : null as any;
        data["pledgedAmount"] = this.pledgedAmount !== undefined ? this.pledgedAmount : null as any;
        data["totalOverallCreditsPaid"] = this.totalOverallCreditsPaid !== undefined ? this.totalOverallCreditsPaid : null as any;
        data["totalProgramCreditsPaid"] = this.totalProgramCreditsPaid !== undefined ? this.totalProgramCreditsPaid : null as any;
        data["totalArrearsCreditsPaid"] = this.totalArrearsCreditsPaid !== undefined ? this.totalArrearsCreditsPaid : null as any;
        data["arrearsAmountRemaining"] = this.arrearsAmountRemaining !== undefined ? this.arrearsAmountRemaining : null as any;
        data["totalProgramInstallments"] = this.totalProgramInstallments !== undefined ? this.totalProgramInstallments : null as any;
        data["totalArrearsInstallments"] = this.totalArrearsInstallments !== undefined ? this.totalArrearsInstallments : null as any;
        data["totalMonthsEnrolled"] = this.totalMonthsEnrolled !== undefined ? this.totalMonthsEnrolled : null as any;
        data["programCreditsRemaining"] = this.programCreditsRemaining !== undefined ? this.programCreditsRemaining : null as any;
        data["arrearsCreditsRemaining"] = this.arrearsCreditsRemaining !== undefined ? this.arrearsCreditsRemaining : null as any;
        data["thirdPartyAgreeable"] = this.thirdPartyAgreeable !== undefined ? this.thirdPartyAgreeable : null as any;
        data["liheapReceived"] = this.liheapReceived !== undefined ? this.liheapReceived : null as any;
        data["liheapRequested"] = this.liheapRequested !== undefined ? this.liheapRequested : null as any;
        data["weatherizationReceived"] = this.weatherizationReceived !== undefined ? this.weatherizationReceived : null as any;
        data["weatherizationRequested"] = this.weatherizationRequested !== undefined ? this.weatherizationRequested : null as any;
        data["weatherizationStatus"] = this.weatherizationStatus !== undefined ? this.weatherizationStatus : null as any;
        data["approvedTimestamp"] = this.approvedTimestamp ? this.approvedTimestamp.toISOString() : null as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : null as any;
        data["arrearsCreditExpiration"] = this.arrearsCreditExpiration ? this.arrearsCreditExpiration.toISOString() : null as any;
        data["programCreditExpiration"] = this.programCreditExpiration ? this.programCreditExpiration.toISOString() : null as any;
        data["editorDate"] = this.editorDate ? this.editorDate.toISOString() : null as any;
        data["editorUser"] = this.editorUser !== undefined ? this.editorUser : null as any;
        data["createdUser"] = this.createdUser !== undefined ? this.createdUser : null as any;
        return data;
    }

    clone(): EnrollmentReport {
        const json = this.toJSON();
        let result = new EnrollmentReport();
        result.init(json);
        return result;
    }
}

export interface IEnrollmentReport {
    agency?: string | null;
    ssn?: string | null;
    encryptedSsn?: string | null;
    customer?: string | null;
    accountNumber?: string | null;
    initialBillDate?: Date | null;
    programExpiration?: Date | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    budgetBillAmount?: number | null;
    customerPayAmount?: number | null;
    enrollmentStatus?: string | null;
    rejectionReason?: string | null;
    confirmDate?: Date | null;
    importDate?: Date | null;
    firstName?: string | null;
    lastName?: string | null;
    povertyLevelDisplay?: number | null;
    elderly?: boolean;
    disabled?: boolean;
    childUnder5?: boolean;
    amerenCssCode?: string | null;
    programName?: string | null;
    statusName?: string | null;
    upfrontPaySource?: KcPaySourceType | null;
    upfromAmountPaid?: number | null;
    originalArrearsOwed?: number;
    progamMonthlyCredit?: number | null;
    arrearsMonthlyCredit?: number | null;
    totalMonthlyCredit?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    pledgedAmount?: number;
    totalOverallCreditsPaid?: number | null;
    totalProgramCreditsPaid?: number | null;
    totalArrearsCreditsPaid?: number | null;
    arrearsAmountRemaining?: number | null;
    totalProgramInstallments?: number | null;
    totalArrearsInstallments?: number | null;
    totalMonthsEnrolled?: number | null;
    programCreditsRemaining?: number | null;
    arrearsCreditsRemaining?: number | null;
    thirdPartyAgreeable?: boolean;
    liheapReceived?: boolean | null;
    liheapRequested?: boolean | null;
    weatherizationReceived?: boolean | null;
    weatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    approvedTimestamp?: Date | null;
    confirmedDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    editorDate?: Date | null;
    editorUser?: string | null;
    createdUser?: string | null;
}

export class EnrollmentDownload implements IEnrollmentDownload {
    agencyName?: string | null;
    ssn?: string | null;
    encryptedSsn?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    accountNumber?: string | null;
    initialBillDate?: Date | null;
    programExpiration?: Date | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    budgetBillAmount?: number | null;
    customerPayAmount?: number | null;
    enrollmentStatus?: string | null;
    rejectionReason?: string | null;
    confirmDate?: Date | null;
    importDate?: Date | null;
    povertyLevelDisplay?: number | null;
    isElderly?: boolean;
    isDisabled?: boolean;
    hasChildUnderFive?: boolean;
    amerenCssCode?: string | null;
    programName?: string | null;
    statusName?: string | null;
    upfrontPaySource?: KcPaySourceType | null;
    upfromAmountPaid?: number | null;
    originalArrearsOwed?: number;
    progamMonthlyCredit?: number | null;
    arrearsMonthlyCredit?: number | null;
    totalMonthlyCredit?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    pledgedAmount?: number;
    totalOverallCreditsPaid?: number | null;
    totalProgramCreditsPaid?: number | null;
    totalArrearsCreditsPaid?: number | null;
    arrearsAmountRemaining?: number | null;
    totalProgramInstallments?: number | null;
    totalArrearsInstallments?: number | null;
    totalMonthsEnrolled?: number | null;
    programCreditsRemaining?: number | null;
    arrearsCreditsRemaining?: number | null;
    isThirdPartyAgreeable?: boolean;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    createdDate?: Date;
    thirdPartyAgreement?: Date | null;
    approvedTimestamp?: Date | null;
    downloadTimestamp?: Date | null;
    confirmedDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    editorDate?: Date | null;
    editorUser?: string | null;
    createdUser?: string | null;

    constructor(data?: IEnrollmentDownload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.encryptedSsn = _data["encryptedSsn"] !== undefined ? _data["encryptedSsn"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.initialBillDate = _data["initialBillDate"] ? new Date(_data["initialBillDate"].toString()) : null as any;
            this.programExpiration = _data["programExpiration"] ? new Date(_data["programExpiration"].toString()) : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerPayAmount = _data["customerPayAmount"] !== undefined ? _data["customerPayAmount"] : null as any;
            this.enrollmentStatus = _data["enrollmentStatus"] !== undefined ? _data["enrollmentStatus"] : null as any;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : null as any;
            this.confirmDate = _data["confirmDate"] ? new Date(_data["confirmDate"].toString()) : null as any;
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : null as any;
            this.povertyLevelDisplay = _data["povertyLevelDisplay"] !== undefined ? _data["povertyLevelDisplay"] : null as any;
            this.isElderly = _data["isElderly"] !== undefined ? _data["isElderly"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.hasChildUnderFive = _data["hasChildUnderFive"] !== undefined ? _data["hasChildUnderFive"] : null as any;
            this.amerenCssCode = _data["amerenCssCode"] !== undefined ? _data["amerenCssCode"] : null as any;
            this.programName = _data["programName"] !== undefined ? _data["programName"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.upfrontPaySource = _data["upfrontPaySource"] !== undefined ? _data["upfrontPaySource"] : null as any;
            this.upfromAmountPaid = _data["upfromAmountPaid"] !== undefined ? _data["upfromAmountPaid"] : null as any;
            this.originalArrearsOwed = _data["originalArrearsOwed"] !== undefined ? _data["originalArrearsOwed"] : null as any;
            this.progamMonthlyCredit = _data["progamMonthlyCredit"] !== undefined ? _data["progamMonthlyCredit"] : null as any;
            this.arrearsMonthlyCredit = _data["arrearsMonthlyCredit"] !== undefined ? _data["arrearsMonthlyCredit"] : null as any;
            this.totalMonthlyCredit = _data["totalMonthlyCredit"] !== undefined ? _data["totalMonthlyCredit"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.enrollmentRejected = _data["enrollmentRejected"] !== undefined ? _data["enrollmentRejected"] : null as any;
            this.pledgedAmount = _data["pledgedAmount"] !== undefined ? _data["pledgedAmount"] : null as any;
            this.totalOverallCreditsPaid = _data["totalOverallCreditsPaid"] !== undefined ? _data["totalOverallCreditsPaid"] : null as any;
            this.totalProgramCreditsPaid = _data["totalProgramCreditsPaid"] !== undefined ? _data["totalProgramCreditsPaid"] : null as any;
            this.totalArrearsCreditsPaid = _data["totalArrearsCreditsPaid"] !== undefined ? _data["totalArrearsCreditsPaid"] : null as any;
            this.arrearsAmountRemaining = _data["arrearsAmountRemaining"] !== undefined ? _data["arrearsAmountRemaining"] : null as any;
            this.totalProgramInstallments = _data["totalProgramInstallments"] !== undefined ? _data["totalProgramInstallments"] : null as any;
            this.totalArrearsInstallments = _data["totalArrearsInstallments"] !== undefined ? _data["totalArrearsInstallments"] : null as any;
            this.totalMonthsEnrolled = _data["totalMonthsEnrolled"] !== undefined ? _data["totalMonthsEnrolled"] : null as any;
            this.programCreditsRemaining = _data["programCreditsRemaining"] !== undefined ? _data["programCreditsRemaining"] : null as any;
            this.arrearsCreditsRemaining = _data["arrearsCreditsRemaining"] !== undefined ? _data["arrearsCreditsRemaining"] : null as any;
            this.isThirdPartyAgreeable = _data["isThirdPartyAgreeable"] !== undefined ? _data["isThirdPartyAgreeable"] : null as any;
            this.isLiheapReceived = _data["isLiheapReceived"] !== undefined ? _data["isLiheapReceived"] : null as any;
            this.isLiheapRequested = _data["isLiheapRequested"] !== undefined ? _data["isLiheapRequested"] : null as any;
            this.isWeatherizationReceived = _data["isWeatherizationReceived"] !== undefined ? _data["isWeatherizationReceived"] : null as any;
            this.isWeatherizationRequested = _data["isWeatherizationRequested"] !== undefined ? _data["isWeatherizationRequested"] : null as any;
            this.weatherizationStatus = _data["weatherizationStatus"] !== undefined ? _data["weatherizationStatus"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.thirdPartyAgreement = _data["thirdPartyAgreement"] ? new Date(_data["thirdPartyAgreement"].toString()) : null as any;
            this.approvedTimestamp = _data["approvedTimestamp"] ? new Date(_data["approvedTimestamp"].toString()) : null as any;
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : null as any;
            this.arrearsCreditExpiration = _data["arrearsCreditExpiration"] ? new Date(_data["arrearsCreditExpiration"].toString()) : null as any;
            this.programCreditExpiration = _data["programCreditExpiration"] ? new Date(_data["programCreditExpiration"].toString()) : null as any;
            this.editorDate = _data["editorDate"] ? new Date(_data["editorDate"].toString()) : null as any;
            this.editorUser = _data["editorUser"] !== undefined ? _data["editorUser"] : null as any;
            this.createdUser = _data["createdUser"] !== undefined ? _data["createdUser"] : null as any;
        }
    }

    static fromJS(data: any): EnrollmentDownload {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentDownload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["encryptedSsn"] = this.encryptedSsn !== undefined ? this.encryptedSsn : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["initialBillDate"] = this.initialBillDate ? this.initialBillDate.toISOString() : null as any;
        data["programExpiration"] = this.programExpiration ? this.programExpiration.toISOString() : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerPayAmount"] = this.customerPayAmount !== undefined ? this.customerPayAmount : null as any;
        data["enrollmentStatus"] = this.enrollmentStatus !== undefined ? this.enrollmentStatus : null as any;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : null as any;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : null as any;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : null as any;
        data["povertyLevelDisplay"] = this.povertyLevelDisplay !== undefined ? this.povertyLevelDisplay : null as any;
        data["isElderly"] = this.isElderly !== undefined ? this.isElderly : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["hasChildUnderFive"] = this.hasChildUnderFive !== undefined ? this.hasChildUnderFive : null as any;
        data["amerenCssCode"] = this.amerenCssCode !== undefined ? this.amerenCssCode : null as any;
        data["programName"] = this.programName !== undefined ? this.programName : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["upfrontPaySource"] = this.upfrontPaySource !== undefined ? this.upfrontPaySource : null as any;
        data["upfromAmountPaid"] = this.upfromAmountPaid !== undefined ? this.upfromAmountPaid : null as any;
        data["originalArrearsOwed"] = this.originalArrearsOwed !== undefined ? this.originalArrearsOwed : null as any;
        data["progamMonthlyCredit"] = this.progamMonthlyCredit !== undefined ? this.progamMonthlyCredit : null as any;
        data["arrearsMonthlyCredit"] = this.arrearsMonthlyCredit !== undefined ? this.arrearsMonthlyCredit : null as any;
        data["totalMonthlyCredit"] = this.totalMonthlyCredit !== undefined ? this.totalMonthlyCredit : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["enrollmentRejected"] = this.enrollmentRejected !== undefined ? this.enrollmentRejected : null as any;
        data["pledgedAmount"] = this.pledgedAmount !== undefined ? this.pledgedAmount : null as any;
        data["totalOverallCreditsPaid"] = this.totalOverallCreditsPaid !== undefined ? this.totalOverallCreditsPaid : null as any;
        data["totalProgramCreditsPaid"] = this.totalProgramCreditsPaid !== undefined ? this.totalProgramCreditsPaid : null as any;
        data["totalArrearsCreditsPaid"] = this.totalArrearsCreditsPaid !== undefined ? this.totalArrearsCreditsPaid : null as any;
        data["arrearsAmountRemaining"] = this.arrearsAmountRemaining !== undefined ? this.arrearsAmountRemaining : null as any;
        data["totalProgramInstallments"] = this.totalProgramInstallments !== undefined ? this.totalProgramInstallments : null as any;
        data["totalArrearsInstallments"] = this.totalArrearsInstallments !== undefined ? this.totalArrearsInstallments : null as any;
        data["totalMonthsEnrolled"] = this.totalMonthsEnrolled !== undefined ? this.totalMonthsEnrolled : null as any;
        data["programCreditsRemaining"] = this.programCreditsRemaining !== undefined ? this.programCreditsRemaining : null as any;
        data["arrearsCreditsRemaining"] = this.arrearsCreditsRemaining !== undefined ? this.arrearsCreditsRemaining : null as any;
        data["isThirdPartyAgreeable"] = this.isThirdPartyAgreeable !== undefined ? this.isThirdPartyAgreeable : null as any;
        data["isLiheapReceived"] = this.isLiheapReceived !== undefined ? this.isLiheapReceived : null as any;
        data["isLiheapRequested"] = this.isLiheapRequested !== undefined ? this.isLiheapRequested : null as any;
        data["isWeatherizationReceived"] = this.isWeatherizationReceived !== undefined ? this.isWeatherizationReceived : null as any;
        data["isWeatherizationRequested"] = this.isWeatherizationRequested !== undefined ? this.isWeatherizationRequested : null as any;
        data["weatherizationStatus"] = this.weatherizationStatus !== undefined ? this.weatherizationStatus : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["thirdPartyAgreement"] = this.thirdPartyAgreement ? this.thirdPartyAgreement.toISOString() : null as any;
        data["approvedTimestamp"] = this.approvedTimestamp ? this.approvedTimestamp.toISOString() : null as any;
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : null as any;
        data["arrearsCreditExpiration"] = this.arrearsCreditExpiration ? this.arrearsCreditExpiration.toISOString() : null as any;
        data["programCreditExpiration"] = this.programCreditExpiration ? this.programCreditExpiration.toISOString() : null as any;
        data["editorDate"] = this.editorDate ? this.editorDate.toISOString() : null as any;
        data["editorUser"] = this.editorUser !== undefined ? this.editorUser : null as any;
        data["createdUser"] = this.createdUser !== undefined ? this.createdUser : null as any;
        return data;
    }

    clone(): EnrollmentDownload {
        const json = this.toJSON();
        let result = new EnrollmentDownload();
        result.init(json);
        return result;
    }
}

export interface IEnrollmentDownload {
    agencyName?: string | null;
    ssn?: string | null;
    encryptedSsn?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    accountNumber?: string | null;
    initialBillDate?: Date | null;
    programExpiration?: Date | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    budgetBillAmount?: number | null;
    customerPayAmount?: number | null;
    enrollmentStatus?: string | null;
    rejectionReason?: string | null;
    confirmDate?: Date | null;
    importDate?: Date | null;
    povertyLevelDisplay?: number | null;
    isElderly?: boolean;
    isDisabled?: boolean;
    hasChildUnderFive?: boolean;
    amerenCssCode?: string | null;
    programName?: string | null;
    statusName?: string | null;
    upfrontPaySource?: KcPaySourceType | null;
    upfromAmountPaid?: number | null;
    originalArrearsOwed?: number;
    progamMonthlyCredit?: number | null;
    arrearsMonthlyCredit?: number | null;
    totalMonthlyCredit?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    pledgedAmount?: number;
    totalOverallCreditsPaid?: number | null;
    totalProgramCreditsPaid?: number | null;
    totalArrearsCreditsPaid?: number | null;
    arrearsAmountRemaining?: number | null;
    totalProgramInstallments?: number | null;
    totalArrearsInstallments?: number | null;
    totalMonthsEnrolled?: number | null;
    programCreditsRemaining?: number | null;
    arrearsCreditsRemaining?: number | null;
    isThirdPartyAgreeable?: boolean;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    createdDate?: Date;
    thirdPartyAgreement?: Date | null;
    approvedTimestamp?: Date | null;
    downloadTimestamp?: Date | null;
    confirmedDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    editorDate?: Date | null;
    editorUser?: string | null;
    createdUser?: string | null;
}

export class ApprovedEnrollment extends BaseViewModel implements IApprovedEnrollment {
    keepingCurrentApplicationId?: string;
    programName?: string | null;
    programMonthlyCredit?: number | null;
    statusName?: string | null;
    accountNumber?: string | null;
    agencyName?: string | null;
    amerenCssCode?: string | null;
    clientSsn?: string | null;
    clientLastName?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientFederalPovertyLevelDisplay?: number | null;
    isThirdPartyAgreeable?: boolean;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientIsElderly?: boolean | null;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    downloadTimestamp?: Date | null;

    constructor(data?: IApprovedEnrollment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.programName = _data["programName"] !== undefined ? _data["programName"] : null as any;
            this.programMonthlyCredit = _data["programMonthlyCredit"] !== undefined ? _data["programMonthlyCredit"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.amerenCssCode = _data["amerenCssCode"] !== undefined ? _data["amerenCssCode"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientMiddleInitial = _data["clientMiddleInitial"] !== undefined ? _data["clientMiddleInitial"] : null as any;
            this.clientFederalPovertyLevelDisplay = _data["clientFederalPovertyLevelDisplay"] !== undefined ? _data["clientFederalPovertyLevelDisplay"] : null as any;
            this.isThirdPartyAgreeable = _data["isThirdPartyAgreeable"] !== undefined ? _data["isThirdPartyAgreeable"] : null as any;
            this.clientHasChildrenUnderFive = _data["clientHasChildrenUnderFive"] !== undefined ? _data["clientHasChildrenUnderFive"] : null as any;
            this.clientIsDisabled = _data["clientIsDisabled"] !== undefined ? _data["clientIsDisabled"] : null as any;
            this.clientIsElderly = _data["clientIsElderly"] !== undefined ? _data["clientIsElderly"] : null as any;
            this.isLiheapReceived = _data["isLiheapReceived"] !== undefined ? _data["isLiheapReceived"] : null as any;
            this.isLiheapRequested = _data["isLiheapRequested"] !== undefined ? _data["isLiheapRequested"] : null as any;
            this.isWeatherizationReceived = _data["isWeatherizationReceived"] !== undefined ? _data["isWeatherizationReceived"] : null as any;
            this.isWeatherizationRequested = _data["isWeatherizationRequested"] !== undefined ? _data["isWeatherizationRequested"] : null as any;
            this.weatherizationStatus = _data["weatherizationStatus"] !== undefined ? _data["weatherizationStatus"] : null as any;
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): ApprovedEnrollment {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedEnrollment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["programName"] = this.programName !== undefined ? this.programName : null as any;
        data["programMonthlyCredit"] = this.programMonthlyCredit !== undefined ? this.programMonthlyCredit : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["amerenCssCode"] = this.amerenCssCode !== undefined ? this.amerenCssCode : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientMiddleInitial"] = this.clientMiddleInitial !== undefined ? this.clientMiddleInitial : null as any;
        data["clientFederalPovertyLevelDisplay"] = this.clientFederalPovertyLevelDisplay !== undefined ? this.clientFederalPovertyLevelDisplay : null as any;
        data["isThirdPartyAgreeable"] = this.isThirdPartyAgreeable !== undefined ? this.isThirdPartyAgreeable : null as any;
        data["clientHasChildrenUnderFive"] = this.clientHasChildrenUnderFive !== undefined ? this.clientHasChildrenUnderFive : null as any;
        data["clientIsDisabled"] = this.clientIsDisabled !== undefined ? this.clientIsDisabled : null as any;
        data["clientIsElderly"] = this.clientIsElderly !== undefined ? this.clientIsElderly : null as any;
        data["isLiheapReceived"] = this.isLiheapReceived !== undefined ? this.isLiheapReceived : null as any;
        data["isLiheapRequested"] = this.isLiheapRequested !== undefined ? this.isLiheapRequested : null as any;
        data["isWeatherizationReceived"] = this.isWeatherizationReceived !== undefined ? this.isWeatherizationReceived : null as any;
        data["isWeatherizationRequested"] = this.isWeatherizationRequested !== undefined ? this.isWeatherizationRequested : null as any;
        data["weatherizationStatus"] = this.weatherizationStatus !== undefined ? this.weatherizationStatus : null as any;
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApprovedEnrollment {
        const json = this.toJSON();
        let result = new ApprovedEnrollment();
        result.init(json);
        return result;
    }
}

export interface IApprovedEnrollment extends IBaseViewModel {
    keepingCurrentApplicationId?: string;
    programName?: string | null;
    programMonthlyCredit?: number | null;
    statusName?: string | null;
    accountNumber?: string | null;
    agencyName?: string | null;
    amerenCssCode?: string | null;
    clientSsn?: string | null;
    clientLastName?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientFederalPovertyLevelDisplay?: number | null;
    isThirdPartyAgreeable?: boolean;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientIsElderly?: boolean | null;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    downloadTimestamp?: Date | null;
}

export class BudgetBillingReport implements IBudgetBillingReport {
    agency?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    accountNumber?: string | null;
    serviceAddress?: string | null;
    enrollmentDate?: Date | null;
    firstBillingDate?: Date | null;
    billingDate?: Date | null;
    previousMonthAmount?: number | null;
    currentMonthAmount?: number | null;
    adjustmentAmount?: number | null;

    constructor(data?: IBudgetBillingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.serviceAddress = _data["serviceAddress"] !== undefined ? _data["serviceAddress"] : null as any;
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : null as any;
            this.firstBillingDate = _data["firstBillingDate"] ? new Date(_data["firstBillingDate"].toString()) : null as any;
            this.billingDate = _data["billingDate"] ? new Date(_data["billingDate"].toString()) : null as any;
            this.previousMonthAmount = _data["previousMonthAmount"] !== undefined ? _data["previousMonthAmount"] : null as any;
            this.currentMonthAmount = _data["currentMonthAmount"] !== undefined ? _data["currentMonthAmount"] : null as any;
            this.adjustmentAmount = _data["adjustmentAmount"] !== undefined ? _data["adjustmentAmount"] : null as any;
        }
    }

    static fromJS(data: any): BudgetBillingReport {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetBillingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["serviceAddress"] = this.serviceAddress !== undefined ? this.serviceAddress : null as any;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : null as any;
        data["firstBillingDate"] = this.firstBillingDate ? this.firstBillingDate.toISOString() : null as any;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : null as any;
        data["previousMonthAmount"] = this.previousMonthAmount !== undefined ? this.previousMonthAmount : null as any;
        data["currentMonthAmount"] = this.currentMonthAmount !== undefined ? this.currentMonthAmount : null as any;
        data["adjustmentAmount"] = this.adjustmentAmount !== undefined ? this.adjustmentAmount : null as any;
        return data;
    }

    clone(): BudgetBillingReport {
        const json = this.toJSON();
        let result = new BudgetBillingReport();
        result.init(json);
        return result;
    }
}

export interface IBudgetBillingReport {
    agency?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    accountNumber?: string | null;
    serviceAddress?: string | null;
    enrollmentDate?: Date | null;
    firstBillingDate?: Date | null;
    billingDate?: Date | null;
    previousMonthAmount?: number | null;
    currentMonthAmount?: number | null;
    adjustmentAmount?: number | null;
}

export class CompletionReport implements ICompletionReport {
    agency?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    last4Ssn?: string | null;
    phoneNumber?: string | null;
    phoneExt?: string | null;
    accountNumber?: string | null;
    serviceAddress?: string | null;
    enrollmentDate?: Date | null;
    completionDate?: Date | null;

    constructor(data?: ICompletionReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.phoneExt = _data["phoneExt"] !== undefined ? _data["phoneExt"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.serviceAddress = _data["serviceAddress"] !== undefined ? _data["serviceAddress"] : null as any;
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : null as any;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CompletionReport {
        data = typeof data === 'object' ? data : {};
        let result = new CompletionReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["phoneExt"] = this.phoneExt !== undefined ? this.phoneExt : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["serviceAddress"] = this.serviceAddress !== undefined ? this.serviceAddress : null as any;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : null as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : null as any;
        return data;
    }

    clone(): CompletionReport {
        const json = this.toJSON();
        let result = new CompletionReport();
        result.init(json);
        return result;
    }
}

export interface ICompletionReport {
    agency?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    last4Ssn?: string | null;
    phoneNumber?: string | null;
    phoneExt?: string | null;
    accountNumber?: string | null;
    serviceAddress?: string | null;
    enrollmentDate?: Date | null;
    completionDate?: Date | null;
}

export class ApprovedEnrollmentHistory extends BaseViewModel implements IApprovedEnrollmentHistory {
    downloadTimestamp?: Date | null;
    count?: number;

    constructor(data?: IApprovedEnrollmentHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static override fromJS(data: any): ApprovedEnrollmentHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedEnrollmentHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApprovedEnrollmentHistory {
        const json = this.toJSON();
        let result = new ApprovedEnrollmentHistory();
        result.init(json);
        return result;
    }
}

export interface IApprovedEnrollmentHistory extends IBaseViewModel {
    downloadTimestamp?: Date | null;
    count?: number;
}

export class LookUp extends BaseViewModel implements ILookUp {
    category?: LookUpCategoryType;
    key?: string | null;
    lookupValue?: string | null;
    description?: string | null;
    sortOrder?: number;

    constructor(data?: ILookUp) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.lookupValue = _data["lookupValue"] !== undefined ? _data["lookupValue"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static override fromJS(data: any): LookUp {
        data = typeof data === 'object' ? data : {};
        let result = new LookUp();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["lookupValue"] = this.lookupValue !== undefined ? this.lookupValue : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LookUp {
        const json = this.toJSON();
        let result = new LookUp();
        result.init(json);
        return result;
    }
}

export interface ILookUp extends IBaseViewModel {
    category?: LookUpCategoryType;
    key?: string | null;
    lookupValue?: string | null;
    description?: string | null;
    sortOrder?: number;
}

export enum LookUpCategoryType {
    Unknown = "Unknown",
    States = "States",
    NamePrefix = "NamePrefix",
    NameSuffix = "NameSuffix",
    EmploymentStatus = "EmploymentStatus",
    Gender = "Gender",
    EfsAssistance = "EfsAssistance",
    Region = "Region",
    Zones = "Zones",
    UnionInfo = "UnionInfo",
    Race = "Race",
    AdministrativeAgencyFundAssistanceUhons = "AdministrativeAgencyFundAssistanceUhons",
    AdministrativeAgencyFundAssistanceUff = "AdministrativeAgencyFundAssistanceUff",
    AdministrativeAgencyFundAssistanceSTLWater = "AdministrativeAgencyFundAssistanceSTLWater",
    AdministrativeAgencyFundAssistanceStorm = "AdministrativeAgencyFundAssistanceStorm",
}

export class PagedListOfLookUp implements IPagedListOfLookUp {
    items?: LookUp[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfLookUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LookUp.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfLookUp {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfLookUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfLookUp {
        const json = this.toJSON();
        let result = new PagedListOfLookUp();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfLookUp {
    items?: LookUp[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class MailUsersParameters implements IMailUsersParameters {
    fromMail?: string | null;
    subject?: string | null;
    content?: string | null;
    includeOptOut?: boolean;
    agencyId?: string | null;
    fundTypes?: string[] | null;

    constructor(data?: IMailUsersParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromMail = _data["fromMail"] !== undefined ? _data["fromMail"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.includeOptOut = _data["includeOptOut"] !== undefined ? _data["includeOptOut"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            if (Array.isArray(_data["fundTypes"])) {
                this.fundTypes = [] as any;
                for (let item of _data["fundTypes"])
                    this.fundTypes!.push(item);
            }
            else {
                this.fundTypes = null as any;
            }
        }
    }

    static fromJS(data: any): MailUsersParameters {
        data = typeof data === 'object' ? data : {};
        let result = new MailUsersParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromMail"] = this.fromMail !== undefined ? this.fromMail : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["includeOptOut"] = this.includeOptOut !== undefined ? this.includeOptOut : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        if (Array.isArray(this.fundTypes)) {
            data["fundTypes"] = [];
            for (let item of this.fundTypes)
                data["fundTypes"].push(item);
        }
        return data;
    }

    clone(): MailUsersParameters {
        const json = this.toJSON();
        let result = new MailUsersParameters();
        result.init(json);
        return result;
    }
}

export interface IMailUsersParameters {
    fromMail?: string | null;
    subject?: string | null;
    content?: string | null;
    includeOptOut?: boolean;
    agencyId?: string | null;
    fundTypes?: string[] | null;
}

export class PagedListOfCompanyMailingReport implements IPagedListOfCompanyMailingReport {
    items?: CompanyMailingReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfCompanyMailingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyMailingReport.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfCompanyMailingReport {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfCompanyMailingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfCompanyMailingReport {
        const json = this.toJSON();
        let result = new PagedListOfCompanyMailingReport();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfCompanyMailingReport {
    items?: CompanyMailingReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class CompanyMailingReport implements ICompanyMailingReport {
    company?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    zipcode?: string | null;
    contactName1?: string | null;
    contactPhone1?: string | null;
    contactName2?: string | null;
    contactPhone2?: string | null;
    contactName3?: string | null;
    contactPhone3?: string | null;
    amountPledged?: number;
    state?: string | null;

    constructor(data?: ICompanyMailingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zipcode = _data["zipcode"] !== undefined ? _data["zipcode"] : null as any;
            this.contactName1 = _data["contactName1"] !== undefined ? _data["contactName1"] : null as any;
            this.contactPhone1 = _data["contactPhone1"] !== undefined ? _data["contactPhone1"] : null as any;
            this.contactName2 = _data["contactName2"] !== undefined ? _data["contactName2"] : null as any;
            this.contactPhone2 = _data["contactPhone2"] !== undefined ? _data["contactPhone2"] : null as any;
            this.contactName3 = _data["contactName3"] !== undefined ? _data["contactName3"] : null as any;
            this.contactPhone3 = _data["contactPhone3"] !== undefined ? _data["contactPhone3"] : null as any;
            this.amountPledged = _data["amountPledged"] !== undefined ? _data["amountPledged"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): CompanyMailingReport {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyMailingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zipcode"] = this.zipcode !== undefined ? this.zipcode : null as any;
        data["contactName1"] = this.contactName1 !== undefined ? this.contactName1 : null as any;
        data["contactPhone1"] = this.contactPhone1 !== undefined ? this.contactPhone1 : null as any;
        data["contactName2"] = this.contactName2 !== undefined ? this.contactName2 : null as any;
        data["contactPhone2"] = this.contactPhone2 !== undefined ? this.contactPhone2 : null as any;
        data["contactName3"] = this.contactName3 !== undefined ? this.contactName3 : null as any;
        data["contactPhone3"] = this.contactPhone3 !== undefined ? this.contactPhone3 : null as any;
        data["amountPledged"] = this.amountPledged !== undefined ? this.amountPledged : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }

    clone(): CompanyMailingReport {
        const json = this.toJSON();
        let result = new CompanyMailingReport();
        result.init(json);
        return result;
    }
}

export interface ICompanyMailingReport {
    company?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    zipcode?: string | null;
    contactName1?: string | null;
    contactPhone1?: string | null;
    contactName2?: string | null;
    contactPhone2?: string | null;
    contactName3?: string | null;
    contactPhone3?: string | null;
    amountPledged?: number;
    state?: string | null;
}

export class ShiftPledgeReportSummary implements IShiftPledgeReportSummary {
    pledgeType?: string | null;
    company?: string | null;
    pledgedCount?: number;
    pledgedAmount?: number;
    pledgeTypeTotal?: number;
    order?: number;
    ledgerNumber?: string | null;
    isPrivate?: boolean | null;

    constructor(data?: IShiftPledgeReportSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pledgeType = _data["pledgeType"] !== undefined ? _data["pledgeType"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.pledgedCount = _data["pledgedCount"] !== undefined ? _data["pledgedCount"] : null as any;
            this.pledgedAmount = _data["pledgedAmount"] !== undefined ? _data["pledgedAmount"] : null as any;
            this.pledgeTypeTotal = _data["pledgeTypeTotal"] !== undefined ? _data["pledgeTypeTotal"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
        }
    }

    static fromJS(data: any): ShiftPledgeReportSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftPledgeReportSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pledgeType"] = this.pledgeType !== undefined ? this.pledgeType : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["pledgedCount"] = this.pledgedCount !== undefined ? this.pledgedCount : null as any;
        data["pledgedAmount"] = this.pledgedAmount !== undefined ? this.pledgedAmount : null as any;
        data["pledgeTypeTotal"] = this.pledgeTypeTotal !== undefined ? this.pledgeTypeTotal : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        return data;
    }

    clone(): ShiftPledgeReportSummary {
        const json = this.toJSON();
        let result = new ShiftPledgeReportSummary();
        result.init(json);
        return result;
    }
}

export interface IShiftPledgeReportSummary {
    pledgeType?: string | null;
    company?: string | null;
    pledgedCount?: number;
    pledgedAmount?: number;
    pledgeTypeTotal?: number;
    order?: number;
    ledgerNumber?: string | null;
    isPrivate?: boolean | null;
}

export class PledgeReportParams implements IPledgeReportParams {
    displayPledgeStatus?: PledgeStatusType | null;
    shiftPledgeStatus?: PledgeStatusType | null;
    startDate?: Date | null;
    endDate?: Date | null;
    pledgeTypeId?: string | null;
    pledgeTypeIds?: string[] | null;
    companyId?: string | null;
    agencyId?: string | null;
    entryDate?: Date | null;

    constructor(data?: IPledgeReportParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayPledgeStatus = _data["displayPledgeStatus"] !== undefined ? _data["displayPledgeStatus"] : null as any;
            this.shiftPledgeStatus = _data["shiftPledgeStatus"] !== undefined ? _data["shiftPledgeStatus"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            if (Array.isArray(_data["pledgeTypeIds"])) {
                this.pledgeTypeIds = [] as any;
                for (let item of _data["pledgeTypeIds"])
                    this.pledgeTypeIds!.push(item);
            }
            else {
                this.pledgeTypeIds = null as any;
            }
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PledgeReportParams {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeReportParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayPledgeStatus"] = this.displayPledgeStatus !== undefined ? this.displayPledgeStatus : null as any;
        data["shiftPledgeStatus"] = this.shiftPledgeStatus !== undefined ? this.shiftPledgeStatus : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        if (Array.isArray(this.pledgeTypeIds)) {
            data["pledgeTypeIds"] = [];
            for (let item of this.pledgeTypeIds)
                data["pledgeTypeIds"].push(item);
        }
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : null as any;
        return data;
    }

    clone(): PledgeReportParams {
        const json = this.toJSON();
        let result = new PledgeReportParams();
        result.init(json);
        return result;
    }
}

export interface IPledgeReportParams {
    displayPledgeStatus?: PledgeStatusType | null;
    shiftPledgeStatus?: PledgeStatusType | null;
    startDate?: Date | null;
    endDate?: Date | null;
    pledgeTypeId?: string | null;
    pledgeTypeIds?: string[] | null;
    companyId?: string | null;
    agencyId?: string | null;
    entryDate?: Date | null;
}

export class PagedListOfProcessingReport implements IPagedListOfProcessingReport {
    items?: ProcessingReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfProcessingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProcessingReport.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfProcessingReport {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfProcessingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfProcessingReport {
        const json = this.toJSON();
        let result = new PagedListOfProcessingReport();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfProcessingReport {
    items?: ProcessingReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class ProcessingReport implements IProcessingReport {
    status?: string | null;
    pledgeType?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    company?: string | null;
    clientCompanyAccountNumber?: string | null;
    invoiceNumber?: string | null;
    amount?: number;
    agency?: string | null;
    pledgedDate?: Date;
    enteredDate?: Date;
    crisis?: boolean | null;
    clientLast4Ssn?: string | null;
    paidDate?: Date | null;
    pledgeNumber?: number;
    ledgerNumber?: string | null;
    isPrivate?: boolean;
    censusTract?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;

    constructor(data?: IProcessingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeType = _data["pledgeType"] !== undefined ? _data["pledgeType"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.clientCompanyAccountNumber = _data["clientCompanyAccountNumber"] !== undefined ? _data["clientCompanyAccountNumber"] : null as any;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.pledgedDate = _data["pledgedDate"] ? new Date(_data["pledgedDate"].toString()) : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.crisis = _data["crisis"] !== undefined ? _data["crisis"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.pledgeNumber = _data["pledgeNumber"] !== undefined ? _data["pledgeNumber"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            this.censusTract = _data["censusTract"] !== undefined ? _data["censusTract"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.specialCoding = _data["specialCoding"] !== undefined ? _data["specialCoding"] : null as any;
            this.enteredByName = _data["enteredByName"] !== undefined ? _data["enteredByName"] : null as any;
            this.enteredByEmail = _data["enteredByEmail"] !== undefined ? _data["enteredByEmail"] : null as any;
        }
    }

    static fromJS(data: any): ProcessingReport {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeType"] = this.pledgeType !== undefined ? this.pledgeType : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["clientCompanyAccountNumber"] = this.clientCompanyAccountNumber !== undefined ? this.clientCompanyAccountNumber : null as any;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["pledgedDate"] = this.pledgedDate ? this.pledgedDate.toISOString() : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["crisis"] = this.crisis !== undefined ? this.crisis : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["pledgeNumber"] = this.pledgeNumber !== undefined ? this.pledgeNumber : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["censusTract"] = this.censusTract !== undefined ? this.censusTract : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["specialCoding"] = this.specialCoding !== undefined ? this.specialCoding : null as any;
        data["enteredByName"] = this.enteredByName !== undefined ? this.enteredByName : null as any;
        data["enteredByEmail"] = this.enteredByEmail !== undefined ? this.enteredByEmail : null as any;
        return data;
    }

    clone(): ProcessingReport {
        const json = this.toJSON();
        let result = new ProcessingReport();
        result.init(json);
        return result;
    }
}

export interface IProcessingReport {
    status?: string | null;
    pledgeType?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    company?: string | null;
    clientCompanyAccountNumber?: string | null;
    invoiceNumber?: string | null;
    amount?: number;
    agency?: string | null;
    pledgedDate?: Date;
    enteredDate?: Date;
    crisis?: boolean | null;
    clientLast4Ssn?: string | null;
    paidDate?: Date | null;
    pledgeNumber?: number;
    ledgerNumber?: string | null;
    isPrivate?: boolean;
    censusTract?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;
}

export class PledgeBulkPaymentReport implements IPledgeBulkPaymentReport {
    id?: string;
    count?: number;
    status?: PledgeStatusType;
    hasDifferentStatuses?: boolean;

    constructor(data?: IPledgeBulkPaymentReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.hasDifferentStatuses = _data["hasDifferentStatuses"] !== undefined ? _data["hasDifferentStatuses"] : null as any;
        }
    }

    static fromJS(data: any): PledgeBulkPaymentReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["hasDifferentStatuses"] = this.hasDifferentStatuses !== undefined ? this.hasDifferentStatuses : null as any;
        return data;
    }

    clone(): PledgeBulkPaymentReport {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentReport {
    id?: string;
    count?: number;
    status?: PledgeStatusType;
    hasDifferentStatuses?: boolean;
}

export class PledgeBulkPaymentCreateBatchResponse implements IPledgeBulkPaymentCreateBatchResponse {
    batchId?: string;
    pledgeCount?: number;
    totalAmount?: number;

    constructor(data?: IPledgeBulkPaymentCreateBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : null as any;
            this.pledgeCount = _data["pledgeCount"] !== undefined ? _data["pledgeCount"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
        }
    }

    static fromJS(data: any): PledgeBulkPaymentCreateBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentCreateBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId !== undefined ? this.batchId : null as any;
        data["pledgeCount"] = this.pledgeCount !== undefined ? this.pledgeCount : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        return data;
    }

    clone(): PledgeBulkPaymentCreateBatchResponse {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentCreateBatchResponse();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentCreateBatchResponse {
    batchId?: string;
    pledgeCount?: number;
    totalAmount?: number;
}

export class PledgeBulkPaymentBatchParameters implements IPledgeBulkPaymentBatchParameters {
    startDate?: Date | null;
    endDate?: Date | null;
    pledgeTypes?: string[] | null;
    companies?: (string | null)[] | null;

    constructor(data?: IPledgeBulkPaymentBatchParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["pledgeTypes"])) {
                this.pledgeTypes = [] as any;
                for (let item of _data["pledgeTypes"])
                    this.pledgeTypes!.push(item);
            }
            else {
                this.pledgeTypes = null as any;
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            else {
                this.companies = null as any;
            }
        }
    }

    static fromJS(data: any): PledgeBulkPaymentBatchParameters {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentBatchParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.pledgeTypes)) {
            data["pledgeTypes"] = [];
            for (let item of this.pledgeTypes)
                data["pledgeTypes"].push(item);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        return data;
    }

    clone(): PledgeBulkPaymentBatchParameters {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentBatchParameters();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentBatchParameters {
    startDate?: Date | null;
    endDate?: Date | null;
    pledgeTypes?: string[] | null;
    companies?: (string | null)[] | null;
}

export class BulkPaymentPayPledgeParameters implements IBulkPaymentPayPledgeParameters {
    pledgeIds?: string[] | null;
    paidDate?: Date;

    constructor(data?: IBulkPaymentPayPledgeParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pledgeIds"])) {
                this.pledgeIds = [] as any;
                for (let item of _data["pledgeIds"])
                    this.pledgeIds!.push(item);
            }
            else {
                this.pledgeIds = null as any;
            }
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): BulkPaymentPayPledgeParameters {
        data = typeof data === 'object' ? data : {};
        let result = new BulkPaymentPayPledgeParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pledgeIds)) {
            data["pledgeIds"] = [];
            for (let item of this.pledgeIds)
                data["pledgeIds"].push(item);
        }
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        return data;
    }

    clone(): BulkPaymentPayPledgeParameters {
        const json = this.toJSON();
        let result = new BulkPaymentPayPledgeParameters();
        result.init(json);
        return result;
    }
}

export interface IBulkPaymentPayPledgeParameters {
    pledgeIds?: string[] | null;
    paidDate?: Date;
}

export class PledgeBulkPaymentVendorSummaryViewModel implements IPledgeBulkPaymentVendorSummaryViewModel {
    vendorName?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    totalRemitted?: number;
    footerText?: string | null;
    pledges?: VendorSummaryPledge[] | null;

    constructor(data?: IPledgeBulkPaymentVendorSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorName = _data["vendorName"] !== undefined ? _data["vendorName"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.totalRemitted = _data["totalRemitted"] !== undefined ? _data["totalRemitted"] : null as any;
            this.footerText = _data["footerText"] !== undefined ? _data["footerText"] : null as any;
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(VendorSummaryPledge.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
        }
    }

    static fromJS(data: any): PledgeBulkPaymentVendorSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentVendorSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorName"] = this.vendorName !== undefined ? this.vendorName : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["totalRemitted"] = this.totalRemitted !== undefined ? this.totalRemitted : null as any;
        data["footerText"] = this.footerText !== undefined ? this.footerText : null as any;
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): PledgeBulkPaymentVendorSummaryViewModel {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentVendorSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentVendorSummaryViewModel {
    vendorName?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    totalRemitted?: number;
    footerText?: string | null;
    pledges?: VendorSummaryPledge[] | null;
}

export class VendorSummaryPledge implements IVendorSummaryPledge {
    clientName?: string | null;
    clientLast4Ssn?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    payeeAddress1?: string | null;
    payeeAddress2?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZipCode?: string | null;
    accountNumber?: string | null;
    pledgingAgency?: string | null;
    fundType?: string | null;
    amount?: number;

    constructor(data?: IVendorSummaryPledge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.payeeAddress1 = _data["payeeAddress1"] !== undefined ? _data["payeeAddress1"] : null as any;
            this.payeeAddress2 = _data["payeeAddress2"] !== undefined ? _data["payeeAddress2"] : null as any;
            this.payeeCity = _data["payeeCity"] !== undefined ? _data["payeeCity"] : null as any;
            this.payeeState = _data["payeeState"] !== undefined ? _data["payeeState"] : null as any;
            this.payeeZipCode = _data["payeeZipCode"] !== undefined ? _data["payeeZipCode"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.pledgingAgency = _data["pledgingAgency"] !== undefined ? _data["pledgingAgency"] : null as any;
            this.fundType = _data["fundType"] !== undefined ? _data["fundType"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): VendorSummaryPledge {
        data = typeof data === 'object' ? data : {};
        let result = new VendorSummaryPledge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["payeeAddress1"] = this.payeeAddress1 !== undefined ? this.payeeAddress1 : null as any;
        data["payeeAddress2"] = this.payeeAddress2 !== undefined ? this.payeeAddress2 : null as any;
        data["payeeCity"] = this.payeeCity !== undefined ? this.payeeCity : null as any;
        data["payeeState"] = this.payeeState !== undefined ? this.payeeState : null as any;
        data["payeeZipCode"] = this.payeeZipCode !== undefined ? this.payeeZipCode : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["pledgingAgency"] = this.pledgingAgency !== undefined ? this.pledgingAgency : null as any;
        data["fundType"] = this.fundType !== undefined ? this.fundType : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }

    clone(): VendorSummaryPledge {
        const json = this.toJSON();
        let result = new VendorSummaryPledge();
        result.init(json);
        return result;
    }
}

export interface IVendorSummaryPledge {
    clientName?: string | null;
    clientLast4Ssn?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    payeeAddress1?: string | null;
    payeeAddress2?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZipCode?: string | null;
    accountNumber?: string | null;
    pledgingAgency?: string | null;
    fundType?: string | null;
    amount?: number;
}

export class BulkPaymentPdfParameters implements IBulkPaymentPdfParameters {
    pledgeIds?: string[] | null;

    constructor(data?: IBulkPaymentPdfParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pledgeIds"])) {
                this.pledgeIds = [] as any;
                for (let item of _data["pledgeIds"])
                    this.pledgeIds!.push(item);
            }
            else {
                this.pledgeIds = null as any;
            }
        }
    }

    static fromJS(data: any): BulkPaymentPdfParameters {
        data = typeof data === 'object' ? data : {};
        let result = new BulkPaymentPdfParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pledgeIds)) {
            data["pledgeIds"] = [];
            for (let item of this.pledgeIds)
                data["pledgeIds"].push(item);
        }
        return data;
    }

    clone(): BulkPaymentPdfParameters {
        const json = this.toJSON();
        let result = new BulkPaymentPdfParameters();
        result.init(json);
        return result;
    }
}

export interface IBulkPaymentPdfParameters {
    pledgeIds?: string[] | null;
}

export class PledgeBulkPaymentBatchPreview implements IPledgeBulkPaymentBatchPreview {
    batchId?: string;
    enteredDate?: Date;
    pledgeCount?: number;
    paidCount?: number;
    deletedPledgeCount?: number;

    constructor(data?: IPledgeBulkPaymentBatchPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.pledgeCount = _data["pledgeCount"] !== undefined ? _data["pledgeCount"] : null as any;
            this.paidCount = _data["paidCount"] !== undefined ? _data["paidCount"] : null as any;
            this.deletedPledgeCount = _data["deletedPledgeCount"] !== undefined ? _data["deletedPledgeCount"] : null as any;
        }
    }

    static fromJS(data: any): PledgeBulkPaymentBatchPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentBatchPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId !== undefined ? this.batchId : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["pledgeCount"] = this.pledgeCount !== undefined ? this.pledgeCount : null as any;
        data["paidCount"] = this.paidCount !== undefined ? this.paidCount : null as any;
        data["deletedPledgeCount"] = this.deletedPledgeCount !== undefined ? this.deletedPledgeCount : null as any;
        return data;
    }

    clone(): PledgeBulkPaymentBatchPreview {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentBatchPreview();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentBatchPreview {
    batchId?: string;
    enteredDate?: Date;
    pledgeCount?: number;
    paidCount?: number;
    deletedPledgeCount?: number;
}

export class Pledge extends BaseViewModel implements IPledge {
    clientId?: string;
    pledgeTypeId?: string;
    agencyId?: string;
    companyId?: string | null;
    agencyName?: string | null;
    companyName?: string | null;
    pledgedAmount?: number;
    status?: PledgeStatusType;
    clientCompanyAccountNumber?: string | null;
    clientMissingSsn?: boolean | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    paidDate?: Date | null;
    pledgedDate?: Date;
    federalPovertyLevelDisplay?: number | null;
    company?: Company | null;
    agency?: Agency | null;
    pledgeType?: PledgeType | null;
    isCrisisPledge?: boolean;
    assistanceType?: PledgeAssistanceType | null;
    leverageAmount?: number | null;
    checkMemo?: string | null;
    onetimeCompanyRecipient?: string | null;
    onetimeCompanyAddress1?: string | null;
    onetimeCompanyAddress2?: string | null;
    onetimeCompanyCity?: string | null;
    onetimeCompanyState?: string | null;
    onetimeCompanyZip?: string | null;
    agencyEfnCaseId?: string | null;
    assistanceApplicationId?: string | null;
    uwdaApprovedById?: string | null;
    uwdaApprovedByName?: string | null;
    clientUnionInfo?: string | null;
    specialCoding?: string | null;

    constructor(data?: IPledge) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.pledgedAmount = _data["pledgedAmount"] !== undefined ? _data["pledgedAmount"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.clientCompanyAccountNumber = _data["clientCompanyAccountNumber"] !== undefined ? _data["clientCompanyAccountNumber"] : null as any;
            this.clientMissingSsn = _data["clientMissingSsn"] !== undefined ? _data["clientMissingSsn"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.pledgedDate = _data["pledgedDate"] ? new Date(_data["pledgedDate"].toString()) : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : null as any;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType.fromJS(_data["pledgeType"]) : null as any;
            this.isCrisisPledge = _data["isCrisisPledge"] !== undefined ? _data["isCrisisPledge"] : null as any;
            this.assistanceType = _data["assistanceType"] !== undefined ? _data["assistanceType"] : null as any;
            this.leverageAmount = _data["leverageAmount"] !== undefined ? _data["leverageAmount"] : null as any;
            this.checkMemo = _data["checkMemo"] !== undefined ? _data["checkMemo"] : null as any;
            this.onetimeCompanyRecipient = _data["onetimeCompanyRecipient"] !== undefined ? _data["onetimeCompanyRecipient"] : null as any;
            this.onetimeCompanyAddress1 = _data["onetimeCompanyAddress1"] !== undefined ? _data["onetimeCompanyAddress1"] : null as any;
            this.onetimeCompanyAddress2 = _data["onetimeCompanyAddress2"] !== undefined ? _data["onetimeCompanyAddress2"] : null as any;
            this.onetimeCompanyCity = _data["onetimeCompanyCity"] !== undefined ? _data["onetimeCompanyCity"] : null as any;
            this.onetimeCompanyState = _data["onetimeCompanyState"] !== undefined ? _data["onetimeCompanyState"] : null as any;
            this.onetimeCompanyZip = _data["onetimeCompanyZip"] !== undefined ? _data["onetimeCompanyZip"] : null as any;
            this.agencyEfnCaseId = _data["agencyEfnCaseId"] !== undefined ? _data["agencyEfnCaseId"] : null as any;
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.uwdaApprovedById = _data["uwdaApprovedById"] !== undefined ? _data["uwdaApprovedById"] : null as any;
            this.uwdaApprovedByName = _data["uwdaApprovedByName"] !== undefined ? _data["uwdaApprovedByName"] : null as any;
            this.clientUnionInfo = _data["clientUnionInfo"] !== undefined ? _data["clientUnionInfo"] : null as any;
            this.specialCoding = _data["specialCoding"] !== undefined ? _data["specialCoding"] : null as any;
        }
    }

    static override fromJS(data: any): Pledge {
        data = typeof data === 'object' ? data : {};
        let result = new Pledge();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["pledgedAmount"] = this.pledgedAmount !== undefined ? this.pledgedAmount : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["clientCompanyAccountNumber"] = this.clientCompanyAccountNumber !== undefined ? this.clientCompanyAccountNumber : null as any;
        data["clientMissingSsn"] = this.clientMissingSsn !== undefined ? this.clientMissingSsn : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["pledgedDate"] = this.pledgedDate ? this.pledgedDate.toISOString() : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        data["isCrisisPledge"] = this.isCrisisPledge !== undefined ? this.isCrisisPledge : null as any;
        data["assistanceType"] = this.assistanceType !== undefined ? this.assistanceType : null as any;
        data["leverageAmount"] = this.leverageAmount !== undefined ? this.leverageAmount : null as any;
        data["checkMemo"] = this.checkMemo !== undefined ? this.checkMemo : null as any;
        data["onetimeCompanyRecipient"] = this.onetimeCompanyRecipient !== undefined ? this.onetimeCompanyRecipient : null as any;
        data["onetimeCompanyAddress1"] = this.onetimeCompanyAddress1 !== undefined ? this.onetimeCompanyAddress1 : null as any;
        data["onetimeCompanyAddress2"] = this.onetimeCompanyAddress2 !== undefined ? this.onetimeCompanyAddress2 : null as any;
        data["onetimeCompanyCity"] = this.onetimeCompanyCity !== undefined ? this.onetimeCompanyCity : null as any;
        data["onetimeCompanyState"] = this.onetimeCompanyState !== undefined ? this.onetimeCompanyState : null as any;
        data["onetimeCompanyZip"] = this.onetimeCompanyZip !== undefined ? this.onetimeCompanyZip : null as any;
        data["agencyEfnCaseId"] = this.agencyEfnCaseId !== undefined ? this.agencyEfnCaseId : null as any;
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["uwdaApprovedById"] = this.uwdaApprovedById !== undefined ? this.uwdaApprovedById : null as any;
        data["uwdaApprovedByName"] = this.uwdaApprovedByName !== undefined ? this.uwdaApprovedByName : null as any;
        data["clientUnionInfo"] = this.clientUnionInfo !== undefined ? this.clientUnionInfo : null as any;
        data["specialCoding"] = this.specialCoding !== undefined ? this.specialCoding : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Pledge {
        const json = this.toJSON();
        let result = new Pledge();
        result.init(json);
        return result;
    }
}

export interface IPledge extends IBaseViewModel {
    clientId?: string;
    pledgeTypeId?: string;
    agencyId?: string;
    companyId?: string | null;
    agencyName?: string | null;
    companyName?: string | null;
    pledgedAmount?: number;
    status?: PledgeStatusType;
    clientCompanyAccountNumber?: string | null;
    clientMissingSsn?: boolean | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientLast4Ssn?: string | null;
    paidDate?: Date | null;
    pledgedDate?: Date;
    federalPovertyLevelDisplay?: number | null;
    company?: Company | null;
    agency?: Agency | null;
    pledgeType?: PledgeType | null;
    isCrisisPledge?: boolean;
    assistanceType?: PledgeAssistanceType | null;
    leverageAmount?: number | null;
    checkMemo?: string | null;
    onetimeCompanyRecipient?: string | null;
    onetimeCompanyAddress1?: string | null;
    onetimeCompanyAddress2?: string | null;
    onetimeCompanyCity?: string | null;
    onetimeCompanyState?: string | null;
    onetimeCompanyZip?: string | null;
    agencyEfnCaseId?: string | null;
    assistanceApplicationId?: string | null;
    uwdaApprovedById?: string | null;
    uwdaApprovedByName?: string | null;
    clientUnionInfo?: string | null;
    specialCoding?: string | null;
}

export enum PledgeAssistanceType {
    Electric = "Electric",
    Gas = "Gas",
    RentEviction = "RentEviction",
    RentDeposit = "RentDeposit",
    Mortgage = "Mortgage",
    EmergencyHotel = "EmergencyHotel",
    Prescription = "Prescription",
    Water = "Water",
    Other = "Other",
}

export class PagedListOfPledge implements IPagedListOfPledge {
    items?: Pledge[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfPledge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Pledge.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfPledge {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfPledge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfPledge {
        const json = this.toJSON();
        let result = new PagedListOfPledge();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfPledge {
    items?: Pledge[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class ManualPendingPledgeParameters implements IManualPendingPledgeParameters {
    pledgeIds?: string[] | null;
    paidDate?: Date;

    constructor(data?: IManualPendingPledgeParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pledgeIds"])) {
                this.pledgeIds = [] as any;
                for (let item of _data["pledgeIds"])
                    this.pledgeIds!.push(item);
            }
            else {
                this.pledgeIds = null as any;
            }
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ManualPendingPledgeParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ManualPendingPledgeParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pledgeIds)) {
            data["pledgeIds"] = [];
            for (let item of this.pledgeIds)
                data["pledgeIds"].push(item);
        }
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        return data;
    }

    clone(): ManualPendingPledgeParameters {
        const json = this.toJSON();
        let result = new ManualPendingPledgeParameters();
        result.init(json);
        return result;
    }
}

export interface IManualPendingPledgeParameters {
    pledgeIds?: string[] | null;
    paidDate?: Date;
}

export class PledgeDisplayData implements IPledgeDisplayData {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    fund?: string | null;
    amount?: number;
    date?: Date;
    company?: string | null;
    status?: PledgeStatusType;
    pledgeId?: string;
    paidDate?: Date | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;

    constructor(data?: IPledgeDisplayData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.fund = _data["fund"] !== undefined ? _data["fund"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.specialCoding = _data["specialCoding"] !== undefined ? _data["specialCoding"] : null as any;
            this.enteredByName = _data["enteredByName"] !== undefined ? _data["enteredByName"] : null as any;
            this.enteredByEmail = _data["enteredByEmail"] !== undefined ? _data["enteredByEmail"] : null as any;
        }
    }

    static fromJS(data: any): PledgeDisplayData {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeDisplayData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["fund"] = this.fund !== undefined ? this.fund : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["specialCoding"] = this.specialCoding !== undefined ? this.specialCoding : null as any;
        data["enteredByName"] = this.enteredByName !== undefined ? this.enteredByName : null as any;
        data["enteredByEmail"] = this.enteredByEmail !== undefined ? this.enteredByEmail : null as any;
        return data;
    }

    clone(): PledgeDisplayData {
        const json = this.toJSON();
        let result = new PledgeDisplayData();
        result.init(json);
        return result;
    }
}

export interface IPledgeDisplayData {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    fund?: string | null;
    amount?: number;
    date?: Date;
    company?: string | null;
    status?: PledgeStatusType;
    pledgeId?: string;
    paidDate?: Date | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;
}

export class GetPledgesByBatchRequest implements IGetPledgesByBatchRequest {
    clientName?: string | null;
    pledgeTypeId?: string | null;
    companyId?: string | null;
    batchId?: string | null;

    constructor(data?: IGetPledgesByBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : null as any;
        }
    }

    static fromJS(data: any): GetPledgesByBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPledgesByBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["batchId"] = this.batchId !== undefined ? this.batchId : null as any;
        return data;
    }

    clone(): GetPledgesByBatchRequest {
        const json = this.toJSON();
        let result = new GetPledgesByBatchRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPledgesByBatchRequest {
    clientName?: string | null;
    pledgeTypeId?: string | null;
    companyId?: string | null;
    batchId?: string | null;
}

export class UserPledgeAccess implements IUserPledgeAccess {
    canEditPledge?: boolean;
    canChangeStatus?: boolean;
    canChangeAgency?: boolean;

    constructor(data?: IUserPledgeAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEditPledge = _data["canEditPledge"] !== undefined ? _data["canEditPledge"] : null as any;
            this.canChangeStatus = _data["canChangeStatus"] !== undefined ? _data["canChangeStatus"] : null as any;
            this.canChangeAgency = _data["canChangeAgency"] !== undefined ? _data["canChangeAgency"] : null as any;
        }
    }

    static fromJS(data: any): UserPledgeAccess {
        data = typeof data === 'object' ? data : {};
        let result = new UserPledgeAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEditPledge"] = this.canEditPledge !== undefined ? this.canEditPledge : null as any;
        data["canChangeStatus"] = this.canChangeStatus !== undefined ? this.canChangeStatus : null as any;
        data["canChangeAgency"] = this.canChangeAgency !== undefined ? this.canChangeAgency : null as any;
        return data;
    }

    clone(): UserPledgeAccess {
        const json = this.toJSON();
        let result = new UserPledgeAccess();
        result.init(json);
        return result;
    }
}

export interface IUserPledgeAccess {
    canEditPledge?: boolean;
    canChangeStatus?: boolean;
    canChangeAgency?: boolean;
}

export class PagedListOfPledgeDetailReport implements IPagedListOfPledgeDetailReport {
    items?: PledgeDetailReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfPledgeDetailReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PledgeDetailReport.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfPledgeDetailReport {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfPledgeDetailReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfPledgeDetailReport {
        const json = this.toJSON();
        let result = new PagedListOfPledgeDetailReport();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfPledgeDetailReport {
    items?: PledgeDetailReport[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class PledgeDetailReport extends BaseViewModel implements IPledgeDetailReport {
    agencyName?: string | null;
    status?: PledgeStatusType;
    pledgeNumber?: number | null;
    pledgeType?: string | null;
    assistanceType?: PledgeAssistanceType | null;
    leverageAmount?: number;
    companyName?: string | null;
    onetimeCompanyRecipient?: string | null;
    accountNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    pledgeDate?: Date | null;
    paidDate?: Date | null;
    pledgeAmount?: number;
    ttl?: number;
    approvedBy?: string | null;
    ledgerNumber?: string | null;
    isPrivate?: boolean;
    isUwda?: boolean;
    censusTract?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;

    constructor(data?: IPledgeDetailReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeNumber = _data["pledgeNumber"] !== undefined ? _data["pledgeNumber"] : null as any;
            this.pledgeType = _data["pledgeType"] !== undefined ? _data["pledgeType"] : null as any;
            this.assistanceType = _data["assistanceType"] !== undefined ? _data["assistanceType"] : null as any;
            this.leverageAmount = _data["leverageAmount"] !== undefined ? _data["leverageAmount"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.onetimeCompanyRecipient = _data["onetimeCompanyRecipient"] !== undefined ? _data["onetimeCompanyRecipient"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.pledgeDate = _data["pledgeDate"] ? new Date(_data["pledgeDate"].toString()) : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.pledgeAmount = _data["pledgeAmount"] !== undefined ? _data["pledgeAmount"] : null as any;
            this.ttl = _data["ttl"] !== undefined ? _data["ttl"] : null as any;
            this.approvedBy = _data["approvedBy"] !== undefined ? _data["approvedBy"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            this.isUwda = _data["isUwda"] !== undefined ? _data["isUwda"] : null as any;
            this.censusTract = _data["censusTract"] !== undefined ? _data["censusTract"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.specialCoding = _data["specialCoding"] !== undefined ? _data["specialCoding"] : null as any;
            this.enteredByName = _data["enteredByName"] !== undefined ? _data["enteredByName"] : null as any;
            this.enteredByEmail = _data["enteredByEmail"] !== undefined ? _data["enteredByEmail"] : null as any;
        }
    }

    static override fromJS(data: any): PledgeDetailReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeDetailReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeNumber"] = this.pledgeNumber !== undefined ? this.pledgeNumber : null as any;
        data["pledgeType"] = this.pledgeType !== undefined ? this.pledgeType : null as any;
        data["assistanceType"] = this.assistanceType !== undefined ? this.assistanceType : null as any;
        data["leverageAmount"] = this.leverageAmount !== undefined ? this.leverageAmount : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["onetimeCompanyRecipient"] = this.onetimeCompanyRecipient !== undefined ? this.onetimeCompanyRecipient : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleName"] = this.middleName !== undefined ? this.middleName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["pledgeDate"] = this.pledgeDate ? this.pledgeDate.toISOString() : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["pledgeAmount"] = this.pledgeAmount !== undefined ? this.pledgeAmount : null as any;
        data["ttl"] = this.ttl !== undefined ? this.ttl : null as any;
        data["approvedBy"] = this.approvedBy !== undefined ? this.approvedBy : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["isUwda"] = this.isUwda !== undefined ? this.isUwda : null as any;
        data["censusTract"] = this.censusTract !== undefined ? this.censusTract : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["specialCoding"] = this.specialCoding !== undefined ? this.specialCoding : null as any;
        data["enteredByName"] = this.enteredByName !== undefined ? this.enteredByName : null as any;
        data["enteredByEmail"] = this.enteredByEmail !== undefined ? this.enteredByEmail : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeDetailReport {
        const json = this.toJSON();
        let result = new PledgeDetailReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeDetailReport extends IBaseViewModel {
    agencyName?: string | null;
    status?: PledgeStatusType;
    pledgeNumber?: number | null;
    pledgeType?: string | null;
    assistanceType?: PledgeAssistanceType | null;
    leverageAmount?: number;
    companyName?: string | null;
    onetimeCompanyRecipient?: string | null;
    accountNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    pledgeDate?: Date | null;
    paidDate?: Date | null;
    pledgeAmount?: number;
    ttl?: number;
    approvedBy?: string | null;
    ledgerNumber?: string | null;
    isPrivate?: boolean;
    isUwda?: boolean;
    censusTract?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    specialCoding?: string | null;
    enteredByName?: string | null;
    enteredByEmail?: string | null;
}

export class PledgeSummaryReport extends BaseViewModel implements IPledgeSummaryReport {
    agencyName?: string | null;
    pledgeType?: string | null;
    helpedCount?: number;
    pledgeCount?: number;
    pledgeAmount?: number | null;
    sort?: number;
    ledgerNumber?: string | null;
    isPrivate?: boolean | null;

    constructor(data?: IPledgeSummaryReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.pledgeType = _data["pledgeType"] !== undefined ? _data["pledgeType"] : null as any;
            this.helpedCount = _data["helpedCount"] !== undefined ? _data["helpedCount"] : null as any;
            this.pledgeCount = _data["pledgeCount"] !== undefined ? _data["pledgeCount"] : null as any;
            this.pledgeAmount = _data["pledgeAmount"] !== undefined ? _data["pledgeAmount"] : null as any;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
        }
    }

    static override fromJS(data: any): PledgeSummaryReport {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeSummaryReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["pledgeType"] = this.pledgeType !== undefined ? this.pledgeType : null as any;
        data["helpedCount"] = this.helpedCount !== undefined ? this.helpedCount : null as any;
        data["pledgeCount"] = this.pledgeCount !== undefined ? this.pledgeCount : null as any;
        data["pledgeAmount"] = this.pledgeAmount !== undefined ? this.pledgeAmount : null as any;
        data["sort"] = this.sort !== undefined ? this.sort : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeSummaryReport {
        const json = this.toJSON();
        let result = new PledgeSummaryReport();
        result.init(json);
        return result;
    }
}

export interface IPledgeSummaryReport extends IBaseViewModel {
    agencyName?: string | null;
    pledgeType?: string | null;
    helpedCount?: number;
    pledgeCount?: number;
    pledgeAmount?: number | null;
    sort?: number;
    ledgerNumber?: string | null;
    isPrivate?: boolean | null;
}

export class PledgeTypeBalance implements IPledgeTypeBalance {
    pledgeTypeId?: string | null;
    balance?: number;
    yearlyPledgeTotal?: number;

    constructor(data?: IPledgeTypeBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : null as any;
            this.yearlyPledgeTotal = _data["yearlyPledgeTotal"] !== undefined ? _data["yearlyPledgeTotal"] : null as any;
        }
    }

    static fromJS(data: any): PledgeTypeBalance {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeTypeBalance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["balance"] = this.balance !== undefined ? this.balance : null as any;
        data["yearlyPledgeTotal"] = this.yearlyPledgeTotal !== undefined ? this.yearlyPledgeTotal : null as any;
        return data;
    }

    clone(): PledgeTypeBalance {
        const json = this.toJSON();
        let result = new PledgeTypeBalance();
        result.init(json);
        return result;
    }
}

export interface IPledgeTypeBalance {
    pledgeTypeId?: string | null;
    balance?: number;
    yearlyPledgeTotal?: number;
}

export class PledgeTypeBalanceParameters implements IPledgeTypeBalanceParameters {
    agencyId?: string;
    pledgeTypeIds?: string[] | null;

    constructor(data?: IPledgeTypeBalanceParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            if (Array.isArray(_data["pledgeTypeIds"])) {
                this.pledgeTypeIds = [] as any;
                for (let item of _data["pledgeTypeIds"])
                    this.pledgeTypeIds!.push(item);
            }
            else {
                this.pledgeTypeIds = null as any;
            }
        }
    }

    static fromJS(data: any): PledgeTypeBalanceParameters {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeTypeBalanceParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        if (Array.isArray(this.pledgeTypeIds)) {
            data["pledgeTypeIds"] = [];
            for (let item of this.pledgeTypeIds)
                data["pledgeTypeIds"].push(item);
        }
        return data;
    }

    clone(): PledgeTypeBalanceParameters {
        const json = this.toJSON();
        let result = new PledgeTypeBalanceParameters();
        result.init(json);
        return result;
    }
}

export interface IPledgeTypeBalanceParameters {
    agencyId?: string;
    pledgeTypeIds?: string[] | null;
}

export class PagedListOfPledgeType implements IPagedListOfPledgeType {
    items?: PledgeType[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfPledgeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PledgeType.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfPledgeType {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfPledgeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfPledgeType {
        const json = this.toJSON();
        let result = new PagedListOfPledgeType();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfPledgeType {
    items?: PledgeType[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class MassAssignPledgeTypeParams implements IMassAssignPledgeTypeParams {
    newPledgeType?: string;
    sourcePledgeType?: string;

    constructor(data?: IMassAssignPledgeTypeParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPledgeType = _data["newPledgeType"] !== undefined ? _data["newPledgeType"] : null as any;
            this.sourcePledgeType = _data["sourcePledgeType"] !== undefined ? _data["sourcePledgeType"] : null as any;
        }
    }

    static fromJS(data: any): MassAssignPledgeTypeParams {
        data = typeof data === 'object' ? data : {};
        let result = new MassAssignPledgeTypeParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPledgeType"] = this.newPledgeType !== undefined ? this.newPledgeType : null as any;
        data["sourcePledgeType"] = this.sourcePledgeType !== undefined ? this.sourcePledgeType : null as any;
        return data;
    }

    clone(): MassAssignPledgeTypeParams {
        const json = this.toJSON();
        let result = new MassAssignPledgeTypeParams();
        result.init(json);
        return result;
    }
}

export interface IMassAssignPledgeTypeParams {
    newPledgeType?: string;
    sourcePledgeType?: string;
}

export class PledgeTypeSelectionViewModel implements IPledgeTypeSelectionViewModel {
    id?: string | null;
    name?: string | null;

    constructor(data?: IPledgeTypeSelectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): PledgeTypeSelectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeTypeSelectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): PledgeTypeSelectionViewModel {
        const json = this.toJSON();
        let result = new PledgeTypeSelectionViewModel();
        result.init(json);
        return result;
    }
}

export interface IPledgeTypeSelectionViewModel {
    id?: string | null;
    name?: string | null;
}

export class ApplicationCountyEligibilityResult implements IApplicationCountyEligibilityResult {
    isCountyActive?: boolean;
    hasFundAdministrativePledgeType?: boolean;

    constructor(data?: IApplicationCountyEligibilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCountyActive = _data["isCountyActive"] !== undefined ? _data["isCountyActive"] : null as any;
            this.hasFundAdministrativePledgeType = _data["hasFundAdministrativePledgeType"] !== undefined ? _data["hasFundAdministrativePledgeType"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationCountyEligibilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCountyEligibilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCountyActive"] = this.isCountyActive !== undefined ? this.isCountyActive : null as any;
        data["hasFundAdministrativePledgeType"] = this.hasFundAdministrativePledgeType !== undefined ? this.hasFundAdministrativePledgeType : null as any;
        return data;
    }

    clone(): ApplicationCountyEligibilityResult {
        const json = this.toJSON();
        let result = new ApplicationCountyEligibilityResult();
        result.init(json);
        return result;
    }
}

export interface IApplicationCountyEligibilityResult {
    isCountyActive?: boolean;
    hasFundAdministrativePledgeType?: boolean;
}

export class DraftApplicationModel implements IDraftApplicationModel {
    eligibilityScreening?: DraftApplicationEligibilityScreening | null;
    standardQuestions?: DraftApplicationStandardQuestions | null;
    isTranslated?: boolean | null;
    applicationType?: AssistanceApplicationType;
    internalFormData?: InternalDraftFormData | null;

    constructor(data?: IDraftApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligibilityScreening = _data["eligibilityScreening"] ? DraftApplicationEligibilityScreening.fromJS(_data["eligibilityScreening"]) : null as any;
            this.standardQuestions = _data["standardQuestions"] ? DraftApplicationStandardQuestions.fromJS(_data["standardQuestions"]) : null as any;
            this.isTranslated = _data["isTranslated"] !== undefined ? _data["isTranslated"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.internalFormData = _data["internalFormData"] ? InternalDraftFormData.fromJS(_data["internalFormData"]) : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligibilityScreening"] = this.eligibilityScreening ? this.eligibilityScreening.toJSON() : null as any;
        data["standardQuestions"] = this.standardQuestions ? this.standardQuestions.toJSON() : null as any;
        data["isTranslated"] = this.isTranslated !== undefined ? this.isTranslated : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["internalFormData"] = this.internalFormData ? this.internalFormData.toJSON() : null as any;
        return data;
    }

    clone(): DraftApplicationModel {
        const json = this.toJSON();
        let result = new DraftApplicationModel();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationModel {
    eligibilityScreening?: DraftApplicationEligibilityScreening | null;
    standardQuestions?: DraftApplicationStandardQuestions | null;
    isTranslated?: boolean | null;
    applicationType?: AssistanceApplicationType;
    internalFormData?: InternalDraftFormData | null;
}

export class DraftApplicationEligibilityScreening implements IDraftApplicationEligibilityScreening {
    state?: string | null;
    county?: string | null;
    childrenCount?: number | null;
    adultCount?: number | null;
    householdIncome?: number;
    contactPreference?: string | null;
    email?: string | null;
    phone?: string | null;
    agreedToNotifications?: boolean | null;

    constructor(data?: IDraftApplicationEligibilityScreening) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.childrenCount = _data["childrenCount"] !== undefined ? _data["childrenCount"] : null as any;
            this.adultCount = _data["adultCount"] !== undefined ? _data["adultCount"] : null as any;
            this.householdIncome = _data["householdIncome"] !== undefined ? _data["householdIncome"] : null as any;
            this.contactPreference = _data["contactPreference"] !== undefined ? _data["contactPreference"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.agreedToNotifications = _data["agreedToNotifications"] !== undefined ? _data["agreedToNotifications"] : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationEligibilityScreening {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationEligibilityScreening();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["childrenCount"] = this.childrenCount !== undefined ? this.childrenCount : null as any;
        data["adultCount"] = this.adultCount !== undefined ? this.adultCount : null as any;
        data["householdIncome"] = this.householdIncome !== undefined ? this.householdIncome : null as any;
        data["contactPreference"] = this.contactPreference !== undefined ? this.contactPreference : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["agreedToNotifications"] = this.agreedToNotifications !== undefined ? this.agreedToNotifications : null as any;
        return data;
    }

    clone(): DraftApplicationEligibilityScreening {
        const json = this.toJSON();
        let result = new DraftApplicationEligibilityScreening();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationEligibilityScreening {
    state?: string | null;
    county?: string | null;
    childrenCount?: number | null;
    adultCount?: number | null;
    householdIncome?: number;
    contactPreference?: string | null;
    email?: string | null;
    phone?: string | null;
    agreedToNotifications?: boolean | null;
}

export class DraftApplicationStandardQuestions implements IDraftApplicationStandardQuestions {
    applicantInformation?: DraftApplicationApplicantInformation | null;
    householdInformation?: DraftApplicationHouseholdInformation | null;
    assistanceRequestDescription?: DraftApplicationAssistanceRequestDescription | null;
    circumstances?: string | null;

    constructor(data?: IDraftApplicationStandardQuestions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantInformation = _data["applicantInformation"] ? DraftApplicationApplicantInformation.fromJS(_data["applicantInformation"]) : null as any;
            this.householdInformation = _data["householdInformation"] ? DraftApplicationHouseholdInformation.fromJS(_data["householdInformation"]) : null as any;
            this.assistanceRequestDescription = _data["assistanceRequestDescription"] ? DraftApplicationAssistanceRequestDescription.fromJS(_data["assistanceRequestDescription"]) : null as any;
            this.circumstances = _data["circumstances"] !== undefined ? _data["circumstances"] : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationStandardQuestions {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationStandardQuestions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantInformation"] = this.applicantInformation ? this.applicantInformation.toJSON() : null as any;
        data["householdInformation"] = this.householdInformation ? this.householdInformation.toJSON() : null as any;
        data["assistanceRequestDescription"] = this.assistanceRequestDescription ? this.assistanceRequestDescription.toJSON() : null as any;
        data["circumstances"] = this.circumstances !== undefined ? this.circumstances : null as any;
        return data;
    }

    clone(): DraftApplicationStandardQuestions {
        const json = this.toJSON();
        let result = new DraftApplicationStandardQuestions();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationStandardQuestions {
    applicantInformation?: DraftApplicationApplicantInformation | null;
    householdInformation?: DraftApplicationHouseholdInformation | null;
    assistanceRequestDescription?: DraftApplicationAssistanceRequestDescription | null;
    circumstances?: string | null;
}

export class DraftApplicationApplicantInformation implements IDraftApplicationApplicantInformation {
    emailAddress?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    birthYear?: string | null;
    address?: string | null;
    zipCode?: string | null;
    state?: string | null;
    employmentStatus?: string | null;
    race?: string | null;
    otherRace?: string | null;
    gender?: string | null;
    totalMonthlyIncome?: number | null;
    totalHouseholdMonthlyIncome?: number | null;
    alternativePhone?: string | null;
    county?: string | null;
    isElderly?: boolean | null;
    isDisabled?: boolean | null;
    hasChildrenUnderFive?: boolean | null;
    isVeteran?: boolean | null;
    isHomeless?: boolean | null;
    membersAreElderly?: boolean | null;
    membersAreDisabled?: boolean | null;
    membersHaveChildrenUnderFive?: boolean | null;
    unionInfo?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number;

    constructor(data?: IDraftApplicationApplicantInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.race = _data["race"] !== undefined ? _data["race"] : null as any;
            this.otherRace = _data["otherRace"] !== undefined ? _data["otherRace"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.totalMonthlyIncome = _data["totalMonthlyIncome"] !== undefined ? _data["totalMonthlyIncome"] : null as any;
            this.totalHouseholdMonthlyIncome = _data["totalHouseholdMonthlyIncome"] !== undefined ? _data["totalHouseholdMonthlyIncome"] : null as any;
            this.alternativePhone = _data["alternativePhone"] !== undefined ? _data["alternativePhone"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.isElderly = _data["isElderly"] !== undefined ? _data["isElderly"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.hasChildrenUnderFive = _data["hasChildrenUnderFive"] !== undefined ? _data["hasChildrenUnderFive"] : null as any;
            this.isVeteran = _data["isVeteran"] !== undefined ? _data["isVeteran"] : null as any;
            this.isHomeless = _data["isHomeless"] !== undefined ? _data["isHomeless"] : null as any;
            this.membersAreElderly = _data["membersAreElderly"] !== undefined ? _data["membersAreElderly"] : null as any;
            this.membersAreDisabled = _data["membersAreDisabled"] !== undefined ? _data["membersAreDisabled"] : null as any;
            this.membersHaveChildrenUnderFive = _data["membersHaveChildrenUnderFive"] !== undefined ? _data["membersHaveChildrenUnderFive"] : null as any;
            this.unionInfo = _data["unionInfo"] !== undefined ? _data["unionInfo"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalAmountDue = _data["totalAmountDue"] !== undefined ? _data["totalAmountDue"] : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationApplicantInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationApplicantInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["race"] = this.race !== undefined ? this.race : null as any;
        data["otherRace"] = this.otherRace !== undefined ? this.otherRace : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["totalMonthlyIncome"] = this.totalMonthlyIncome !== undefined ? this.totalMonthlyIncome : null as any;
        data["totalHouseholdMonthlyIncome"] = this.totalHouseholdMonthlyIncome !== undefined ? this.totalHouseholdMonthlyIncome : null as any;
        data["alternativePhone"] = this.alternativePhone !== undefined ? this.alternativePhone : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["isElderly"] = this.isElderly !== undefined ? this.isElderly : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["hasChildrenUnderFive"] = this.hasChildrenUnderFive !== undefined ? this.hasChildrenUnderFive : null as any;
        data["isVeteran"] = this.isVeteran !== undefined ? this.isVeteran : null as any;
        data["isHomeless"] = this.isHomeless !== undefined ? this.isHomeless : null as any;
        data["membersAreElderly"] = this.membersAreElderly !== undefined ? this.membersAreElderly : null as any;
        data["membersAreDisabled"] = this.membersAreDisabled !== undefined ? this.membersAreDisabled : null as any;
        data["membersHaveChildrenUnderFive"] = this.membersHaveChildrenUnderFive !== undefined ? this.membersHaveChildrenUnderFive : null as any;
        data["unionInfo"] = this.unionInfo !== undefined ? this.unionInfo : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalAmountDue"] = this.totalAmountDue !== undefined ? this.totalAmountDue : null as any;
        return data;
    }

    clone(): DraftApplicationApplicantInformation {
        const json = this.toJSON();
        let result = new DraftApplicationApplicantInformation();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationApplicantInformation {
    emailAddress?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    birthYear?: string | null;
    address?: string | null;
    zipCode?: string | null;
    state?: string | null;
    employmentStatus?: string | null;
    race?: string | null;
    otherRace?: string | null;
    gender?: string | null;
    totalMonthlyIncome?: number | null;
    totalHouseholdMonthlyIncome?: number | null;
    alternativePhone?: string | null;
    county?: string | null;
    isElderly?: boolean | null;
    isDisabled?: boolean | null;
    hasChildrenUnderFive?: boolean | null;
    isVeteran?: boolean | null;
    isHomeless?: boolean | null;
    membersAreElderly?: boolean | null;
    membersAreDisabled?: boolean | null;
    membersHaveChildrenUnderFive?: boolean | null;
    unionInfo?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number;
}

export class DraftApplicationHouseholdInformation implements IDraftApplicationHouseholdInformation {
    adults?: DraftApplicationAdult[] | null;
    minors?: DraftApplicationMinor[] | null;

    constructor(data?: IDraftApplicationHouseholdInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["adults"])) {
                this.adults = [] as any;
                for (let item of _data["adults"])
                    this.adults!.push(DraftApplicationAdult.fromJS(item));
            }
            else {
                this.adults = null as any;
            }
            if (Array.isArray(_data["minors"])) {
                this.minors = [] as any;
                for (let item of _data["minors"])
                    this.minors!.push(DraftApplicationMinor.fromJS(item));
            }
            else {
                this.minors = null as any;
            }
        }
    }

    static fromJS(data: any): DraftApplicationHouseholdInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationHouseholdInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adults)) {
            data["adults"] = [];
            for (let item of this.adults)
                data["adults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.minors)) {
            data["minors"] = [];
            for (let item of this.minors)
                data["minors"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): DraftApplicationHouseholdInformation {
        const json = this.toJSON();
        let result = new DraftApplicationHouseholdInformation();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationHouseholdInformation {
    adults?: DraftApplicationAdult[] | null;
    minors?: DraftApplicationMinor[] | null;
}

export class DraftApplicationAdult implements IDraftApplicationAdult {
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: string | null;
    employmentStatus?: string | null;
    totalMonthlyIncome?: number | null;

    constructor(data?: IDraftApplicationAdult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.totalMonthlyIncome = _data["totalMonthlyIncome"] !== undefined ? _data["totalMonthlyIncome"] : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationAdult {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationAdult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["totalMonthlyIncome"] = this.totalMonthlyIncome !== undefined ? this.totalMonthlyIncome : null as any;
        return data;
    }

    clone(): DraftApplicationAdult {
        const json = this.toJSON();
        let result = new DraftApplicationAdult();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationAdult {
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: string | null;
    employmentStatus?: string | null;
    totalMonthlyIncome?: number | null;
}

export class DraftApplicationMinor implements IDraftApplicationMinor {
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: string | null;

    constructor(data?: IDraftApplicationMinor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationMinor {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationMinor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        return data;
    }

    clone(): DraftApplicationMinor {
        const json = this.toJSON();
        let result = new DraftApplicationMinor();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationMinor {
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: string | null;
}

export class DraftApplicationAssistanceRequestDescription implements IDraftApplicationAssistanceRequestDescription {
    uhonsRent?: boolean | null;
    uhonsElectric?: boolean | null;
    uhonsGasHeat?: boolean | null;
    uhonsWater?: boolean | null;
    uhonsSewer?: boolean | null;
    uhonsChildcareExpenses?: boolean | null;
    uhonsTransportationRideShare?: boolean | null;
    uhonsCarRepair?: boolean | null;
    evictionNotification?: boolean | null;
    stlWaterWater?: boolean | null;

    constructor(data?: IDraftApplicationAssistanceRequestDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uhonsRent = _data["uhonsRent"] !== undefined ? _data["uhonsRent"] : null as any;
            this.uhonsElectric = _data["uhonsElectric"] !== undefined ? _data["uhonsElectric"] : null as any;
            this.uhonsGasHeat = _data["uhonsGasHeat"] !== undefined ? _data["uhonsGasHeat"] : null as any;
            this.uhonsWater = _data["uhonsWater"] !== undefined ? _data["uhonsWater"] : null as any;
            this.uhonsSewer = _data["uhonsSewer"] !== undefined ? _data["uhonsSewer"] : null as any;
            this.uhonsChildcareExpenses = _data["uhonsChildcareExpenses"] !== undefined ? _data["uhonsChildcareExpenses"] : null as any;
            this.uhonsTransportationRideShare = _data["uhonsTransportationRideShare"] !== undefined ? _data["uhonsTransportationRideShare"] : null as any;
            this.uhonsCarRepair = _data["uhonsCarRepair"] !== undefined ? _data["uhonsCarRepair"] : null as any;
            this.evictionNotification = _data["evictionNotification"] !== undefined ? _data["evictionNotification"] : null as any;
            this.stlWaterWater = _data["stlWaterWater"] !== undefined ? _data["stlWaterWater"] : null as any;
        }
    }

    static fromJS(data: any): DraftApplicationAssistanceRequestDescription {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationAssistanceRequestDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uhonsRent"] = this.uhonsRent !== undefined ? this.uhonsRent : null as any;
        data["uhonsElectric"] = this.uhonsElectric !== undefined ? this.uhonsElectric : null as any;
        data["uhonsGasHeat"] = this.uhonsGasHeat !== undefined ? this.uhonsGasHeat : null as any;
        data["uhonsWater"] = this.uhonsWater !== undefined ? this.uhonsWater : null as any;
        data["uhonsSewer"] = this.uhonsSewer !== undefined ? this.uhonsSewer : null as any;
        data["uhonsChildcareExpenses"] = this.uhonsChildcareExpenses !== undefined ? this.uhonsChildcareExpenses : null as any;
        data["uhonsTransportationRideShare"] = this.uhonsTransportationRideShare !== undefined ? this.uhonsTransportationRideShare : null as any;
        data["uhonsCarRepair"] = this.uhonsCarRepair !== undefined ? this.uhonsCarRepair : null as any;
        data["evictionNotification"] = this.evictionNotification !== undefined ? this.evictionNotification : null as any;
        data["stlWaterWater"] = this.stlWaterWater !== undefined ? this.stlWaterWater : null as any;
        return data;
    }

    clone(): DraftApplicationAssistanceRequestDescription {
        const json = this.toJSON();
        let result = new DraftApplicationAssistanceRequestDescription();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationAssistanceRequestDescription {
    uhonsRent?: boolean | null;
    uhonsElectric?: boolean | null;
    uhonsGasHeat?: boolean | null;
    uhonsWater?: boolean | null;
    uhonsSewer?: boolean | null;
    uhonsChildcareExpenses?: boolean | null;
    uhonsTransportationRideShare?: boolean | null;
    uhonsCarRepair?: boolean | null;
    evictionNotification?: boolean | null;
    stlWaterWater?: boolean | null;
}

export class GerDraftApplicationResponse implements IGerDraftApplicationResponse {
    draftApplication?: DraftApplication | null;
    isExpired?: boolean;

    constructor(data?: IGerDraftApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftApplication = _data["draftApplication"] ? DraftApplication.fromJS(_data["draftApplication"]) : null as any;
            this.isExpired = _data["isExpired"] !== undefined ? _data["isExpired"] : null as any;
        }
    }

    static fromJS(data: any): GerDraftApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GerDraftApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftApplication"] = this.draftApplication ? this.draftApplication.toJSON() : null as any;
        data["isExpired"] = this.isExpired !== undefined ? this.isExpired : null as any;
        return data;
    }

    clone(): GerDraftApplicationResponse {
        const json = this.toJSON();
        let result = new GerDraftApplicationResponse();
        result.init(json);
        return result;
    }
}

export interface IGerDraftApplicationResponse {
    draftApplication?: DraftApplication | null;
    isExpired?: boolean;
}

export class BaseEntity implements IBaseEntity {
    id?: string;
    enteredBy?: string | null;
    enteredDate?: Date;
    modifiedBy?: string | null;
    modifiedDate?: Date | null;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.enteredBy = _data["enteredBy"] !== undefined ? _data["enteredBy"] : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.modifiedBy = _data["modifiedBy"] !== undefined ? _data["modifiedBy"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["enteredBy"] = this.enteredBy !== undefined ? this.enteredBy : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["modifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        return data;
    }

    clone(): BaseEntity {
        const json = this.toJSON();
        let result = new BaseEntity();
        result.init(json);
        return result;
    }
}

export interface IBaseEntity {
    id?: string;
    enteredBy?: string | null;
    enteredDate?: Date;
    modifiedBy?: string | null;
    modifiedDate?: Date | null;
}

export class DraftApplication extends BaseEntity implements IDraftApplication {
    accessCode?: string | null;
    application?: DraftApplicationModel | null;
    type?: DraftApplicationType;
    clientId?: string | null;
    pledgeTypeId?: string | null;
    userId?: string | null;
    applicationType?: AssistanceApplicationType | null;
    client?: Client2 | null;
    pledgeType?: PledgeType2 | null;
    user?: User2 | null;
    files?: DraftApplicationFileEntity[] | null;

    constructor(data?: IDraftApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accessCode = _data["accessCode"] !== undefined ? _data["accessCode"] : null as any;
            this.application = _data["application"] ? DraftApplicationModel.fromJS(_data["application"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : null as any;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DraftApplicationFileEntity.fromJS(item));
            }
            else {
                this.files = null as any;
            }
        }
    }

    static override fromJS(data: any): DraftApplication {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessCode"] = this.accessCode !== undefined ? this.accessCode : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DraftApplication {
        const json = this.toJSON();
        let result = new DraftApplication();
        result.init(json);
        return result;
    }
}

export interface IDraftApplication extends IBaseEntity {
    accessCode?: string | null;
    application?: DraftApplicationModel | null;
    type?: DraftApplicationType;
    clientId?: string | null;
    pledgeTypeId?: string | null;
    userId?: string | null;
    applicationType?: AssistanceApplicationType | null;
    client?: Client2 | null;
    pledgeType?: PledgeType2 | null;
    user?: User2 | null;
    files?: DraftApplicationFileEntity[] | null;
}

export enum DraftApplicationType {
    Public = "Public",
    Internal = "Internal",
}

export class Client2 extends BaseEntity implements IClient2 {
    ssn?: string | null;
    ssnhash?: string | null;
    last4Ssn?: string | null;
    prefix?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleInitial?: string | null;
    suffix?: string | null;
    race?: string | null;
    otherRace?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    phoneExt?: string | null;
    birthYear?: number | null;
    email?: string | null;
    gender?: string | null;
    individualMonthlyIncome?: number | null;
    houseHoldIncome?: number | null;
    houseHoldSize?: number | null;
    employmentStatus?: string | null;
    isElderly?: boolean;
    isDisabled?: boolean;
    hasChildrenUnderFive?: boolean;
    isVeteran?: boolean;
    isHomeless?: boolean;
    isVerifiedPublicHousing?: boolean;
    membersAreElderly?: boolean;
    membersAreDisabled?: boolean;
    membersHaveChildrenUnderFive?: boolean;
    phoneAlt?: string | null;
    createdByAgencyId?: string | null;
    federalPovertyLevelDisplay?: number | null;
    unionInfo?: string | null;
    lastVerifiedDate?: Date | null;
    lastVerifiedBy?: string | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
    efnCases?: EfnCase2[] | null;
    efsAssistances?: EfsAssistance[] | null;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
    pledges?: Pledge2[] | null;

    constructor(data?: IClient2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.suffix = _data["suffix"] !== undefined ? _data["suffix"] : null as any;
            this.race = _data["race"] !== undefined ? _data["race"] : null as any;
            this.otherRace = _data["otherRace"] !== undefined ? _data["otherRace"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.phoneExt = _data["phoneExt"] !== undefined ? _data["phoneExt"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.individualMonthlyIncome = _data["individualMonthlyIncome"] !== undefined ? _data["individualMonthlyIncome"] : null as any;
            this.houseHoldIncome = _data["houseHoldIncome"] !== undefined ? _data["houseHoldIncome"] : null as any;
            this.houseHoldSize = _data["houseHoldSize"] !== undefined ? _data["houseHoldSize"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.isElderly = _data["isElderly"] !== undefined ? _data["isElderly"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.hasChildrenUnderFive = _data["hasChildrenUnderFive"] !== undefined ? _data["hasChildrenUnderFive"] : null as any;
            this.isVeteran = _data["isVeteran"] !== undefined ? _data["isVeteran"] : null as any;
            this.isHomeless = _data["isHomeless"] !== undefined ? _data["isHomeless"] : null as any;
            this.isVerifiedPublicHousing = _data["isVerifiedPublicHousing"] !== undefined ? _data["isVerifiedPublicHousing"] : null as any;
            this.membersAreElderly = _data["membersAreElderly"] !== undefined ? _data["membersAreElderly"] : null as any;
            this.membersAreDisabled = _data["membersAreDisabled"] !== undefined ? _data["membersAreDisabled"] : null as any;
            this.membersHaveChildrenUnderFive = _data["membersHaveChildrenUnderFive"] !== undefined ? _data["membersHaveChildrenUnderFive"] : null as any;
            this.phoneAlt = _data["phoneAlt"] !== undefined ? _data["phoneAlt"] : null as any;
            this.createdByAgencyId = _data["createdByAgencyId"] !== undefined ? _data["createdByAgencyId"] : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.unionInfo = _data["unionInfo"] !== undefined ? _data["unionInfo"] : null as any;
            this.lastVerifiedDate = _data["lastVerifiedDate"] ? new Date(_data["lastVerifiedDate"].toString()) : null as any;
            this.lastVerifiedBy = _data["lastVerifiedBy"] !== undefined ? _data["lastVerifiedBy"] : null as any;
            if (Array.isArray(_data["assistanceApplications"])) {
                this.assistanceApplications = [] as any;
                for (let item of _data["assistanceApplications"])
                    this.assistanceApplications!.push(AssistanceApplicationEntity.fromJS(item));
            }
            else {
                this.assistanceApplications = null as any;
            }
            if (Array.isArray(_data["efnCases"])) {
                this.efnCases = [] as any;
                for (let item of _data["efnCases"])
                    this.efnCases!.push(EfnCase2.fromJS(item));
            }
            else {
                this.efnCases = null as any;
            }
            if (Array.isArray(_data["efsAssistances"])) {
                this.efsAssistances = [] as any;
                for (let item of _data["efsAssistances"])
                    this.efsAssistances!.push(EfsAssistance.fromJS(item));
            }
            else {
                this.efsAssistances = null as any;
            }
            if (Array.isArray(_data["keepingCurrentApplications"])) {
                this.keepingCurrentApplications = [] as any;
                for (let item of _data["keepingCurrentApplications"])
                    this.keepingCurrentApplications!.push(KeepingCurrentApplication.fromJS(item));
            }
            else {
                this.keepingCurrentApplications = null as any;
            }
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(Pledge2.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
        }
    }

    static override fromJS(data: any): Client2 {
        data = typeof data === 'object' ? data : {};
        let result = new Client2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["suffix"] = this.suffix !== undefined ? this.suffix : null as any;
        data["race"] = this.race !== undefined ? this.race : null as any;
        data["otherRace"] = this.otherRace !== undefined ? this.otherRace : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["phoneExt"] = this.phoneExt !== undefined ? this.phoneExt : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["individualMonthlyIncome"] = this.individualMonthlyIncome !== undefined ? this.individualMonthlyIncome : null as any;
        data["houseHoldIncome"] = this.houseHoldIncome !== undefined ? this.houseHoldIncome : null as any;
        data["houseHoldSize"] = this.houseHoldSize !== undefined ? this.houseHoldSize : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["isElderly"] = this.isElderly !== undefined ? this.isElderly : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["hasChildrenUnderFive"] = this.hasChildrenUnderFive !== undefined ? this.hasChildrenUnderFive : null as any;
        data["isVeteran"] = this.isVeteran !== undefined ? this.isVeteran : null as any;
        data["isHomeless"] = this.isHomeless !== undefined ? this.isHomeless : null as any;
        data["isVerifiedPublicHousing"] = this.isVerifiedPublicHousing !== undefined ? this.isVerifiedPublicHousing : null as any;
        data["membersAreElderly"] = this.membersAreElderly !== undefined ? this.membersAreElderly : null as any;
        data["membersAreDisabled"] = this.membersAreDisabled !== undefined ? this.membersAreDisabled : null as any;
        data["membersHaveChildrenUnderFive"] = this.membersHaveChildrenUnderFive !== undefined ? this.membersHaveChildrenUnderFive : null as any;
        data["phoneAlt"] = this.phoneAlt !== undefined ? this.phoneAlt : null as any;
        data["createdByAgencyId"] = this.createdByAgencyId !== undefined ? this.createdByAgencyId : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["unionInfo"] = this.unionInfo !== undefined ? this.unionInfo : null as any;
        data["lastVerifiedDate"] = this.lastVerifiedDate ? this.lastVerifiedDate.toISOString() : null as any;
        data["lastVerifiedBy"] = this.lastVerifiedBy !== undefined ? this.lastVerifiedBy : null as any;
        if (Array.isArray(this.assistanceApplications)) {
            data["assistanceApplications"] = [];
            for (let item of this.assistanceApplications)
                data["assistanceApplications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCases)) {
            data["efnCases"] = [];
            for (let item of this.efnCases)
                data["efnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efsAssistances)) {
            data["efsAssistances"] = [];
            for (let item of this.efsAssistances)
                data["efsAssistances"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentApplications)) {
            data["keepingCurrentApplications"] = [];
            for (let item of this.keepingCurrentApplications)
                data["keepingCurrentApplications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Client2 {
        const json = this.toJSON();
        let result = new Client2();
        result.init(json);
        return result;
    }
}

export interface IClient2 extends IBaseEntity {
    ssn?: string | null;
    ssnhash?: string | null;
    last4Ssn?: string | null;
    prefix?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleInitial?: string | null;
    suffix?: string | null;
    race?: string | null;
    otherRace?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    phoneExt?: string | null;
    birthYear?: number | null;
    email?: string | null;
    gender?: string | null;
    individualMonthlyIncome?: number | null;
    houseHoldIncome?: number | null;
    houseHoldSize?: number | null;
    employmentStatus?: string | null;
    isElderly?: boolean;
    isDisabled?: boolean;
    hasChildrenUnderFive?: boolean;
    isVeteran?: boolean;
    isHomeless?: boolean;
    isVerifiedPublicHousing?: boolean;
    membersAreElderly?: boolean;
    membersAreDisabled?: boolean;
    membersHaveChildrenUnderFive?: boolean;
    phoneAlt?: string | null;
    createdByAgencyId?: string | null;
    federalPovertyLevelDisplay?: number | null;
    unionInfo?: string | null;
    lastVerifiedDate?: Date | null;
    lastVerifiedBy?: string | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
    efnCases?: EfnCase2[] | null;
    efsAssistances?: EfsAssistance[] | null;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
    pledges?: Pledge2[] | null;
}

export class AssistanceApplicationEntity extends BaseEntity implements IAssistanceApplicationEntity {
    clientId?: string;
    fundTypeId?: string | null;
    assignedAgencyId?: string | null;
    applicationType?: AssistanceApplicationType;
    createdByUserId?: string | null;
    companyId?: string | null;
    summary?: string | null;
    description?: string | null;
    hasTranslation?: boolean;
    translatedDescription?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    totalNeed?: number | null;
    deadline?: Date | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: AssistanceApplicationStatus;
    denialReason?: AssistanceApplicationDenialReason | null;
    otherDenialReason?: string | null;
    auditState?: AssistanceApplicationStateAuditType;
    fundPledgeTypeId?: string | null;
    client?: Client2 | null;
    fundType?: FundType2 | null;
    pledgeType?: PledgeType2 | null;
    assignedAgency?: Agency2 | null;
    createdByUser?: User2 | null;
    company?: Company2 | null;
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    applicantAddress?: string | null;
    applicantZipCode?: string | null;
    applicantCity?: string | null;
    applicantState?: string | null;
    applicantCounty?: string | null;
    applicantPhone?: string | null;
    applicantEmail?: string | null;
    applicantIndividualMonthlyIncome?: number | null;
    applicantHouseHoldIncome?: number | null;
    applicantEmploymentStatus?: string | null;
    censusTract?: string | null;
    agreedToNotifications?: boolean | null;
    familyEducatedAboutResources?: boolean | null;
    assistanceApplicationAreasOfNeeds?: AssistanceApplicationAreasOfNeedEntity | null;
    adults?: AssistanceApplicationAdultEntity[] | null;
    minors?: AssistanceApplicationMinorEntity[] | null;
    comments?: AssistanceApplicationCommentEntity[] | null;
    files?: AssistanceApplicationFileEntity[] | null;
    companies?: AssistanceApplicationCompanyEntity[] | null;
    stateAudits?: AssistanceApplicationStateAuditEntity[] | null;
    informationRequests?: AssistanceApplicationInformationRequestEntity[] | null;
    stormApplication?: StormApplication | null;

    constructor(data?: IAssistanceApplicationEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.fundTypeId = _data["fundTypeId"] !== undefined ? _data["fundTypeId"] : null as any;
            this.assignedAgencyId = _data["assignedAgencyId"] !== undefined ? _data["assignedAgencyId"] : null as any;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : null as any;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.hasTranslation = _data["hasTranslation"] !== undefined ? _data["hasTranslation"] : null as any;
            this.translatedDescription = _data["translatedDescription"] !== undefined ? _data["translatedDescription"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : null as any;
            this.fundedDate = _data["fundedDate"] ? new Date(_data["fundedDate"].toString()) : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.otherDenialReason = _data["otherDenialReason"] !== undefined ? _data["otherDenialReason"] : null as any;
            this.auditState = _data["auditState"] !== undefined ? _data["auditState"] : null as any;
            this.fundPledgeTypeId = _data["fundPledgeTypeId"] !== undefined ? _data["fundPledgeTypeId"] : null as any;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : null as any;
            this.fundType = _data["fundType"] ? FundType2.fromJS(_data["fundType"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
            this.assignedAgency = _data["assignedAgency"] ? Agency2.fromJS(_data["assignedAgency"]) : null as any;
            this.createdByUser = _data["createdByUser"] ? User2.fromJS(_data["createdByUser"]) : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            this.applicantFirstName = _data["applicantFirstName"] !== undefined ? _data["applicantFirstName"] : null as any;
            this.applicantLastName = _data["applicantLastName"] !== undefined ? _data["applicantLastName"] : null as any;
            this.applicantAddress = _data["applicantAddress"] !== undefined ? _data["applicantAddress"] : null as any;
            this.applicantZipCode = _data["applicantZipCode"] !== undefined ? _data["applicantZipCode"] : null as any;
            this.applicantCity = _data["applicantCity"] !== undefined ? _data["applicantCity"] : null as any;
            this.applicantState = _data["applicantState"] !== undefined ? _data["applicantState"] : null as any;
            this.applicantCounty = _data["applicantCounty"] !== undefined ? _data["applicantCounty"] : null as any;
            this.applicantPhone = _data["applicantPhone"] !== undefined ? _data["applicantPhone"] : null as any;
            this.applicantEmail = _data["applicantEmail"] !== undefined ? _data["applicantEmail"] : null as any;
            this.applicantIndividualMonthlyIncome = _data["applicantIndividualMonthlyIncome"] !== undefined ? _data["applicantIndividualMonthlyIncome"] : null as any;
            this.applicantHouseHoldIncome = _data["applicantHouseHoldIncome"] !== undefined ? _data["applicantHouseHoldIncome"] : null as any;
            this.applicantEmploymentStatus = _data["applicantEmploymentStatus"] !== undefined ? _data["applicantEmploymentStatus"] : null as any;
            this.censusTract = _data["censusTract"] !== undefined ? _data["censusTract"] : null as any;
            this.agreedToNotifications = _data["agreedToNotifications"] !== undefined ? _data["agreedToNotifications"] : null as any;
            this.familyEducatedAboutResources = _data["familyEducatedAboutResources"] !== undefined ? _data["familyEducatedAboutResources"] : null as any;
            this.assistanceApplicationAreasOfNeeds = _data["assistanceApplicationAreasOfNeeds"] ? AssistanceApplicationAreasOfNeedEntity.fromJS(_data["assistanceApplicationAreasOfNeeds"]) : null as any;
            if (Array.isArray(_data["adults"])) {
                this.adults = [] as any;
                for (let item of _data["adults"])
                    this.adults!.push(AssistanceApplicationAdultEntity.fromJS(item));
            }
            else {
                this.adults = null as any;
            }
            if (Array.isArray(_data["minors"])) {
                this.minors = [] as any;
                for (let item of _data["minors"])
                    this.minors!.push(AssistanceApplicationMinorEntity.fromJS(item));
            }
            else {
                this.minors = null as any;
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(AssistanceApplicationCommentEntity.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AssistanceApplicationFileEntity.fromJS(item));
            }
            else {
                this.files = null as any;
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(AssistanceApplicationCompanyEntity.fromJS(item));
            }
            else {
                this.companies = null as any;
            }
            if (Array.isArray(_data["stateAudits"])) {
                this.stateAudits = [] as any;
                for (let item of _data["stateAudits"])
                    this.stateAudits!.push(AssistanceApplicationStateAuditEntity.fromJS(item));
            }
            else {
                this.stateAudits = null as any;
            }
            if (Array.isArray(_data["informationRequests"])) {
                this.informationRequests = [] as any;
                for (let item of _data["informationRequests"])
                    this.informationRequests!.push(AssistanceApplicationInformationRequestEntity.fromJS(item));
            }
            else {
                this.informationRequests = null as any;
            }
            this.stormApplication = _data["stormApplication"] ? StormApplication.fromJS(_data["stormApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["fundTypeId"] = this.fundTypeId !== undefined ? this.fundTypeId : null as any;
        data["assignedAgencyId"] = this.assignedAgencyId !== undefined ? this.assignedAgencyId : null as any;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : null as any;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["hasTranslation"] = this.hasTranslation !== undefined ? this.hasTranslation : null as any;
        data["translatedDescription"] = this.translatedDescription !== undefined ? this.translatedDescription : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : null as any;
        data["fundedDate"] = this.fundedDate ? this.fundedDate.toISOString() : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["otherDenialReason"] = this.otherDenialReason !== undefined ? this.otherDenialReason : null as any;
        data["auditState"] = this.auditState !== undefined ? this.auditState : null as any;
        data["fundPledgeTypeId"] = this.fundPledgeTypeId !== undefined ? this.fundPledgeTypeId : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["fundType"] = this.fundType ? this.fundType.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        data["assignedAgency"] = this.assignedAgency ? this.assignedAgency.toJSON() : null as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["applicantFirstName"] = this.applicantFirstName !== undefined ? this.applicantFirstName : null as any;
        data["applicantLastName"] = this.applicantLastName !== undefined ? this.applicantLastName : null as any;
        data["applicantAddress"] = this.applicantAddress !== undefined ? this.applicantAddress : null as any;
        data["applicantZipCode"] = this.applicantZipCode !== undefined ? this.applicantZipCode : null as any;
        data["applicantCity"] = this.applicantCity !== undefined ? this.applicantCity : null as any;
        data["applicantState"] = this.applicantState !== undefined ? this.applicantState : null as any;
        data["applicantCounty"] = this.applicantCounty !== undefined ? this.applicantCounty : null as any;
        data["applicantPhone"] = this.applicantPhone !== undefined ? this.applicantPhone : null as any;
        data["applicantEmail"] = this.applicantEmail !== undefined ? this.applicantEmail : null as any;
        data["applicantIndividualMonthlyIncome"] = this.applicantIndividualMonthlyIncome !== undefined ? this.applicantIndividualMonthlyIncome : null as any;
        data["applicantHouseHoldIncome"] = this.applicantHouseHoldIncome !== undefined ? this.applicantHouseHoldIncome : null as any;
        data["applicantEmploymentStatus"] = this.applicantEmploymentStatus !== undefined ? this.applicantEmploymentStatus : null as any;
        data["censusTract"] = this.censusTract !== undefined ? this.censusTract : null as any;
        data["agreedToNotifications"] = this.agreedToNotifications !== undefined ? this.agreedToNotifications : null as any;
        data["familyEducatedAboutResources"] = this.familyEducatedAboutResources !== undefined ? this.familyEducatedAboutResources : null as any;
        data["assistanceApplicationAreasOfNeeds"] = this.assistanceApplicationAreasOfNeeds ? this.assistanceApplicationAreasOfNeeds.toJSON() : null as any;
        if (Array.isArray(this.adults)) {
            data["adults"] = [];
            for (let item of this.adults)
                data["adults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.minors)) {
            data["minors"] = [];
            for (let item of this.minors)
                data["minors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.stateAudits)) {
            data["stateAudits"] = [];
            for (let item of this.stateAudits)
                data["stateAudits"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.informationRequests)) {
            data["informationRequests"] = [];
            for (let item of this.informationRequests)
                data["informationRequests"].push(item ? item.toJSON() : null as any);
        }
        data["stormApplication"] = this.stormApplication ? this.stormApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationEntity extends IBaseEntity {
    clientId?: string;
    fundTypeId?: string | null;
    assignedAgencyId?: string | null;
    applicationType?: AssistanceApplicationType;
    createdByUserId?: string | null;
    companyId?: string | null;
    summary?: string | null;
    description?: string | null;
    hasTranslation?: boolean;
    translatedDescription?: string | null;
    note?: string | null;
    accountNumber?: string | null;
    totalNeed?: number | null;
    deadline?: Date | null;
    fundedDate?: Date | null;
    isPublic?: boolean;
    status?: AssistanceApplicationStatus;
    denialReason?: AssistanceApplicationDenialReason | null;
    otherDenialReason?: string | null;
    auditState?: AssistanceApplicationStateAuditType;
    fundPledgeTypeId?: string | null;
    client?: Client2 | null;
    fundType?: FundType2 | null;
    pledgeType?: PledgeType2 | null;
    assignedAgency?: Agency2 | null;
    createdByUser?: User2 | null;
    company?: Company2 | null;
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    applicantAddress?: string | null;
    applicantZipCode?: string | null;
    applicantCity?: string | null;
    applicantState?: string | null;
    applicantCounty?: string | null;
    applicantPhone?: string | null;
    applicantEmail?: string | null;
    applicantIndividualMonthlyIncome?: number | null;
    applicantHouseHoldIncome?: number | null;
    applicantEmploymentStatus?: string | null;
    censusTract?: string | null;
    agreedToNotifications?: boolean | null;
    familyEducatedAboutResources?: boolean | null;
    assistanceApplicationAreasOfNeeds?: AssistanceApplicationAreasOfNeedEntity | null;
    adults?: AssistanceApplicationAdultEntity[] | null;
    minors?: AssistanceApplicationMinorEntity[] | null;
    comments?: AssistanceApplicationCommentEntity[] | null;
    files?: AssistanceApplicationFileEntity[] | null;
    companies?: AssistanceApplicationCompanyEntity[] | null;
    stateAudits?: AssistanceApplicationStateAuditEntity[] | null;
    informationRequests?: AssistanceApplicationInformationRequestEntity[] | null;
    stormApplication?: StormApplication | null;
}

export class FundType2 extends BaseEntity implements IFundType2 {
    name?: string | null;
    slug?: string | null;
    assistanceApplicationType?: AssistanceApplicationType | null;
    auditType?: AuditType;
    isBirthYearAndSsnOptional?: boolean;
    assistanceApplications?: AssistanceApplicationEntity[] | null;

    constructor(data?: IFundType2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : null as any;
            this.assistanceApplicationType = _data["assistanceApplicationType"] !== undefined ? _data["assistanceApplicationType"] : null as any;
            this.auditType = _data["auditType"] !== undefined ? _data["auditType"] : null as any;
            this.isBirthYearAndSsnOptional = _data["isBirthYearAndSsnOptional"] !== undefined ? _data["isBirthYearAndSsnOptional"] : null as any;
            if (Array.isArray(_data["assistanceApplications"])) {
                this.assistanceApplications = [] as any;
                for (let item of _data["assistanceApplications"])
                    this.assistanceApplications!.push(AssistanceApplicationEntity.fromJS(item));
            }
            else {
                this.assistanceApplications = null as any;
            }
        }
    }

    static override fromJS(data: any): FundType2 {
        data = typeof data === 'object' ? data : {};
        let result = new FundType2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["slug"] = this.slug !== undefined ? this.slug : null as any;
        data["assistanceApplicationType"] = this.assistanceApplicationType !== undefined ? this.assistanceApplicationType : null as any;
        data["auditType"] = this.auditType !== undefined ? this.auditType : null as any;
        data["isBirthYearAndSsnOptional"] = this.isBirthYearAndSsnOptional !== undefined ? this.isBirthYearAndSsnOptional : null as any;
        if (Array.isArray(this.assistanceApplications)) {
            data["assistanceApplications"] = [];
            for (let item of this.assistanceApplications)
                data["assistanceApplications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FundType2 {
        const json = this.toJSON();
        let result = new FundType2();
        result.init(json);
        return result;
    }
}

export interface IFundType2 extends IBaseEntity {
    name?: string | null;
    slug?: string | null;
    assistanceApplicationType?: AssistanceApplicationType | null;
    auditType?: AuditType;
    isBirthYearAndSsnOptional?: boolean;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
}

export class PledgeType2 extends BaseEntity implements IPledgeType2 {
    name?: string | null;
    minSinglePledgeAmt?: number;
    maxSinglePledgeAmt?: number;
    maxYearlyPledgeAmt?: number;
    status?: StatusType;
    crisisPledgeThreshold?: number;
    fiscalStartMonth?: number;
    fiscalStartDay?: number;
    isKeepingCurrent?: boolean;
    isSsnRequired?: boolean;
    isEmergencyNatGasRepair?: boolean;
    isPovertyLevelRequired?: boolean;
    maxPovertyLevel?: number | null;
    regionValue?: string | null;
    efsStartDate?: Date;
    efsEndDate?: Date;
    isEfs?: boolean;
    assistanceApplicationType?: AssistanceApplicationType | null;
    isUwda?: boolean;
    isPrivate?: boolean;
    ledgerNumber?: string | null;
    managementAgencyId?: string | null;
    managementAgency?: Agency2 | null;
    isFundAdministrativeAgency?: boolean;
    agencyPledgeTypes?: AgencyPledgeType[] | null;
    allocations?: Allocation2[] | null;
    companyPledgeTypes?: CompanyPledgeType[] | null;
    efsAssistances?: EfsAssistance[] | null;
    pledges?: Pledge2[] | null;
    efnCases?: EfnCase2[] | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;

    constructor(data?: IPledgeType2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.minSinglePledgeAmt = _data["minSinglePledgeAmt"] !== undefined ? _data["minSinglePledgeAmt"] : null as any;
            this.maxSinglePledgeAmt = _data["maxSinglePledgeAmt"] !== undefined ? _data["maxSinglePledgeAmt"] : null as any;
            this.maxYearlyPledgeAmt = _data["maxYearlyPledgeAmt"] !== undefined ? _data["maxYearlyPledgeAmt"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.crisisPledgeThreshold = _data["crisisPledgeThreshold"] !== undefined ? _data["crisisPledgeThreshold"] : null as any;
            this.fiscalStartMonth = _data["fiscalStartMonth"] !== undefined ? _data["fiscalStartMonth"] : null as any;
            this.fiscalStartDay = _data["fiscalStartDay"] !== undefined ? _data["fiscalStartDay"] : null as any;
            this.isKeepingCurrent = _data["isKeepingCurrent"] !== undefined ? _data["isKeepingCurrent"] : null as any;
            this.isSsnRequired = _data["isSsnRequired"] !== undefined ? _data["isSsnRequired"] : null as any;
            this.isEmergencyNatGasRepair = _data["isEmergencyNatGasRepair"] !== undefined ? _data["isEmergencyNatGasRepair"] : null as any;
            this.isPovertyLevelRequired = _data["isPovertyLevelRequired"] !== undefined ? _data["isPovertyLevelRequired"] : null as any;
            this.maxPovertyLevel = _data["maxPovertyLevel"] !== undefined ? _data["maxPovertyLevel"] : null as any;
            this.regionValue = _data["regionValue"] !== undefined ? _data["regionValue"] : null as any;
            this.efsStartDate = _data["efsStartDate"] ? new Date(_data["efsStartDate"].toString()) : null as any;
            this.efsEndDate = _data["efsEndDate"] ? new Date(_data["efsEndDate"].toString()) : null as any;
            this.isEfs = _data["isEfs"] !== undefined ? _data["isEfs"] : null as any;
            this.assistanceApplicationType = _data["assistanceApplicationType"] !== undefined ? _data["assistanceApplicationType"] : null as any;
            this.isUwda = _data["isUwda"] !== undefined ? _data["isUwda"] : null as any;
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            this.ledgerNumber = _data["ledgerNumber"] !== undefined ? _data["ledgerNumber"] : null as any;
            this.managementAgencyId = _data["managementAgencyId"] !== undefined ? _data["managementAgencyId"] : null as any;
            this.managementAgency = _data["managementAgency"] ? Agency2.fromJS(_data["managementAgency"]) : null as any;
            this.isFundAdministrativeAgency = _data["isFundAdministrativeAgency"] !== undefined ? _data["isFundAdministrativeAgency"] : null as any;
            if (Array.isArray(_data["agencyPledgeTypes"])) {
                this.agencyPledgeTypes = [] as any;
                for (let item of _data["agencyPledgeTypes"])
                    this.agencyPledgeTypes!.push(AgencyPledgeType.fromJS(item));
            }
            else {
                this.agencyPledgeTypes = null as any;
            }
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(Allocation2.fromJS(item));
            }
            else {
                this.allocations = null as any;
            }
            if (Array.isArray(_data["companyPledgeTypes"])) {
                this.companyPledgeTypes = [] as any;
                for (let item of _data["companyPledgeTypes"])
                    this.companyPledgeTypes!.push(CompanyPledgeType.fromJS(item));
            }
            else {
                this.companyPledgeTypes = null as any;
            }
            if (Array.isArray(_data["efsAssistances"])) {
                this.efsAssistances = [] as any;
                for (let item of _data["efsAssistances"])
                    this.efsAssistances!.push(EfsAssistance.fromJS(item));
            }
            else {
                this.efsAssistances = null as any;
            }
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(Pledge2.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
            if (Array.isArray(_data["efnCases"])) {
                this.efnCases = [] as any;
                for (let item of _data["efnCases"])
                    this.efnCases!.push(EfnCase2.fromJS(item));
            }
            else {
                this.efnCases = null as any;
            }
            if (Array.isArray(_data["assistanceApplications"])) {
                this.assistanceApplications = [] as any;
                for (let item of _data["assistanceApplications"])
                    this.assistanceApplications!.push(AssistanceApplicationEntity.fromJS(item));
            }
            else {
                this.assistanceApplications = null as any;
            }
        }
    }

    static override fromJS(data: any): PledgeType2 {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeType2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["minSinglePledgeAmt"] = this.minSinglePledgeAmt !== undefined ? this.minSinglePledgeAmt : null as any;
        data["maxSinglePledgeAmt"] = this.maxSinglePledgeAmt !== undefined ? this.maxSinglePledgeAmt : null as any;
        data["maxYearlyPledgeAmt"] = this.maxYearlyPledgeAmt !== undefined ? this.maxYearlyPledgeAmt : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["crisisPledgeThreshold"] = this.crisisPledgeThreshold !== undefined ? this.crisisPledgeThreshold : null as any;
        data["fiscalStartMonth"] = this.fiscalStartMonth !== undefined ? this.fiscalStartMonth : null as any;
        data["fiscalStartDay"] = this.fiscalStartDay !== undefined ? this.fiscalStartDay : null as any;
        data["isKeepingCurrent"] = this.isKeepingCurrent !== undefined ? this.isKeepingCurrent : null as any;
        data["isSsnRequired"] = this.isSsnRequired !== undefined ? this.isSsnRequired : null as any;
        data["isEmergencyNatGasRepair"] = this.isEmergencyNatGasRepair !== undefined ? this.isEmergencyNatGasRepair : null as any;
        data["isPovertyLevelRequired"] = this.isPovertyLevelRequired !== undefined ? this.isPovertyLevelRequired : null as any;
        data["maxPovertyLevel"] = this.maxPovertyLevel !== undefined ? this.maxPovertyLevel : null as any;
        data["regionValue"] = this.regionValue !== undefined ? this.regionValue : null as any;
        data["efsStartDate"] = this.efsStartDate ? this.efsStartDate.toISOString() : null as any;
        data["efsEndDate"] = this.efsEndDate ? this.efsEndDate.toISOString() : null as any;
        data["isEfs"] = this.isEfs !== undefined ? this.isEfs : null as any;
        data["assistanceApplicationType"] = this.assistanceApplicationType !== undefined ? this.assistanceApplicationType : null as any;
        data["isUwda"] = this.isUwda !== undefined ? this.isUwda : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["ledgerNumber"] = this.ledgerNumber !== undefined ? this.ledgerNumber : null as any;
        data["managementAgencyId"] = this.managementAgencyId !== undefined ? this.managementAgencyId : null as any;
        data["managementAgency"] = this.managementAgency ? this.managementAgency.toJSON() : null as any;
        data["isFundAdministrativeAgency"] = this.isFundAdministrativeAgency !== undefined ? this.isFundAdministrativeAgency : null as any;
        if (Array.isArray(this.agencyPledgeTypes)) {
            data["agencyPledgeTypes"] = [];
            for (let item of this.agencyPledgeTypes)
                data["agencyPledgeTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.companyPledgeTypes)) {
            data["companyPledgeTypes"] = [];
            for (let item of this.companyPledgeTypes)
                data["companyPledgeTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efsAssistances)) {
            data["efsAssistances"] = [];
            for (let item of this.efsAssistances)
                data["efsAssistances"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCases)) {
            data["efnCases"] = [];
            for (let item of this.efnCases)
                data["efnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.assistanceApplications)) {
            data["assistanceApplications"] = [];
            for (let item of this.assistanceApplications)
                data["assistanceApplications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PledgeType2 {
        const json = this.toJSON();
        let result = new PledgeType2();
        result.init(json);
        return result;
    }
}

export interface IPledgeType2 extends IBaseEntity {
    name?: string | null;
    minSinglePledgeAmt?: number;
    maxSinglePledgeAmt?: number;
    maxYearlyPledgeAmt?: number;
    status?: StatusType;
    crisisPledgeThreshold?: number;
    fiscalStartMonth?: number;
    fiscalStartDay?: number;
    isKeepingCurrent?: boolean;
    isSsnRequired?: boolean;
    isEmergencyNatGasRepair?: boolean;
    isPovertyLevelRequired?: boolean;
    maxPovertyLevel?: number | null;
    regionValue?: string | null;
    efsStartDate?: Date;
    efsEndDate?: Date;
    isEfs?: boolean;
    assistanceApplicationType?: AssistanceApplicationType | null;
    isUwda?: boolean;
    isPrivate?: boolean;
    ledgerNumber?: string | null;
    managementAgencyId?: string | null;
    managementAgency?: Agency2 | null;
    isFundAdministrativeAgency?: boolean;
    agencyPledgeTypes?: AgencyPledgeType[] | null;
    allocations?: Allocation2[] | null;
    companyPledgeTypes?: CompanyPledgeType[] | null;
    efsAssistances?: EfsAssistance[] | null;
    pledges?: Pledge2[] | null;
    efnCases?: EfnCase2[] | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
}

export class Agency2 extends BaseEntity implements IAgency2 {
    agencyName?: string | null;
    status?: AgencyStatusType;
    amerenCssCode?: string | null;
    efnZones?: string | null;
    isEfnAgency?: boolean;
    isDefaultManagementAgency?: boolean;
    agencyEfnCases?: AgencyEfnCase2[] | null;
    agencyPledgeTypes?: AgencyPledgeType[] | null;
    agencyPrograms?: AgencyProgram[] | null;
    allocations?: Allocation2[] | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
    efnCases?: EfnCase2[] | null;
    efsAssistances?: EfsAssistance[] | null;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
    pledges?: Pledge2[] | null;
    users?: User2[] | null;

    constructor(data?: IAgency2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.amerenCssCode = _data["amerenCssCode"] !== undefined ? _data["amerenCssCode"] : null as any;
            this.efnZones = _data["efnZones"] !== undefined ? _data["efnZones"] : null as any;
            this.isEfnAgency = _data["isEfnAgency"] !== undefined ? _data["isEfnAgency"] : null as any;
            this.isDefaultManagementAgency = _data["isDefaultManagementAgency"] !== undefined ? _data["isDefaultManagementAgency"] : null as any;
            if (Array.isArray(_data["agencyEfnCases"])) {
                this.agencyEfnCases = [] as any;
                for (let item of _data["agencyEfnCases"])
                    this.agencyEfnCases!.push(AgencyEfnCase2.fromJS(item));
            }
            else {
                this.agencyEfnCases = null as any;
            }
            if (Array.isArray(_data["agencyPledgeTypes"])) {
                this.agencyPledgeTypes = [] as any;
                for (let item of _data["agencyPledgeTypes"])
                    this.agencyPledgeTypes!.push(AgencyPledgeType.fromJS(item));
            }
            else {
                this.agencyPledgeTypes = null as any;
            }
            if (Array.isArray(_data["agencyPrograms"])) {
                this.agencyPrograms = [] as any;
                for (let item of _data["agencyPrograms"])
                    this.agencyPrograms!.push(AgencyProgram.fromJS(item));
            }
            else {
                this.agencyPrograms = null as any;
            }
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(Allocation2.fromJS(item));
            }
            else {
                this.allocations = null as any;
            }
            if (Array.isArray(_data["assistanceApplications"])) {
                this.assistanceApplications = [] as any;
                for (let item of _data["assistanceApplications"])
                    this.assistanceApplications!.push(AssistanceApplicationEntity.fromJS(item));
            }
            else {
                this.assistanceApplications = null as any;
            }
            if (Array.isArray(_data["efnCases"])) {
                this.efnCases = [] as any;
                for (let item of _data["efnCases"])
                    this.efnCases!.push(EfnCase2.fromJS(item));
            }
            else {
                this.efnCases = null as any;
            }
            if (Array.isArray(_data["efsAssistances"])) {
                this.efsAssistances = [] as any;
                for (let item of _data["efsAssistances"])
                    this.efsAssistances!.push(EfsAssistance.fromJS(item));
            }
            else {
                this.efsAssistances = null as any;
            }
            if (Array.isArray(_data["keepingCurrentApplications"])) {
                this.keepingCurrentApplications = [] as any;
                for (let item of _data["keepingCurrentApplications"])
                    this.keepingCurrentApplications!.push(KeepingCurrentApplication.fromJS(item));
            }
            else {
                this.keepingCurrentApplications = null as any;
            }
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(Pledge2.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User2.fromJS(item));
            }
            else {
                this.users = null as any;
            }
        }
    }

    static override fromJS(data: any): Agency2 {
        data = typeof data === 'object' ? data : {};
        let result = new Agency2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["amerenCssCode"] = this.amerenCssCode !== undefined ? this.amerenCssCode : null as any;
        data["efnZones"] = this.efnZones !== undefined ? this.efnZones : null as any;
        data["isEfnAgency"] = this.isEfnAgency !== undefined ? this.isEfnAgency : null as any;
        data["isDefaultManagementAgency"] = this.isDefaultManagementAgency !== undefined ? this.isDefaultManagementAgency : null as any;
        if (Array.isArray(this.agencyEfnCases)) {
            data["agencyEfnCases"] = [];
            for (let item of this.agencyEfnCases)
                data["agencyEfnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.agencyPledgeTypes)) {
            data["agencyPledgeTypes"] = [];
            for (let item of this.agencyPledgeTypes)
                data["agencyPledgeTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.agencyPrograms)) {
            data["agencyPrograms"] = [];
            for (let item of this.agencyPrograms)
                data["agencyPrograms"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.assistanceApplications)) {
            data["assistanceApplications"] = [];
            for (let item of this.assistanceApplications)
                data["assistanceApplications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCases)) {
            data["efnCases"] = [];
            for (let item of this.efnCases)
                data["efnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efsAssistances)) {
            data["efsAssistances"] = [];
            for (let item of this.efsAssistances)
                data["efsAssistances"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentApplications)) {
            data["keepingCurrentApplications"] = [];
            for (let item of this.keepingCurrentApplications)
                data["keepingCurrentApplications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Agency2 {
        const json = this.toJSON();
        let result = new Agency2();
        result.init(json);
        return result;
    }
}

export interface IAgency2 extends IBaseEntity {
    agencyName?: string | null;
    status?: AgencyStatusType;
    amerenCssCode?: string | null;
    efnZones?: string | null;
    isEfnAgency?: boolean;
    isDefaultManagementAgency?: boolean;
    agencyEfnCases?: AgencyEfnCase2[] | null;
    agencyPledgeTypes?: AgencyPledgeType[] | null;
    agencyPrograms?: AgencyProgram[] | null;
    allocations?: Allocation2[] | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
    efnCases?: EfnCase2[] | null;
    efsAssistances?: EfsAssistance[] | null;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
    pledges?: Pledge2[] | null;
    users?: User2[] | null;
}

export class AgencyEfnCase2 extends BaseEntity implements IAgencyEfnCase2 {
    agencyId?: string;
    efnCaseId?: string;
    originalCommitAmount?: number | null;
    currentCommitAmount?: number | null;
    commitNote?: string | null;
    status?: AgencyEfnCaseStatusType;
    pledgeId?: string | null;
    agency?: Agency2 | null;
    efnCase?: EfnCase2 | null;
    pledge?: Pledge2 | null;

    constructor(data?: IAgencyEfnCase2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.originalCommitAmount = _data["originalCommitAmount"] !== undefined ? _data["originalCommitAmount"] : null as any;
            this.currentCommitAmount = _data["currentCommitAmount"] !== undefined ? _data["currentCommitAmount"] : null as any;
            this.commitNote = _data["commitNote"] !== undefined ? _data["commitNote"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.efnCase = _data["efnCase"] ? EfnCase2.fromJS(_data["efnCase"]) : null as any;
            this.pledge = _data["pledge"] ? Pledge2.fromJS(_data["pledge"]) : null as any;
        }
    }

    static override fromJS(data: any): AgencyEfnCase2 {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyEfnCase2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["originalCommitAmount"] = this.originalCommitAmount !== undefined ? this.originalCommitAmount : null as any;
        data["currentCommitAmount"] = this.currentCommitAmount !== undefined ? this.currentCommitAmount : null as any;
        data["commitNote"] = this.commitNote !== undefined ? this.commitNote : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["efnCase"] = this.efnCase ? this.efnCase.toJSON() : null as any;
        data["pledge"] = this.pledge ? this.pledge.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AgencyEfnCase2 {
        const json = this.toJSON();
        let result = new AgencyEfnCase2();
        result.init(json);
        return result;
    }
}

export interface IAgencyEfnCase2 extends IBaseEntity {
    agencyId?: string;
    efnCaseId?: string;
    originalCommitAmount?: number | null;
    currentCommitAmount?: number | null;
    commitNote?: string | null;
    status?: AgencyEfnCaseStatusType;
    pledgeId?: string | null;
    agency?: Agency2 | null;
    efnCase?: EfnCase2 | null;
    pledge?: Pledge2 | null;
}

export class EfnCase2 extends BaseEntity implements IEfnCase2 {
    clientId?: string;
    createdByAgencyId?: string | null;
    pledgeTypeId?: string | null;
    totalNeed?: number | null;
    summary?: string | null;
    description?: string | null;
    caseNote?: string | null;
    status?: EfnCaseStatusType;
    deadline?: Date | null;
    fundedDate?: Date | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientSsn?: string | null;
    clientAddress?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientEmail?: string | null;
    paymentTo?: string | null;
    payeeAddress?: string | null;
    accountNumber?: string | null;
    createdByUserId?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    payeeAddress2?: string | null;
    companyId?: string | null;
    companyName?: string | null;
    isPublic?: boolean;
    client?: Client2 | null;
    pledgeType?: PledgeType2 | null;
    company?: Company2 | null;
    createdByAgency?: Agency2 | null;
    createdByUser?: User2 | null;
    agencyEfnCases?: AgencyEfnCase2[] | null;
    efnCaseComments?: EfnCaseComments[] | null;
    efnCaseFiles?: EfnCaseFiles[] | null;

    constructor(data?: IEfnCase2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.createdByAgencyId = _data["createdByAgencyId"] !== undefined ? _data["createdByAgencyId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.totalNeed = _data["totalNeed"] !== undefined ? _data["totalNeed"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.caseNote = _data["caseNote"] !== undefined ? _data["caseNote"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : null as any;
            this.fundedDate = _data["fundedDate"] ? new Date(_data["fundedDate"].toString()) : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientAddress = _data["clientAddress"] !== undefined ? _data["clientAddress"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientEmail = _data["clientEmail"] !== undefined ? _data["clientEmail"] : null as any;
            this.paymentTo = _data["paymentTo"] !== undefined ? _data["paymentTo"] : null as any;
            this.payeeAddress = _data["payeeAddress"] !== undefined ? _data["payeeAddress"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : null as any;
            this.payeeCity = _data["payeeCity"] !== undefined ? _data["payeeCity"] : null as any;
            this.payeeState = _data["payeeState"] !== undefined ? _data["payeeState"] : null as any;
            this.payeeZip = _data["payeeZip"] !== undefined ? _data["payeeZip"] : null as any;
            this.payeeAddress2 = _data["payeeAddress2"] !== undefined ? _data["payeeAddress2"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            this.createdByAgency = _data["createdByAgency"] ? Agency2.fromJS(_data["createdByAgency"]) : null as any;
            this.createdByUser = _data["createdByUser"] ? User2.fromJS(_data["createdByUser"]) : null as any;
            if (Array.isArray(_data["agencyEfnCases"])) {
                this.agencyEfnCases = [] as any;
                for (let item of _data["agencyEfnCases"])
                    this.agencyEfnCases!.push(AgencyEfnCase2.fromJS(item));
            }
            else {
                this.agencyEfnCases = null as any;
            }
            if (Array.isArray(_data["efnCaseComments"])) {
                this.efnCaseComments = [] as any;
                for (let item of _data["efnCaseComments"])
                    this.efnCaseComments!.push(EfnCaseComments.fromJS(item));
            }
            else {
                this.efnCaseComments = null as any;
            }
            if (Array.isArray(_data["efnCaseFiles"])) {
                this.efnCaseFiles = [] as any;
                for (let item of _data["efnCaseFiles"])
                    this.efnCaseFiles!.push(EfnCaseFiles.fromJS(item));
            }
            else {
                this.efnCaseFiles = null as any;
            }
        }
    }

    static override fromJS(data: any): EfnCase2 {
        data = typeof data === 'object' ? data : {};
        let result = new EfnCase2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["createdByAgencyId"] = this.createdByAgencyId !== undefined ? this.createdByAgencyId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["totalNeed"] = this.totalNeed !== undefined ? this.totalNeed : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["caseNote"] = this.caseNote !== undefined ? this.caseNote : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : null as any;
        data["fundedDate"] = this.fundedDate ? this.fundedDate.toISOString() : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientAddress"] = this.clientAddress !== undefined ? this.clientAddress : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientEmail"] = this.clientEmail !== undefined ? this.clientEmail : null as any;
        data["paymentTo"] = this.paymentTo !== undefined ? this.paymentTo : null as any;
        data["payeeAddress"] = this.payeeAddress !== undefined ? this.payeeAddress : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : null as any;
        data["payeeCity"] = this.payeeCity !== undefined ? this.payeeCity : null as any;
        data["payeeState"] = this.payeeState !== undefined ? this.payeeState : null as any;
        data["payeeZip"] = this.payeeZip !== undefined ? this.payeeZip : null as any;
        data["payeeAddress2"] = this.payeeAddress2 !== undefined ? this.payeeAddress2 : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["createdByAgency"] = this.createdByAgency ? this.createdByAgency.toJSON() : null as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : null as any;
        if (Array.isArray(this.agencyEfnCases)) {
            data["agencyEfnCases"] = [];
            for (let item of this.agencyEfnCases)
                data["agencyEfnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCaseComments)) {
            data["efnCaseComments"] = [];
            for (let item of this.efnCaseComments)
                data["efnCaseComments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCaseFiles)) {
            data["efnCaseFiles"] = [];
            for (let item of this.efnCaseFiles)
                data["efnCaseFiles"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EfnCase2 {
        const json = this.toJSON();
        let result = new EfnCase2();
        result.init(json);
        return result;
    }
}

export interface IEfnCase2 extends IBaseEntity {
    clientId?: string;
    createdByAgencyId?: string | null;
    pledgeTypeId?: string | null;
    totalNeed?: number | null;
    summary?: string | null;
    description?: string | null;
    caseNote?: string | null;
    status?: EfnCaseStatusType;
    deadline?: Date | null;
    fundedDate?: Date | null;
    clientFirstName?: string | null;
    clientLastName?: string | null;
    clientSsn?: string | null;
    clientAddress?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientEmail?: string | null;
    paymentTo?: string | null;
    payeeAddress?: string | null;
    accountNumber?: string | null;
    createdByUserId?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    payeeAddress2?: string | null;
    companyId?: string | null;
    companyName?: string | null;
    isPublic?: boolean;
    client?: Client2 | null;
    pledgeType?: PledgeType2 | null;
    company?: Company2 | null;
    createdByAgency?: Agency2 | null;
    createdByUser?: User2 | null;
    agencyEfnCases?: AgencyEfnCase2[] | null;
    efnCaseComments?: EfnCaseComments[] | null;
    efnCaseFiles?: EfnCaseFiles[] | null;
}

export class Company2 extends BaseEntity implements ICompany2 {
    isUwdaCompany?: boolean;
    name?: string | null;
    isIndividual?: boolean;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    allocateAllowed?: boolean | null;
    sortOrder?: number | null;
    status?: StatusType;
    contactName1?: string | null;
    contactPhone1?: string | null;
    contactName2?: string | null;
    contactPhone2?: string | null;
    contactName3?: string | null;
    contactPhone3?: string | null;
    isAccountValidationEnforced?: boolean | null;
    isAccountValidAlphabetical?: boolean | null;
    isAccountValidNumerical?: boolean | null;
    isAccountValidSpecialChars?: boolean | null;
    accountValidationMinLen?: number | null;
    accountValidationMaxLen?: number | null;
    accountValidationErrorMsg?: string | null;
    regionValue?: string | null;
    urlLink?: string | null;
    urlDisplay?: string | null;
    lastUsedDate?: Date | null;
    category?: CompanyCategoryType;
    allocations?: Allocation2[] | null;
    companyPledgeTypes?: CompanyPledgeType[] | null;
    efnCases?: EfnCase2[] | null;
    pledges?: Pledge2[] | null;
    users?: User2[] | null;

    constructor(data?: ICompany2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isUwdaCompany = _data["isUwdaCompany"] !== undefined ? _data["isUwdaCompany"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isIndividual = _data["isIndividual"] !== undefined ? _data["isIndividual"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.allocateAllowed = _data["allocateAllowed"] !== undefined ? _data["allocateAllowed"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.contactName1 = _data["contactName1"] !== undefined ? _data["contactName1"] : null as any;
            this.contactPhone1 = _data["contactPhone1"] !== undefined ? _data["contactPhone1"] : null as any;
            this.contactName2 = _data["contactName2"] !== undefined ? _data["contactName2"] : null as any;
            this.contactPhone2 = _data["contactPhone2"] !== undefined ? _data["contactPhone2"] : null as any;
            this.contactName3 = _data["contactName3"] !== undefined ? _data["contactName3"] : null as any;
            this.contactPhone3 = _data["contactPhone3"] !== undefined ? _data["contactPhone3"] : null as any;
            this.isAccountValidationEnforced = _data["isAccountValidationEnforced"] !== undefined ? _data["isAccountValidationEnforced"] : null as any;
            this.isAccountValidAlphabetical = _data["isAccountValidAlphabetical"] !== undefined ? _data["isAccountValidAlphabetical"] : null as any;
            this.isAccountValidNumerical = _data["isAccountValidNumerical"] !== undefined ? _data["isAccountValidNumerical"] : null as any;
            this.isAccountValidSpecialChars = _data["isAccountValidSpecialChars"] !== undefined ? _data["isAccountValidSpecialChars"] : null as any;
            this.accountValidationMinLen = _data["accountValidationMinLen"] !== undefined ? _data["accountValidationMinLen"] : null as any;
            this.accountValidationMaxLen = _data["accountValidationMaxLen"] !== undefined ? _data["accountValidationMaxLen"] : null as any;
            this.accountValidationErrorMsg = _data["accountValidationErrorMsg"] !== undefined ? _data["accountValidationErrorMsg"] : null as any;
            this.regionValue = _data["regionValue"] !== undefined ? _data["regionValue"] : null as any;
            this.urlLink = _data["urlLink"] !== undefined ? _data["urlLink"] : null as any;
            this.urlDisplay = _data["urlDisplay"] !== undefined ? _data["urlDisplay"] : null as any;
            this.lastUsedDate = _data["lastUsedDate"] ? new Date(_data["lastUsedDate"].toString()) : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(Allocation2.fromJS(item));
            }
            else {
                this.allocations = null as any;
            }
            if (Array.isArray(_data["companyPledgeTypes"])) {
                this.companyPledgeTypes = [] as any;
                for (let item of _data["companyPledgeTypes"])
                    this.companyPledgeTypes!.push(CompanyPledgeType.fromJS(item));
            }
            else {
                this.companyPledgeTypes = null as any;
            }
            if (Array.isArray(_data["efnCases"])) {
                this.efnCases = [] as any;
                for (let item of _data["efnCases"])
                    this.efnCases!.push(EfnCase2.fromJS(item));
            }
            else {
                this.efnCases = null as any;
            }
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(Pledge2.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User2.fromJS(item));
            }
            else {
                this.users = null as any;
            }
        }
    }

    static override fromJS(data: any): Company2 {
        data = typeof data === 'object' ? data : {};
        let result = new Company2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUwdaCompany"] = this.isUwdaCompany !== undefined ? this.isUwdaCompany : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isIndividual"] = this.isIndividual !== undefined ? this.isIndividual : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["allocateAllowed"] = this.allocateAllowed !== undefined ? this.allocateAllowed : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["contactName1"] = this.contactName1 !== undefined ? this.contactName1 : null as any;
        data["contactPhone1"] = this.contactPhone1 !== undefined ? this.contactPhone1 : null as any;
        data["contactName2"] = this.contactName2 !== undefined ? this.contactName2 : null as any;
        data["contactPhone2"] = this.contactPhone2 !== undefined ? this.contactPhone2 : null as any;
        data["contactName3"] = this.contactName3 !== undefined ? this.contactName3 : null as any;
        data["contactPhone3"] = this.contactPhone3 !== undefined ? this.contactPhone3 : null as any;
        data["isAccountValidationEnforced"] = this.isAccountValidationEnforced !== undefined ? this.isAccountValidationEnforced : null as any;
        data["isAccountValidAlphabetical"] = this.isAccountValidAlphabetical !== undefined ? this.isAccountValidAlphabetical : null as any;
        data["isAccountValidNumerical"] = this.isAccountValidNumerical !== undefined ? this.isAccountValidNumerical : null as any;
        data["isAccountValidSpecialChars"] = this.isAccountValidSpecialChars !== undefined ? this.isAccountValidSpecialChars : null as any;
        data["accountValidationMinLen"] = this.accountValidationMinLen !== undefined ? this.accountValidationMinLen : null as any;
        data["accountValidationMaxLen"] = this.accountValidationMaxLen !== undefined ? this.accountValidationMaxLen : null as any;
        data["accountValidationErrorMsg"] = this.accountValidationErrorMsg !== undefined ? this.accountValidationErrorMsg : null as any;
        data["regionValue"] = this.regionValue !== undefined ? this.regionValue : null as any;
        data["urlLink"] = this.urlLink !== undefined ? this.urlLink : null as any;
        data["urlDisplay"] = this.urlDisplay !== undefined ? this.urlDisplay : null as any;
        data["lastUsedDate"] = this.lastUsedDate ? this.lastUsedDate.toISOString() : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.companyPledgeTypes)) {
            data["companyPledgeTypes"] = [];
            for (let item of this.companyPledgeTypes)
                data["companyPledgeTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCases)) {
            data["efnCases"] = [];
            for (let item of this.efnCases)
                data["efnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Company2 {
        const json = this.toJSON();
        let result = new Company2();
        result.init(json);
        return result;
    }
}

export interface ICompany2 extends IBaseEntity {
    isUwdaCompany?: boolean;
    name?: string | null;
    isIndividual?: boolean;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    allocateAllowed?: boolean | null;
    sortOrder?: number | null;
    status?: StatusType;
    contactName1?: string | null;
    contactPhone1?: string | null;
    contactName2?: string | null;
    contactPhone2?: string | null;
    contactName3?: string | null;
    contactPhone3?: string | null;
    isAccountValidationEnforced?: boolean | null;
    isAccountValidAlphabetical?: boolean | null;
    isAccountValidNumerical?: boolean | null;
    isAccountValidSpecialChars?: boolean | null;
    accountValidationMinLen?: number | null;
    accountValidationMaxLen?: number | null;
    accountValidationErrorMsg?: string | null;
    regionValue?: string | null;
    urlLink?: string | null;
    urlDisplay?: string | null;
    lastUsedDate?: Date | null;
    category?: CompanyCategoryType;
    allocations?: Allocation2[] | null;
    companyPledgeTypes?: CompanyPledgeType[] | null;
    efnCases?: EfnCase2[] | null;
    pledges?: Pledge2[] | null;
    users?: User2[] | null;
}

export class Allocation2 extends BaseEntity implements IAllocation2 {
    agencyId?: string;
    companyId?: string | null;
    pledgeTypeId?: string;
    reason?: string | null;
    amount?: number;
    adminPercent?: number | null;
    status?: StatusType | null;
    agency?: Agency2 | null;
    company?: Company2 | null;
    pledgeType?: PledgeType2 | null;
    allocationLedgers?: AllocationLedger[] | null;

    constructor(data?: IAllocation2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.adminPercent = _data["adminPercent"] !== undefined ? _data["adminPercent"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
            if (Array.isArray(_data["allocationLedgers"])) {
                this.allocationLedgers = [] as any;
                for (let item of _data["allocationLedgers"])
                    this.allocationLedgers!.push(AllocationLedger.fromJS(item));
            }
            else {
                this.allocationLedgers = null as any;
            }
        }
    }

    static override fromJS(data: any): Allocation2 {
        data = typeof data === 'object' ? data : {};
        let result = new Allocation2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["adminPercent"] = this.adminPercent !== undefined ? this.adminPercent : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        if (Array.isArray(this.allocationLedgers)) {
            data["allocationLedgers"] = [];
            for (let item of this.allocationLedgers)
                data["allocationLedgers"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Allocation2 {
        const json = this.toJSON();
        let result = new Allocation2();
        result.init(json);
        return result;
    }
}

export interface IAllocation2 extends IBaseEntity {
    agencyId?: string;
    companyId?: string | null;
    pledgeTypeId?: string;
    reason?: string | null;
    amount?: number;
    adminPercent?: number | null;
    status?: StatusType | null;
    agency?: Agency2 | null;
    company?: Company2 | null;
    pledgeType?: PledgeType2 | null;
    allocationLedgers?: AllocationLedger[] | null;
}

export class AllocationLedger extends BaseEntity implements IAllocationLedger {
    pledgeId?: string;
    allocationId?: string;
    amount?: number;
    reason?: string | null;
    allocation?: Allocation2 | null;
    pledge?: Pledge2 | null;

    constructor(data?: IAllocationLedger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.allocationId = _data["allocationId"] !== undefined ? _data["allocationId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.allocation = _data["allocation"] ? Allocation2.fromJS(_data["allocation"]) : null as any;
            this.pledge = _data["pledge"] ? Pledge2.fromJS(_data["pledge"]) : null as any;
        }
    }

    static override fromJS(data: any): AllocationLedger {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationLedger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["allocationId"] = this.allocationId !== undefined ? this.allocationId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["allocation"] = this.allocation ? this.allocation.toJSON() : null as any;
        data["pledge"] = this.pledge ? this.pledge.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AllocationLedger {
        const json = this.toJSON();
        let result = new AllocationLedger();
        result.init(json);
        return result;
    }
}

export interface IAllocationLedger extends IBaseEntity {
    pledgeId?: string;
    allocationId?: string;
    amount?: number;
    reason?: string | null;
    allocation?: Allocation2 | null;
    pledge?: Pledge2 | null;
}

export class Pledge2 extends BaseEntity implements IPledge2 {
    clientId?: string;
    pledgeTypeId?: string;
    agencyId?: string;
    companyId?: string | null;
    clientCompanyAccountNumber?: string | null;
    pledgedAmount?: number;
    pledgedDate?: Date;
    hadTraining?: boolean | null;
    householdBudgetTraining?: boolean | null;
    amerenBudgetTraining?: boolean | null;
    creditCounselling?: boolean | null;
    caseManagement?: boolean | null;
    otherTraining?: boolean | null;
    accountBalance?: number | null;
    clientPayment?: number | null;
    serviceIsDisconnected?: boolean | null;
    justificationOfWaiver?: string | null;
    status?: PledgeStatusType;
    isCrisisPledge?: boolean | null;
    invoiceNumber?: string | null;
    paidDate?: Date | null;
    pledgeNumber?: number;
    clientSsn?: string | null;
    clientSsnhash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    program?: number;
    federalPovertyLevelDisplay?: number | null;
    assistanceType?: PledgeAssistanceType | null;
    leverageAmount?: number | null;
    checkMemo?: string | null;
    onetimeCompanyAddress1?: string | null;
    onetimeCompanyAddress2?: string | null;
    onetimeCompanyCity?: string | null;
    onetimeCompanyState?: string | null;
    onetimeCompanyZip?: string | null;
    agencyEfnCaseId?: string | null;
    onetimeCompanyRecipient?: string | null;
    uwdaApprovedById?: string | null;
    uwdaApprovedByName?: string | null;
    clientUnionInfo?: string | null;
    clientCensusTract?: string | null;
    specialCoding?: string | null;
    agency?: Agency2 | null;
    client?: Client2 | null;
    company?: Company2 | null;
    pledgeType?: PledgeType2 | null;
    uwdaApprovedBy?: User2 | null;
    bulkPaymentBatchHistory?: PledgeBulkPaymentBatchHistoryEntity | null;
    agencyEfnCases?: AgencyEfnCase2[] | null;
    allocationLedgers?: AllocationLedger[] | null;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;

    constructor(data?: IPledge2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.clientCompanyAccountNumber = _data["clientCompanyAccountNumber"] !== undefined ? _data["clientCompanyAccountNumber"] : null as any;
            this.pledgedAmount = _data["pledgedAmount"] !== undefined ? _data["pledgedAmount"] : null as any;
            this.pledgedDate = _data["pledgedDate"] ? new Date(_data["pledgedDate"].toString()) : null as any;
            this.hadTraining = _data["hadTraining"] !== undefined ? _data["hadTraining"] : null as any;
            this.householdBudgetTraining = _data["householdBudgetTraining"] !== undefined ? _data["householdBudgetTraining"] : null as any;
            this.amerenBudgetTraining = _data["amerenBudgetTraining"] !== undefined ? _data["amerenBudgetTraining"] : null as any;
            this.creditCounselling = _data["creditCounselling"] !== undefined ? _data["creditCounselling"] : null as any;
            this.caseManagement = _data["caseManagement"] !== undefined ? _data["caseManagement"] : null as any;
            this.otherTraining = _data["otherTraining"] !== undefined ? _data["otherTraining"] : null as any;
            this.accountBalance = _data["accountBalance"] !== undefined ? _data["accountBalance"] : null as any;
            this.clientPayment = _data["clientPayment"] !== undefined ? _data["clientPayment"] : null as any;
            this.serviceIsDisconnected = _data["serviceIsDisconnected"] !== undefined ? _data["serviceIsDisconnected"] : null as any;
            this.justificationOfWaiver = _data["justificationOfWaiver"] !== undefined ? _data["justificationOfWaiver"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isCrisisPledge = _data["isCrisisPledge"] !== undefined ? _data["isCrisisPledge"] : null as any;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.pledgeNumber = _data["pledgeNumber"] !== undefined ? _data["pledgeNumber"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientSsnhash = _data["clientSsnhash"] !== undefined ? _data["clientSsnhash"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.clientPrefix = _data["clientPrefix"] !== undefined ? _data["clientPrefix"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientMiddleInitial = _data["clientMiddleInitial"] !== undefined ? _data["clientMiddleInitial"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientSuffix = _data["clientSuffix"] !== undefined ? _data["clientSuffix"] : null as any;
            this.clientAddress1 = _data["clientAddress1"] !== undefined ? _data["clientAddress1"] : null as any;
            this.clientAddress2 = _data["clientAddress2"] !== undefined ? _data["clientAddress2"] : null as any;
            this.clientCity = _data["clientCity"] !== undefined ? _data["clientCity"] : null as any;
            this.clientState = _data["clientState"] !== undefined ? _data["clientState"] : null as any;
            this.clientZipCode = _data["clientZipCode"] !== undefined ? _data["clientZipCode"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientPhoneExt = _data["clientPhoneExt"] !== undefined ? _data["clientPhoneExt"] : null as any;
            this.clientBirthYear = _data["clientBirthYear"] !== undefined ? _data["clientBirthYear"] : null as any;
            this.clientEmail = _data["clientEmail"] !== undefined ? _data["clientEmail"] : null as any;
            this.clientGender = _data["clientGender"] !== undefined ? _data["clientGender"] : null as any;
            this.clientHouseHoldIncome = _data["clientHouseHoldIncome"] !== undefined ? _data["clientHouseHoldIncome"] : null as any;
            this.clientHouseHoldSize = _data["clientHouseHoldSize"] !== undefined ? _data["clientHouseHoldSize"] : null as any;
            this.clientEmploymentStatus = _data["clientEmploymentStatus"] !== undefined ? _data["clientEmploymentStatus"] : null as any;
            this.clientIsElderly = _data["clientIsElderly"] !== undefined ? _data["clientIsElderly"] : null as any;
            this.clientIsDisabled = _data["clientIsDisabled"] !== undefined ? _data["clientIsDisabled"] : null as any;
            this.clientHasChildrenUnderFive = _data["clientHasChildrenUnderFive"] !== undefined ? _data["clientHasChildrenUnderFive"] : null as any;
            this.clientIsVeteran = _data["clientIsVeteran"] !== undefined ? _data["clientIsVeteran"] : null as any;
            this.clientIsHomeless = _data["clientIsHomeless"] !== undefined ? _data["clientIsHomeless"] : null as any;
            this.clientMembersAreElderly = _data["clientMembersAreElderly"] !== undefined ? _data["clientMembersAreElderly"] : null as any;
            this.clientMembersAreDisabled = _data["clientMembersAreDisabled"] !== undefined ? _data["clientMembersAreDisabled"] : null as any;
            this.clientMembersHaveChildrenUnderFive = _data["clientMembersHaveChildrenUnderFive"] !== undefined ? _data["clientMembersHaveChildrenUnderFive"] : null as any;
            this.clientPhoneAlt = _data["clientPhoneAlt"] !== undefined ? _data["clientPhoneAlt"] : null as any;
            this.program = _data["program"] !== undefined ? _data["program"] : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.assistanceType = _data["assistanceType"] !== undefined ? _data["assistanceType"] : null as any;
            this.leverageAmount = _data["leverageAmount"] !== undefined ? _data["leverageAmount"] : null as any;
            this.checkMemo = _data["checkMemo"] !== undefined ? _data["checkMemo"] : null as any;
            this.onetimeCompanyAddress1 = _data["onetimeCompanyAddress1"] !== undefined ? _data["onetimeCompanyAddress1"] : null as any;
            this.onetimeCompanyAddress2 = _data["onetimeCompanyAddress2"] !== undefined ? _data["onetimeCompanyAddress2"] : null as any;
            this.onetimeCompanyCity = _data["onetimeCompanyCity"] !== undefined ? _data["onetimeCompanyCity"] : null as any;
            this.onetimeCompanyState = _data["onetimeCompanyState"] !== undefined ? _data["onetimeCompanyState"] : null as any;
            this.onetimeCompanyZip = _data["onetimeCompanyZip"] !== undefined ? _data["onetimeCompanyZip"] : null as any;
            this.agencyEfnCaseId = _data["agencyEfnCaseId"] !== undefined ? _data["agencyEfnCaseId"] : null as any;
            this.onetimeCompanyRecipient = _data["onetimeCompanyRecipient"] !== undefined ? _data["onetimeCompanyRecipient"] : null as any;
            this.uwdaApprovedById = _data["uwdaApprovedById"] !== undefined ? _data["uwdaApprovedById"] : null as any;
            this.uwdaApprovedByName = _data["uwdaApprovedByName"] !== undefined ? _data["uwdaApprovedByName"] : null as any;
            this.clientUnionInfo = _data["clientUnionInfo"] !== undefined ? _data["clientUnionInfo"] : null as any;
            this.clientCensusTract = _data["clientCensusTract"] !== undefined ? _data["clientCensusTract"] : null as any;
            this.specialCoding = _data["specialCoding"] !== undefined ? _data["specialCoding"] : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
            this.uwdaApprovedBy = _data["uwdaApprovedBy"] ? User2.fromJS(_data["uwdaApprovedBy"]) : null as any;
            this.bulkPaymentBatchHistory = _data["bulkPaymentBatchHistory"] ? PledgeBulkPaymentBatchHistoryEntity.fromJS(_data["bulkPaymentBatchHistory"]) : null as any;
            if (Array.isArray(_data["agencyEfnCases"])) {
                this.agencyEfnCases = [] as any;
                for (let item of _data["agencyEfnCases"])
                    this.agencyEfnCases!.push(AgencyEfnCase2.fromJS(item));
            }
            else {
                this.agencyEfnCases = null as any;
            }
            if (Array.isArray(_data["allocationLedgers"])) {
                this.allocationLedgers = [] as any;
                for (let item of _data["allocationLedgers"])
                    this.allocationLedgers!.push(AllocationLedger.fromJS(item));
            }
            else {
                this.allocationLedgers = null as any;
            }
            if (Array.isArray(_data["keepingCurrentApplications"])) {
                this.keepingCurrentApplications = [] as any;
                for (let item of _data["keepingCurrentApplications"])
                    this.keepingCurrentApplications!.push(KeepingCurrentApplication.fromJS(item));
            }
            else {
                this.keepingCurrentApplications = null as any;
            }
        }
    }

    static override fromJS(data: any): Pledge2 {
        data = typeof data === 'object' ? data : {};
        let result = new Pledge2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["clientCompanyAccountNumber"] = this.clientCompanyAccountNumber !== undefined ? this.clientCompanyAccountNumber : null as any;
        data["pledgedAmount"] = this.pledgedAmount !== undefined ? this.pledgedAmount : null as any;
        data["pledgedDate"] = this.pledgedDate ? this.pledgedDate.toISOString() : null as any;
        data["hadTraining"] = this.hadTraining !== undefined ? this.hadTraining : null as any;
        data["householdBudgetTraining"] = this.householdBudgetTraining !== undefined ? this.householdBudgetTraining : null as any;
        data["amerenBudgetTraining"] = this.amerenBudgetTraining !== undefined ? this.amerenBudgetTraining : null as any;
        data["creditCounselling"] = this.creditCounselling !== undefined ? this.creditCounselling : null as any;
        data["caseManagement"] = this.caseManagement !== undefined ? this.caseManagement : null as any;
        data["otherTraining"] = this.otherTraining !== undefined ? this.otherTraining : null as any;
        data["accountBalance"] = this.accountBalance !== undefined ? this.accountBalance : null as any;
        data["clientPayment"] = this.clientPayment !== undefined ? this.clientPayment : null as any;
        data["serviceIsDisconnected"] = this.serviceIsDisconnected !== undefined ? this.serviceIsDisconnected : null as any;
        data["justificationOfWaiver"] = this.justificationOfWaiver !== undefined ? this.justificationOfWaiver : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isCrisisPledge"] = this.isCrisisPledge !== undefined ? this.isCrisisPledge : null as any;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["pledgeNumber"] = this.pledgeNumber !== undefined ? this.pledgeNumber : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientSsnhash"] = this.clientSsnhash !== undefined ? this.clientSsnhash : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["clientPrefix"] = this.clientPrefix !== undefined ? this.clientPrefix : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientMiddleInitial"] = this.clientMiddleInitial !== undefined ? this.clientMiddleInitial : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientSuffix"] = this.clientSuffix !== undefined ? this.clientSuffix : null as any;
        data["clientAddress1"] = this.clientAddress1 !== undefined ? this.clientAddress1 : null as any;
        data["clientAddress2"] = this.clientAddress2 !== undefined ? this.clientAddress2 : null as any;
        data["clientCity"] = this.clientCity !== undefined ? this.clientCity : null as any;
        data["clientState"] = this.clientState !== undefined ? this.clientState : null as any;
        data["clientZipCode"] = this.clientZipCode !== undefined ? this.clientZipCode : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientPhoneExt"] = this.clientPhoneExt !== undefined ? this.clientPhoneExt : null as any;
        data["clientBirthYear"] = this.clientBirthYear !== undefined ? this.clientBirthYear : null as any;
        data["clientEmail"] = this.clientEmail !== undefined ? this.clientEmail : null as any;
        data["clientGender"] = this.clientGender !== undefined ? this.clientGender : null as any;
        data["clientHouseHoldIncome"] = this.clientHouseHoldIncome !== undefined ? this.clientHouseHoldIncome : null as any;
        data["clientHouseHoldSize"] = this.clientHouseHoldSize !== undefined ? this.clientHouseHoldSize : null as any;
        data["clientEmploymentStatus"] = this.clientEmploymentStatus !== undefined ? this.clientEmploymentStatus : null as any;
        data["clientIsElderly"] = this.clientIsElderly !== undefined ? this.clientIsElderly : null as any;
        data["clientIsDisabled"] = this.clientIsDisabled !== undefined ? this.clientIsDisabled : null as any;
        data["clientHasChildrenUnderFive"] = this.clientHasChildrenUnderFive !== undefined ? this.clientHasChildrenUnderFive : null as any;
        data["clientIsVeteran"] = this.clientIsVeteran !== undefined ? this.clientIsVeteran : null as any;
        data["clientIsHomeless"] = this.clientIsHomeless !== undefined ? this.clientIsHomeless : null as any;
        data["clientMembersAreElderly"] = this.clientMembersAreElderly !== undefined ? this.clientMembersAreElderly : null as any;
        data["clientMembersAreDisabled"] = this.clientMembersAreDisabled !== undefined ? this.clientMembersAreDisabled : null as any;
        data["clientMembersHaveChildrenUnderFive"] = this.clientMembersHaveChildrenUnderFive !== undefined ? this.clientMembersHaveChildrenUnderFive : null as any;
        data["clientPhoneAlt"] = this.clientPhoneAlt !== undefined ? this.clientPhoneAlt : null as any;
        data["program"] = this.program !== undefined ? this.program : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["assistanceType"] = this.assistanceType !== undefined ? this.assistanceType : null as any;
        data["leverageAmount"] = this.leverageAmount !== undefined ? this.leverageAmount : null as any;
        data["checkMemo"] = this.checkMemo !== undefined ? this.checkMemo : null as any;
        data["onetimeCompanyAddress1"] = this.onetimeCompanyAddress1 !== undefined ? this.onetimeCompanyAddress1 : null as any;
        data["onetimeCompanyAddress2"] = this.onetimeCompanyAddress2 !== undefined ? this.onetimeCompanyAddress2 : null as any;
        data["onetimeCompanyCity"] = this.onetimeCompanyCity !== undefined ? this.onetimeCompanyCity : null as any;
        data["onetimeCompanyState"] = this.onetimeCompanyState !== undefined ? this.onetimeCompanyState : null as any;
        data["onetimeCompanyZip"] = this.onetimeCompanyZip !== undefined ? this.onetimeCompanyZip : null as any;
        data["agencyEfnCaseId"] = this.agencyEfnCaseId !== undefined ? this.agencyEfnCaseId : null as any;
        data["onetimeCompanyRecipient"] = this.onetimeCompanyRecipient !== undefined ? this.onetimeCompanyRecipient : null as any;
        data["uwdaApprovedById"] = this.uwdaApprovedById !== undefined ? this.uwdaApprovedById : null as any;
        data["uwdaApprovedByName"] = this.uwdaApprovedByName !== undefined ? this.uwdaApprovedByName : null as any;
        data["clientUnionInfo"] = this.clientUnionInfo !== undefined ? this.clientUnionInfo : null as any;
        data["clientCensusTract"] = this.clientCensusTract !== undefined ? this.clientCensusTract : null as any;
        data["specialCoding"] = this.specialCoding !== undefined ? this.specialCoding : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        data["uwdaApprovedBy"] = this.uwdaApprovedBy ? this.uwdaApprovedBy.toJSON() : null as any;
        data["bulkPaymentBatchHistory"] = this.bulkPaymentBatchHistory ? this.bulkPaymentBatchHistory.toJSON() : null as any;
        if (Array.isArray(this.agencyEfnCases)) {
            data["agencyEfnCases"] = [];
            for (let item of this.agencyEfnCases)
                data["agencyEfnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allocationLedgers)) {
            data["allocationLedgers"] = [];
            for (let item of this.allocationLedgers)
                data["allocationLedgers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentApplications)) {
            data["keepingCurrentApplications"] = [];
            for (let item of this.keepingCurrentApplications)
                data["keepingCurrentApplications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Pledge2 {
        const json = this.toJSON();
        let result = new Pledge2();
        result.init(json);
        return result;
    }
}

export interface IPledge2 extends IBaseEntity {
    clientId?: string;
    pledgeTypeId?: string;
    agencyId?: string;
    companyId?: string | null;
    clientCompanyAccountNumber?: string | null;
    pledgedAmount?: number;
    pledgedDate?: Date;
    hadTraining?: boolean | null;
    householdBudgetTraining?: boolean | null;
    amerenBudgetTraining?: boolean | null;
    creditCounselling?: boolean | null;
    caseManagement?: boolean | null;
    otherTraining?: boolean | null;
    accountBalance?: number | null;
    clientPayment?: number | null;
    serviceIsDisconnected?: boolean | null;
    justificationOfWaiver?: string | null;
    status?: PledgeStatusType;
    isCrisisPledge?: boolean | null;
    invoiceNumber?: string | null;
    paidDate?: Date | null;
    pledgeNumber?: number;
    clientSsn?: string | null;
    clientSsnhash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    program?: number;
    federalPovertyLevelDisplay?: number | null;
    assistanceType?: PledgeAssistanceType | null;
    leverageAmount?: number | null;
    checkMemo?: string | null;
    onetimeCompanyAddress1?: string | null;
    onetimeCompanyAddress2?: string | null;
    onetimeCompanyCity?: string | null;
    onetimeCompanyState?: string | null;
    onetimeCompanyZip?: string | null;
    agencyEfnCaseId?: string | null;
    onetimeCompanyRecipient?: string | null;
    uwdaApprovedById?: string | null;
    uwdaApprovedByName?: string | null;
    clientUnionInfo?: string | null;
    clientCensusTract?: string | null;
    specialCoding?: string | null;
    agency?: Agency2 | null;
    client?: Client2 | null;
    company?: Company2 | null;
    pledgeType?: PledgeType2 | null;
    uwdaApprovedBy?: User2 | null;
    bulkPaymentBatchHistory?: PledgeBulkPaymentBatchHistoryEntity | null;
    agencyEfnCases?: AgencyEfnCase2[] | null;
    allocationLedgers?: AllocationLedger[] | null;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
}

export class User2 extends BaseEntity implements IUser2 {
    companyId?: string | null;
    username?: string | null;
    passwordHash?: string | null;
    passwordSalt?: string | null;
    userType?: UserType | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    oldAgencyName?: string | null;
    status?: UserStatusType;
    emailOptOut?: boolean;
    passwordExpire?: Date | null;
    accessFailedCount?: number;
    lockoutEnd?: Date | null;
    phone?: string | null;
    agencyId?: string | null;
    phoneExt?: string | null;
    receiveEfnEmails?: boolean;
    uwAgreementDate?: Date | null;
    password?: string | null;
    canAuditApplications?: boolean | null;
    canReviewApplications?: boolean | null;
    agency?: Agency2 | null;
    company?: Company2 | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
    efnCases?: EfnCase2[] | null;
    assistanceApplicationComments?: AssistanceApplicationCommentEntity[] | null;
    efnCaseComments?: EfnCaseComments[] | null;
    assistanceApplicationFiles?: AssistanceApplicationFileEntity[] | null;
    efnCaseFiles?: EfnCaseFiles[] | null;
    pledges?: Pledge2[] | null;

    constructor(data?: IUser2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.passwordHash = _data["passwordHash"] !== undefined ? _data["passwordHash"] : null as any;
            this.passwordSalt = _data["passwordSalt"] !== undefined ? _data["passwordSalt"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.oldAgencyName = _data["oldAgencyName"] !== undefined ? _data["oldAgencyName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.emailOptOut = _data["emailOptOut"] !== undefined ? _data["emailOptOut"] : null as any;
            this.passwordExpire = _data["passwordExpire"] ? new Date(_data["passwordExpire"].toString()) : null as any;
            this.accessFailedCount = _data["accessFailedCount"] !== undefined ? _data["accessFailedCount"] : null as any;
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.phoneExt = _data["phoneExt"] !== undefined ? _data["phoneExt"] : null as any;
            this.receiveEfnEmails = _data["receiveEfnEmails"] !== undefined ? _data["receiveEfnEmails"] : null as any;
            this.uwAgreementDate = _data["uwAgreementDate"] ? new Date(_data["uwAgreementDate"].toString()) : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.canAuditApplications = _data["canAuditApplications"] !== undefined ? _data["canAuditApplications"] : null as any;
            this.canReviewApplications = _data["canReviewApplications"] !== undefined ? _data["canReviewApplications"] : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            if (Array.isArray(_data["assistanceApplications"])) {
                this.assistanceApplications = [] as any;
                for (let item of _data["assistanceApplications"])
                    this.assistanceApplications!.push(AssistanceApplicationEntity.fromJS(item));
            }
            else {
                this.assistanceApplications = null as any;
            }
            if (Array.isArray(_data["efnCases"])) {
                this.efnCases = [] as any;
                for (let item of _data["efnCases"])
                    this.efnCases!.push(EfnCase2.fromJS(item));
            }
            else {
                this.efnCases = null as any;
            }
            if (Array.isArray(_data["assistanceApplicationComments"])) {
                this.assistanceApplicationComments = [] as any;
                for (let item of _data["assistanceApplicationComments"])
                    this.assistanceApplicationComments!.push(AssistanceApplicationCommentEntity.fromJS(item));
            }
            else {
                this.assistanceApplicationComments = null as any;
            }
            if (Array.isArray(_data["efnCaseComments"])) {
                this.efnCaseComments = [] as any;
                for (let item of _data["efnCaseComments"])
                    this.efnCaseComments!.push(EfnCaseComments.fromJS(item));
            }
            else {
                this.efnCaseComments = null as any;
            }
            if (Array.isArray(_data["assistanceApplicationFiles"])) {
                this.assistanceApplicationFiles = [] as any;
                for (let item of _data["assistanceApplicationFiles"])
                    this.assistanceApplicationFiles!.push(AssistanceApplicationFileEntity.fromJS(item));
            }
            else {
                this.assistanceApplicationFiles = null as any;
            }
            if (Array.isArray(_data["efnCaseFiles"])) {
                this.efnCaseFiles = [] as any;
                for (let item of _data["efnCaseFiles"])
                    this.efnCaseFiles!.push(EfnCaseFiles.fromJS(item));
            }
            else {
                this.efnCaseFiles = null as any;
            }
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(Pledge2.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
        }
    }

    static override fromJS(data: any): User2 {
        data = typeof data === 'object' ? data : {};
        let result = new User2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["passwordHash"] = this.passwordHash !== undefined ? this.passwordHash : null as any;
        data["passwordSalt"] = this.passwordSalt !== undefined ? this.passwordSalt : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["oldAgencyName"] = this.oldAgencyName !== undefined ? this.oldAgencyName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["emailOptOut"] = this.emailOptOut !== undefined ? this.emailOptOut : null as any;
        data["passwordExpire"] = this.passwordExpire ? this.passwordExpire.toISOString() : null as any;
        data["accessFailedCount"] = this.accessFailedCount !== undefined ? this.accessFailedCount : null as any;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["phoneExt"] = this.phoneExt !== undefined ? this.phoneExt : null as any;
        data["receiveEfnEmails"] = this.receiveEfnEmails !== undefined ? this.receiveEfnEmails : null as any;
        data["uwAgreementDate"] = this.uwAgreementDate ? this.uwAgreementDate.toISOString() : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["canAuditApplications"] = this.canAuditApplications !== undefined ? this.canAuditApplications : null as any;
        data["canReviewApplications"] = this.canReviewApplications !== undefined ? this.canReviewApplications : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        if (Array.isArray(this.assistanceApplications)) {
            data["assistanceApplications"] = [];
            for (let item of this.assistanceApplications)
                data["assistanceApplications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCases)) {
            data["efnCases"] = [];
            for (let item of this.efnCases)
                data["efnCases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.assistanceApplicationComments)) {
            data["assistanceApplicationComments"] = [];
            for (let item of this.assistanceApplicationComments)
                data["assistanceApplicationComments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCaseComments)) {
            data["efnCaseComments"] = [];
            for (let item of this.efnCaseComments)
                data["efnCaseComments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.assistanceApplicationFiles)) {
            data["assistanceApplicationFiles"] = [];
            for (let item of this.assistanceApplicationFiles)
                data["assistanceApplicationFiles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.efnCaseFiles)) {
            data["efnCaseFiles"] = [];
            for (let item of this.efnCaseFiles)
                data["efnCaseFiles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): User2 {
        const json = this.toJSON();
        let result = new User2();
        result.init(json);
        return result;
    }
}

export interface IUser2 extends IBaseEntity {
    companyId?: string | null;
    username?: string | null;
    passwordHash?: string | null;
    passwordSalt?: string | null;
    userType?: UserType | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    oldAgencyName?: string | null;
    status?: UserStatusType;
    emailOptOut?: boolean;
    passwordExpire?: Date | null;
    accessFailedCount?: number;
    lockoutEnd?: Date | null;
    phone?: string | null;
    agencyId?: string | null;
    phoneExt?: string | null;
    receiveEfnEmails?: boolean;
    uwAgreementDate?: Date | null;
    password?: string | null;
    canAuditApplications?: boolean | null;
    canReviewApplications?: boolean | null;
    agency?: Agency2 | null;
    company?: Company2 | null;
    assistanceApplications?: AssistanceApplicationEntity[] | null;
    efnCases?: EfnCase2[] | null;
    assistanceApplicationComments?: AssistanceApplicationCommentEntity[] | null;
    efnCaseComments?: EfnCaseComments[] | null;
    assistanceApplicationFiles?: AssistanceApplicationFileEntity[] | null;
    efnCaseFiles?: EfnCaseFiles[] | null;
    pledges?: Pledge2[] | null;
}

export class AssistanceApplicationCommentEntity extends BaseEntity implements IAssistanceApplicationCommentEntity {
    assistanceApplicationId?: string;
    userId?: string;
    comment?: string | null;
    assistanceApplication?: AssistanceApplicationEntity | null;
    user?: User2 | null;

    constructor(data?: IAssistanceApplicationCommentEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationCommentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationCommentEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationCommentEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationCommentEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationCommentEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    userId?: string;
    comment?: string | null;
    assistanceApplication?: AssistanceApplicationEntity | null;
    user?: User2 | null;
}

export class EfnCaseComments extends BaseEntity implements IEfnCaseComments {
    efnCaseId?: string;
    userId?: string;
    comment?: string | null;
    efnCase?: EfnCase2 | null;
    user?: User2 | null;

    constructor(data?: IEfnCaseComments) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.efnCase = _data["efnCase"] ? EfnCase2.fromJS(_data["efnCase"]) : null as any;
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): EfnCaseComments {
        data = typeof data === 'object' ? data : {};
        let result = new EfnCaseComments();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["efnCase"] = this.efnCase ? this.efnCase.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfnCaseComments {
        const json = this.toJSON();
        let result = new EfnCaseComments();
        result.init(json);
        return result;
    }
}

export interface IEfnCaseComments extends IBaseEntity {
    efnCaseId?: string;
    userId?: string;
    comment?: string | null;
    efnCase?: EfnCase2 | null;
    user?: User2 | null;
}

export class AssistanceApplicationFileEntity extends BaseEntity implements IAssistanceApplicationFileEntity {
    assistanceApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileUrl?: string | null;
    caseFileType?: string | null;
    assistanceApplication?: AssistanceApplicationEntity | null;
    user?: User2 | null;

    constructor(data?: IAssistanceApplicationFileEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.caseFileType = _data["caseFileType"] !== undefined ? _data["caseFileType"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationFileEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["caseFileType"] = this.caseFileType !== undefined ? this.caseFileType : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationFileEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationFileEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationFileEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileUrl?: string | null;
    caseFileType?: string | null;
    assistanceApplication?: AssistanceApplicationEntity | null;
    user?: User2 | null;
}

export class EfnCaseFiles extends BaseEntity implements IEfnCaseFiles {
    efnCaseId?: string;
    userId?: string;
    fileName?: string | null;
    fileUrl?: string | null;
    efnCase?: EfnCase2 | null;
    user?: User2 | null;

    constructor(data?: IEfnCaseFiles) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.efnCaseId = _data["efnCaseId"] !== undefined ? _data["efnCaseId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.efnCase = _data["efnCase"] ? EfnCase2.fromJS(_data["efnCase"]) : null as any;
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): EfnCaseFiles {
        data = typeof data === 'object' ? data : {};
        let result = new EfnCaseFiles();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efnCaseId"] = this.efnCaseId !== undefined ? this.efnCaseId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["efnCase"] = this.efnCase ? this.efnCase.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfnCaseFiles {
        const json = this.toJSON();
        let result = new EfnCaseFiles();
        result.init(json);
        return result;
    }
}

export interface IEfnCaseFiles extends IBaseEntity {
    efnCaseId?: string;
    userId?: string;
    fileName?: string | null;
    fileUrl?: string | null;
    efnCase?: EfnCase2 | null;
    user?: User2 | null;
}

export class PledgeBulkPaymentBatchHistoryEntity extends BaseEntity implements IPledgeBulkPaymentBatchHistoryEntity {
    pledgeBulkPaymentBatchId?: string;
    pledgeBulkPaymentBatchEntity?: PledgeBulkPaymentBatchEntity | null;
    pledgeId?: string;
    pledge?: Pledge2 | null;

    constructor(data?: IPledgeBulkPaymentBatchHistoryEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pledgeBulkPaymentBatchId = _data["pledgeBulkPaymentBatchId"] !== undefined ? _data["pledgeBulkPaymentBatchId"] : null as any;
            this.pledgeBulkPaymentBatchEntity = _data["pledgeBulkPaymentBatchEntity"] ? PledgeBulkPaymentBatchEntity.fromJS(_data["pledgeBulkPaymentBatchEntity"]) : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.pledge = _data["pledge"] ? Pledge2.fromJS(_data["pledge"]) : null as any;
        }
    }

    static override fromJS(data: any): PledgeBulkPaymentBatchHistoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentBatchHistoryEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pledgeBulkPaymentBatchId"] = this.pledgeBulkPaymentBatchId !== undefined ? this.pledgeBulkPaymentBatchId : null as any;
        data["pledgeBulkPaymentBatchEntity"] = this.pledgeBulkPaymentBatchEntity ? this.pledgeBulkPaymentBatchEntity.toJSON() : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["pledge"] = this.pledge ? this.pledge.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PledgeBulkPaymentBatchHistoryEntity {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentBatchHistoryEntity();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentBatchHistoryEntity extends IBaseEntity {
    pledgeBulkPaymentBatchId?: string;
    pledgeBulkPaymentBatchEntity?: PledgeBulkPaymentBatchEntity | null;
    pledgeId?: string;
    pledge?: Pledge2 | null;
}

export class PledgeBulkPaymentBatchEntity extends BaseEntity implements IPledgeBulkPaymentBatchEntity {
    pledges?: PledgeBulkPaymentBatchHistoryEntity[] | null;

    constructor(data?: IPledgeBulkPaymentBatchEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(PledgeBulkPaymentBatchHistoryEntity.fromJS(item));
            }
            else {
                this.pledges = null as any;
            }
        }
    }

    static override fromJS(data: any): PledgeBulkPaymentBatchEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeBulkPaymentBatchEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PledgeBulkPaymentBatchEntity {
        const json = this.toJSON();
        let result = new PledgeBulkPaymentBatchEntity();
        result.init(json);
        return result;
    }
}

export interface IPledgeBulkPaymentBatchEntity extends IBaseEntity {
    pledges?: PledgeBulkPaymentBatchHistoryEntity[] | null;
}

export class KeepingCurrentApplication extends BaseEntity implements IKeepingCurrentApplication {
    keepingCurrentProgramId?: string;
    keepingCurrentStatusId?: string;
    clientId?: string;
    pledgeStatus?: PledgeStatusType;
    clientSsn?: string | null;
    clientSsnhash?: string | null;
    clientLast4Ssn?: string | null;
    totalAmountOwed?: number;
    upfrontAmountDue?: number | null;
    upfrontAmountPaid?: number | null;
    upfrontPaySource?: KcPaySourceType | null;
    programMonthlyCredit?: number | null;
    programTotalNumMonthlyCredits?: number | null;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number | null;
    arrearsMonthlyPercent?: number | null;
    arrearsTotalNumMonthlyCredits?: number | null;
    arrearsMonthlyEstimatedCredit?: number | null;
    arrearsTotalEstimatedCredits?: number | null;
    totalMonthlyEstimatedCredit?: number | null;
    grandTotalEstimatedCredits?: number | null;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    isThirdPartyAgreeable?: boolean;
    thirdPartyAgreement?: Date | null;
    downloadTimestamp?: Date | null;
    approvedTimestamp?: Date | null;
    rowIsNotActive?: boolean;
    accountNumber?: string | null;
    agencyId?: string;
    pledgeId?: string | null;
    clientFederalPovertyLevelDisplay?: number | null;
    agency?: Agency2 | null;
    client?: Client2 | null;
    keepingCurrentProgram?: KeepingCurrentProgram | null;
    keepingCurrentStatus?: KeepingCurrentStatus | null;
    pledge?: Pledge2 | null;
    keepingCurrentApplicationNotes?: KeepingCurrentApplicationNote[] | null;
    keepingCurrentCancellations?: KeepingCurrentCancellation[] | null;
    keepingCurrentConfirmOrphans?: KeepingCurrentConfirmOrphan[] | null;
    keepingCurrentConfirmations?: KeepingCurrentConfirmation[] | null;
    keepingCurrentMissedPayments?: KeepingCurrentMissedPayment[] | null;
    keepingCurrentMonthlyBills?: KeepingCurrentMonthlyBill[] | null;
    keepingCurrentMonthlyCredits?: KeepingCurrentMonthlyCredit[] | null;

    constructor(data?: IKeepingCurrentApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentProgramId = _data["keepingCurrentProgramId"] !== undefined ? _data["keepingCurrentProgramId"] : null as any;
            this.keepingCurrentStatusId = _data["keepingCurrentStatusId"] !== undefined ? _data["keepingCurrentStatusId"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.pledgeStatus = _data["pledgeStatus"] !== undefined ? _data["pledgeStatus"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientSsnhash = _data["clientSsnhash"] !== undefined ? _data["clientSsnhash"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.totalAmountOwed = _data["totalAmountOwed"] !== undefined ? _data["totalAmountOwed"] : null as any;
            this.upfrontAmountDue = _data["upfrontAmountDue"] !== undefined ? _data["upfrontAmountDue"] : null as any;
            this.upfrontAmountPaid = _data["upfrontAmountPaid"] !== undefined ? _data["upfrontAmountPaid"] : null as any;
            this.upfrontPaySource = _data["upfrontPaySource"] !== undefined ? _data["upfrontPaySource"] : null as any;
            this.programMonthlyCredit = _data["programMonthlyCredit"] !== undefined ? _data["programMonthlyCredit"] : null as any;
            this.programTotalNumMonthlyCredits = _data["programTotalNumMonthlyCredits"] !== undefined ? _data["programTotalNumMonthlyCredits"] : null as any;
            this.programTotalEstimatedCredits = _data["programTotalEstimatedCredits"] !== undefined ? _data["programTotalEstimatedCredits"] : null as any;
            this.arrearsUpfrontPercent = _data["arrearsUpfrontPercent"] !== undefined ? _data["arrearsUpfrontPercent"] : null as any;
            this.arrearsMonthlyPercent = _data["arrearsMonthlyPercent"] !== undefined ? _data["arrearsMonthlyPercent"] : null as any;
            this.arrearsTotalNumMonthlyCredits = _data["arrearsTotalNumMonthlyCredits"] !== undefined ? _data["arrearsTotalNumMonthlyCredits"] : null as any;
            this.arrearsMonthlyEstimatedCredit = _data["arrearsMonthlyEstimatedCredit"] !== undefined ? _data["arrearsMonthlyEstimatedCredit"] : null as any;
            this.arrearsTotalEstimatedCredits = _data["arrearsTotalEstimatedCredits"] !== undefined ? _data["arrearsTotalEstimatedCredits"] : null as any;
            this.totalMonthlyEstimatedCredit = _data["totalMonthlyEstimatedCredit"] !== undefined ? _data["totalMonthlyEstimatedCredit"] : null as any;
            this.grandTotalEstimatedCredits = _data["grandTotalEstimatedCredits"] !== undefined ? _data["grandTotalEstimatedCredits"] : null as any;
            this.isLiheapReceived = _data["isLiheapReceived"] !== undefined ? _data["isLiheapReceived"] : null as any;
            this.isLiheapRequested = _data["isLiheapRequested"] !== undefined ? _data["isLiheapRequested"] : null as any;
            this.isWeatherizationReceived = _data["isWeatherizationReceived"] !== undefined ? _data["isWeatherizationReceived"] : null as any;
            this.isWeatherizationRequested = _data["isWeatherizationRequested"] !== undefined ? _data["isWeatherizationRequested"] : null as any;
            this.weatherizationStatus = _data["weatherizationStatus"] !== undefined ? _data["weatherizationStatus"] : null as any;
            this.isThirdPartyAgreeable = _data["isThirdPartyAgreeable"] !== undefined ? _data["isThirdPartyAgreeable"] : null as any;
            this.thirdPartyAgreement = _data["thirdPartyAgreement"] ? new Date(_data["thirdPartyAgreement"].toString()) : null as any;
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
            this.approvedTimestamp = _data["approvedTimestamp"] ? new Date(_data["approvedTimestamp"].toString()) : null as any;
            this.rowIsNotActive = _data["rowIsNotActive"] !== undefined ? _data["rowIsNotActive"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.clientFederalPovertyLevelDisplay = _data["clientFederalPovertyLevelDisplay"] !== undefined ? _data["clientFederalPovertyLevelDisplay"] : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : null as any;
            this.keepingCurrentProgram = _data["keepingCurrentProgram"] ? KeepingCurrentProgram.fromJS(_data["keepingCurrentProgram"]) : null as any;
            this.keepingCurrentStatus = _data["keepingCurrentStatus"] ? KeepingCurrentStatus.fromJS(_data["keepingCurrentStatus"]) : null as any;
            this.pledge = _data["pledge"] ? Pledge2.fromJS(_data["pledge"]) : null as any;
            if (Array.isArray(_data["keepingCurrentApplicationNotes"])) {
                this.keepingCurrentApplicationNotes = [] as any;
                for (let item of _data["keepingCurrentApplicationNotes"])
                    this.keepingCurrentApplicationNotes!.push(KeepingCurrentApplicationNote.fromJS(item));
            }
            else {
                this.keepingCurrentApplicationNotes = null as any;
            }
            if (Array.isArray(_data["keepingCurrentCancellations"])) {
                this.keepingCurrentCancellations = [] as any;
                for (let item of _data["keepingCurrentCancellations"])
                    this.keepingCurrentCancellations!.push(KeepingCurrentCancellation.fromJS(item));
            }
            else {
                this.keepingCurrentCancellations = null as any;
            }
            if (Array.isArray(_data["keepingCurrentConfirmOrphans"])) {
                this.keepingCurrentConfirmOrphans = [] as any;
                for (let item of _data["keepingCurrentConfirmOrphans"])
                    this.keepingCurrentConfirmOrphans!.push(KeepingCurrentConfirmOrphan.fromJS(item));
            }
            else {
                this.keepingCurrentConfirmOrphans = null as any;
            }
            if (Array.isArray(_data["keepingCurrentConfirmations"])) {
                this.keepingCurrentConfirmations = [] as any;
                for (let item of _data["keepingCurrentConfirmations"])
                    this.keepingCurrentConfirmations!.push(KeepingCurrentConfirmation.fromJS(item));
            }
            else {
                this.keepingCurrentConfirmations = null as any;
            }
            if (Array.isArray(_data["keepingCurrentMissedPayments"])) {
                this.keepingCurrentMissedPayments = [] as any;
                for (let item of _data["keepingCurrentMissedPayments"])
                    this.keepingCurrentMissedPayments!.push(KeepingCurrentMissedPayment.fromJS(item));
            }
            else {
                this.keepingCurrentMissedPayments = null as any;
            }
            if (Array.isArray(_data["keepingCurrentMonthlyBills"])) {
                this.keepingCurrentMonthlyBills = [] as any;
                for (let item of _data["keepingCurrentMonthlyBills"])
                    this.keepingCurrentMonthlyBills!.push(KeepingCurrentMonthlyBill.fromJS(item));
            }
            else {
                this.keepingCurrentMonthlyBills = null as any;
            }
            if (Array.isArray(_data["keepingCurrentMonthlyCredits"])) {
                this.keepingCurrentMonthlyCredits = [] as any;
                for (let item of _data["keepingCurrentMonthlyCredits"])
                    this.keepingCurrentMonthlyCredits!.push(KeepingCurrentMonthlyCredit.fromJS(item));
            }
            else {
                this.keepingCurrentMonthlyCredits = null as any;
            }
        }
    }

    static override fromJS(data: any): KeepingCurrentApplication {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentProgramId"] = this.keepingCurrentProgramId !== undefined ? this.keepingCurrentProgramId : null as any;
        data["keepingCurrentStatusId"] = this.keepingCurrentStatusId !== undefined ? this.keepingCurrentStatusId : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["pledgeStatus"] = this.pledgeStatus !== undefined ? this.pledgeStatus : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientSsnhash"] = this.clientSsnhash !== undefined ? this.clientSsnhash : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["totalAmountOwed"] = this.totalAmountOwed !== undefined ? this.totalAmountOwed : null as any;
        data["upfrontAmountDue"] = this.upfrontAmountDue !== undefined ? this.upfrontAmountDue : null as any;
        data["upfrontAmountPaid"] = this.upfrontAmountPaid !== undefined ? this.upfrontAmountPaid : null as any;
        data["upfrontPaySource"] = this.upfrontPaySource !== undefined ? this.upfrontPaySource : null as any;
        data["programMonthlyCredit"] = this.programMonthlyCredit !== undefined ? this.programMonthlyCredit : null as any;
        data["programTotalNumMonthlyCredits"] = this.programTotalNumMonthlyCredits !== undefined ? this.programTotalNumMonthlyCredits : null as any;
        data["programTotalEstimatedCredits"] = this.programTotalEstimatedCredits !== undefined ? this.programTotalEstimatedCredits : null as any;
        data["arrearsUpfrontPercent"] = this.arrearsUpfrontPercent !== undefined ? this.arrearsUpfrontPercent : null as any;
        data["arrearsMonthlyPercent"] = this.arrearsMonthlyPercent !== undefined ? this.arrearsMonthlyPercent : null as any;
        data["arrearsTotalNumMonthlyCredits"] = this.arrearsTotalNumMonthlyCredits !== undefined ? this.arrearsTotalNumMonthlyCredits : null as any;
        data["arrearsMonthlyEstimatedCredit"] = this.arrearsMonthlyEstimatedCredit !== undefined ? this.arrearsMonthlyEstimatedCredit : null as any;
        data["arrearsTotalEstimatedCredits"] = this.arrearsTotalEstimatedCredits !== undefined ? this.arrearsTotalEstimatedCredits : null as any;
        data["totalMonthlyEstimatedCredit"] = this.totalMonthlyEstimatedCredit !== undefined ? this.totalMonthlyEstimatedCredit : null as any;
        data["grandTotalEstimatedCredits"] = this.grandTotalEstimatedCredits !== undefined ? this.grandTotalEstimatedCredits : null as any;
        data["isLiheapReceived"] = this.isLiheapReceived !== undefined ? this.isLiheapReceived : null as any;
        data["isLiheapRequested"] = this.isLiheapRequested !== undefined ? this.isLiheapRequested : null as any;
        data["isWeatherizationReceived"] = this.isWeatherizationReceived !== undefined ? this.isWeatherizationReceived : null as any;
        data["isWeatherizationRequested"] = this.isWeatherizationRequested !== undefined ? this.isWeatherizationRequested : null as any;
        data["weatherizationStatus"] = this.weatherizationStatus !== undefined ? this.weatherizationStatus : null as any;
        data["isThirdPartyAgreeable"] = this.isThirdPartyAgreeable !== undefined ? this.isThirdPartyAgreeable : null as any;
        data["thirdPartyAgreement"] = this.thirdPartyAgreement ? this.thirdPartyAgreement.toISOString() : null as any;
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        data["approvedTimestamp"] = this.approvedTimestamp ? this.approvedTimestamp.toISOString() : null as any;
        data["rowIsNotActive"] = this.rowIsNotActive !== undefined ? this.rowIsNotActive : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["clientFederalPovertyLevelDisplay"] = this.clientFederalPovertyLevelDisplay !== undefined ? this.clientFederalPovertyLevelDisplay : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["keepingCurrentProgram"] = this.keepingCurrentProgram ? this.keepingCurrentProgram.toJSON() : null as any;
        data["keepingCurrentStatus"] = this.keepingCurrentStatus ? this.keepingCurrentStatus.toJSON() : null as any;
        data["pledge"] = this.pledge ? this.pledge.toJSON() : null as any;
        if (Array.isArray(this.keepingCurrentApplicationNotes)) {
            data["keepingCurrentApplicationNotes"] = [];
            for (let item of this.keepingCurrentApplicationNotes)
                data["keepingCurrentApplicationNotes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentCancellations)) {
            data["keepingCurrentCancellations"] = [];
            for (let item of this.keepingCurrentCancellations)
                data["keepingCurrentCancellations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentConfirmOrphans)) {
            data["keepingCurrentConfirmOrphans"] = [];
            for (let item of this.keepingCurrentConfirmOrphans)
                data["keepingCurrentConfirmOrphans"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentConfirmations)) {
            data["keepingCurrentConfirmations"] = [];
            for (let item of this.keepingCurrentConfirmations)
                data["keepingCurrentConfirmations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentMissedPayments)) {
            data["keepingCurrentMissedPayments"] = [];
            for (let item of this.keepingCurrentMissedPayments)
                data["keepingCurrentMissedPayments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentMonthlyBills)) {
            data["keepingCurrentMonthlyBills"] = [];
            for (let item of this.keepingCurrentMonthlyBills)
                data["keepingCurrentMonthlyBills"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentMonthlyCredits)) {
            data["keepingCurrentMonthlyCredits"] = [];
            for (let item of this.keepingCurrentMonthlyCredits)
                data["keepingCurrentMonthlyCredits"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentApplication {
        const json = this.toJSON();
        let result = new KeepingCurrentApplication();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentApplication extends IBaseEntity {
    keepingCurrentProgramId?: string;
    keepingCurrentStatusId?: string;
    clientId?: string;
    pledgeStatus?: PledgeStatusType;
    clientSsn?: string | null;
    clientSsnhash?: string | null;
    clientLast4Ssn?: string | null;
    totalAmountOwed?: number;
    upfrontAmountDue?: number | null;
    upfrontAmountPaid?: number | null;
    upfrontPaySource?: KcPaySourceType | null;
    programMonthlyCredit?: number | null;
    programTotalNumMonthlyCredits?: number | null;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number | null;
    arrearsMonthlyPercent?: number | null;
    arrearsTotalNumMonthlyCredits?: number | null;
    arrearsMonthlyEstimatedCredit?: number | null;
    arrearsTotalEstimatedCredits?: number | null;
    totalMonthlyEstimatedCredit?: number | null;
    grandTotalEstimatedCredits?: number | null;
    isLiheapReceived?: boolean | null;
    isLiheapRequested?: boolean | null;
    isWeatherizationReceived?: boolean | null;
    isWeatherizationRequested?: boolean | null;
    weatherizationStatus?: WeatherizationStatusesType | null;
    isThirdPartyAgreeable?: boolean;
    thirdPartyAgreement?: Date | null;
    downloadTimestamp?: Date | null;
    approvedTimestamp?: Date | null;
    rowIsNotActive?: boolean;
    accountNumber?: string | null;
    agencyId?: string;
    pledgeId?: string | null;
    clientFederalPovertyLevelDisplay?: number | null;
    agency?: Agency2 | null;
    client?: Client2 | null;
    keepingCurrentProgram?: KeepingCurrentProgram | null;
    keepingCurrentStatus?: KeepingCurrentStatus | null;
    pledge?: Pledge2 | null;
    keepingCurrentApplicationNotes?: KeepingCurrentApplicationNote[] | null;
    keepingCurrentCancellations?: KeepingCurrentCancellation[] | null;
    keepingCurrentConfirmOrphans?: KeepingCurrentConfirmOrphan[] | null;
    keepingCurrentConfirmations?: KeepingCurrentConfirmation[] | null;
    keepingCurrentMissedPayments?: KeepingCurrentMissedPayment[] | null;
    keepingCurrentMonthlyBills?: KeepingCurrentMonthlyBill[] | null;
    keepingCurrentMonthlyCredits?: KeepingCurrentMonthlyCredit[] | null;
}

export class KeepingCurrentProgram extends BaseEntity implements IKeepingCurrentProgram {
    programName?: string | null;
    hasArrearsCredits?: boolean | null;
    displaySortOrder?: number;
    rowIsNotActive?: boolean;
    minLevel?: number;
    maxLevel?: number;
    pledgeTypeId?: string;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
    keepingCurrentProgramLevels?: KeepingCurrentProgramLevel[] | null;

    constructor(data?: IKeepingCurrentProgram) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programName = _data["programName"] !== undefined ? _data["programName"] : null as any;
            this.hasArrearsCredits = _data["hasArrearsCredits"] !== undefined ? _data["hasArrearsCredits"] : null as any;
            this.displaySortOrder = _data["displaySortOrder"] !== undefined ? _data["displaySortOrder"] : null as any;
            this.rowIsNotActive = _data["rowIsNotActive"] !== undefined ? _data["rowIsNotActive"] : null as any;
            this.minLevel = _data["minLevel"] !== undefined ? _data["minLevel"] : null as any;
            this.maxLevel = _data["maxLevel"] !== undefined ? _data["maxLevel"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            if (Array.isArray(_data["keepingCurrentApplications"])) {
                this.keepingCurrentApplications = [] as any;
                for (let item of _data["keepingCurrentApplications"])
                    this.keepingCurrentApplications!.push(KeepingCurrentApplication.fromJS(item));
            }
            else {
                this.keepingCurrentApplications = null as any;
            }
            if (Array.isArray(_data["keepingCurrentProgramLevels"])) {
                this.keepingCurrentProgramLevels = [] as any;
                for (let item of _data["keepingCurrentProgramLevels"])
                    this.keepingCurrentProgramLevels!.push(KeepingCurrentProgramLevel.fromJS(item));
            }
            else {
                this.keepingCurrentProgramLevels = null as any;
            }
        }
    }

    static override fromJS(data: any): KeepingCurrentProgram {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentProgram();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programName"] = this.programName !== undefined ? this.programName : null as any;
        data["hasArrearsCredits"] = this.hasArrearsCredits !== undefined ? this.hasArrearsCredits : null as any;
        data["displaySortOrder"] = this.displaySortOrder !== undefined ? this.displaySortOrder : null as any;
        data["rowIsNotActive"] = this.rowIsNotActive !== undefined ? this.rowIsNotActive : null as any;
        data["minLevel"] = this.minLevel !== undefined ? this.minLevel : null as any;
        data["maxLevel"] = this.maxLevel !== undefined ? this.maxLevel : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        if (Array.isArray(this.keepingCurrentApplications)) {
            data["keepingCurrentApplications"] = [];
            for (let item of this.keepingCurrentApplications)
                data["keepingCurrentApplications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.keepingCurrentProgramLevels)) {
            data["keepingCurrentProgramLevels"] = [];
            for (let item of this.keepingCurrentProgramLevels)
                data["keepingCurrentProgramLevels"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentProgram {
        const json = this.toJSON();
        let result = new KeepingCurrentProgram();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentProgram extends IBaseEntity {
    programName?: string | null;
    hasArrearsCredits?: boolean | null;
    displaySortOrder?: number;
    rowIsNotActive?: boolean;
    minLevel?: number;
    maxLevel?: number;
    pledgeTypeId?: string;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
    keepingCurrentProgramLevels?: KeepingCurrentProgramLevel[] | null;
}

export class KeepingCurrentProgramLevel extends BaseEntity implements IKeepingCurrentProgramLevel {
    keepingCurrentProgramId?: string;
    federalPovertyLevelId?: string;
    isValidProgramLevel?: boolean | null;
    isRequiredSeniorDisabledOrChild?: boolean;
    programMonthlyCredit?: number;
    programTotalNumMonthlyCredits?: number;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number;
    arrearsMonthlyPercent?: number;
    arrearsTotalNumMonthlyCredits?: number;
    rowIsNotActive?: boolean;
    federalPovertyLevel?: FederalPovertyLevel2 | null;
    keepingCurrentProgram?: KeepingCurrentProgram | null;

    constructor(data?: IKeepingCurrentProgramLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentProgramId = _data["keepingCurrentProgramId"] !== undefined ? _data["keepingCurrentProgramId"] : null as any;
            this.federalPovertyLevelId = _data["federalPovertyLevelId"] !== undefined ? _data["federalPovertyLevelId"] : null as any;
            this.isValidProgramLevel = _data["isValidProgramLevel"] !== undefined ? _data["isValidProgramLevel"] : null as any;
            this.isRequiredSeniorDisabledOrChild = _data["isRequiredSeniorDisabledOrChild"] !== undefined ? _data["isRequiredSeniorDisabledOrChild"] : null as any;
            this.programMonthlyCredit = _data["programMonthlyCredit"] !== undefined ? _data["programMonthlyCredit"] : null as any;
            this.programTotalNumMonthlyCredits = _data["programTotalNumMonthlyCredits"] !== undefined ? _data["programTotalNumMonthlyCredits"] : null as any;
            this.programTotalEstimatedCredits = _data["programTotalEstimatedCredits"] !== undefined ? _data["programTotalEstimatedCredits"] : null as any;
            this.arrearsUpfrontPercent = _data["arrearsUpfrontPercent"] !== undefined ? _data["arrearsUpfrontPercent"] : null as any;
            this.arrearsMonthlyPercent = _data["arrearsMonthlyPercent"] !== undefined ? _data["arrearsMonthlyPercent"] : null as any;
            this.arrearsTotalNumMonthlyCredits = _data["arrearsTotalNumMonthlyCredits"] !== undefined ? _data["arrearsTotalNumMonthlyCredits"] : null as any;
            this.rowIsNotActive = _data["rowIsNotActive"] !== undefined ? _data["rowIsNotActive"] : null as any;
            this.federalPovertyLevel = _data["federalPovertyLevel"] ? FederalPovertyLevel2.fromJS(_data["federalPovertyLevel"]) : null as any;
            this.keepingCurrentProgram = _data["keepingCurrentProgram"] ? KeepingCurrentProgram.fromJS(_data["keepingCurrentProgram"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentProgramLevel {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentProgramLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentProgramId"] = this.keepingCurrentProgramId !== undefined ? this.keepingCurrentProgramId : null as any;
        data["federalPovertyLevelId"] = this.federalPovertyLevelId !== undefined ? this.federalPovertyLevelId : null as any;
        data["isValidProgramLevel"] = this.isValidProgramLevel !== undefined ? this.isValidProgramLevel : null as any;
        data["isRequiredSeniorDisabledOrChild"] = this.isRequiredSeniorDisabledOrChild !== undefined ? this.isRequiredSeniorDisabledOrChild : null as any;
        data["programMonthlyCredit"] = this.programMonthlyCredit !== undefined ? this.programMonthlyCredit : null as any;
        data["programTotalNumMonthlyCredits"] = this.programTotalNumMonthlyCredits !== undefined ? this.programTotalNumMonthlyCredits : null as any;
        data["programTotalEstimatedCredits"] = this.programTotalEstimatedCredits !== undefined ? this.programTotalEstimatedCredits : null as any;
        data["arrearsUpfrontPercent"] = this.arrearsUpfrontPercent !== undefined ? this.arrearsUpfrontPercent : null as any;
        data["arrearsMonthlyPercent"] = this.arrearsMonthlyPercent !== undefined ? this.arrearsMonthlyPercent : null as any;
        data["arrearsTotalNumMonthlyCredits"] = this.arrearsTotalNumMonthlyCredits !== undefined ? this.arrearsTotalNumMonthlyCredits : null as any;
        data["rowIsNotActive"] = this.rowIsNotActive !== undefined ? this.rowIsNotActive : null as any;
        data["federalPovertyLevel"] = this.federalPovertyLevel ? this.federalPovertyLevel.toJSON() : null as any;
        data["keepingCurrentProgram"] = this.keepingCurrentProgram ? this.keepingCurrentProgram.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentProgramLevel {
        const json = this.toJSON();
        let result = new KeepingCurrentProgramLevel();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentProgramLevel extends IBaseEntity {
    keepingCurrentProgramId?: string;
    federalPovertyLevelId?: string;
    isValidProgramLevel?: boolean | null;
    isRequiredSeniorDisabledOrChild?: boolean;
    programMonthlyCredit?: number;
    programTotalNumMonthlyCredits?: number;
    programTotalEstimatedCredits?: number | null;
    arrearsUpfrontPercent?: number;
    arrearsMonthlyPercent?: number;
    arrearsTotalNumMonthlyCredits?: number;
    rowIsNotActive?: boolean;
    federalPovertyLevel?: FederalPovertyLevel2 | null;
    keepingCurrentProgram?: KeepingCurrentProgram | null;
}

export class FederalPovertyLevel2 extends BaseEntity implements IFederalPovertyLevel2 {
    federalPovertyLevelDisplay?: string | null;
    minLevel?: number;
    maxLevel?: number;
    keepingCurrentProgramLevels?: KeepingCurrentProgramLevel[] | null;

    constructor(data?: IFederalPovertyLevel2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.minLevel = _data["minLevel"] !== undefined ? _data["minLevel"] : null as any;
            this.maxLevel = _data["maxLevel"] !== undefined ? _data["maxLevel"] : null as any;
            if (Array.isArray(_data["keepingCurrentProgramLevels"])) {
                this.keepingCurrentProgramLevels = [] as any;
                for (let item of _data["keepingCurrentProgramLevels"])
                    this.keepingCurrentProgramLevels!.push(KeepingCurrentProgramLevel.fromJS(item));
            }
            else {
                this.keepingCurrentProgramLevels = null as any;
            }
        }
    }

    static override fromJS(data: any): FederalPovertyLevel2 {
        data = typeof data === 'object' ? data : {};
        let result = new FederalPovertyLevel2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["minLevel"] = this.minLevel !== undefined ? this.minLevel : null as any;
        data["maxLevel"] = this.maxLevel !== undefined ? this.maxLevel : null as any;
        if (Array.isArray(this.keepingCurrentProgramLevels)) {
            data["keepingCurrentProgramLevels"] = [];
            for (let item of this.keepingCurrentProgramLevels)
                data["keepingCurrentProgramLevels"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FederalPovertyLevel2 {
        const json = this.toJSON();
        let result = new FederalPovertyLevel2();
        result.init(json);
        return result;
    }
}

export interface IFederalPovertyLevel2 extends IBaseEntity {
    federalPovertyLevelDisplay?: string | null;
    minLevel?: number;
    maxLevel?: number;
    keepingCurrentProgramLevels?: KeepingCurrentProgramLevel[] | null;
}

export class KeepingCurrentStatus extends BaseEntity implements IKeepingCurrentStatus {
    statusName?: string | null;
    isSystemSet?: boolean;
    displaySortOrder?: number;
    isNewStatus?: boolean;
    isPendingApprovalStatus?: boolean;
    isApprovedStatus?: boolean;
    isRejectedStatus?: boolean;
    isPayMissedStatus?: boolean;
    isDefaultedStatus?: boolean;
    isCancelledStatus?: boolean;
    isExpiredStatus?: boolean;
    isDeletedStatus?: boolean;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;

    constructor(data?: IKeepingCurrentStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.isSystemSet = _data["isSystemSet"] !== undefined ? _data["isSystemSet"] : null as any;
            this.displaySortOrder = _data["displaySortOrder"] !== undefined ? _data["displaySortOrder"] : null as any;
            this.isNewStatus = _data["isNewStatus"] !== undefined ? _data["isNewStatus"] : null as any;
            this.isPendingApprovalStatus = _data["isPendingApprovalStatus"] !== undefined ? _data["isPendingApprovalStatus"] : null as any;
            this.isApprovedStatus = _data["isApprovedStatus"] !== undefined ? _data["isApprovedStatus"] : null as any;
            this.isRejectedStatus = _data["isRejectedStatus"] !== undefined ? _data["isRejectedStatus"] : null as any;
            this.isPayMissedStatus = _data["isPayMissedStatus"] !== undefined ? _data["isPayMissedStatus"] : null as any;
            this.isDefaultedStatus = _data["isDefaultedStatus"] !== undefined ? _data["isDefaultedStatus"] : null as any;
            this.isCancelledStatus = _data["isCancelledStatus"] !== undefined ? _data["isCancelledStatus"] : null as any;
            this.isExpiredStatus = _data["isExpiredStatus"] !== undefined ? _data["isExpiredStatus"] : null as any;
            this.isDeletedStatus = _data["isDeletedStatus"] !== undefined ? _data["isDeletedStatus"] : null as any;
            if (Array.isArray(_data["keepingCurrentApplications"])) {
                this.keepingCurrentApplications = [] as any;
                for (let item of _data["keepingCurrentApplications"])
                    this.keepingCurrentApplications!.push(KeepingCurrentApplication.fromJS(item));
            }
            else {
                this.keepingCurrentApplications = null as any;
            }
        }
    }

    static override fromJS(data: any): KeepingCurrentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["isSystemSet"] = this.isSystemSet !== undefined ? this.isSystemSet : null as any;
        data["displaySortOrder"] = this.displaySortOrder !== undefined ? this.displaySortOrder : null as any;
        data["isNewStatus"] = this.isNewStatus !== undefined ? this.isNewStatus : null as any;
        data["isPendingApprovalStatus"] = this.isPendingApprovalStatus !== undefined ? this.isPendingApprovalStatus : null as any;
        data["isApprovedStatus"] = this.isApprovedStatus !== undefined ? this.isApprovedStatus : null as any;
        data["isRejectedStatus"] = this.isRejectedStatus !== undefined ? this.isRejectedStatus : null as any;
        data["isPayMissedStatus"] = this.isPayMissedStatus !== undefined ? this.isPayMissedStatus : null as any;
        data["isDefaultedStatus"] = this.isDefaultedStatus !== undefined ? this.isDefaultedStatus : null as any;
        data["isCancelledStatus"] = this.isCancelledStatus !== undefined ? this.isCancelledStatus : null as any;
        data["isExpiredStatus"] = this.isExpiredStatus !== undefined ? this.isExpiredStatus : null as any;
        data["isDeletedStatus"] = this.isDeletedStatus !== undefined ? this.isDeletedStatus : null as any;
        if (Array.isArray(this.keepingCurrentApplications)) {
            data["keepingCurrentApplications"] = [];
            for (let item of this.keepingCurrentApplications)
                data["keepingCurrentApplications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentStatus {
        const json = this.toJSON();
        let result = new KeepingCurrentStatus();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentStatus extends IBaseEntity {
    statusName?: string | null;
    isSystemSet?: boolean;
    displaySortOrder?: number;
    isNewStatus?: boolean;
    isPendingApprovalStatus?: boolean;
    isApprovedStatus?: boolean;
    isRejectedStatus?: boolean;
    isPayMissedStatus?: boolean;
    isDefaultedStatus?: boolean;
    isCancelledStatus?: boolean;
    isExpiredStatus?: boolean;
    isDeletedStatus?: boolean;
    keepingCurrentApplications?: KeepingCurrentApplication[] | null;
}

export class KeepingCurrentApplicationNote extends BaseEntity implements IKeepingCurrentApplicationNote {
    keepingCurrentApplicationId?: string;
    notes?: string | null;
    status?: StatusType;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentApplicationNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentApplicationNote {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentApplicationNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentApplicationNote {
        const json = this.toJSON();
        let result = new KeepingCurrentApplicationNote();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentApplicationNote extends IBaseEntity {
    keepingCurrentApplicationId?: string;
    notes?: string | null;
    status?: StatusType;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class KeepingCurrentCancellation extends BaseEntity implements IKeepingCurrentCancellation {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    cancellationDate?: Date | null;
    cancellationReason?: string | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentCancellation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.cancellationDate = _data["cancellationDate"] ? new Date(_data["cancellationDate"].toString()) : null as any;
            this.cancellationReason = _data["cancellationReason"] !== undefined ? _data["cancellationReason"] : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentCancellation {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentCancellation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : null as any;
        data["cancellationReason"] = this.cancellationReason !== undefined ? this.cancellationReason : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentCancellation {
        const json = this.toJSON();
        let result = new KeepingCurrentCancellation();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentCancellation extends IBaseEntity {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    cancellationDate?: Date | null;
    cancellationReason?: string | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class KeepingCurrentConfirmOrphan extends BaseEntity implements IKeepingCurrentConfirmOrphan {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    arrearsInstallments?: number | null;
    confirmedDate?: Date | null;
    initialBillDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    rejectionReason?: string | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentConfirmOrphan) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalAmountDue = _data["totalAmountDue"] !== undefined ? _data["totalAmountDue"] : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.arrearsInstallments = _data["arrearsInstallments"] !== undefined ? _data["arrearsInstallments"] : null as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : null as any;
            this.initialBillDate = _data["initialBillDate"] ? new Date(_data["initialBillDate"].toString()) : null as any;
            this.arrearsCreditExpiration = _data["arrearsCreditExpiration"] ? new Date(_data["arrearsCreditExpiration"].toString()) : null as any;
            this.programCreditExpiration = _data["programCreditExpiration"] ? new Date(_data["programCreditExpiration"].toString()) : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.enrollmentRejected = _data["enrollmentRejected"] !== undefined ? _data["enrollmentRejected"] : null as any;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentConfirmOrphan {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentConfirmOrphan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalAmountDue"] = this.totalAmountDue !== undefined ? this.totalAmountDue : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["arrearsInstallments"] = this.arrearsInstallments !== undefined ? this.arrearsInstallments : null as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : null as any;
        data["initialBillDate"] = this.initialBillDate ? this.initialBillDate.toISOString() : null as any;
        data["arrearsCreditExpiration"] = this.arrearsCreditExpiration ? this.arrearsCreditExpiration.toISOString() : null as any;
        data["programCreditExpiration"] = this.programCreditExpiration ? this.programCreditExpiration.toISOString() : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["enrollmentRejected"] = this.enrollmentRejected !== undefined ? this.enrollmentRejected : null as any;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentConfirmOrphan {
        const json = this.toJSON();
        let result = new KeepingCurrentConfirmOrphan();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentConfirmOrphan extends IBaseEntity {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    arrearsInstallments?: number | null;
    confirmedDate?: Date | null;
    initialBillDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    rejectionReason?: string | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class KeepingCurrentConfirmation extends BaseEntity implements IKeepingCurrentConfirmation {
    keepingCurrentApplicationId?: string;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    arrearsInstallments?: number | null;
    confirmedDate?: Date | null;
    initialBillDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    rejectionReason?: string | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentConfirmation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.totalAmountDue = _data["totalAmountDue"] !== undefined ? _data["totalAmountDue"] : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.arrearsInstallments = _data["arrearsInstallments"] !== undefined ? _data["arrearsInstallments"] : null as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : null as any;
            this.initialBillDate = _data["initialBillDate"] ? new Date(_data["initialBillDate"].toString()) : null as any;
            this.arrearsCreditExpiration = _data["arrearsCreditExpiration"] ? new Date(_data["arrearsCreditExpiration"].toString()) : null as any;
            this.programCreditExpiration = _data["programCreditExpiration"] ? new Date(_data["programCreditExpiration"].toString()) : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.enrollmentRejected = _data["enrollmentRejected"] !== undefined ? _data["enrollmentRejected"] : null as any;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentConfirmation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["totalAmountDue"] = this.totalAmountDue !== undefined ? this.totalAmountDue : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["arrearsInstallments"] = this.arrearsInstallments !== undefined ? this.arrearsInstallments : null as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : null as any;
        data["initialBillDate"] = this.initialBillDate ? this.initialBillDate.toISOString() : null as any;
        data["arrearsCreditExpiration"] = this.arrearsCreditExpiration ? this.arrearsCreditExpiration.toISOString() : null as any;
        data["programCreditExpiration"] = this.programCreditExpiration ? this.programCreditExpiration.toISOString() : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["enrollmentRejected"] = this.enrollmentRejected !== undefined ? this.enrollmentRejected : null as any;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentConfirmation {
        const json = this.toJSON();
        let result = new KeepingCurrentConfirmation();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentConfirmation extends IBaseEntity {
    keepingCurrentApplicationId?: string;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    totalAmountDue?: number | null;
    programCredit?: number | null;
    arrearsCredit?: number | null;
    arrearsInstallments?: number | null;
    confirmedDate?: Date | null;
    initialBillDate?: Date | null;
    arrearsCreditExpiration?: Date | null;
    programCreditExpiration?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    enrollmentRejected?: boolean | null;
    rejectionReason?: string | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class KeepingCurrentMissedPayment extends BaseEntity implements IKeepingCurrentMissedPayment {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    paymentDueDate?: Date | null;
    deliquentDate?: Date | null;
    billingDate?: Date | null;
    amountDue?: number | null;
    amountPaid?: number | null;
    downloadTimestamp?: Date | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentMissedPayment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : null as any;
            this.deliquentDate = _data["deliquentDate"] ? new Date(_data["deliquentDate"].toString()) : null as any;
            this.billingDate = _data["billingDate"] ? new Date(_data["billingDate"].toString()) : null as any;
            this.amountDue = _data["amountDue"] !== undefined ? _data["amountDue"] : null as any;
            this.amountPaid = _data["amountPaid"] !== undefined ? _data["amountPaid"] : null as any;
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentMissedPayment {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentMissedPayment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : null as any;
        data["deliquentDate"] = this.deliquentDate ? this.deliquentDate.toISOString() : null as any;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : null as any;
        data["amountDue"] = this.amountDue !== undefined ? this.amountDue : null as any;
        data["amountPaid"] = this.amountPaid !== undefined ? this.amountPaid : null as any;
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentMissedPayment {
        const json = this.toJSON();
        let result = new KeepingCurrentMissedPayment();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentMissedPayment extends IBaseEntity {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    paymentDueDate?: Date | null;
    deliquentDate?: Date | null;
    billingDate?: Date | null;
    amountDue?: number | null;
    amountPaid?: number | null;
    downloadTimestamp?: Date | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class KeepingCurrentMonthlyBill extends BaseEntity implements IKeepingCurrentMonthlyBill {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    paymentDueDate?: Date | null;
    deliquentDate?: Date | null;
    billingDate?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentMonthlyBill) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : null as any;
            this.deliquentDate = _data["deliquentDate"] ? new Date(_data["deliquentDate"].toString()) : null as any;
            this.billingDate = _data["billingDate"] ? new Date(_data["billingDate"].toString()) : null as any;
            this.budgetBillAmount = _data["budgetBillAmount"] !== undefined ? _data["budgetBillAmount"] : null as any;
            this.customerMonthlyPayment = _data["customerMonthlyPayment"] !== undefined ? _data["customerMonthlyPayment"] : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentMonthlyBill {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentMonthlyBill();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : null as any;
        data["deliquentDate"] = this.deliquentDate ? this.deliquentDate.toISOString() : null as any;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : null as any;
        data["budgetBillAmount"] = this.budgetBillAmount !== undefined ? this.budgetBillAmount : null as any;
        data["customerMonthlyPayment"] = this.customerMonthlyPayment !== undefined ? this.customerMonthlyPayment : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentMonthlyBill {
        const json = this.toJSON();
        let result = new KeepingCurrentMonthlyBill();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentMonthlyBill extends IBaseEntity {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    paymentDueDate?: Date | null;
    deliquentDate?: Date | null;
    billingDate?: Date | null;
    budgetBillAmount?: number | null;
    customerMonthlyPayment?: number | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class KeepingCurrentMonthlyCredit extends BaseEntity implements IKeepingCurrentMonthlyCredit {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    creditDate?: Date | null;
    arrearsCredit?: number | null;
    programCredit?: number | null;
    totalCredit?: number | null;
    downloadTimestamp?: Date | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;

    constructor(data?: IKeepingCurrentMonthlyCredit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepingCurrentApplicationId = _data["keepingCurrentApplicationId"] !== undefined ? _data["keepingCurrentApplicationId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.creditDate = _data["creditDate"] ? new Date(_data["creditDate"].toString()) : null as any;
            this.arrearsCredit = _data["arrearsCredit"] !== undefined ? _data["arrearsCredit"] : null as any;
            this.programCredit = _data["programCredit"] !== undefined ? _data["programCredit"] : null as any;
            this.totalCredit = _data["totalCredit"] !== undefined ? _data["totalCredit"] : null as any;
            this.downloadTimestamp = _data["downloadTimestamp"] ? new Date(_data["downloadTimestamp"].toString()) : null as any;
            this.keepingCurrentApplication = _data["keepingCurrentApplication"] ? KeepingCurrentApplication.fromJS(_data["keepingCurrentApplication"]) : null as any;
        }
    }

    static override fromJS(data: any): KeepingCurrentMonthlyCredit {
        data = typeof data === 'object' ? data : {};
        let result = new KeepingCurrentMonthlyCredit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepingCurrentApplicationId"] = this.keepingCurrentApplicationId !== undefined ? this.keepingCurrentApplicationId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["creditDate"] = this.creditDate ? this.creditDate.toISOString() : null as any;
        data["arrearsCredit"] = this.arrearsCredit !== undefined ? this.arrearsCredit : null as any;
        data["programCredit"] = this.programCredit !== undefined ? this.programCredit : null as any;
        data["totalCredit"] = this.totalCredit !== undefined ? this.totalCredit : null as any;
        data["downloadTimestamp"] = this.downloadTimestamp ? this.downloadTimestamp.toISOString() : null as any;
        data["keepingCurrentApplication"] = this.keepingCurrentApplication ? this.keepingCurrentApplication.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): KeepingCurrentMonthlyCredit {
        const json = this.toJSON();
        let result = new KeepingCurrentMonthlyCredit();
        result.init(json);
        return result;
    }
}

export interface IKeepingCurrentMonthlyCredit extends IBaseEntity {
    keepingCurrentApplicationId?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    accountNumber?: string | null;
    creditDate?: Date | null;
    arrearsCredit?: number | null;
    programCredit?: number | null;
    totalCredit?: number | null;
    downloadTimestamp?: Date | null;
    keepingCurrentApplication?: KeepingCurrentApplication | null;
}

export class CompanyPledgeType extends BaseEntity implements ICompanyPledgeType {
    companyId?: string;
    pledgeTypeId?: string;
    company?: Company2 | null;
    pledgeType?: PledgeType2 | null;

    constructor(data?: ICompanyPledgeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
        }
    }

    static override fromJS(data: any): CompanyPledgeType {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPledgeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): CompanyPledgeType {
        const json = this.toJSON();
        let result = new CompanyPledgeType();
        result.init(json);
        return result;
    }
}

export interface ICompanyPledgeType extends IBaseEntity {
    companyId?: string;
    pledgeTypeId?: string;
    company?: Company2 | null;
    pledgeType?: PledgeType2 | null;
}

export class AgencyPledgeType extends BaseEntity implements IAgencyPledgeType {
    agencyId?: string;
    pledgeTypeId?: string;
    agency?: Agency2 | null;
    pledgeType?: PledgeType2 | null;

    constructor(data?: IAgencyPledgeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
        }
    }

    static override fromJS(data: any): AgencyPledgeType {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyPledgeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AgencyPledgeType {
        const json = this.toJSON();
        let result = new AgencyPledgeType();
        result.init(json);
        return result;
    }
}

export interface IAgencyPledgeType extends IBaseEntity {
    agencyId?: string;
    pledgeTypeId?: string;
    agency?: Agency2 | null;
    pledgeType?: PledgeType2 | null;
}

export class AgencyProgram implements IAgencyProgram {
    id?: string;
    agencyId?: string;
    programId?: number;
    enteredBy?: string | null;
    enteredDate?: Date;
    modifiedBy?: string | null;
    modifiedDate?: Date | null;
    agency?: Agency2 | null;

    constructor(data?: IAgencyProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.programId = _data["programId"] !== undefined ? _data["programId"] : null as any;
            this.enteredBy = _data["enteredBy"] !== undefined ? _data["enteredBy"] : null as any;
            this.enteredDate = _data["enteredDate"] ? new Date(_data["enteredDate"].toString()) : null as any;
            this.modifiedBy = _data["modifiedBy"] !== undefined ? _data["modifiedBy"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
        }
    }

    static fromJS(data: any): AgencyProgram {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["programId"] = this.programId !== undefined ? this.programId : null as any;
        data["enteredBy"] = this.enteredBy !== undefined ? this.enteredBy : null as any;
        data["enteredDate"] = this.enteredDate ? this.enteredDate.toISOString() : null as any;
        data["modifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        return data;
    }

    clone(): AgencyProgram {
        const json = this.toJSON();
        let result = new AgencyProgram();
        result.init(json);
        return result;
    }
}

export interface IAgencyProgram {
    id?: string;
    agencyId?: string;
    programId?: number;
    enteredBy?: string | null;
    enteredDate?: Date;
    modifiedBy?: string | null;
    modifiedDate?: Date | null;
    agency?: Agency2 | null;
}

export class EfsAssistance extends BaseEntity implements IEfsAssistance {
    clientId?: string;
    agencyId?: string | null;
    assistanceType?: string | null;
    zipCode?: string | null;
    description?: string | null;
    confirmed?: number;
    status?: number;
    pledgeTypeId?: string;
    pledgeTypeName?: string | null;
    clientCompanyAccountNumber?: string | null;
    clientSsn?: string | null;
    clientSsnhash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    federalPovertyLevelDisplay?: number | null;
    assistanceDate?: Date;
    agency?: Agency2 | null;
    client?: Client2 | null;
    pledgeType?: PledgeType2 | null;

    constructor(data?: IEfsAssistance) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : null as any;
            this.assistanceType = _data["assistanceType"] !== undefined ? _data["assistanceType"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pledgeTypeId = _data["pledgeTypeId"] !== undefined ? _data["pledgeTypeId"] : null as any;
            this.pledgeTypeName = _data["pledgeTypeName"] !== undefined ? _data["pledgeTypeName"] : null as any;
            this.clientCompanyAccountNumber = _data["clientCompanyAccountNumber"] !== undefined ? _data["clientCompanyAccountNumber"] : null as any;
            this.clientSsn = _data["clientSsn"] !== undefined ? _data["clientSsn"] : null as any;
            this.clientSsnhash = _data["clientSsnhash"] !== undefined ? _data["clientSsnhash"] : null as any;
            this.clientLast4Ssn = _data["clientLast4Ssn"] !== undefined ? _data["clientLast4Ssn"] : null as any;
            this.clientPrefix = _data["clientPrefix"] !== undefined ? _data["clientPrefix"] : null as any;
            this.clientFirstName = _data["clientFirstName"] !== undefined ? _data["clientFirstName"] : null as any;
            this.clientMiddleInitial = _data["clientMiddleInitial"] !== undefined ? _data["clientMiddleInitial"] : null as any;
            this.clientLastName = _data["clientLastName"] !== undefined ? _data["clientLastName"] : null as any;
            this.clientSuffix = _data["clientSuffix"] !== undefined ? _data["clientSuffix"] : null as any;
            this.clientAddress1 = _data["clientAddress1"] !== undefined ? _data["clientAddress1"] : null as any;
            this.clientAddress2 = _data["clientAddress2"] !== undefined ? _data["clientAddress2"] : null as any;
            this.clientCity = _data["clientCity"] !== undefined ? _data["clientCity"] : null as any;
            this.clientState = _data["clientState"] !== undefined ? _data["clientState"] : null as any;
            this.clientZipCode = _data["clientZipCode"] !== undefined ? _data["clientZipCode"] : null as any;
            this.clientCounty = _data["clientCounty"] !== undefined ? _data["clientCounty"] : null as any;
            this.clientPhone = _data["clientPhone"] !== undefined ? _data["clientPhone"] : null as any;
            this.clientPhoneExt = _data["clientPhoneExt"] !== undefined ? _data["clientPhoneExt"] : null as any;
            this.clientBirthYear = _data["clientBirthYear"] !== undefined ? _data["clientBirthYear"] : null as any;
            this.clientEmail = _data["clientEmail"] !== undefined ? _data["clientEmail"] : null as any;
            this.clientGender = _data["clientGender"] !== undefined ? _data["clientGender"] : null as any;
            this.clientHouseHoldIncome = _data["clientHouseHoldIncome"] !== undefined ? _data["clientHouseHoldIncome"] : null as any;
            this.clientHouseHoldSize = _data["clientHouseHoldSize"] !== undefined ? _data["clientHouseHoldSize"] : null as any;
            this.clientEmploymentStatus = _data["clientEmploymentStatus"] !== undefined ? _data["clientEmploymentStatus"] : null as any;
            this.clientIsElderly = _data["clientIsElderly"] !== undefined ? _data["clientIsElderly"] : null as any;
            this.clientIsDisabled = _data["clientIsDisabled"] !== undefined ? _data["clientIsDisabled"] : null as any;
            this.clientHasChildrenUnderFive = _data["clientHasChildrenUnderFive"] !== undefined ? _data["clientHasChildrenUnderFive"] : null as any;
            this.clientIsVeteran = _data["clientIsVeteran"] !== undefined ? _data["clientIsVeteran"] : null as any;
            this.clientIsHomeless = _data["clientIsHomeless"] !== undefined ? _data["clientIsHomeless"] : null as any;
            this.clientMembersAreElderly = _data["clientMembersAreElderly"] !== undefined ? _data["clientMembersAreElderly"] : null as any;
            this.clientMembersAreDisabled = _data["clientMembersAreDisabled"] !== undefined ? _data["clientMembersAreDisabled"] : null as any;
            this.clientMembersHaveChildrenUnderFive = _data["clientMembersHaveChildrenUnderFive"] !== undefined ? _data["clientMembersHaveChildrenUnderFive"] : null as any;
            this.clientPhoneAlt = _data["clientPhoneAlt"] !== undefined ? _data["clientPhoneAlt"] : null as any;
            this.federalPovertyLevelDisplay = _data["federalPovertyLevelDisplay"] !== undefined ? _data["federalPovertyLevelDisplay"] : null as any;
            this.assistanceDate = _data["assistanceDate"] ? new Date(_data["assistanceDate"].toString()) : null as any;
            this.agency = _data["agency"] ? Agency2.fromJS(_data["agency"]) : null as any;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : null as any;
            this.pledgeType = _data["pledgeType"] ? PledgeType2.fromJS(_data["pledgeType"]) : null as any;
        }
    }

    static override fromJS(data: any): EfsAssistance {
        data = typeof data === 'object' ? data : {};
        let result = new EfsAssistance();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : null as any;
        data["assistanceType"] = this.assistanceType !== undefined ? this.assistanceType : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pledgeTypeId"] = this.pledgeTypeId !== undefined ? this.pledgeTypeId : null as any;
        data["pledgeTypeName"] = this.pledgeTypeName !== undefined ? this.pledgeTypeName : null as any;
        data["clientCompanyAccountNumber"] = this.clientCompanyAccountNumber !== undefined ? this.clientCompanyAccountNumber : null as any;
        data["clientSsn"] = this.clientSsn !== undefined ? this.clientSsn : null as any;
        data["clientSsnhash"] = this.clientSsnhash !== undefined ? this.clientSsnhash : null as any;
        data["clientLast4Ssn"] = this.clientLast4Ssn !== undefined ? this.clientLast4Ssn : null as any;
        data["clientPrefix"] = this.clientPrefix !== undefined ? this.clientPrefix : null as any;
        data["clientFirstName"] = this.clientFirstName !== undefined ? this.clientFirstName : null as any;
        data["clientMiddleInitial"] = this.clientMiddleInitial !== undefined ? this.clientMiddleInitial : null as any;
        data["clientLastName"] = this.clientLastName !== undefined ? this.clientLastName : null as any;
        data["clientSuffix"] = this.clientSuffix !== undefined ? this.clientSuffix : null as any;
        data["clientAddress1"] = this.clientAddress1 !== undefined ? this.clientAddress1 : null as any;
        data["clientAddress2"] = this.clientAddress2 !== undefined ? this.clientAddress2 : null as any;
        data["clientCity"] = this.clientCity !== undefined ? this.clientCity : null as any;
        data["clientState"] = this.clientState !== undefined ? this.clientState : null as any;
        data["clientZipCode"] = this.clientZipCode !== undefined ? this.clientZipCode : null as any;
        data["clientCounty"] = this.clientCounty !== undefined ? this.clientCounty : null as any;
        data["clientPhone"] = this.clientPhone !== undefined ? this.clientPhone : null as any;
        data["clientPhoneExt"] = this.clientPhoneExt !== undefined ? this.clientPhoneExt : null as any;
        data["clientBirthYear"] = this.clientBirthYear !== undefined ? this.clientBirthYear : null as any;
        data["clientEmail"] = this.clientEmail !== undefined ? this.clientEmail : null as any;
        data["clientGender"] = this.clientGender !== undefined ? this.clientGender : null as any;
        data["clientHouseHoldIncome"] = this.clientHouseHoldIncome !== undefined ? this.clientHouseHoldIncome : null as any;
        data["clientHouseHoldSize"] = this.clientHouseHoldSize !== undefined ? this.clientHouseHoldSize : null as any;
        data["clientEmploymentStatus"] = this.clientEmploymentStatus !== undefined ? this.clientEmploymentStatus : null as any;
        data["clientIsElderly"] = this.clientIsElderly !== undefined ? this.clientIsElderly : null as any;
        data["clientIsDisabled"] = this.clientIsDisabled !== undefined ? this.clientIsDisabled : null as any;
        data["clientHasChildrenUnderFive"] = this.clientHasChildrenUnderFive !== undefined ? this.clientHasChildrenUnderFive : null as any;
        data["clientIsVeteran"] = this.clientIsVeteran !== undefined ? this.clientIsVeteran : null as any;
        data["clientIsHomeless"] = this.clientIsHomeless !== undefined ? this.clientIsHomeless : null as any;
        data["clientMembersAreElderly"] = this.clientMembersAreElderly !== undefined ? this.clientMembersAreElderly : null as any;
        data["clientMembersAreDisabled"] = this.clientMembersAreDisabled !== undefined ? this.clientMembersAreDisabled : null as any;
        data["clientMembersHaveChildrenUnderFive"] = this.clientMembersHaveChildrenUnderFive !== undefined ? this.clientMembersHaveChildrenUnderFive : null as any;
        data["clientPhoneAlt"] = this.clientPhoneAlt !== undefined ? this.clientPhoneAlt : null as any;
        data["federalPovertyLevelDisplay"] = this.federalPovertyLevelDisplay !== undefined ? this.federalPovertyLevelDisplay : null as any;
        data["assistanceDate"] = this.assistanceDate ? this.assistanceDate.toISOString() : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["client"] = this.client ? this.client.toJSON() : null as any;
        data["pledgeType"] = this.pledgeType ? this.pledgeType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EfsAssistance {
        const json = this.toJSON();
        let result = new EfsAssistance();
        result.init(json);
        return result;
    }
}

export interface IEfsAssistance extends IBaseEntity {
    clientId?: string;
    agencyId?: string | null;
    assistanceType?: string | null;
    zipCode?: string | null;
    description?: string | null;
    confirmed?: number;
    status?: number;
    pledgeTypeId?: string;
    pledgeTypeName?: string | null;
    clientCompanyAccountNumber?: string | null;
    clientSsn?: string | null;
    clientSsnhash?: string | null;
    clientLast4Ssn?: string | null;
    clientPrefix?: string | null;
    clientFirstName?: string | null;
    clientMiddleInitial?: string | null;
    clientLastName?: string | null;
    clientSuffix?: string | null;
    clientAddress1?: string | null;
    clientAddress2?: string | null;
    clientCity?: string | null;
    clientState?: string | null;
    clientZipCode?: string | null;
    clientCounty?: string | null;
    clientPhone?: string | null;
    clientPhoneExt?: string | null;
    clientBirthYear?: number | null;
    clientEmail?: string | null;
    clientGender?: string | null;
    clientHouseHoldIncome?: number | null;
    clientHouseHoldSize?: number | null;
    clientEmploymentStatus?: string | null;
    clientIsElderly?: boolean | null;
    clientIsDisabled?: boolean | null;
    clientHasChildrenUnderFive?: boolean | null;
    clientIsVeteran?: boolean | null;
    clientIsHomeless?: boolean | null;
    clientMembersAreElderly?: boolean | null;
    clientMembersAreDisabled?: boolean | null;
    clientMembersHaveChildrenUnderFive?: boolean | null;
    clientPhoneAlt?: string | null;
    federalPovertyLevelDisplay?: number | null;
    assistanceDate?: Date;
    agency?: Agency2 | null;
    client?: Client2 | null;
    pledgeType?: PledgeType2 | null;
}

export class AssistanceApplicationAreasOfNeedEntity extends BaseEntity implements IAssistanceApplicationAreasOfNeedEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    uhonsRent?: boolean;
    uhonsElectric?: boolean;
    uhonsGasHeat?: boolean;
    uhonsWater?: boolean;
    uhonsSewer?: boolean;
    uhonsChildcareExpenses?: boolean;
    uhonsTransportationRideShare?: boolean;
    uhonsCarRepair?: boolean;
    evictionNotification?: boolean;
    uffMortgagePayment?: boolean;
    uffCarInsurance?: boolean;
    uffChildEdSupportUniforms?: boolean;
    uffSecurityDeposit?: boolean;
    uffTuition?: boolean;
    uffCarRepair?: boolean;
    uffRentPayment?: boolean;
    uffStateLicensedChildcareProvider?: boolean;
    uffMovingExpenses?: boolean;
    uffChildSupportTutoring?: boolean;
    uffCarPayment?: boolean;
    uffUtilityBills?: boolean;
    stlWaterWater?: boolean;
    stormAppliances?: boolean;
    stormMoldRemediationAssistance?: boolean;
    stormTemporaryStorageAssistance?: boolean;
    stormHvacPlumbing?: boolean;
    stormConstruction?: boolean;
    stormOtherDisasterCausedUnmetNeeds?: boolean;

    constructor(data?: IAssistanceApplicationAreasOfNeedEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.uhonsRent = _data["uhonsRent"] !== undefined ? _data["uhonsRent"] : null as any;
            this.uhonsElectric = _data["uhonsElectric"] !== undefined ? _data["uhonsElectric"] : null as any;
            this.uhonsGasHeat = _data["uhonsGasHeat"] !== undefined ? _data["uhonsGasHeat"] : null as any;
            this.uhonsWater = _data["uhonsWater"] !== undefined ? _data["uhonsWater"] : null as any;
            this.uhonsSewer = _data["uhonsSewer"] !== undefined ? _data["uhonsSewer"] : null as any;
            this.uhonsChildcareExpenses = _data["uhonsChildcareExpenses"] !== undefined ? _data["uhonsChildcareExpenses"] : null as any;
            this.uhonsTransportationRideShare = _data["uhonsTransportationRideShare"] !== undefined ? _data["uhonsTransportationRideShare"] : null as any;
            this.uhonsCarRepair = _data["uhonsCarRepair"] !== undefined ? _data["uhonsCarRepair"] : null as any;
            this.evictionNotification = _data["evictionNotification"] !== undefined ? _data["evictionNotification"] : null as any;
            this.uffMortgagePayment = _data["uffMortgagePayment"] !== undefined ? _data["uffMortgagePayment"] : null as any;
            this.uffCarInsurance = _data["uffCarInsurance"] !== undefined ? _data["uffCarInsurance"] : null as any;
            this.uffChildEdSupportUniforms = _data["uffChildEdSupportUniforms"] !== undefined ? _data["uffChildEdSupportUniforms"] : null as any;
            this.uffSecurityDeposit = _data["uffSecurityDeposit"] !== undefined ? _data["uffSecurityDeposit"] : null as any;
            this.uffTuition = _data["uffTuition"] !== undefined ? _data["uffTuition"] : null as any;
            this.uffCarRepair = _data["uffCarRepair"] !== undefined ? _data["uffCarRepair"] : null as any;
            this.uffRentPayment = _data["uffRentPayment"] !== undefined ? _data["uffRentPayment"] : null as any;
            this.uffStateLicensedChildcareProvider = _data["uffStateLicensedChildcareProvider"] !== undefined ? _data["uffStateLicensedChildcareProvider"] : null as any;
            this.uffMovingExpenses = _data["uffMovingExpenses"] !== undefined ? _data["uffMovingExpenses"] : null as any;
            this.uffChildSupportTutoring = _data["uffChildSupportTutoring"] !== undefined ? _data["uffChildSupportTutoring"] : null as any;
            this.uffCarPayment = _data["uffCarPayment"] !== undefined ? _data["uffCarPayment"] : null as any;
            this.uffUtilityBills = _data["uffUtilityBills"] !== undefined ? _data["uffUtilityBills"] : null as any;
            this.stlWaterWater = _data["stlWaterWater"] !== undefined ? _data["stlWaterWater"] : null as any;
            this.stormAppliances = _data["stormAppliances"] !== undefined ? _data["stormAppliances"] : null as any;
            this.stormMoldRemediationAssistance = _data["stormMoldRemediationAssistance"] !== undefined ? _data["stormMoldRemediationAssistance"] : null as any;
            this.stormTemporaryStorageAssistance = _data["stormTemporaryStorageAssistance"] !== undefined ? _data["stormTemporaryStorageAssistance"] : null as any;
            this.stormHvacPlumbing = _data["stormHvacPlumbing"] !== undefined ? _data["stormHvacPlumbing"] : null as any;
            this.stormConstruction = _data["stormConstruction"] !== undefined ? _data["stormConstruction"] : null as any;
            this.stormOtherDisasterCausedUnmetNeeds = _data["stormOtherDisasterCausedUnmetNeeds"] !== undefined ? _data["stormOtherDisasterCausedUnmetNeeds"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationAreasOfNeedEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationAreasOfNeedEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["uhonsRent"] = this.uhonsRent !== undefined ? this.uhonsRent : null as any;
        data["uhonsElectric"] = this.uhonsElectric !== undefined ? this.uhonsElectric : null as any;
        data["uhonsGasHeat"] = this.uhonsGasHeat !== undefined ? this.uhonsGasHeat : null as any;
        data["uhonsWater"] = this.uhonsWater !== undefined ? this.uhonsWater : null as any;
        data["uhonsSewer"] = this.uhonsSewer !== undefined ? this.uhonsSewer : null as any;
        data["uhonsChildcareExpenses"] = this.uhonsChildcareExpenses !== undefined ? this.uhonsChildcareExpenses : null as any;
        data["uhonsTransportationRideShare"] = this.uhonsTransportationRideShare !== undefined ? this.uhonsTransportationRideShare : null as any;
        data["uhonsCarRepair"] = this.uhonsCarRepair !== undefined ? this.uhonsCarRepair : null as any;
        data["evictionNotification"] = this.evictionNotification !== undefined ? this.evictionNotification : null as any;
        data["uffMortgagePayment"] = this.uffMortgagePayment !== undefined ? this.uffMortgagePayment : null as any;
        data["uffCarInsurance"] = this.uffCarInsurance !== undefined ? this.uffCarInsurance : null as any;
        data["uffChildEdSupportUniforms"] = this.uffChildEdSupportUniforms !== undefined ? this.uffChildEdSupportUniforms : null as any;
        data["uffSecurityDeposit"] = this.uffSecurityDeposit !== undefined ? this.uffSecurityDeposit : null as any;
        data["uffTuition"] = this.uffTuition !== undefined ? this.uffTuition : null as any;
        data["uffCarRepair"] = this.uffCarRepair !== undefined ? this.uffCarRepair : null as any;
        data["uffRentPayment"] = this.uffRentPayment !== undefined ? this.uffRentPayment : null as any;
        data["uffStateLicensedChildcareProvider"] = this.uffStateLicensedChildcareProvider !== undefined ? this.uffStateLicensedChildcareProvider : null as any;
        data["uffMovingExpenses"] = this.uffMovingExpenses !== undefined ? this.uffMovingExpenses : null as any;
        data["uffChildSupportTutoring"] = this.uffChildSupportTutoring !== undefined ? this.uffChildSupportTutoring : null as any;
        data["uffCarPayment"] = this.uffCarPayment !== undefined ? this.uffCarPayment : null as any;
        data["uffUtilityBills"] = this.uffUtilityBills !== undefined ? this.uffUtilityBills : null as any;
        data["stlWaterWater"] = this.stlWaterWater !== undefined ? this.stlWaterWater : null as any;
        data["stormAppliances"] = this.stormAppliances !== undefined ? this.stormAppliances : null as any;
        data["stormMoldRemediationAssistance"] = this.stormMoldRemediationAssistance !== undefined ? this.stormMoldRemediationAssistance : null as any;
        data["stormTemporaryStorageAssistance"] = this.stormTemporaryStorageAssistance !== undefined ? this.stormTemporaryStorageAssistance : null as any;
        data["stormHvacPlumbing"] = this.stormHvacPlumbing !== undefined ? this.stormHvacPlumbing : null as any;
        data["stormConstruction"] = this.stormConstruction !== undefined ? this.stormConstruction : null as any;
        data["stormOtherDisasterCausedUnmetNeeds"] = this.stormOtherDisasterCausedUnmetNeeds !== undefined ? this.stormOtherDisasterCausedUnmetNeeds : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationAreasOfNeedEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationAreasOfNeedEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationAreasOfNeedEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    uhonsRent?: boolean;
    uhonsElectric?: boolean;
    uhonsGasHeat?: boolean;
    uhonsWater?: boolean;
    uhonsSewer?: boolean;
    uhonsChildcareExpenses?: boolean;
    uhonsTransportationRideShare?: boolean;
    uhonsCarRepair?: boolean;
    evictionNotification?: boolean;
    uffMortgagePayment?: boolean;
    uffCarInsurance?: boolean;
    uffChildEdSupportUniforms?: boolean;
    uffSecurityDeposit?: boolean;
    uffTuition?: boolean;
    uffCarRepair?: boolean;
    uffRentPayment?: boolean;
    uffStateLicensedChildcareProvider?: boolean;
    uffMovingExpenses?: boolean;
    uffChildSupportTutoring?: boolean;
    uffCarPayment?: boolean;
    uffUtilityBills?: boolean;
    stlWaterWater?: boolean;
    stormAppliances?: boolean;
    stormMoldRemediationAssistance?: boolean;
    stormTemporaryStorageAssistance?: boolean;
    stormHvacPlumbing?: boolean;
    stormConstruction?: boolean;
    stormOtherDisasterCausedUnmetNeeds?: boolean;
}

export class AssistanceApplicationAdultEntity extends BaseEntity implements IAssistanceApplicationAdultEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    last4Ssn?: string | null;
    employmentStatus?: string | null;
    monthlyIncomeAmount?: number;
    birthYear?: number | null;

    constructor(data?: IAssistanceApplicationAdultEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
            this.employmentStatus = _data["employmentStatus"] !== undefined ? _data["employmentStatus"] : null as any;
            this.monthlyIncomeAmount = _data["monthlyIncomeAmount"] !== undefined ? _data["monthlyIncomeAmount"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationAdultEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationAdultEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        data["employmentStatus"] = this.employmentStatus !== undefined ? this.employmentStatus : null as any;
        data["monthlyIncomeAmount"] = this.monthlyIncomeAmount !== undefined ? this.monthlyIncomeAmount : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationAdultEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationAdultEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationAdultEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    ssnhash?: string | null;
    last4Ssn?: string | null;
    employmentStatus?: string | null;
    monthlyIncomeAmount?: number;
    birthYear?: number | null;
}

export class AssistanceApplicationMinorEntity extends BaseEntity implements IAssistanceApplicationMinorEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: number | null;
    ssn?: string | null;
    ssnhash?: string | null;
    last4Ssn?: string | null;

    constructor(data?: IAssistanceApplicationMinorEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthYear = _data["birthYear"] !== undefined ? _data["birthYear"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.ssnhash = _data["ssnhash"] !== undefined ? _data["ssnhash"] : null as any;
            this.last4Ssn = _data["last4Ssn"] !== undefined ? _data["last4Ssn"] : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationMinorEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationMinorEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthYear"] = this.birthYear !== undefined ? this.birthYear : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["ssnhash"] = this.ssnhash !== undefined ? this.ssnhash : null as any;
        data["last4Ssn"] = this.last4Ssn !== undefined ? this.last4Ssn : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationMinorEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationMinorEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationMinorEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    firstName?: string | null;
    lastName?: string | null;
    birthYear?: number | null;
    ssn?: string | null;
    ssnhash?: string | null;
    last4Ssn?: string | null;
}

export class AssistanceApplicationCompanyEntity extends BaseEntity implements IAssistanceApplicationCompanyEntity {
    assistanceApplicationId?: string;
    companyId?: string;
    accountNumber?: string | null;
    amount?: number;
    pledgeId?: string | null;
    category?: CompanyCategoryType | null;
    payeeAddress?: string | null;
    payeeAddress2?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    assistanceApplication?: AssistanceApplicationEntity | null;
    company?: Company2 | null;
    pledge?: Pledge2 | null;

    constructor(data?: IAssistanceApplicationCompanyEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.pledgeId = _data["pledgeId"] !== undefined ? _data["pledgeId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.payeeAddress = _data["payeeAddress"] !== undefined ? _data["payeeAddress"] : null as any;
            this.payeeAddress2 = _data["payeeAddress2"] !== undefined ? _data["payeeAddress2"] : null as any;
            this.payeeCity = _data["payeeCity"] !== undefined ? _data["payeeCity"] : null as any;
            this.payeeState = _data["payeeState"] !== undefined ? _data["payeeState"] : null as any;
            this.payeeZip = _data["payeeZip"] !== undefined ? _data["payeeZip"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : null as any;
            this.pledge = _data["pledge"] ? Pledge2.fromJS(_data["pledge"]) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationCompanyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationCompanyEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["pledgeId"] = this.pledgeId !== undefined ? this.pledgeId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["payeeAddress"] = this.payeeAddress !== undefined ? this.payeeAddress : null as any;
        data["payeeAddress2"] = this.payeeAddress2 !== undefined ? this.payeeAddress2 : null as any;
        data["payeeCity"] = this.payeeCity !== undefined ? this.payeeCity : null as any;
        data["payeeState"] = this.payeeState !== undefined ? this.payeeState : null as any;
        data["payeeZip"] = this.payeeZip !== undefined ? this.payeeZip : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["company"] = this.company ? this.company.toJSON() : null as any;
        data["pledge"] = this.pledge ? this.pledge.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationCompanyEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationCompanyEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationCompanyEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    companyId?: string;
    accountNumber?: string | null;
    amount?: number;
    pledgeId?: string | null;
    category?: CompanyCategoryType | null;
    payeeAddress?: string | null;
    payeeAddress2?: string | null;
    payeeCity?: string | null;
    payeeState?: string | null;
    payeeZip?: string | null;
    assistanceApplication?: AssistanceApplicationEntity | null;
    company?: Company2 | null;
    pledge?: Pledge2 | null;
}

export class AssistanceApplicationStateAuditEntity extends BaseEntity implements IAssistanceApplicationStateAuditEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    auditorId?: string | null;
    auditDate?: Date;
    oldState?: AssistanceApplicationStateAuditType;
    newState?: AssistanceApplicationStateAuditType;
    note?: string | null;
    auditor?: User2 | null;

    constructor(data?: IAssistanceApplicationStateAuditEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.auditorId = _data["auditorId"] !== undefined ? _data["auditorId"] : null as any;
            this.auditDate = _data["auditDate"] ? new Date(_data["auditDate"].toString()) : null as any;
            this.oldState = _data["oldState"] !== undefined ? _data["oldState"] : null as any;
            this.newState = _data["newState"] !== undefined ? _data["newState"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.auditor = _data["auditor"] ? User2.fromJS(_data["auditor"]) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationStateAuditEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationStateAuditEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["auditorId"] = this.auditorId !== undefined ? this.auditorId : null as any;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : null as any;
        data["oldState"] = this.oldState !== undefined ? this.oldState : null as any;
        data["newState"] = this.newState !== undefined ? this.newState : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["auditor"] = this.auditor ? this.auditor.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationStateAuditEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationStateAuditEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationStateAuditEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    auditorId?: string | null;
    auditDate?: Date;
    oldState?: AssistanceApplicationStateAuditType;
    newState?: AssistanceApplicationStateAuditType;
    note?: string | null;
    auditor?: User2 | null;
}

export class AssistanceApplicationInformationRequestEntity extends BaseEntity implements IAssistanceApplicationInformationRequestEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    requestDate?: Date;
    note?: string | null;
    requesterId?: string | null;
    requester?: User2 | null;
    informationProviderId?: string | null;
    informationProvider?: User2 | null;
    completedDate?: Date | null;

    constructor(data?: IAssistanceApplicationInformationRequestEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.assistanceApplication = _data["assistanceApplication"] ? AssistanceApplicationEntity.fromJS(_data["assistanceApplication"]) : null as any;
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.requesterId = _data["requesterId"] !== undefined ? _data["requesterId"] : null as any;
            this.requester = _data["requester"] ? User2.fromJS(_data["requester"]) : null as any;
            this.informationProviderId = _data["informationProviderId"] !== undefined ? _data["informationProviderId"] : null as any;
            this.informationProvider = _data["informationProvider"] ? User2.fromJS(_data["informationProvider"]) : null as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): AssistanceApplicationInformationRequestEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssistanceApplicationInformationRequestEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["assistanceApplication"] = this.assistanceApplication ? this.assistanceApplication.toJSON() : null as any;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["requesterId"] = this.requesterId !== undefined ? this.requesterId : null as any;
        data["requester"] = this.requester ? this.requester.toJSON() : null as any;
        data["informationProviderId"] = this.informationProviderId !== undefined ? this.informationProviderId : null as any;
        data["informationProvider"] = this.informationProvider ? this.informationProvider.toJSON() : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssistanceApplicationInformationRequestEntity {
        const json = this.toJSON();
        let result = new AssistanceApplicationInformationRequestEntity();
        result.init(json);
        return result;
    }
}

export interface IAssistanceApplicationInformationRequestEntity extends IBaseEntity {
    assistanceApplicationId?: string;
    assistanceApplication?: AssistanceApplicationEntity | null;
    requestDate?: Date;
    note?: string | null;
    requesterId?: string | null;
    requester?: User2 | null;
    informationProviderId?: string | null;
    informationProvider?: User2 | null;
    completedDate?: Date | null;
}

export class StormApplication implements IStormApplication {
    id?: string;
    assistanceApplicationId?: string;
    tierLevel?: TierLevel;
    femaRegistrationNumber?: string | null;
    visionLinkNumber?: string | null;
    longTermRecoveryApproved?: boolean;
    damagedDwellingAddress1?: string | null;
    damagedDwellingAddress2?: string | null;
    damagedDwellingCity?: string | null;
    damagedDwellingState?: string | null;
    damagedDwellingZipCode?: string | null;

    constructor(data?: IStormApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.assistanceApplicationId = _data["assistanceApplicationId"] !== undefined ? _data["assistanceApplicationId"] : null as any;
            this.tierLevel = _data["tierLevel"] !== undefined ? _data["tierLevel"] : null as any;
            this.femaRegistrationNumber = _data["femaRegistrationNumber"] !== undefined ? _data["femaRegistrationNumber"] : null as any;
            this.visionLinkNumber = _data["visionLinkNumber"] !== undefined ? _data["visionLinkNumber"] : null as any;
            this.longTermRecoveryApproved = _data["longTermRecoveryApproved"] !== undefined ? _data["longTermRecoveryApproved"] : null as any;
            this.damagedDwellingAddress1 = _data["damagedDwellingAddress1"] !== undefined ? _data["damagedDwellingAddress1"] : null as any;
            this.damagedDwellingAddress2 = _data["damagedDwellingAddress2"] !== undefined ? _data["damagedDwellingAddress2"] : null as any;
            this.damagedDwellingCity = _data["damagedDwellingCity"] !== undefined ? _data["damagedDwellingCity"] : null as any;
            this.damagedDwellingState = _data["damagedDwellingState"] !== undefined ? _data["damagedDwellingState"] : null as any;
            this.damagedDwellingZipCode = _data["damagedDwellingZipCode"] !== undefined ? _data["damagedDwellingZipCode"] : null as any;
        }
    }

    static fromJS(data: any): StormApplication {
        data = typeof data === 'object' ? data : {};
        let result = new StormApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["assistanceApplicationId"] = this.assistanceApplicationId !== undefined ? this.assistanceApplicationId : null as any;
        data["tierLevel"] = this.tierLevel !== undefined ? this.tierLevel : null as any;
        data["femaRegistrationNumber"] = this.femaRegistrationNumber !== undefined ? this.femaRegistrationNumber : null as any;
        data["visionLinkNumber"] = this.visionLinkNumber !== undefined ? this.visionLinkNumber : null as any;
        data["longTermRecoveryApproved"] = this.longTermRecoveryApproved !== undefined ? this.longTermRecoveryApproved : null as any;
        data["damagedDwellingAddress1"] = this.damagedDwellingAddress1 !== undefined ? this.damagedDwellingAddress1 : null as any;
        data["damagedDwellingAddress2"] = this.damagedDwellingAddress2 !== undefined ? this.damagedDwellingAddress2 : null as any;
        data["damagedDwellingCity"] = this.damagedDwellingCity !== undefined ? this.damagedDwellingCity : null as any;
        data["damagedDwellingState"] = this.damagedDwellingState !== undefined ? this.damagedDwellingState : null as any;
        data["damagedDwellingZipCode"] = this.damagedDwellingZipCode !== undefined ? this.damagedDwellingZipCode : null as any;
        return data;
    }

    clone(): StormApplication {
        const json = this.toJSON();
        let result = new StormApplication();
        result.init(json);
        return result;
    }
}

export interface IStormApplication {
    id?: string;
    assistanceApplicationId?: string;
    tierLevel?: TierLevel;
    femaRegistrationNumber?: string | null;
    visionLinkNumber?: string | null;
    longTermRecoveryApproved?: boolean;
    damagedDwellingAddress1?: string | null;
    damagedDwellingAddress2?: string | null;
    damagedDwellingCity?: string | null;
    damagedDwellingState?: string | null;
    damagedDwellingZipCode?: string | null;
}

export class DraftApplicationFileEntity extends BaseEntity implements IDraftApplicationFileEntity {
    draftApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileUrl?: string | null;
    caseFileType?: string | null;
    draftApplication?: DraftApplication | null;
    user?: User2 | null;

    constructor(data?: IDraftApplicationFileEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.draftApplicationId = _data["draftApplicationId"] !== undefined ? _data["draftApplicationId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.caseFileType = _data["caseFileType"] !== undefined ? _data["caseFileType"] : null as any;
            this.draftApplication = _data["draftApplication"] ? DraftApplication.fromJS(_data["draftApplication"]) : null as any;
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): DraftApplicationFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationFileEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftApplicationId"] = this.draftApplicationId !== undefined ? this.draftApplicationId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["caseFileType"] = this.caseFileType !== undefined ? this.caseFileType : null as any;
        data["draftApplication"] = this.draftApplication ? this.draftApplication.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): DraftApplicationFileEntity {
        const json = this.toJSON();
        let result = new DraftApplicationFileEntity();
        result.init(json);
        return result;
    }
}

export interface IDraftApplicationFileEntity extends IBaseEntity {
    draftApplicationId?: string;
    userId?: string | null;
    fileName?: string | null;
    fileUrl?: string | null;
    caseFileType?: string | null;
    draftApplication?: DraftApplication | null;
    user?: User2 | null;
}

export class MaxAnnualIncomeLevelViewModel implements IMaxAnnualIncomeLevelViewModel {
    year?: number;
    householdSize?: number;
    maxAnnualIncome?: number;

    constructor(data?: IMaxAnnualIncomeLevelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.householdSize = _data["householdSize"] !== undefined ? _data["householdSize"] : null as any;
            this.maxAnnualIncome = _data["maxAnnualIncome"] !== undefined ? _data["maxAnnualIncome"] : null as any;
        }
    }

    static fromJS(data: any): MaxAnnualIncomeLevelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaxAnnualIncomeLevelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["householdSize"] = this.householdSize !== undefined ? this.householdSize : null as any;
        data["maxAnnualIncome"] = this.maxAnnualIncome !== undefined ? this.maxAnnualIncome : null as any;
        return data;
    }

    clone(): MaxAnnualIncomeLevelViewModel {
        const json = this.toJSON();
        let result = new MaxAnnualIncomeLevelViewModel();
        result.init(json);
        return result;
    }
}

export interface IMaxAnnualIncomeLevelViewModel {
    year?: number;
    householdSize?: number;
    maxAnnualIncome?: number;
}

export class LoginResult implements ILoginResult {
    securityToken?: string | null;
    currentUser?: User | null;
    currentAgency?: any | null;
    userAgency?: Agency | null;
    defaultManagementAgency?: Agency | null;
    userCompany?: Company | null;
    environment?: string | null;
    errorMessage?: string | null;
    systemData?: SystemData | null;
    expriesAt?: Date;
    appConfig?: AppConfig | null;

    constructor(data?: ILoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityToken = _data["securityToken"] !== undefined ? _data["securityToken"] : null as any;
            this.currentUser = _data["currentUser"] ? User.fromJS(_data["currentUser"]) : null as any;
            this.currentAgency = _data["currentAgency"] !== undefined ? _data["currentAgency"] : null as any;
            this.userAgency = _data["userAgency"] ? Agency.fromJS(_data["userAgency"]) : null as any;
            this.defaultManagementAgency = _data["defaultManagementAgency"] ? Agency.fromJS(_data["defaultManagementAgency"]) : null as any;
            this.userCompany = _data["userCompany"] ? Company.fromJS(_data["userCompany"]) : null as any;
            this.environment = _data["environment"] !== undefined ? _data["environment"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
            this.systemData = _data["systemData"] ? SystemData.fromJS(_data["systemData"]) : null as any;
            this.expriesAt = _data["expriesAt"] ? new Date(_data["expriesAt"].toString()) : null as any;
            this.appConfig = _data["appConfig"] ? AppConfig.fromJS(_data["appConfig"]) : null as any;
        }
    }

    static fromJS(data: any): LoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken !== undefined ? this.securityToken : null as any;
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : null as any;
        data["currentAgency"] = this.currentAgency !== undefined ? this.currentAgency : null as any;
        data["userAgency"] = this.userAgency ? this.userAgency.toJSON() : null as any;
        data["defaultManagementAgency"] = this.defaultManagementAgency ? this.defaultManagementAgency.toJSON() : null as any;
        data["userCompany"] = this.userCompany ? this.userCompany.toJSON() : null as any;
        data["environment"] = this.environment !== undefined ? this.environment : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        data["systemData"] = this.systemData ? this.systemData.toJSON() : null as any;
        data["expriesAt"] = this.expriesAt ? this.expriesAt.toISOString() : null as any;
        data["appConfig"] = this.appConfig ? this.appConfig.toJSON() : null as any;
        return data;
    }

    clone(): LoginResult {
        const json = this.toJSON();
        let result = new LoginResult();
        result.init(json);
        return result;
    }
}

export interface ILoginResult {
    securityToken?: string | null;
    currentUser?: User | null;
    currentAgency?: any | null;
    userAgency?: Agency | null;
    defaultManagementAgency?: Agency | null;
    userCompany?: Company | null;
    environment?: string | null;
    errorMessage?: string | null;
    systemData?: SystemData | null;
    expriesAt?: Date;
    appConfig?: AppConfig | null;
}

export class SystemData extends BaseViewModel implements ISystemData {
    states?: LookUp[] | null;
    prefix?: LookUp[] | null;
    suffix?: LookUp[] | null;
    employmentStatus?: LookUp[] | null;
    unionInfo?: LookUp[] | null;
    gender?: LookUp[] | null;
    race?: LookUp[] | null;
    administrativeAgencyFundAssistanceUhons?: LookUp[] | null;
    administrativeAgencyFundAssistanceUff?: LookUp[] | null;
    administrativeAgencyFundAssistanceStorm?: LookUp[] | null;
    administrativeAgencyFundAssistanceSTLWater?: LookUp[] | null;
    zones?: LookUp[] | null;
    assistanceType?: LookUp[] | null;
    region?: LookUp[] | null;
    kcStatuses?: KcStatus[] | null;
    kcPrograms?: KcProgram[] | null;
    setting?: Setting | null;
    pledgeTypes?: PledgeType[] | null;
    categories?: CompanyCategory[] | null;

    constructor(data?: ISystemData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(LookUp.fromJS(item));
            }
            else {
                this.states = null as any;
            }
            if (Array.isArray(_data["prefix"])) {
                this.prefix = [] as any;
                for (let item of _data["prefix"])
                    this.prefix!.push(LookUp.fromJS(item));
            }
            else {
                this.prefix = null as any;
            }
            if (Array.isArray(_data["suffix"])) {
                this.suffix = [] as any;
                for (let item of _data["suffix"])
                    this.suffix!.push(LookUp.fromJS(item));
            }
            else {
                this.suffix = null as any;
            }
            if (Array.isArray(_data["employmentStatus"])) {
                this.employmentStatus = [] as any;
                for (let item of _data["employmentStatus"])
                    this.employmentStatus!.push(LookUp.fromJS(item));
            }
            else {
                this.employmentStatus = null as any;
            }
            if (Array.isArray(_data["unionInfo"])) {
                this.unionInfo = [] as any;
                for (let item of _data["unionInfo"])
                    this.unionInfo!.push(LookUp.fromJS(item));
            }
            else {
                this.unionInfo = null as any;
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(LookUp.fromJS(item));
            }
            else {
                this.gender = null as any;
            }
            if (Array.isArray(_data["race"])) {
                this.race = [] as any;
                for (let item of _data["race"])
                    this.race!.push(LookUp.fromJS(item));
            }
            else {
                this.race = null as any;
            }
            if (Array.isArray(_data["administrativeAgencyFundAssistanceUhons"])) {
                this.administrativeAgencyFundAssistanceUhons = [] as any;
                for (let item of _data["administrativeAgencyFundAssistanceUhons"])
                    this.administrativeAgencyFundAssistanceUhons!.push(LookUp.fromJS(item));
            }
            else {
                this.administrativeAgencyFundAssistanceUhons = null as any;
            }
            if (Array.isArray(_data["administrativeAgencyFundAssistanceUff"])) {
                this.administrativeAgencyFundAssistanceUff = [] as any;
                for (let item of _data["administrativeAgencyFundAssistanceUff"])
                    this.administrativeAgencyFundAssistanceUff!.push(LookUp.fromJS(item));
            }
            else {
                this.administrativeAgencyFundAssistanceUff = null as any;
            }
            if (Array.isArray(_data["administrativeAgencyFundAssistanceStorm"])) {
                this.administrativeAgencyFundAssistanceStorm = [] as any;
                for (let item of _data["administrativeAgencyFundAssistanceStorm"])
                    this.administrativeAgencyFundAssistanceStorm!.push(LookUp.fromJS(item));
            }
            else {
                this.administrativeAgencyFundAssistanceStorm = null as any;
            }
            if (Array.isArray(_data["administrativeAgencyFundAssistanceSTLWater"])) {
                this.administrativeAgencyFundAssistanceSTLWater = [] as any;
                for (let item of _data["administrativeAgencyFundAssistanceSTLWater"])
                    this.administrativeAgencyFundAssistanceSTLWater!.push(LookUp.fromJS(item));
            }
            else {
                this.administrativeAgencyFundAssistanceSTLWater = null as any;
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(LookUp.fromJS(item));
            }
            else {
                this.zones = null as any;
            }
            if (Array.isArray(_data["assistanceType"])) {
                this.assistanceType = [] as any;
                for (let item of _data["assistanceType"])
                    this.assistanceType!.push(LookUp.fromJS(item));
            }
            else {
                this.assistanceType = null as any;
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(LookUp.fromJS(item));
            }
            else {
                this.region = null as any;
            }
            if (Array.isArray(_data["kcStatuses"])) {
                this.kcStatuses = [] as any;
                for (let item of _data["kcStatuses"])
                    this.kcStatuses!.push(KcStatus.fromJS(item));
            }
            else {
                this.kcStatuses = null as any;
            }
            if (Array.isArray(_data["kcPrograms"])) {
                this.kcPrograms = [] as any;
                for (let item of _data["kcPrograms"])
                    this.kcPrograms!.push(KcProgram.fromJS(item));
            }
            else {
                this.kcPrograms = null as any;
            }
            this.setting = _data["setting"] ? Setting.fromJS(_data["setting"]) : null as any;
            if (Array.isArray(_data["pledgeTypes"])) {
                this.pledgeTypes = [] as any;
                for (let item of _data["pledgeTypes"])
                    this.pledgeTypes!.push(PledgeType.fromJS(item));
            }
            else {
                this.pledgeTypes = null as any;
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CompanyCategory.fromJS(item));
            }
            else {
                this.categories = null as any;
            }
        }
    }

    static override fromJS(data: any): SystemData {
        data = typeof data === 'object' ? data : {};
        let result = new SystemData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prefix)) {
            data["prefix"] = [];
            for (let item of this.prefix)
                data["prefix"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.suffix)) {
            data["suffix"] = [];
            for (let item of this.suffix)
                data["suffix"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.employmentStatus)) {
            data["employmentStatus"] = [];
            for (let item of this.employmentStatus)
                data["employmentStatus"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.unionInfo)) {
            data["unionInfo"] = [];
            for (let item of this.unionInfo)
                data["unionInfo"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.race)) {
            data["race"] = [];
            for (let item of this.race)
                data["race"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.administrativeAgencyFundAssistanceUhons)) {
            data["administrativeAgencyFundAssistanceUhons"] = [];
            for (let item of this.administrativeAgencyFundAssistanceUhons)
                data["administrativeAgencyFundAssistanceUhons"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.administrativeAgencyFundAssistanceUff)) {
            data["administrativeAgencyFundAssistanceUff"] = [];
            for (let item of this.administrativeAgencyFundAssistanceUff)
                data["administrativeAgencyFundAssistanceUff"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.administrativeAgencyFundAssistanceStorm)) {
            data["administrativeAgencyFundAssistanceStorm"] = [];
            for (let item of this.administrativeAgencyFundAssistanceStorm)
                data["administrativeAgencyFundAssistanceStorm"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.administrativeAgencyFundAssistanceSTLWater)) {
            data["administrativeAgencyFundAssistanceSTLWater"] = [];
            for (let item of this.administrativeAgencyFundAssistanceSTLWater)
                data["administrativeAgencyFundAssistanceSTLWater"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.assistanceType)) {
            data["assistanceType"] = [];
            for (let item of this.assistanceType)
                data["assistanceType"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kcStatuses)) {
            data["kcStatuses"] = [];
            for (let item of this.kcStatuses)
                data["kcStatuses"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kcPrograms)) {
            data["kcPrograms"] = [];
            for (let item of this.kcPrograms)
                data["kcPrograms"].push(item ? item.toJSON() : null as any);
        }
        data["setting"] = this.setting ? this.setting.toJSON() : null as any;
        if (Array.isArray(this.pledgeTypes)) {
            data["pledgeTypes"] = [];
            for (let item of this.pledgeTypes)
                data["pledgeTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SystemData {
        const json = this.toJSON();
        let result = new SystemData();
        result.init(json);
        return result;
    }
}

export interface ISystemData extends IBaseViewModel {
    states?: LookUp[] | null;
    prefix?: LookUp[] | null;
    suffix?: LookUp[] | null;
    employmentStatus?: LookUp[] | null;
    unionInfo?: LookUp[] | null;
    gender?: LookUp[] | null;
    race?: LookUp[] | null;
    administrativeAgencyFundAssistanceUhons?: LookUp[] | null;
    administrativeAgencyFundAssistanceUff?: LookUp[] | null;
    administrativeAgencyFundAssistanceStorm?: LookUp[] | null;
    administrativeAgencyFundAssistanceSTLWater?: LookUp[] | null;
    zones?: LookUp[] | null;
    assistanceType?: LookUp[] | null;
    region?: LookUp[] | null;
    kcStatuses?: KcStatus[] | null;
    kcPrograms?: KcProgram[] | null;
    setting?: Setting | null;
    pledgeTypes?: PledgeType[] | null;
    categories?: CompanyCategory[] | null;
}

export class Setting extends BaseViewModel implements ISetting {
    agencyInviteMaxCount?: number | null;
    kcFplAcceptanceRate?: number | null;
    emailNotificationText?: string | null;
    daysBackToPledge?: number | null;

    constructor(data?: ISetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyInviteMaxCount = _data["agencyInviteMaxCount"] !== undefined ? _data["agencyInviteMaxCount"] : null as any;
            this.kcFplAcceptanceRate = _data["kcFplAcceptanceRate"] !== undefined ? _data["kcFplAcceptanceRate"] : null as any;
            this.emailNotificationText = _data["emailNotificationText"] !== undefined ? _data["emailNotificationText"] : null as any;
            this.daysBackToPledge = _data["daysBackToPledge"] !== undefined ? _data["daysBackToPledge"] : null as any;
        }
    }

    static override fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyInviteMaxCount"] = this.agencyInviteMaxCount !== undefined ? this.agencyInviteMaxCount : null as any;
        data["kcFplAcceptanceRate"] = this.kcFplAcceptanceRate !== undefined ? this.kcFplAcceptanceRate : null as any;
        data["emailNotificationText"] = this.emailNotificationText !== undefined ? this.emailNotificationText : null as any;
        data["daysBackToPledge"] = this.daysBackToPledge !== undefined ? this.daysBackToPledge : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting extends IBaseViewModel {
    agencyInviteMaxCount?: number | null;
    kcFplAcceptanceRate?: number | null;
    emailNotificationText?: string | null;
    daysBackToPledge?: number | null;
}

export class CompanyCategory implements ICompanyCategory {
    category?: CompanyCategoryType;
    categoryLabel?: string | null;

    constructor(data?: ICompanyCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.categoryLabel = _data["categoryLabel"] !== undefined ? _data["categoryLabel"] : null as any;
        }
    }

    static fromJS(data: any): CompanyCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["categoryLabel"] = this.categoryLabel !== undefined ? this.categoryLabel : null as any;
        return data;
    }

    clone(): CompanyCategory {
        const json = this.toJSON();
        let result = new CompanyCategory();
        result.init(json);
        return result;
    }
}

export interface ICompanyCategory {
    category?: CompanyCategoryType;
    categoryLabel?: string | null;
}

export class AppConfig implements IAppConfig {
    clientVerificationStalenessDays?: number;

    constructor(data?: IAppConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientVerificationStalenessDays = _data["clientVerificationStalenessDays"] !== undefined ? _data["clientVerificationStalenessDays"] : null as any;
        }
    }

    static fromJS(data: any): AppConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientVerificationStalenessDays"] = this.clientVerificationStalenessDays !== undefined ? this.clientVerificationStalenessDays : null as any;
        return data;
    }

    clone(): AppConfig {
        const json = this.toJSON();
        let result = new AppConfig();
        result.init(json);
        return result;
    }
}

export interface IAppConfig {
    clientVerificationStalenessDays?: number;
}

export class LoginParameters implements ILoginParameters {
    email!: string;
    password!: string;

    constructor(data?: ILoginParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static fromJS(data: any): LoginParameters {
        data = typeof data === 'object' ? data : {};
        let result = new LoginParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        return data;
    }

    clone(): LoginParameters {
        const json = this.toJSON();
        let result = new LoginParameters();
        result.init(json);
        return result;
    }
}

export interface ILoginParameters {
    email: string;
    password: string;
}

export class GenericApiResponse implements IGenericApiResponse {
    success?: boolean;
    message?: string | null;

    constructor(data?: IGenericApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): GenericApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenericApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): GenericApiResponse {
        const json = this.toJSON();
        let result = new GenericApiResponse();
        result.init(json);
        return result;
    }
}

export interface IGenericApiResponse {
    success?: boolean;
    message?: string | null;
}

export class EmailParameter implements IEmailParameter {
    email!: string;

    constructor(data?: IEmailParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): EmailParameter {
        data = typeof data === 'object' ? data : {};
        let result = new EmailParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): EmailParameter {
        const json = this.toJSON();
        let result = new EmailParameter();
        result.init(json);
        return result;
    }
}

export interface IEmailParameter {
    email: string;
}

export class ResetPasswordParameters implements IResetPasswordParameters {
    token!: string;
    newPassword!: string;

    constructor(data?: IResetPasswordParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : null as any;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null as any;
        }
    }

    static fromJS(data: any): ResetPasswordParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : null as any;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null as any;
        return data;
    }

    clone(): ResetPasswordParameters {
        const json = this.toJSON();
        let result = new ResetPasswordParameters();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordParameters {
    token: string;
    newPassword: string;
}

export class PagedListOfUser implements IPagedListOfUser {
    items?: User[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;

    constructor(data?: IPagedListOfUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(User.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : null as any;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : null as any;
            this.isFirstPage = _data["isFirstPage"] !== undefined ? _data["isFirstPage"] : null as any;
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PagedListOfUser {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : null as any;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : null as any;
        data["isFirstPage"] = this.isFirstPage !== undefined ? this.isFirstPage : null as any;
        data["isLastPage"] = this.isLastPage !== undefined ? this.isLastPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): PagedListOfUser {
        const json = this.toJSON();
        let result = new PagedListOfUser();
        result.init(json);
        return result;
    }
}

export interface IPagedListOfUser {
    items?: User[] | null;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    isFirstPage?: boolean;
    isLastPage?: boolean;
    pageCount?: number;
    offset?: number;
    pageIndex?: number;
    limit?: number;
    totalCount?: number;
}

export class ChangePasswordParameters implements IChangePasswordParameters {
    id!: string;
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : null as any;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null as any;
        }
    }

    static fromJS(data: any): ChangePasswordParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : null as any;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null as any;
        return data;
    }

    clone(): ChangePasswordParameters {
        const json = this.toJSON();
        let result = new ChangePasswordParameters();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordParameters {
    id: string;
    currentPassword: string;
    newPassword: string;
}

export class DateTimeOffsetParameter implements IDateTimeOffsetParameter {
    date?: Date;

    constructor(data?: IDateTimeOffsetParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DateTimeOffsetParameter {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeOffsetParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }

    clone(): DateTimeOffsetParameter {
        const json = this.toJSON();
        let result = new DateTimeOffsetParameter();
        result.init(json);
        return result;
    }
}

export interface IDateTimeOffsetParameter {
    date?: Date;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}